/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Query:{
		aggregateAdBoard:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput"
		},
		findFirstAdBoard:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		},
		findFirstAdBoardOrThrow:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		},
		adBoards:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		},
		adBoard:{
			where:"AdBoardWhereUniqueInput"
		},
		getAdBoard:{
			where:"AdBoardWhereUniqueInput"
		},
		groupByAdBoard:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithAggregationInput",
			by:"AdBoardScalarFieldEnum",
			having:"AdBoardScalarWhereWithAggregatesInput"
		},
		aggregateAdBoardGroup:{
			where:"AdBoardGroupWhereInput",
			orderBy:"AdBoardGroupOrderByWithRelationInput",
			cursor:"AdBoardGroupWhereUniqueInput"
		},
		findFirstAdBoardGroup:{
			where:"AdBoardGroupWhereInput",
			orderBy:"AdBoardGroupOrderByWithRelationInput",
			cursor:"AdBoardGroupWhereUniqueInput",
			distinct:"AdBoardGroupScalarFieldEnum"
		},
		findFirstAdBoardGroupOrThrow:{
			where:"AdBoardGroupWhereInput",
			orderBy:"AdBoardGroupOrderByWithRelationInput",
			cursor:"AdBoardGroupWhereUniqueInput",
			distinct:"AdBoardGroupScalarFieldEnum"
		},
		adBoardGroups:{
			where:"AdBoardGroupWhereInput",
			orderBy:"AdBoardGroupOrderByWithRelationInput",
			cursor:"AdBoardGroupWhereUniqueInput",
			distinct:"AdBoardGroupScalarFieldEnum"
		},
		adBoardGroup:{
			where:"AdBoardGroupWhereUniqueInput"
		},
		getAdBoardGroup:{
			where:"AdBoardGroupWhereUniqueInput"
		},
		groupByAdBoardGroup:{
			where:"AdBoardGroupWhereInput",
			orderBy:"AdBoardGroupOrderByWithAggregationInput",
			by:"AdBoardGroupScalarFieldEnum",
			having:"AdBoardGroupScalarWhereWithAggregatesInput"
		},
		aggregateAdBoardType:{
			where:"AdBoardTypeWhereInput",
			orderBy:"AdBoardTypeOrderByWithRelationInput",
			cursor:"AdBoardTypeWhereUniqueInput"
		},
		findFirstAdBoardType:{
			where:"AdBoardTypeWhereInput",
			orderBy:"AdBoardTypeOrderByWithRelationInput",
			cursor:"AdBoardTypeWhereUniqueInput",
			distinct:"AdBoardTypeScalarFieldEnum"
		},
		findFirstAdBoardTypeOrThrow:{
			where:"AdBoardTypeWhereInput",
			orderBy:"AdBoardTypeOrderByWithRelationInput",
			cursor:"AdBoardTypeWhereUniqueInput",
			distinct:"AdBoardTypeScalarFieldEnum"
		},
		adBoardTypes:{
			where:"AdBoardTypeWhereInput",
			orderBy:"AdBoardTypeOrderByWithRelationInput",
			cursor:"AdBoardTypeWhereUniqueInput",
			distinct:"AdBoardTypeScalarFieldEnum"
		},
		adBoardType:{
			where:"AdBoardTypeWhereUniqueInput"
		},
		getAdBoardType:{
			where:"AdBoardTypeWhereUniqueInput"
		},
		groupByAdBoardType:{
			where:"AdBoardTypeWhereInput",
			orderBy:"AdBoardTypeOrderByWithAggregationInput",
			by:"AdBoardTypeScalarFieldEnum",
			having:"AdBoardTypeScalarWhereWithAggregatesInput"
		},
		aggregateAdvertisementCategory:{
			where:"AdvertisementCategoryWhereInput",
			orderBy:"AdvertisementCategoryOrderByWithRelationInput",
			cursor:"AdvertisementCategoryWhereUniqueInput"
		},
		findFirstAdvertisementCategory:{
			where:"AdvertisementCategoryWhereInput",
			orderBy:"AdvertisementCategoryOrderByWithRelationInput",
			cursor:"AdvertisementCategoryWhereUniqueInput",
			distinct:"AdvertisementCategoryScalarFieldEnum"
		},
		findFirstAdvertisementCategoryOrThrow:{
			where:"AdvertisementCategoryWhereInput",
			orderBy:"AdvertisementCategoryOrderByWithRelationInput",
			cursor:"AdvertisementCategoryWhereUniqueInput",
			distinct:"AdvertisementCategoryScalarFieldEnum"
		},
		advertisementCategories:{
			where:"AdvertisementCategoryWhereInput",
			orderBy:"AdvertisementCategoryOrderByWithRelationInput",
			cursor:"AdvertisementCategoryWhereUniqueInput",
			distinct:"AdvertisementCategoryScalarFieldEnum"
		},
		advertisementCategory:{
			where:"AdvertisementCategoryWhereUniqueInput"
		},
		getAdvertisementCategory:{
			where:"AdvertisementCategoryWhereUniqueInput"
		},
		groupByAdvertisementCategory:{
			where:"AdvertisementCategoryWhereInput",
			orderBy:"AdvertisementCategoryOrderByWithAggregationInput",
			by:"AdvertisementCategoryScalarFieldEnum",
			having:"AdvertisementCategoryScalarWhereWithAggregatesInput"
		},
		aggregateAudit:{
			where:"AuditWhereInput",
			orderBy:"AuditOrderByWithRelationInput",
			cursor:"AuditWhereUniqueInput"
		},
		findFirstAudit:{
			where:"AuditWhereInput",
			orderBy:"AuditOrderByWithRelationInput",
			cursor:"AuditWhereUniqueInput",
			distinct:"AuditScalarFieldEnum"
		},
		findFirstAuditOrThrow:{
			where:"AuditWhereInput",
			orderBy:"AuditOrderByWithRelationInput",
			cursor:"AuditWhereUniqueInput",
			distinct:"AuditScalarFieldEnum"
		},
		audits:{
			where:"AuditWhereInput",
			orderBy:"AuditOrderByWithRelationInput",
			cursor:"AuditWhereUniqueInput",
			distinct:"AuditScalarFieldEnum"
		},
		audit:{
			where:"AuditWhereUniqueInput"
		},
		getAudit:{
			where:"AuditWhereUniqueInput"
		},
		groupByAudit:{
			where:"AuditWhereInput",
			orderBy:"AuditOrderByWithAggregationInput",
			by:"AuditScalarFieldEnum",
			having:"AuditScalarWhereWithAggregatesInput"
		},
		aggregateBooking:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithRelationInput",
			cursor:"BookingWhereUniqueInput"
		},
		findFirstBooking:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithRelationInput",
			cursor:"BookingWhereUniqueInput",
			distinct:"BookingScalarFieldEnum"
		},
		findFirstBookingOrThrow:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithRelationInput",
			cursor:"BookingWhereUniqueInput",
			distinct:"BookingScalarFieldEnum"
		},
		bookings:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithRelationInput",
			cursor:"BookingWhereUniqueInput",
			distinct:"BookingScalarFieldEnum"
		},
		booking:{
			where:"BookingWhereUniqueInput"
		},
		getBooking:{
			where:"BookingWhereUniqueInput"
		},
		groupByBooking:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithAggregationInput",
			by:"BookingScalarFieldEnum",
			having:"BookingScalarWhereWithAggregatesInput"
		},
		aggregateBusinessCategory:{
			where:"BusinessCategoryWhereInput",
			orderBy:"BusinessCategoryOrderByWithRelationInput",
			cursor:"BusinessCategoryWhereUniqueInput"
		},
		findFirstBusinessCategory:{
			where:"BusinessCategoryWhereInput",
			orderBy:"BusinessCategoryOrderByWithRelationInput",
			cursor:"BusinessCategoryWhereUniqueInput",
			distinct:"BusinessCategoryScalarFieldEnum"
		},
		findFirstBusinessCategoryOrThrow:{
			where:"BusinessCategoryWhereInput",
			orderBy:"BusinessCategoryOrderByWithRelationInput",
			cursor:"BusinessCategoryWhereUniqueInput",
			distinct:"BusinessCategoryScalarFieldEnum"
		},
		businessCategories:{
			where:"BusinessCategoryWhereInput",
			orderBy:"BusinessCategoryOrderByWithRelationInput",
			cursor:"BusinessCategoryWhereUniqueInput",
			distinct:"BusinessCategoryScalarFieldEnum"
		},
		businessCategory:{
			where:"BusinessCategoryWhereUniqueInput"
		},
		getBusinessCategory:{
			where:"BusinessCategoryWhereUniqueInput"
		},
		groupByBusinessCategory:{
			where:"BusinessCategoryWhereInput",
			orderBy:"BusinessCategoryOrderByWithAggregationInput",
			by:"BusinessCategoryScalarFieldEnum",
			having:"BusinessCategoryScalarWhereWithAggregatesInput"
		},
		aggregateCamera:{
			where:"CameraWhereInput",
			orderBy:"CameraOrderByWithRelationInput",
			cursor:"CameraWhereUniqueInput"
		},
		findFirstCamera:{
			where:"CameraWhereInput",
			orderBy:"CameraOrderByWithRelationInput",
			cursor:"CameraWhereUniqueInput",
			distinct:"CameraScalarFieldEnum"
		},
		findFirstCameraOrThrow:{
			where:"CameraWhereInput",
			orderBy:"CameraOrderByWithRelationInput",
			cursor:"CameraWhereUniqueInput",
			distinct:"CameraScalarFieldEnum"
		},
		cameras:{
			where:"CameraWhereInput",
			orderBy:"CameraOrderByWithRelationInput",
			cursor:"CameraWhereUniqueInput",
			distinct:"CameraScalarFieldEnum"
		},
		camera:{
			where:"CameraWhereUniqueInput"
		},
		getCamera:{
			where:"CameraWhereUniqueInput"
		},
		groupByCamera:{
			where:"CameraWhereInput",
			orderBy:"CameraOrderByWithAggregationInput",
			by:"CameraScalarFieldEnum",
			having:"CameraScalarWhereWithAggregatesInput"
		},
		aggregateCampaign:{
			where:"CampaignWhereInput",
			orderBy:"CampaignOrderByWithRelationInput",
			cursor:"CampaignWhereUniqueInput"
		},
		findFirstCampaign:{
			where:"CampaignWhereInput",
			orderBy:"CampaignOrderByWithRelationInput",
			cursor:"CampaignWhereUniqueInput",
			distinct:"CampaignScalarFieldEnum"
		},
		findFirstCampaignOrThrow:{
			where:"CampaignWhereInput",
			orderBy:"CampaignOrderByWithRelationInput",
			cursor:"CampaignWhereUniqueInput",
			distinct:"CampaignScalarFieldEnum"
		},
		campaigns:{
			where:"CampaignWhereInput",
			orderBy:"CampaignOrderByWithRelationInput",
			cursor:"CampaignWhereUniqueInput",
			distinct:"CampaignScalarFieldEnum"
		},
		campaign:{
			where:"CampaignWhereUniqueInput"
		},
		getCampaign:{
			where:"CampaignWhereUniqueInput"
		},
		groupByCampaign:{
			where:"CampaignWhereInput",
			orderBy:"CampaignOrderByWithAggregationInput",
			by:"CampaignScalarFieldEnum",
			having:"CampaignScalarWhereWithAggregatesInput"
		},
		aggregateFile:{
			where:"FileWhereInput",
			orderBy:"FileOrderByWithRelationInput",
			cursor:"FileWhereUniqueInput"
		},
		findFirstFile:{
			where:"FileWhereInput",
			orderBy:"FileOrderByWithRelationInput",
			cursor:"FileWhereUniqueInput",
			distinct:"FileScalarFieldEnum"
		},
		findFirstFileOrThrow:{
			where:"FileWhereInput",
			orderBy:"FileOrderByWithRelationInput",
			cursor:"FileWhereUniqueInput",
			distinct:"FileScalarFieldEnum"
		},
		files:{
			where:"FileWhereInput",
			orderBy:"FileOrderByWithRelationInput",
			cursor:"FileWhereUniqueInput",
			distinct:"FileScalarFieldEnum"
		},
		file:{
			where:"FileWhereUniqueInput"
		},
		getFile:{
			where:"FileWhereUniqueInput"
		},
		groupByFile:{
			where:"FileWhereInput",
			orderBy:"FileOrderByWithAggregationInput",
			by:"FileScalarFieldEnum",
			having:"FileScalarWhereWithAggregatesInput"
		},
		aggregateMembership:{
			where:"MembershipWhereInput",
			orderBy:"MembershipOrderByWithRelationInput",
			cursor:"MembershipWhereUniqueInput"
		},
		findFirstMembership:{
			where:"MembershipWhereInput",
			orderBy:"MembershipOrderByWithRelationInput",
			cursor:"MembershipWhereUniqueInput",
			distinct:"MembershipScalarFieldEnum"
		},
		findFirstMembershipOrThrow:{
			where:"MembershipWhereInput",
			orderBy:"MembershipOrderByWithRelationInput",
			cursor:"MembershipWhereUniqueInput",
			distinct:"MembershipScalarFieldEnum"
		},
		memberships:{
			where:"MembershipWhereInput",
			orderBy:"MembershipOrderByWithRelationInput",
			cursor:"MembershipWhereUniqueInput",
			distinct:"MembershipScalarFieldEnum"
		},
		membership:{
			where:"MembershipWhereUniqueInput"
		},
		getMembership:{
			where:"MembershipWhereUniqueInput"
		},
		groupByMembership:{
			where:"MembershipWhereInput",
			orderBy:"MembershipOrderByWithAggregationInput",
			by:"MembershipScalarFieldEnum",
			having:"MembershipScalarWhereWithAggregatesInput"
		},
		aggregateNotification:{
			where:"NotificationWhereInput",
			orderBy:"NotificationOrderByWithRelationInput",
			cursor:"NotificationWhereUniqueInput"
		},
		findFirstNotification:{
			where:"NotificationWhereInput",
			orderBy:"NotificationOrderByWithRelationInput",
			cursor:"NotificationWhereUniqueInput",
			distinct:"NotificationScalarFieldEnum"
		},
		findFirstNotificationOrThrow:{
			where:"NotificationWhereInput",
			orderBy:"NotificationOrderByWithRelationInput",
			cursor:"NotificationWhereUniqueInput",
			distinct:"NotificationScalarFieldEnum"
		},
		notifications:{
			where:"NotificationWhereInput",
			orderBy:"NotificationOrderByWithRelationInput",
			cursor:"NotificationWhereUniqueInput",
			distinct:"NotificationScalarFieldEnum"
		},
		notification:{
			where:"NotificationWhereUniqueInput"
		},
		getNotification:{
			where:"NotificationWhereUniqueInput"
		},
		groupByNotification:{
			where:"NotificationWhereInput",
			orderBy:"NotificationOrderByWithAggregationInput",
			by:"NotificationScalarFieldEnum",
			having:"NotificationScalarWhereWithAggregatesInput"
		},
		aggregateOrder:{
			where:"OrderWhereInput",
			orderBy:"OrderOrderByWithRelationInput",
			cursor:"OrderWhereUniqueInput"
		},
		findFirstOrder:{
			where:"OrderWhereInput",
			orderBy:"OrderOrderByWithRelationInput",
			cursor:"OrderWhereUniqueInput",
			distinct:"OrderScalarFieldEnum"
		},
		findFirstOrderOrThrow:{
			where:"OrderWhereInput",
			orderBy:"OrderOrderByWithRelationInput",
			cursor:"OrderWhereUniqueInput",
			distinct:"OrderScalarFieldEnum"
		},
		orders:{
			where:"OrderWhereInput",
			orderBy:"OrderOrderByWithRelationInput",
			cursor:"OrderWhereUniqueInput",
			distinct:"OrderScalarFieldEnum"
		},
		order:{
			where:"OrderWhereUniqueInput"
		},
		getOrder:{
			where:"OrderWhereUniqueInput"
		},
		groupByOrder:{
			where:"OrderWhereInput",
			orderBy:"OrderOrderByWithAggregationInput",
			by:"OrderScalarFieldEnum",
			having:"OrderScalarWhereWithAggregatesInput"
		},
		aggregatePlayer:{
			where:"PlayerWhereInput",
			orderBy:"PlayerOrderByWithRelationInput",
			cursor:"PlayerWhereUniqueInput"
		},
		findFirstPlayer:{
			where:"PlayerWhereInput",
			orderBy:"PlayerOrderByWithRelationInput",
			cursor:"PlayerWhereUniqueInput",
			distinct:"PlayerScalarFieldEnum"
		},
		findFirstPlayerOrThrow:{
			where:"PlayerWhereInput",
			orderBy:"PlayerOrderByWithRelationInput",
			cursor:"PlayerWhereUniqueInput",
			distinct:"PlayerScalarFieldEnum"
		},
		players:{
			where:"PlayerWhereInput",
			orderBy:"PlayerOrderByWithRelationInput",
			cursor:"PlayerWhereUniqueInput",
			distinct:"PlayerScalarFieldEnum"
		},
		player:{
			where:"PlayerWhereUniqueInput"
		},
		getPlayer:{
			where:"PlayerWhereUniqueInput"
		},
		groupByPlayer:{
			where:"PlayerWhereInput",
			orderBy:"PlayerOrderByWithAggregationInput",
			by:"PlayerScalarFieldEnum",
			having:"PlayerScalarWhereWithAggregatesInput"
		},
		aggregatePlaylist:{
			where:"PlaylistWhereInput",
			orderBy:"PlaylistOrderByWithRelationInput",
			cursor:"PlaylistWhereUniqueInput"
		},
		findFirstPlaylist:{
			where:"PlaylistWhereInput",
			orderBy:"PlaylistOrderByWithRelationInput",
			cursor:"PlaylistWhereUniqueInput",
			distinct:"PlaylistScalarFieldEnum"
		},
		findFirstPlaylistOrThrow:{
			where:"PlaylistWhereInput",
			orderBy:"PlaylistOrderByWithRelationInput",
			cursor:"PlaylistWhereUniqueInput",
			distinct:"PlaylistScalarFieldEnum"
		},
		playlist:{
			where:"PlaylistWhereUniqueInput"
		},
		getPlaylist:{
			where:"PlaylistWhereUniqueInput"
		},
		groupByPlaylist:{
			where:"PlaylistWhereInput",
			orderBy:"PlaylistOrderByWithAggregationInput",
			by:"PlaylistScalarFieldEnum",
			having:"PlaylistScalarWhereWithAggregatesInput"
		},
		aggregateSlotConfiguration:{
			where:"SlotConfigurationWhereInput",
			orderBy:"SlotConfigurationOrderByWithRelationInput",
			cursor:"SlotConfigurationWhereUniqueInput"
		},
		findFirstSlotConfiguration:{
			where:"SlotConfigurationWhereInput",
			orderBy:"SlotConfigurationOrderByWithRelationInput",
			cursor:"SlotConfigurationWhereUniqueInput",
			distinct:"SlotConfigurationScalarFieldEnum"
		},
		findFirstSlotConfigurationOrThrow:{
			where:"SlotConfigurationWhereInput",
			orderBy:"SlotConfigurationOrderByWithRelationInput",
			cursor:"SlotConfigurationWhereUniqueInput",
			distinct:"SlotConfigurationScalarFieldEnum"
		},
		slotConfigurations:{
			where:"SlotConfigurationWhereInput",
			orderBy:"SlotConfigurationOrderByWithRelationInput",
			cursor:"SlotConfigurationWhereUniqueInput",
			distinct:"SlotConfigurationScalarFieldEnum"
		},
		slotConfiguration:{
			where:"SlotConfigurationWhereUniqueInput"
		},
		getSlotConfiguration:{
			where:"SlotConfigurationWhereUniqueInput"
		},
		groupBySlotConfiguration:{
			where:"SlotConfigurationWhereInput",
			orderBy:"SlotConfigurationOrderByWithAggregationInput",
			by:"SlotConfigurationScalarFieldEnum",
			having:"SlotConfigurationScalarWhereWithAggregatesInput"
		},
		aggregateSubscription:{
			where:"SubscriptionWhereInput",
			orderBy:"SubscriptionOrderByWithRelationInput",
			cursor:"SubscriptionWhereUniqueInput"
		},
		findFirstSubscription:{
			where:"SubscriptionWhereInput",
			orderBy:"SubscriptionOrderByWithRelationInput",
			cursor:"SubscriptionWhereUniqueInput",
			distinct:"SubscriptionScalarFieldEnum"
		},
		findFirstSubscriptionOrThrow:{
			where:"SubscriptionWhereInput",
			orderBy:"SubscriptionOrderByWithRelationInput",
			cursor:"SubscriptionWhereUniqueInput",
			distinct:"SubscriptionScalarFieldEnum"
		},
		subscriptions:{
			where:"SubscriptionWhereInput",
			orderBy:"SubscriptionOrderByWithRelationInput",
			cursor:"SubscriptionWhereUniqueInput",
			distinct:"SubscriptionScalarFieldEnum"
		},
		subscription:{
			where:"SubscriptionWhereUniqueInput"
		},
		getSubscription:{
			where:"SubscriptionWhereUniqueInput"
		},
		groupBySubscription:{
			where:"SubscriptionWhereInput",
			orderBy:"SubscriptionOrderByWithAggregationInput",
			by:"SubscriptionScalarFieldEnum",
			having:"SubscriptionScalarWhereWithAggregatesInput"
		},
		aggregateUser:{
			where:"UserWhereInput",
			orderBy:"UserOrderByWithRelationInput",
			cursor:"UserWhereUniqueInput"
		},
		findFirstUser:{
			where:"UserWhereInput",
			orderBy:"UserOrderByWithRelationInput",
			cursor:"UserWhereUniqueInput",
			distinct:"UserScalarFieldEnum"
		},
		findFirstUserOrThrow:{
			where:"UserWhereInput",
			orderBy:"UserOrderByWithRelationInput",
			cursor:"UserWhereUniqueInput",
			distinct:"UserScalarFieldEnum"
		},
		users:{
			where:"UserWhereInput",
			orderBy:"UserOrderByWithRelationInput",
			cursor:"UserWhereUniqueInput",
			distinct:"UserScalarFieldEnum"
		},
		user:{
			where:"UserWhereUniqueInput"
		},
		getUser:{
			where:"UserWhereUniqueInput"
		},
		groupByUser:{
			where:"UserWhereInput",
			orderBy:"UserOrderByWithAggregationInput",
			by:"UserScalarFieldEnum",
			having:"UserScalarWhereWithAggregatesInput"
		},
		aggregateUserPosition:{
			where:"UserPositionWhereInput",
			orderBy:"UserPositionOrderByWithRelationInput",
			cursor:"UserPositionWhereUniqueInput"
		},
		findFirstUserPosition:{
			where:"UserPositionWhereInput",
			orderBy:"UserPositionOrderByWithRelationInput",
			cursor:"UserPositionWhereUniqueInput",
			distinct:"UserPositionScalarFieldEnum"
		},
		findFirstUserPositionOrThrow:{
			where:"UserPositionWhereInput",
			orderBy:"UserPositionOrderByWithRelationInput",
			cursor:"UserPositionWhereUniqueInput",
			distinct:"UserPositionScalarFieldEnum"
		},
		userPositions:{
			where:"UserPositionWhereInput",
			orderBy:"UserPositionOrderByWithRelationInput",
			cursor:"UserPositionWhereUniqueInput",
			distinct:"UserPositionScalarFieldEnum"
		},
		userPosition:{
			where:"UserPositionWhereUniqueInput"
		},
		getUserPosition:{
			where:"UserPositionWhereUniqueInput"
		},
		groupByUserPosition:{
			where:"UserPositionWhereInput",
			orderBy:"UserPositionOrderByWithAggregationInput",
			by:"UserPositionScalarFieldEnum",
			having:"UserPositionScalarWhereWithAggregatesInput"
		},
		aggregateWishlist:{
			where:"WishlistWhereInput",
			orderBy:"WishlistOrderByWithRelationInput",
			cursor:"WishlistWhereUniqueInput"
		},
		findFirstWishlist:{
			where:"WishlistWhereInput",
			orderBy:"WishlistOrderByWithRelationInput",
			cursor:"WishlistWhereUniqueInput",
			distinct:"WishlistScalarFieldEnum"
		},
		findFirstWishlistOrThrow:{
			where:"WishlistWhereInput",
			orderBy:"WishlistOrderByWithRelationInput",
			cursor:"WishlistWhereUniqueInput",
			distinct:"WishlistScalarFieldEnum"
		},
		wishlists:{
			where:"WishlistWhereInput",
			orderBy:"WishlistOrderByWithRelationInput",
			cursor:"WishlistWhereUniqueInput",
			distinct:"WishlistScalarFieldEnum"
		},
		wishlist:{
			where:"WishlistWhereUniqueInput"
		},
		getWishlist:{
			where:"WishlistWhereUniqueInput"
		},
		groupByWishlist:{
			where:"WishlistWhereInput",
			orderBy:"WishlistOrderByWithAggregationInput",
			by:"WishlistScalarFieldEnum",
			having:"WishlistScalarWhereWithAggregatesInput"
		},
		aggregateWorkspace:{
			where:"WorkspaceWhereInput",
			orderBy:"WorkspaceOrderByWithRelationInput",
			cursor:"WorkspaceWhereUniqueInput"
		},
		findFirstWorkspace:{
			where:"WorkspaceWhereInput",
			orderBy:"WorkspaceOrderByWithRelationInput",
			cursor:"WorkspaceWhereUniqueInput",
			distinct:"WorkspaceScalarFieldEnum"
		},
		findFirstWorkspaceOrThrow:{
			where:"WorkspaceWhereInput",
			orderBy:"WorkspaceOrderByWithRelationInput",
			cursor:"WorkspaceWhereUniqueInput",
			distinct:"WorkspaceScalarFieldEnum"
		},
		workspaces:{
			where:"WorkspaceWhereInput",
			orderBy:"WorkspaceOrderByWithRelationInput",
			cursor:"WorkspaceWhereUniqueInput",
			distinct:"WorkspaceScalarFieldEnum"
		},
		workspace:{
			where:"WorkspaceWhereUniqueInput"
		},
		getWorkspace:{
			where:"WorkspaceWhereUniqueInput"
		},
		groupByWorkspace:{
			where:"WorkspaceWhereInput",
			orderBy:"WorkspaceOrderByWithAggregationInput",
			by:"WorkspaceScalarFieldEnum",
			having:"WorkspaceScalarWhereWithAggregatesInput"
		},
		aggregateWorkspaceRole:{
			where:"WorkspaceRoleWhereInput",
			orderBy:"WorkspaceRoleOrderByWithRelationInput",
			cursor:"WorkspaceRoleWhereUniqueInput"
		},
		findFirstWorkspaceRole:{
			where:"WorkspaceRoleWhereInput",
			orderBy:"WorkspaceRoleOrderByWithRelationInput",
			cursor:"WorkspaceRoleWhereUniqueInput",
			distinct:"WorkspaceRoleScalarFieldEnum"
		},
		findFirstWorkspaceRoleOrThrow:{
			where:"WorkspaceRoleWhereInput",
			orderBy:"WorkspaceRoleOrderByWithRelationInput",
			cursor:"WorkspaceRoleWhereUniqueInput",
			distinct:"WorkspaceRoleScalarFieldEnum"
		},
		workspaceRoles:{
			where:"WorkspaceRoleWhereInput",
			orderBy:"WorkspaceRoleOrderByWithRelationInput",
			cursor:"WorkspaceRoleWhereUniqueInput",
			distinct:"WorkspaceRoleScalarFieldEnum"
		},
		workspaceRole:{
			where:"WorkspaceRoleWhereUniqueInput"
		},
		getWorkspaceRole:{
			where:"WorkspaceRoleWhereUniqueInput"
		},
		groupByWorkspaceRole:{
			where:"WorkspaceRoleWhereInput",
			orderBy:"WorkspaceRoleOrderByWithAggregationInput",
			by:"WorkspaceRoleScalarFieldEnum",
			having:"WorkspaceRoleScalarWhereWithAggregatesInput"
		},
		adBoardPublicReviews:{
			where:"AdBoardPublicReviewWhereInput",
			orderBy:"AdBoardPublicReviewOrderByWithRelationInput",
			cursor:"AdBoardPublicReviewWhereUniqueInput",
			distinct:"AdBoardPublicReviewScalarFieldEnum"
		},
		billboardAiCameraStats:{
			where:"BillboardAiCameraStatWhereInput",
			orderBy:"BillboardAiCameraStatOrderByWithRelationInput",
			cursor:"BillboardAiCameraStatWhereUniqueInput",
			distinct:"BillboardAiCameraStatScalarFieldEnum"
		},
		bookingHistories:{
			where:"BookingHistoryWhereInput",
			orderBy:"BookingHistoryOrderByWithRelationInput",
			cursor:"BookingHistoryWhereUniqueInput",
			distinct:"BookingHistoryScalarFieldEnum"
		},
		contentVersions:{
			where:"ContentVersionWhereInput",
			orderBy:"ContentVersionOrderByWithRelationInput",
			cursor:"ContentVersionWhereUniqueInput",
			distinct:"ContentVersionScalarFieldEnum"
		},
		findFirstStreamingDevice:{
			where:"StreamingDeviceWhereInput",
			orderBy:"StreamingDeviceOrderByWithRelationInput",
			cursor:"StreamingDeviceWhereUniqueInput",
			distinct:"StreamingDeviceScalarFieldEnum"
		},
		streamingDevices:{
			where:"StreamingDeviceWhereInput",
			orderBy:"StreamingDeviceOrderByWithRelationInput",
			cursor:"StreamingDeviceWhereUniqueInput",
			distinct:"StreamingDeviceScalarFieldEnum"
		},
		aggregateTrafficStat:{
			endDate:"DateTime",
			startDate:"DateTime"
		},
		trafficStats:{
			where:"TrafficStatWhereInput",
			orderBy:"TrafficStatOrderByWithRelationInput",
			cursor:"TrafficStatWhereUniqueInput",
			distinct:"TrafficStatScalarFieldEnum"
		},
		getAdBoardAvailability:{

		},
		playlogs:{
			endTimestamp:"DateTime",
			startTimestamp:"DateTime"
		}
	},
	AdBoardStatus: "enum" as const,
	AdboardDraftStatus: "enum" as const,
	DateTime: `scalar.DateTime` as const,
	AdBoardWhereInput:{
		AND:"AdBoardWhereInput",
		OR:"AdBoardWhereInput",
		NOT:"AdBoardWhereInput",
		id:"StringFilter",
		state:"StringFilter",
		city:"StringFilter",
		country:"StringFilter",
		outdoor:"BoolFilter",
		locationCategoryId:"StringNullableFilter",
		locationSubCategoryId:"StringNullableFilter",
		alias:"StringNullableFilter",
		title:"StringFilter",
		pricePerDay:"IntFilter",
		pricingTiers:"PricingTierObjectEqualityInput",
		originalPricePerDay:"IntNullableFilter",
		description:"StringNullableFilter",
		aboutSpecifications:"SpecificationObjectEqualityInput",
		adBoardTypeId:"StringNullableFilter",
		tags:"StringNullableListFilter",
		featuredImage:"StringNullableFilter",
		galleryImgs:"StringNullableListFilter",
		specifications:"SpecificationObjectEqualityInput",
		notes:"StringNullableListFilter",
		impressionMultiplier:"FloatNullableFilter",
		resolution:"ResolutionNullableCompositeFilter",
		screenSize:"ScreenSizeNullableCompositeFilter",
		categoryId:"StringNullableFilter",
		restrictedBusinessIds:"StringNullableListFilter",
		targetAudiences:"StringNullableListFilter",
		playbackTimes:"PlaybackTimeObjectEqualityInput",
		acceptedMediaTypes:"StringNullableListFilter",
		status:"EnumAdBoardStatusFilter",
		adboardDraftStatus:"EnumAdboardDraftStatusNullableFilter",
		isLive:"BoolFilter",
		numberOfDisplays:"IntFilter",
		dailyOperationHours:"IntFilter",
		adsPerLoop:"IntFilter",
		adsDuration:"IntFilter",
		monthlyPrice:"FloatNullableFilter",
		offlineBookingsEnabled:"BoolFilter",
		createdAt:"DateTimeNullableFilter",
		createdByUserId:"StringNullableFilter",
		href:"StringNullableFilter",
		workspaceId:"StringFilter",
		playerIds:"StringNullableListFilter",
		publisherScreenId:"StringNullableFilter",
		additionalData:"JsonNullableFilter",
		publishedVersionId:"StringNullableFilter",
		lastPublishedAt:"DateTimeNullableFilter",
		isArchived:"BoolFilter",
		archivedAt:"DateTimeNullableFilter",
		archivedByUserId:"StringNullableFilter",
		updatedAt:"DateTimeNullableFilter",
		wishlistIds:"StringNullableListFilter",
		locationCategory:"LocationCategoryNullableRelationFilter",
		locationSubCategory:"LocationSubCategoryNullableRelationFilter",
		type:"AdBoardTypeNullableRelationFilter",
		category:"BusinessCategoryNullableRelationFilter",
		restrictedBusines:"BusinessCategoryListRelationFilter",
		bookings:"BookingListRelationFilter",
		orders:"OrderListRelationFilter",
		slotConfigurations:"SlotConfigurationListRelationFilter",
		createdBy:"UserNullableRelationFilter",
		workspace:"WorkspaceRelationFilter",
		players:"PlayerListRelationFilter",
		adBoardGroup:"AdBoardGroupNullableRelationFilter",
		publishedVersion:"AdBoardNullableRelationFilter",
		draftAdboard:"AdBoardNullableRelationFilter",
		history:"AdBoardPublishHistoryListRelationFilter",
		reviewComments:"AdBoardReviewCommentListRelationFilter",
		archivedBy:"UserNullableRelationFilter",
		publicReviews:"AdBoardPublicReviewListRelationFilter",
		wishlists:"WishlistListRelationFilter"
	},
	StringFilter:{
		mode:"QueryMode",
		not:"NestedStringFilter"
	},
	QueryMode: "enum" as const,
	NestedStringFilter:{
		not:"NestedStringFilter"
	},
	BoolFilter:{
		not:"NestedBoolFilter"
	},
	NestedBoolFilter:{
		not:"NestedBoolFilter"
	},
	StringNullableFilter:{
		mode:"QueryMode",
		not:"NestedStringNullableFilter"
	},
	NestedStringNullableFilter:{
		not:"NestedStringNullableFilter"
	},
	IntFilter:{
		not:"NestedIntFilter"
	},
	NestedIntFilter:{
		not:"NestedIntFilter"
	},
	PricingTierObjectEqualityInput:{

	},
	IntNullableFilter:{
		not:"NestedIntNullableFilter"
	},
	NestedIntNullableFilter:{
		not:"NestedIntNullableFilter"
	},
	SpecificationObjectEqualityInput:{

	},
	StringNullableListFilter:{

	},
	FloatNullableFilter:{
		not:"NestedFloatNullableFilter"
	},
	NestedFloatNullableFilter:{
		not:"NestedFloatNullableFilter"
	},
	ResolutionNullableCompositeFilter:{
		equals:"ResolutionObjectEqualityInput",
		is:"ResolutionWhereInput",
		isNot:"ResolutionWhereInput"
	},
	ResolutionObjectEqualityInput:{

	},
	ResolutionWhereInput:{
		AND:"ResolutionWhereInput",
		OR:"ResolutionWhereInput",
		NOT:"ResolutionWhereInput",
		height:"IntFilter",
		width:"IntFilter"
	},
	ScreenSizeNullableCompositeFilter:{
		equals:"ScreenSizeObjectEqualityInput",
		is:"ScreenSizeWhereInput",
		isNot:"ScreenSizeWhereInput"
	},
	ScreenSizeObjectEqualityInput:{
		unit:"MeasurementUnit"
	},
	MeasurementUnit: "enum" as const,
	ScreenSizeWhereInput:{
		AND:"ScreenSizeWhereInput",
		OR:"ScreenSizeWhereInput",
		NOT:"ScreenSizeWhereInput",
		height:"FloatFilter",
		unit:"EnumMeasurementUnitFilter",
		width:"FloatFilter"
	},
	FloatFilter:{
		not:"NestedFloatFilter"
	},
	NestedFloatFilter:{
		not:"NestedFloatFilter"
	},
	EnumMeasurementUnitFilter:{
		equals:"MeasurementUnit",
		in:"MeasurementUnit",
		notIn:"MeasurementUnit",
		not:"NestedEnumMeasurementUnitFilter"
	},
	NestedEnumMeasurementUnitFilter:{
		equals:"MeasurementUnit",
		in:"MeasurementUnit",
		notIn:"MeasurementUnit",
		not:"NestedEnumMeasurementUnitFilter"
	},
	PlaybackTimeObjectEqualityInput:{

	},
	EnumAdBoardStatusFilter:{
		equals:"AdBoardStatus",
		in:"AdBoardStatus",
		notIn:"AdBoardStatus",
		not:"NestedEnumAdBoardStatusFilter"
	},
	NestedEnumAdBoardStatusFilter:{
		equals:"AdBoardStatus",
		in:"AdBoardStatus",
		notIn:"AdBoardStatus",
		not:"NestedEnumAdBoardStatusFilter"
	},
	EnumAdboardDraftStatusNullableFilter:{
		equals:"AdboardDraftStatus",
		in:"AdboardDraftStatus",
		notIn:"AdboardDraftStatus",
		not:"NestedEnumAdboardDraftStatusNullableFilter"
	},
	NestedEnumAdboardDraftStatusNullableFilter:{
		equals:"AdboardDraftStatus",
		in:"AdboardDraftStatus",
		notIn:"AdboardDraftStatus",
		not:"NestedEnumAdboardDraftStatusNullableFilter"
	},
	DateTimeNullableFilter:{
		equals:"DateTime",
		in:"DateTime",
		notIn:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		gt:"DateTime",
		gte:"DateTime",
		not:"NestedDateTimeNullableFilter"
	},
	NestedDateTimeNullableFilter:{
		equals:"DateTime",
		in:"DateTime",
		notIn:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		gt:"DateTime",
		gte:"DateTime",
		not:"NestedDateTimeNullableFilter"
	},
	JsonNullableFilter:{
		equals:"JSON",
		not:"JSON"
	},
	JSON: `scalar.JSON` as const,
	LocationCategoryNullableRelationFilter:{
		is:"LocationCategoryWhereInput",
		isNot:"LocationCategoryWhereInput"
	},
	LocationCategoryWhereInput:{
		AND:"LocationCategoryWhereInput",
		OR:"LocationCategoryWhereInput",
		NOT:"LocationCategoryWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		adBoards:"AdBoardListRelationFilter",
		locationSubCategory:"LocationSubCategoryListRelationFilter"
	},
	AdBoardListRelationFilter:{
		every:"AdBoardWhereInput",
		some:"AdBoardWhereInput",
		none:"AdBoardWhereInput"
	},
	LocationSubCategoryListRelationFilter:{
		every:"LocationSubCategoryWhereInput",
		some:"LocationSubCategoryWhereInput",
		none:"LocationSubCategoryWhereInput"
	},
	LocationSubCategoryWhereInput:{
		AND:"LocationSubCategoryWhereInput",
		OR:"LocationSubCategoryWhereInput",
		NOT:"LocationSubCategoryWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		locationCategoryId:"StringNullableFilter",
		locationCategory:"LocationCategoryNullableRelationFilter",
		adBoards:"AdBoardListRelationFilter"
	},
	LocationSubCategoryNullableRelationFilter:{
		is:"LocationSubCategoryWhereInput",
		isNot:"LocationSubCategoryWhereInput"
	},
	AdBoardTypeNullableRelationFilter:{
		is:"AdBoardTypeWhereInput",
		isNot:"AdBoardTypeWhereInput"
	},
	AdBoardTypeWhereInput:{
		AND:"AdBoardTypeWhereInput",
		OR:"AdBoardTypeWhereInput",
		NOT:"AdBoardTypeWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		description:"StringNullableFilter",
		adBoards:"AdBoardListRelationFilter"
	},
	BusinessCategoryNullableRelationFilter:{
		is:"BusinessCategoryWhereInput",
		isNot:"BusinessCategoryWhereInput"
	},
	BusinessCategoryWhereInput:{
		AND:"BusinessCategoryWhereInput",
		OR:"BusinessCategoryWhereInput",
		NOT:"BusinessCategoryWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		description:"StringNullableFilter",
		restrictedByAdBoardIds:"StringNullableListFilter",
		adBoards:"AdBoardListRelationFilter",
		restrictedByAdBoards:"AdBoardListRelationFilter",
		campaigns:"CampaignListRelationFilter",
		bookings:"BookingListRelationFilter"
	},
	CampaignListRelationFilter:{
		every:"CampaignWhereInput",
		some:"CampaignWhereInput",
		none:"CampaignWhereInput"
	},
	CampaignWhereInput:{
		AND:"CampaignWhereInput",
		OR:"CampaignWhereInput",
		NOT:"CampaignWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		description:"StringNullableFilter",
		businessCategoryId:"StringFilter",
		purpose:"StringFilter",
		userId:"StringFilter",
		adCategoryId:"StringNullableListFilter",
		payment:"BookingPaymentNullableCompositeFilter",
		paymentStatus:"EnumPaymentStatusFilter",
		priceSummary:"PriceSummaryNullableCompositeFilter",
		selectedDates:"OrderSelectedDateCompositeFilter",
		origin:"StringFilter",
		assetsIDs:"StringNullableListFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		businessCategory:"BusinessCategoryRelationFilter",
		user:"UserRelationFilter",
		adCategory:"AdvertisementCategoryListRelationFilter",
		bookings:"BookingListRelationFilter",
		payments:"PaymentListRelationFilter",
		assets:"FileListRelationFilter"
	},
	BookingPaymentNullableCompositeFilter:{
		equals:"BookingPaymentObjectEqualityInput",
		is:"BookingPaymentWhereInput",
		isNot:"BookingPaymentWhereInput"
	},
	BookingPaymentObjectEqualityInput:{
		customer:"BookingCustomerObjectEqualityInput",
		paymentGateway:"PaymentGatewayName",
		totalDetails:"PaymentTotalDetailsObjectEqualityInput",
		razorpay:"JSON",
		stripe:"JSON"
	},
	BookingCustomerObjectEqualityInput:{
		customerDetails:"PaymentCustomerDetailsObjectEqualityInput"
	},
	PaymentCustomerDetailsObjectEqualityInput:{

	},
	PaymentGatewayName: "enum" as const,
	PaymentTotalDetailsObjectEqualityInput:{

	},
	BookingPaymentWhereInput:{
		AND:"BookingPaymentWhereInput",
		OR:"BookingPaymentWhereInput",
		NOT:"BookingPaymentWhereInput",
		liveMode:"BoolFilter",
		checkoutSessionId:"StringNullableFilter",
		customer:"BookingCustomerNullableCompositeFilter",
		paymentGateway:"EnumPaymentGatewayNameFilter",
		paymentId:"StringFilter",
		sessionId:"StringNullableFilter",
		totalDetails:"PaymentTotalDetailsNullableCompositeFilter",
		razorpay:"JsonNullableFilter",
		stripe:"JsonNullableFilter"
	},
	BookingCustomerNullableCompositeFilter:{
		equals:"BookingCustomerObjectEqualityInput",
		is:"BookingCustomerWhereInput",
		isNot:"BookingCustomerWhereInput"
	},
	BookingCustomerWhereInput:{
		AND:"BookingCustomerWhereInput",
		OR:"BookingCustomerWhereInput",
		NOT:"BookingCustomerWhereInput",
		customerId:"StringFilter",
		customerDetails:"PaymentCustomerDetailsNullableCompositeFilter"
	},
	PaymentCustomerDetailsNullableCompositeFilter:{
		equals:"PaymentCustomerDetailsObjectEqualityInput",
		is:"PaymentCustomerDetailsWhereInput",
		isNot:"PaymentCustomerDetailsWhereInput"
	},
	PaymentCustomerDetailsWhereInput:{
		AND:"PaymentCustomerDetailsWhereInput",
		OR:"PaymentCustomerDetailsWhereInput",
		NOT:"PaymentCustomerDetailsWhereInput",
		email:"StringFilter",
		name:"StringFilter",
		phone:"StringNullableFilter"
	},
	EnumPaymentGatewayNameFilter:{
		equals:"PaymentGatewayName",
		in:"PaymentGatewayName",
		notIn:"PaymentGatewayName",
		not:"NestedEnumPaymentGatewayNameFilter"
	},
	NestedEnumPaymentGatewayNameFilter:{
		equals:"PaymentGatewayName",
		in:"PaymentGatewayName",
		notIn:"PaymentGatewayName",
		not:"NestedEnumPaymentGatewayNameFilter"
	},
	PaymentTotalDetailsNullableCompositeFilter:{
		equals:"PaymentTotalDetailsObjectEqualityInput",
		is:"PaymentTotalDetailsWhereInput",
		isNot:"PaymentTotalDetailsWhereInput"
	},
	PaymentTotalDetailsWhereInput:{
		AND:"PaymentTotalDetailsWhereInput",
		OR:"PaymentTotalDetailsWhereInput",
		NOT:"PaymentTotalDetailsWhereInput",
		discount:"FloatFilter",
		shipping:"FloatFilter",
		subtotal:"FloatFilter",
		tax:"FloatFilter",
		total:"FloatFilter"
	},
	EnumPaymentStatusFilter:{
		equals:"PaymentStatus",
		in:"PaymentStatus",
		notIn:"PaymentStatus",
		not:"NestedEnumPaymentStatusFilter"
	},
	PaymentStatus: "enum" as const,
	NestedEnumPaymentStatusFilter:{
		equals:"PaymentStatus",
		in:"PaymentStatus",
		notIn:"PaymentStatus",
		not:"NestedEnumPaymentStatusFilter"
	},
	PriceSummaryNullableCompositeFilter:{
		equals:"PriceSummaryObjectEqualityInput",
		is:"PriceSummaryWhereInput",
		isNot:"PriceSummaryWhereInput"
	},
	PriceSummaryObjectEqualityInput:{

	},
	PriceSummaryWhereInput:{
		AND:"PriceSummaryWhereInput",
		OR:"PriceSummaryWhereInput",
		NOT:"PriceSummaryWhereInput",
		days:"IntFilter",
		discount:"FloatNullableFilter",
		payableRent:"FloatFilter",
		subtotal:"FloatFilter",
		rentPerDay:"IntFilter",
		serviceCharge:"FloatFilter",
		totalRent:"IntFilter"
	},
	OrderSelectedDateCompositeFilter:{
		equals:"OrderSelectedDateObjectEqualityInput",
		is:"OrderSelectedDateWhereInput",
		isNot:"OrderSelectedDateWhereInput"
	},
	OrderSelectedDateObjectEqualityInput:{
		endDate:"DateTime",
		startDate:"DateTime"
	},
	OrderSelectedDateWhereInput:{
		AND:"OrderSelectedDateWhereInput",
		OR:"OrderSelectedDateWhereInput",
		NOT:"OrderSelectedDateWhereInput",
		endDate:"DateTimeFilter",
		startDate:"DateTimeFilter"
	},
	DateTimeFilter:{
		equals:"DateTime",
		in:"DateTime",
		notIn:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		gt:"DateTime",
		gte:"DateTime",
		not:"NestedDateTimeFilter"
	},
	NestedDateTimeFilter:{
		equals:"DateTime",
		in:"DateTime",
		notIn:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		gt:"DateTime",
		gte:"DateTime",
		not:"NestedDateTimeFilter"
	},
	BusinessCategoryRelationFilter:{
		is:"BusinessCategoryWhereInput",
		isNot:"BusinessCategoryWhereInput"
	},
	UserRelationFilter:{
		is:"UserWhereInput",
		isNot:"UserWhereInput"
	},
	UserWhereInput:{
		AND:"UserWhereInput",
		OR:"UserWhereInput",
		NOT:"UserWhereInput",
		id:"StringFilter",
		uid:"StringNullableFilter",
		email:"StringFilter",
		image:"StringNullableFilter",
		phoneNumber:"StringNullableFilter",
		displayName:"StringNullableFilter",
		otherDetails:"JsonNullableFilter",
		stripe:"UserStripeNullableCompositeFilter",
		roles:"EnumRoleNullableListFilter",
		refunds:"BookingRefundObjectEqualityInput",
		sharedBookingIds:"StringNullableListFilter",
		disclaimerAccepted:"BoolFilter",
		notificationPreference:"NotificationPreferenceNullableCompositeFilter",
		leadWorkspaceIds:"StringNullableListFilter",
		bookings:"BookingListRelationFilter",
		createdFiles:"FileListRelationFilter",
		updatedFiles:"FileListRelationFilter",
		orders:"OrderListRelationFilter",
		changelogs:"ChangelogListRelationFilter",
		adBoards:"AdBoardListRelationFilter",
		audits:"AuditListRelationFilter",
		campaigns:"CampaignListRelationFilter",
		sharedBookings:"BookingListRelationFilter",
		memberships:"MembershipListRelationFilter",
		notifications:"NotificationListRelationFilter",
		publishAdboardVersion:"AdBoardPublishHistoryListRelationFilter",
		reviewComments:"AdBoardReviewCommentListRelationFilter",
		archivedAdboards:"AdBoardListRelationFilter",
		ownedWorkspaces:"WorkspaceListRelationFilter",
		leadWorspaces:"WorkspaceListRelationFilter",
		publicReviews:"AdBoardPublicReviewListRelationFilter",
		userPositions:"UserPositionListRelationFilter",
		wishlists:"WishlistListRelationFilter",
		deletedPlayerIds:"PlayerListRelationFilter",
		deployedContentVersions:"ContentVersionListRelationFilter",
		submittedContentVersions:"ContentVersionListRelationFilter",
		approvedContentVersions:"ContentVersionListRelationFilter"
	},
	UserStripeNullableCompositeFilter:{
		equals:"UserStripeObjectEqualityInput",
		is:"UserStripeWhereInput",
		isNot:"UserStripeWhereInput"
	},
	UserStripeObjectEqualityInput:{

	},
	UserStripeWhereInput:{
		AND:"UserStripeWhereInput",
		OR:"UserStripeWhereInput",
		NOT:"UserStripeWhereInput",
		customerId:"StringFilter"
	},
	EnumRoleNullableListFilter:{
		equals:"Role",
		has:"Role",
		hasEvery:"Role",
		hasSome:"Role"
	},
	Role: "enum" as const,
	BookingRefundObjectEqualityInput:{
		razorpay:"JSON",
		stripe:"JSON"
	},
	NotificationPreferenceNullableCompositeFilter:{
		equals:"NotificationPreferenceObjectEqualityInput",
		is:"NotificationPreferenceWhereInput",
		isNot:"NotificationPreferenceWhereInput"
	},
	NotificationPreferenceObjectEqualityInput:{
		type:"NotificationType",
		channels:"NotificationChannel",
		pushSetting:"PushSettingObjectEqualityInput"
	},
	NotificationType: "enum" as const,
	NotificationChannel: "enum" as const,
	PushSettingObjectEqualityInput:{

	},
	NotificationPreferenceWhereInput:{
		AND:"NotificationPreferenceWhereInput",
		OR:"NotificationPreferenceWhereInput",
		NOT:"NotificationPreferenceWhereInput",
		type:"EnumNotificationTypeNullableListFilter",
		channels:"EnumNotificationChannelNullableListFilter",
		pushSetting:"PushSettingNullableCompositeFilter",
		enabled:"BoolFilter"
	},
	EnumNotificationTypeNullableListFilter:{
		equals:"NotificationType",
		has:"NotificationType",
		hasEvery:"NotificationType",
		hasSome:"NotificationType"
	},
	EnumNotificationChannelNullableListFilter:{
		equals:"NotificationChannel",
		has:"NotificationChannel",
		hasEvery:"NotificationChannel",
		hasSome:"NotificationChannel"
	},
	PushSettingNullableCompositeFilter:{
		equals:"PushSettingObjectEqualityInput",
		is:"PushSettingWhereInput",
		isNot:"PushSettingWhereInput"
	},
	PushSettingWhereInput:{
		AND:"PushSettingWhereInput",
		OR:"PushSettingWhereInput",
		NOT:"PushSettingWhereInput",
		fcmTokens:"StringNullableListFilter"
	},
	BookingListRelationFilter:{
		every:"BookingWhereInput",
		some:"BookingWhereInput",
		none:"BookingWhereInput"
	},
	BookingWhereInput:{
		AND:"BookingWhereInput",
		OR:"BookingWhereInput",
		NOT:"BookingWhereInput",
		id:"StringFilter",
		additionalInformation:"StringNullableFilter",
		origin:"StringNullableFilter",
		bookingCode:"StringFilter",
		bookingDate:"DateTimeFilter",
		bookingFor:"StringFilter",
		purpose:"StringFilter",
		adBoardId:"StringFilter",
		workspaceId:"StringNullableFilter",
		campaignId:"StringNullableFilter",
		businessCategoryId:"StringNullableFilter",
		adCategoryId:"StringNullableListFilter",
		bookingDetails:"BookingUserDetailsCompositeFilter",
		bookingStatus:"EnumBookingStatusFilter",
		paymentStatus:"EnumPaymentStatusNullableFilter",
		deploymentStatus:"EnumDeploymentStatusFilter",
		assetsIDs:"StringNullableListFilter",
		currentDeployedVersionId:"StringNullableFilter",
		selectedDates:"OrderSelectedDateCompositeFilter",
		payment:"BookingPaymentNullableCompositeFilter",
		priceSummary:"PriceSummaryNullableCompositeFilter",
		pisignage:"BookingPisignageDataNullableCompositeFilter",
		userId:"StringFilter",
		sharedUserIds:"StringNullableListFilter",
		isOffline:"BoolFilter",
		isEnquiry:"BoolFilter",
		isPaid:"BoolFilter",
		enquiryDate:"DateTimeNullableFilter",
		approvalDate:"DateTimeNullableFilter",
		paymentDate:"DateTimeNullableFilter",
		confirmationDate:"DateTimeNullableFilter",
		contentScheduledDate:"DateTimeNullableFilter",
		contentLiveDate:"DateTimeNullableFilter",
		completionDate:"DateTimeNullableFilter",
		refundStatus:"EnumRefundStatusFilter",
		businessCategory:"BusinessCategoryNullableRelationFilter",
		adCategory:"AdvertisementCategoryListRelationFilter",
		assets:"FileListRelationFilter",
		contentVersions:"ContentVersionListRelationFilter",
		paymentAllocations:"PaymentAllocationListRelationFilter",
		proofs:"FileListRelationFilter",
		user:"UserRelationFilter",
		adBoard:"AdBoardRelationFilter",
		changelogs:"ChangelogListRelationFilter",
		workspace:"WorkspaceNullableRelationFilter",
		campaign:"CampaignNullableRelationFilter",
		payouts:"PayoutListRelationFilter",
		sharedUsers:"UserListRelationFilter",
		slotUsage:"SlotUsageListRelationFilter",
		review:"AdBoardPublicReviewNullableRelationFilter",
		history:"BookingHistoryListRelationFilter",
		refundRequest:"RefundRequestNullableRelationFilter",
		refundApproval:"RefundApprovalNullableRelationFilter",
		refundProcessed:"RefundProcessedNullableRelationFilter"
	},
	BookingUserDetailsCompositeFilter:{
		equals:"BookingUserDetailsObjectEqualityInput",
		is:"BookingUserDetailsWhereInput",
		isNot:"BookingUserDetailsWhereInput"
	},
	BookingUserDetailsObjectEqualityInput:{

	},
	BookingUserDetailsWhereInput:{
		AND:"BookingUserDetailsWhereInput",
		OR:"BookingUserDetailsWhereInput",
		NOT:"BookingUserDetailsWhereInput",
		email:"StringFilter",
		name:"StringFilter",
		phone:"StringNullableFilter"
	},
	EnumBookingStatusFilter:{
		equals:"BookingStatus",
		in:"BookingStatus",
		notIn:"BookingStatus",
		not:"NestedEnumBookingStatusFilter"
	},
	BookingStatus: "enum" as const,
	NestedEnumBookingStatusFilter:{
		equals:"BookingStatus",
		in:"BookingStatus",
		notIn:"BookingStatus",
		not:"NestedEnumBookingStatusFilter"
	},
	EnumPaymentStatusNullableFilter:{
		equals:"PaymentStatus",
		in:"PaymentStatus",
		notIn:"PaymentStatus",
		not:"NestedEnumPaymentStatusNullableFilter"
	},
	NestedEnumPaymentStatusNullableFilter:{
		equals:"PaymentStatus",
		in:"PaymentStatus",
		notIn:"PaymentStatus",
		not:"NestedEnumPaymentStatusNullableFilter"
	},
	EnumDeploymentStatusFilter:{
		equals:"DeploymentStatus",
		in:"DeploymentStatus",
		notIn:"DeploymentStatus",
		not:"NestedEnumDeploymentStatusFilter"
	},
	DeploymentStatus: "enum" as const,
	NestedEnumDeploymentStatusFilter:{
		equals:"DeploymentStatus",
		in:"DeploymentStatus",
		notIn:"DeploymentStatus",
		not:"NestedEnumDeploymentStatusFilter"
	},
	BookingPisignageDataNullableCompositeFilter:{
		equals:"BookingPisignageDataObjectEqualityInput",
		is:"BookingPisignageDataWhereInput",
		isNot:"BookingPisignageDataWhereInput"
	},
	BookingPisignageDataObjectEqualityInput:{

	},
	BookingPisignageDataWhereInput:{
		AND:"BookingPisignageDataWhereInput",
		OR:"BookingPisignageDataWhereInput",
		NOT:"BookingPisignageDataWhereInput",
		deployedFileName:"StringNullableFilter",
		playlistId:"StringNullableFilter"
	},
	EnumRefundStatusFilter:{
		equals:"RefundStatus",
		in:"RefundStatus",
		notIn:"RefundStatus",
		not:"NestedEnumRefundStatusFilter"
	},
	RefundStatus: "enum" as const,
	NestedEnumRefundStatusFilter:{
		equals:"RefundStatus",
		in:"RefundStatus",
		notIn:"RefundStatus",
		not:"NestedEnumRefundStatusFilter"
	},
	AdvertisementCategoryListRelationFilter:{
		every:"AdvertisementCategoryWhereInput",
		some:"AdvertisementCategoryWhereInput",
		none:"AdvertisementCategoryWhereInput"
	},
	AdvertisementCategoryWhereInput:{
		AND:"AdvertisementCategoryWhereInput",
		OR:"AdvertisementCategoryWhereInput",
		NOT:"AdvertisementCategoryWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		type:"EnumAdvertisementCategoryEnumFilter",
		description:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		campaignIds:"StringNullableListFilter",
		bookingIds:"StringNullableListFilter",
		campaigns:"CampaignListRelationFilter",
		bookings:"BookingListRelationFilter"
	},
	EnumAdvertisementCategoryEnumFilter:{
		equals:"AdvertisementCategoryEnum",
		in:"AdvertisementCategoryEnum",
		notIn:"AdvertisementCategoryEnum",
		not:"NestedEnumAdvertisementCategoryEnumFilter"
	},
	AdvertisementCategoryEnum: "enum" as const,
	NestedEnumAdvertisementCategoryEnumFilter:{
		equals:"AdvertisementCategoryEnum",
		in:"AdvertisementCategoryEnum",
		notIn:"AdvertisementCategoryEnum",
		not:"NestedEnumAdvertisementCategoryEnumFilter"
	},
	FileListRelationFilter:{
		every:"FileWhereInput",
		some:"FileWhereInput",
		none:"FileWhereInput"
	},
	FileWhereInput:{
		AND:"FileWhereInput",
		OR:"FileWhereInput",
		NOT:"FileWhereInput",
		id:"StringFilter",
		contentType:"StringFilter",
		ctime:"StringNullableFilter",
		filename:"StringFilter",
		filepath:"StringNullableFilter",
		isDirectory:"BoolFilter",
		meta:"FileMetaCompositeFilter",
		mtime:"StringFilter",
		name:"StringFilter",
		size:"IntFilter",
		status:"EnumFileStatusNullableFilter",
		type:"StringFilter",
		updatedAt:"DateTimeFilter",
		createdAt:"DateTimeFilter",
		updatedByUserId:"StringNullableFilter",
		createdByUserId:"StringFilter",
		url:"StringFilter",
		bookingsIDs:"StringNullableListFilter",
		workspaceId:"StringNullableFilter",
		proofBookingId:"StringNullableFilter",
		campaignIds:"StringNullableListFilter",
		contentVersionId:"StringNullableListFilter",
		updatedBy:"UserNullableRelationFilter",
		createdBy:"UserRelationFilter",
		bookings:"BookingListRelationFilter",
		workspace:"WorkspaceNullableRelationFilter",
		proofBooking:"BookingNullableRelationFilter",
		campaigns:"CampaignListRelationFilter",
		contentVersions:"ContentVersionListRelationFilter"
	},
	FileMetaCompositeFilter:{
		equals:"FileMetaObjectEqualityInput",
		is:"FileMetaWhereInput",
		isNot:"FileMetaWhereInput"
	},
	FileMetaObjectEqualityInput:{

	},
	FileMetaWhereInput:{
		AND:"FileMetaWhereInput",
		OR:"FileMetaWhereInput",
		NOT:"FileMetaWhereInput",
		duration:"FloatFilter",
		height:"IntFilter",
		width:"IntFilter"
	},
	EnumFileStatusNullableFilter:{
		equals:"FileStatus",
		in:"FileStatus",
		notIn:"FileStatus",
		not:"NestedEnumFileStatusNullableFilter"
	},
	FileStatus: "enum" as const,
	NestedEnumFileStatusNullableFilter:{
		equals:"FileStatus",
		in:"FileStatus",
		notIn:"FileStatus",
		not:"NestedEnumFileStatusNullableFilter"
	},
	UserNullableRelationFilter:{
		is:"UserWhereInput",
		isNot:"UserWhereInput"
	},
	WorkspaceNullableRelationFilter:{
		is:"WorkspaceWhereInput",
		isNot:"WorkspaceWhereInput"
	},
	WorkspaceWhereInput:{
		AND:"WorkspaceWhereInput",
		OR:"WorkspaceWhereInput",
		NOT:"WorkspaceWhereInput",
		id:"StringFilter",
		type:"EnumWorkspaceTypeFilter",
		name:"StringFilter",
		key:"StringFilter",
		userIds:"StringNullableListFilter",
		ownerId:"StringNullableFilter",
		avatar:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		stripeSubscriptionId:"StringNullableFilter",
		leadIds:"StringNullableListFilter",
		webhookAppId:"StringNullableFilter",
		stackAuthTeamId:"StringNullableFilter",
		owner:"UserNullableRelationFilter",
		memberships:"MembershipListRelationFilter",
		adBoards:"AdBoardListRelationFilter",
		playlists:"PlaylistListRelationFilter",
		adBoardGroups:"AdBoardGroupListRelationFilter",
		audits:"AuditListRelationFilter",
		bookings:"BookingListRelationFilter",
		files:"FileListRelationFilter",
		players:"PlayerListRelationFilter",
		transactions:"TransactionListRelationFilter",
		activeSubscription:"SubscriptionNullableRelationFilter",
		workspaceRoles:"WorkspaceRoleListRelationFilter",
		leads:"UserListRelationFilter",
		cameras:"CameraListRelationFilter",
		cameraStreamingDevices:"StreamingDeviceListRelationFilter"
	},
	EnumWorkspaceTypeFilter:{
		equals:"WorkspaceType",
		in:"WorkspaceType",
		notIn:"WorkspaceType",
		not:"NestedEnumWorkspaceTypeFilter"
	},
	WorkspaceType: "enum" as const,
	NestedEnumWorkspaceTypeFilter:{
		equals:"WorkspaceType",
		in:"WorkspaceType",
		notIn:"WorkspaceType",
		not:"NestedEnumWorkspaceTypeFilter"
	},
	MembershipListRelationFilter:{
		every:"MembershipWhereInput",
		some:"MembershipWhereInput",
		none:"MembershipWhereInput"
	},
	MembershipWhereInput:{
		AND:"MembershipWhereInput",
		OR:"MembershipWhereInput",
		NOT:"MembershipWhereInput",
		id:"StringFilter",
		createdAt:"DateTimeFilter",
		userId:"StringFilter",
		workspaceId:"StringFilter",
		roleId:"StringFilter",
		user:"UserRelationFilter",
		workspace:"WorkspaceRelationFilter",
		role:"WorkspaceRoleRelationFilter"
	},
	WorkspaceRelationFilter:{
		is:"WorkspaceWhereInput",
		isNot:"WorkspaceWhereInput"
	},
	WorkspaceRoleRelationFilter:{
		is:"WorkspaceRoleWhereInput",
		isNot:"WorkspaceRoleWhereInput"
	},
	WorkspaceRoleWhereInput:{
		AND:"WorkspaceRoleWhereInput",
		OR:"WorkspaceRoleWhereInput",
		NOT:"WorkspaceRoleWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		permissions:"EnumPermissionNullableListFilter",
		workspaceId:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		workspace:"WorkspaceNullableRelationFilter",
		memberships:"MembershipListRelationFilter"
	},
	EnumPermissionNullableListFilter:{
		equals:"Permission",
		has:"Permission",
		hasEvery:"Permission",
		hasSome:"Permission"
	},
	Permission: "enum" as const,
	PlaylistListRelationFilter:{
		every:"PlaylistWhereInput",
		some:"PlaylistWhereInput",
		none:"PlaylistWhereInput"
	},
	PlaylistWhereInput:{
		AND:"PlaylistWhereInput",
		OR:"PlaylistWhereInput",
		NOT:"PlaylistWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		displayName:"StringNullableFilter",
		assets:"PisignageFileObjectEqualityInput",
		isAdsPlaylist:"BoolNullableFilter",
		footerPlaylistId:"StringNullableFilter",
		sidebarPlaylistId:"StringNullableFilter",
		layout:"EnumScreenLayoutFilter",
		isDeployed:"BoolNullableFilter",
		adBoardGroupIds:"StringNullableListFilter",
		workspaceId:"StringFilter",
		footerPlaylist:"PlaylistNullableRelationFilter",
		sidebarPlaylist:"PlaylistNullableRelationFilter",
		adBoardGroupsForAds:"AdBoardGroupListRelationFilter",
		adBoardGroups:"AdBoardGroupListRelationFilter",
		workspace:"WorkspaceRelationFilter",
		footerParentPlaylists:"PlaylistListRelationFilter",
		sidebarParentPlaylists:"PlaylistListRelationFilter"
	},
	PisignageFileObjectEqualityInput:{

	},
	BoolNullableFilter:{
		not:"NestedBoolNullableFilter"
	},
	NestedBoolNullableFilter:{
		not:"NestedBoolNullableFilter"
	},
	EnumScreenLayoutFilter:{
		equals:"ScreenLayout",
		in:"ScreenLayout",
		notIn:"ScreenLayout",
		not:"NestedEnumScreenLayoutFilter"
	},
	ScreenLayout: "enum" as const,
	NestedEnumScreenLayoutFilter:{
		equals:"ScreenLayout",
		in:"ScreenLayout",
		notIn:"ScreenLayout",
		not:"NestedEnumScreenLayoutFilter"
	},
	PlaylistNullableRelationFilter:{
		is:"PlaylistWhereInput",
		isNot:"PlaylistWhereInput"
	},
	AdBoardGroupListRelationFilter:{
		every:"AdBoardGroupWhereInput",
		some:"AdBoardGroupWhereInput",
		none:"AdBoardGroupWhereInput"
	},
	AdBoardGroupWhereInput:{
		AND:"AdBoardGroupWhereInput",
		OR:"AdBoardGroupWhereInput",
		NOT:"AdBoardGroupWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		adBoardId:"StringNullableFilter",
		schedules:"ScheduleObjectEqualityInput",
		scheduledPlaylistsIDs:"StringNullableListFilter",
		adsPlaylistID:"StringNullableFilter",
		pisignageGroupId:"StringFilter",
		fitImage:"EnumFitTypeFilter",
		fitVideo:"EnumFitTypeFilter",
		workspaceId:"StringFilter",
		adBoard:"AdBoardNullableRelationFilter",
		scheduledPlaylists:"PlaylistListRelationFilter",
		adsPlaylist:"PlaylistNullableRelationFilter",
		pisignagePlayers:"PlayerListRelationFilter",
		workspace:"WorkspaceRelationFilter"
	},
	ScheduleObjectEqualityInput:{

	},
	EnumFitTypeFilter:{
		equals:"FitType",
		in:"FitType",
		notIn:"FitType",
		not:"NestedEnumFitTypeFilter"
	},
	FitType: "enum" as const,
	NestedEnumFitTypeFilter:{
		equals:"FitType",
		in:"FitType",
		notIn:"FitType",
		not:"NestedEnumFitTypeFilter"
	},
	AdBoardNullableRelationFilter:{
		is:"AdBoardWhereInput",
		isNot:"AdBoardWhereInput"
	},
	PlayerListRelationFilter:{
		every:"PlayerWhereInput",
		some:"PlayerWhereInput",
		none:"PlayerWhereInput"
	},
	PlayerWhereInput:{
		AND:"PlayerWhereInput",
		OR:"PlayerWhereInput",
		NOT:"PlayerWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		configLocation:"StringNullableFilter",
		pisignagePlayerId:"StringNullableFilter",
		pisignageGroupId:"StringNullableFilter",
		cpuSerialNumber:"StringNullableFilter",
		displayName:"StringNullableFilter",
		adBoardGroupId:"StringNullableFilter",
		playlistIds:"StringNullableListFilter",
		workpaceId:"StringNullableFilter",
		resolution:"ResolutionNullableCompositeFilter",
		screenSize:"ScreenSizeNullableCompositeFilter",
		signageTypeId:"StringNullableFilter",
		audienceTypeId:"StringNullableListFilter",
		playbackDetails:"PlaybackTimeObjectEqualityInput",
		aspectRatioType:"EnumAspectRatioTypeFilter",
		customAspectRatioWidth:"IntNullableFilter",
		customAspectRatioHeight:"IntNullableFilter",
		map:"MapNullableCompositeFilter",
		isOnline:"BoolFilter",
		adBoardIds:"StringNullableListFilter",
		galleryFiles:"GalleryFileObjectEqualityInput",
		createdAt:"DateTimeNullableFilter",
		updatedAt:"DateTimeNullableFilter",
		markForDeletion:"BoolFilter",
		deletedAt:"DateTimeNullableFilter",
		deletedByUserId:"StringNullableFilter",
		visible:"BoolFilter",
		adBoardGroup:"AdBoardGroupNullableRelationFilter",
		workspace:"WorkspaceNullableRelationFilter",
		status:"PlayerUptimeStatusListRelationFilter",
		cameras:"CameraListRelationFilter",
		signageType:"DigitalSignageNullableRelationFilter",
		audienceType:"AudienceListRelationFilter",
		adBoards:"AdBoardListRelationFilter",
		deletedBy:"UserNullableRelationFilter",
		cameraStreamingDevices:"StreamingDeviceListRelationFilter"
	},
	EnumAspectRatioTypeFilter:{
		equals:"AspectRatioType",
		in:"AspectRatioType",
		notIn:"AspectRatioType",
		not:"NestedEnumAspectRatioTypeFilter"
	},
	AspectRatioType: "enum" as const,
	NestedEnumAspectRatioTypeFilter:{
		equals:"AspectRatioType",
		in:"AspectRatioType",
		notIn:"AspectRatioType",
		not:"NestedEnumAspectRatioTypeFilter"
	},
	MapNullableCompositeFilter:{
		equals:"MapObjectEqualityInput",
		is:"MapWhereInput",
		isNot:"MapWhereInput"
	},
	MapObjectEqualityInput:{

	},
	MapWhereInput:{
		AND:"MapWhereInput",
		OR:"MapWhereInput",
		NOT:"MapWhereInput",
		lat:"FloatFilter",
		lng:"FloatFilter",
		address:"StringNullableFilter",
		city:"StringNullableFilter",
		state:"StringNullableFilter",
		country:"StringNullableFilter"
	},
	GalleryFileObjectEqualityInput:{

	},
	AdBoardGroupNullableRelationFilter:{
		is:"AdBoardGroupWhereInput",
		isNot:"AdBoardGroupWhereInput"
	},
	PlayerUptimeStatusListRelationFilter:{
		every:"PlayerUptimeStatusWhereInput",
		some:"PlayerUptimeStatusWhereInput",
		none:"PlayerUptimeStatusWhereInput"
	},
	PlayerUptimeStatusWhereInput:{
		AND:"PlayerUptimeStatusWhereInput",
		OR:"PlayerUptimeStatusWhereInput",
		NOT:"PlayerUptimeStatusWhereInput",
		id:"StringFilter",
		playerId:"StringFilter",
		cpuSerialNumber:"StringFilter",
		date:"StringFilter",
		uptime:"FloatFilter",
		player:"PlayerRelationFilter"
	},
	PlayerRelationFilter:{
		is:"PlayerWhereInput",
		isNot:"PlayerWhereInput"
	},
	CameraListRelationFilter:{
		every:"CameraWhereInput",
		some:"CameraWhereInput",
		none:"CameraWhereInput"
	},
	CameraWhereInput:{
		AND:"CameraWhereInput",
		OR:"CameraWhereInput",
		NOT:"CameraWhereInput",
		id:"StringFilter",
		name:"StringNullableFilter",
		isOnline:"BoolFilter",
		playerId:"StringNullableFilter",
		workspaceId:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		isPublic:"BoolFilter",
		player:"PlayerNullableRelationFilter",
		workspace:"WorkspaceNullableRelationFilter"
	},
	PlayerNullableRelationFilter:{
		is:"PlayerWhereInput",
		isNot:"PlayerWhereInput"
	},
	DigitalSignageNullableRelationFilter:{
		is:"DigitalSignageWhereInput",
		isNot:"DigitalSignageWhereInput"
	},
	DigitalSignageWhereInput:{
		AND:"DigitalSignageWhereInput",
		OR:"DigitalSignageWhereInput",
		NOT:"DigitalSignageWhereInput",
		id:"StringFilter",
		type:"EnumSignageTypeFilter",
		name:"StringFilter",
		description:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		players:"PlayerListRelationFilter"
	},
	EnumSignageTypeFilter:{
		equals:"SignageType",
		in:"SignageType",
		notIn:"SignageType",
		not:"NestedEnumSignageTypeFilter"
	},
	SignageType: "enum" as const,
	NestedEnumSignageTypeFilter:{
		equals:"SignageType",
		in:"SignageType",
		notIn:"SignageType",
		not:"NestedEnumSignageTypeFilter"
	},
	AudienceListRelationFilter:{
		every:"AudienceWhereInput",
		some:"AudienceWhereInput",
		none:"AudienceWhereInput"
	},
	AudienceWhereInput:{
		AND:"AudienceWhereInput",
		OR:"AudienceWhereInput",
		NOT:"AudienceWhereInput",
		id:"StringFilter",
		type:"EnumAudienceTypeFilter",
		name:"StringFilter",
		description:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		playerIDs:"StringNullableListFilter",
		players:"PlayerListRelationFilter"
	},
	EnumAudienceTypeFilter:{
		equals:"AudienceType",
		in:"AudienceType",
		notIn:"AudienceType",
		not:"NestedEnumAudienceTypeFilter"
	},
	AudienceType: "enum" as const,
	NestedEnumAudienceTypeFilter:{
		equals:"AudienceType",
		in:"AudienceType",
		notIn:"AudienceType",
		not:"NestedEnumAudienceTypeFilter"
	},
	StreamingDeviceListRelationFilter:{
		every:"StreamingDeviceWhereInput",
		some:"StreamingDeviceWhereInput",
		none:"StreamingDeviceWhereInput"
	},
	StreamingDeviceWhereInput:{
		AND:"StreamingDeviceWhereInput",
		OR:"StreamingDeviceWhereInput",
		NOT:"StreamingDeviceWhereInput",
		id:"StringFilter",
		name:"StringNullableFilter",
		deviceId:"StringFilter",
		socketId:"StringNullableFilter",
		isConnected:"BoolNullableFilter",
		playerId:"StringNullableFilter",
		connectionLogs:"ConnectionLogObjectEqualityInput",
		workspaceId:"StringNullableFilter",
		billboardMonitoring:"BillboardMonitoringNullableCompositeFilter",
		trafficMonitoring:"TrafficMonitoringNullableCompositeFilter",
		rtspStreamUrl:"StringNullableFilter",
		publicWebUrl:"StringNullableFilter",
		services:"StreamingServicesNullableCompositeFilter",
		player:"PlayerNullableRelationFilter",
		workspace:"WorkspaceNullableRelationFilter",
		billboardMonitoringAlerts:"BillboardMonitoringAlertListRelationFilter"
	},
	ConnectionLogObjectEqualityInput:{
		timestamp:"DateTime",
		data:"JSON"
	},
	BillboardMonitoringNullableCompositeFilter:{
		equals:"BillboardMonitoringObjectEqualityInput",
		is:"BillboardMonitoringWhereInput",
		isNot:"BillboardMonitoringWhereInput"
	},
	BillboardMonitoringObjectEqualityInput:{
		alertConfigs:"AlertConfigObjectEqualityInput"
	},
	AlertConfigObjectEqualityInput:{
		channel:"AlertChannel"
	},
	AlertChannel: "enum" as const,
	BillboardMonitoringWhereInput:{
		AND:"BillboardMonitoringWhereInput",
		OR:"BillboardMonitoringWhereInput",
		NOT:"BillboardMonitoringWhereInput",
		customInstructions:"StringNullableFilter",
		rtspStreamUrl:"StringNullableFilter",
		aiApiKey:"StringNullableFilter",
		apiCallInterval:"FloatNullableFilter",
		publicWebUrl:"StringNullableFilter",
		alertsEnabled:"BoolNullableFilter",
		alertConfigs:"AlertConfigObjectEqualityInput"
	},
	TrafficMonitoringNullableCompositeFilter:{
		equals:"TrafficMonitoringObjectEqualityInput",
		is:"TrafficMonitoringWhereInput",
		isNot:"TrafficMonitoringWhereInput"
	},
	TrafficMonitoringObjectEqualityInput:{
		metadata:"JSON"
	},
	TrafficMonitoringWhereInput:{
		AND:"TrafficMonitoringWhereInput",
		OR:"TrafficMonitoringWhereInput",
		NOT:"TrafficMonitoringWhereInput",
		enabled:"BoolFilter",
		rtspStreamUrl:"StringNullableFilter",
		metadata:"JsonNullableFilter",
		inferenceInterval:"FloatNullableFilter",
		longStayThreshold:"IntNullableFilter",
		apiEndpoint:"StringNullableFilter",
		batchSize:"IntNullableFilter",
		apiCallInterval:"IntNullableFilter"
	},
	StreamingServicesNullableCompositeFilter:{
		equals:"StreamingServicesObjectEqualityInput",
		is:"StreamingServicesWhereInput",
		isNot:"StreamingServicesWhereInput"
	},
	StreamingServicesObjectEqualityInput:{
		billboardMonitoring:"BillboardMonitoringObjectEqualityInput",
		trafficMonitoring:"TrafficMonitoringObjectEqualityInput"
	},
	StreamingServicesWhereInput:{
		AND:"StreamingServicesWhereInput",
		OR:"StreamingServicesWhereInput",
		NOT:"StreamingServicesWhereInput",
		billboardMonitoring:"BillboardMonitoringNullableCompositeFilter",
		trafficMonitoring:"TrafficMonitoringNullableCompositeFilter",
		rtspStreamUrl:"StringNullableFilter",
		publicWebUrl:"StringNullableFilter"
	},
	BillboardMonitoringAlertListRelationFilter:{
		every:"BillboardMonitoringAlertWhereInput",
		some:"BillboardMonitoringAlertWhereInput",
		none:"BillboardMonitoringAlertWhereInput"
	},
	BillboardMonitoringAlertWhereInput:{
		AND:"BillboardMonitoringAlertWhereInput",
		OR:"BillboardMonitoringAlertWhereInput",
		NOT:"BillboardMonitoringAlertWhereInput",
		id:"StringFilter",
		startTime:"DateTimeFilter",
		endTime:"DateTimeNullableFilter",
		isActive:"BoolFilter",
		isFalsePositive:"BoolFilter",
		enabledAlerts:"AlertConfigObjectEqualityInput",
		streamingDeviceId:"StringFilter",
		streamingDevice:"StreamingDeviceRelationFilter"
	},
	StreamingDeviceRelationFilter:{
		is:"StreamingDeviceWhereInput",
		isNot:"StreamingDeviceWhereInput"
	},
	AuditListRelationFilter:{
		every:"AuditWhereInput",
		some:"AuditWhereInput",
		none:"AuditWhereInput"
	},
	AuditWhereInput:{
		AND:"AuditWhereInput",
		OR:"AuditWhereInput",
		NOT:"AuditWhereInput",
		id:"StringFilter",
		createdAt:"DateTimeFilter",
		message:"StringFilter",
		action:"StringFilter",
		entity:"EntityNullableCompositeFilter",
		userId:"StringFilter",
		workspaceId:"StringNullableFilter",
		updates:"JsonNullableFilter",
		user:"UserRelationFilter",
		workspace:"WorkspaceNullableRelationFilter"
	},
	EntityNullableCompositeFilter:{
		equals:"EntityObjectEqualityInput",
		is:"EntityWhereInput",
		isNot:"EntityWhereInput"
	},
	EntityObjectEqualityInput:{

	},
	EntityWhereInput:{
		AND:"EntityWhereInput",
		OR:"EntityWhereInput",
		NOT:"EntityWhereInput",
		type:"StringFilter",
		id:"StringFilter",
		name:"StringNullableFilter"
	},
	TransactionListRelationFilter:{
		every:"TransactionWhereInput",
		some:"TransactionWhereInput",
		none:"TransactionWhereInput"
	},
	TransactionWhereInput:{
		AND:"TransactionWhereInput",
		OR:"TransactionWhereInput",
		NOT:"TransactionWhereInput",
		workspaceId:"StringNullableFilter",
		id:"StringFilter",
		amount:"FloatFilter",
		createAt:"DateTimeFilter",
		processedAt:"DateTimeNullableFilter",
		relatedEntityId:"StringFilter",
		transactionStatus:"EnumTransactionStatusFilter",
		details:"JsonNullableFilter",
		workspace:"WorkspaceNullableRelationFilter",
		payouts:"PayoutListRelationFilter"
	},
	EnumTransactionStatusFilter:{
		equals:"TransactionStatus",
		in:"TransactionStatus",
		notIn:"TransactionStatus",
		not:"NestedEnumTransactionStatusFilter"
	},
	TransactionStatus: "enum" as const,
	NestedEnumTransactionStatusFilter:{
		equals:"TransactionStatus",
		in:"TransactionStatus",
		notIn:"TransactionStatus",
		not:"NestedEnumTransactionStatusFilter"
	},
	PayoutListRelationFilter:{
		every:"PayoutWhereInput",
		some:"PayoutWhereInput",
		none:"PayoutWhereInput"
	},
	PayoutWhereInput:{
		AND:"PayoutWhereInput",
		OR:"PayoutWhereInput",
		NOT:"PayoutWhereInput",
		id:"StringFilter",
		totalAmount:"FloatFilter",
		commissionRate:"FloatFilter",
		commissionAmount:"FloatFilter",
		netAmount:"FloatFilter",
		createdAt:"DateTimeFilter",
		bookingId:"StringFilter",
		status:"EnumPayoutStatusFilter",
		transactionId:"StringNullableFilter",
		booking:"BookingRelationFilter",
		transaction:"TransactionNullableRelationFilter"
	},
	EnumPayoutStatusFilter:{
		equals:"PayoutStatus",
		in:"PayoutStatus",
		notIn:"PayoutStatus",
		not:"NestedEnumPayoutStatusFilter"
	},
	PayoutStatus: "enum" as const,
	NestedEnumPayoutStatusFilter:{
		equals:"PayoutStatus",
		in:"PayoutStatus",
		notIn:"PayoutStatus",
		not:"NestedEnumPayoutStatusFilter"
	},
	BookingRelationFilter:{
		is:"BookingWhereInput",
		isNot:"BookingWhereInput"
	},
	TransactionNullableRelationFilter:{
		is:"TransactionWhereInput",
		isNot:"TransactionWhereInput"
	},
	SubscriptionNullableRelationFilter:{
		is:"SubscriptionWhereInput",
		isNot:"SubscriptionWhereInput"
	},
	SubscriptionWhereInput:{
		AND:"SubscriptionWhereInput",
		OR:"SubscriptionWhereInput",
		NOT:"SubscriptionWhereInput",
		id:"StringFilter",
		packageId:"StringNullableFilter",
		packageName:"StringNullableFilter",
		priceLookupKey:"StringNullableFilter",
		startDate:"DateTimeNullableFilter",
		endDate:"DateTimeNullableFilter",
		status:"StringFilter",
		stripePaymentIntentId:"StringNullableFilter",
		stripeSubscriptionId:"StringFilter",
		stripeCheckoutSessionId:"StringFilter",
		cancellationDetails:"CancellationDetailsNullableCompositeFilter",
		activeWorkspaceId:"StringFilter",
		activeWorkspace:"WorkspaceRelationFilter"
	},
	CancellationDetailsNullableCompositeFilter:{
		equals:"CancellationDetailsObjectEqualityInput",
		is:"CancellationDetailsWhereInput",
		isNot:"CancellationDetailsWhereInput"
	},
	CancellationDetailsObjectEqualityInput:{
		canceledAt:"DateTime",
		cancelAt:"DateTime"
	},
	CancellationDetailsWhereInput:{
		AND:"CancellationDetailsWhereInput",
		OR:"CancellationDetailsWhereInput",
		NOT:"CancellationDetailsWhereInput",
		canceledAt:"DateTimeNullableFilter",
		cancelAt:"DateTimeNullableFilter",
		cancelAtPeriodEnd:"BoolFilter",
		reason:"StringNullableFilter"
	},
	WorkspaceRoleListRelationFilter:{
		every:"WorkspaceRoleWhereInput",
		some:"WorkspaceRoleWhereInput",
		none:"WorkspaceRoleWhereInput"
	},
	UserListRelationFilter:{
		every:"UserWhereInput",
		some:"UserWhereInput",
		none:"UserWhereInput"
	},
	BookingNullableRelationFilter:{
		is:"BookingWhereInput",
		isNot:"BookingWhereInput"
	},
	ContentVersionListRelationFilter:{
		every:"ContentVersionWhereInput",
		some:"ContentVersionWhereInput",
		none:"ContentVersionWhereInput"
	},
	ContentVersionWhereInput:{
		AND:"ContentVersionWhereInput",
		OR:"ContentVersionWhereInput",
		NOT:"ContentVersionWhereInput",
		id:"StringFilter",
		bookingId:"StringFilter",
		versionNumber:"IntFilter",
		status:"EnumContentApprovalStatusFilter",
		submittedAt:"DateTimeFilter",
		approvedAt:"DateTimeNullableFilter",
		deployedAt:"DateTimeNullableFilter",
		submittedByUserId:"StringFilter",
		approvedByUserId:"StringNullableFilter",
		deployedByUserId:"StringNullableFilter",
		assetIds:"StringNullableListFilter",
		comments:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		booking:"BookingRelationFilter",
		submittedBy:"UserRelationFilter",
		approvedBy:"UserNullableRelationFilter",
		deployedBy:"UserNullableRelationFilter",
		assets:"FileListRelationFilter"
	},
	EnumContentApprovalStatusFilter:{
		equals:"ContentApprovalStatus",
		in:"ContentApprovalStatus",
		notIn:"ContentApprovalStatus",
		not:"NestedEnumContentApprovalStatusFilter"
	},
	ContentApprovalStatus: "enum" as const,
	NestedEnumContentApprovalStatusFilter:{
		equals:"ContentApprovalStatus",
		in:"ContentApprovalStatus",
		notIn:"ContentApprovalStatus",
		not:"NestedEnumContentApprovalStatusFilter"
	},
	PaymentAllocationListRelationFilter:{
		every:"PaymentAllocationWhereInput",
		some:"PaymentAllocationWhereInput",
		none:"PaymentAllocationWhereInput"
	},
	PaymentAllocationWhereInput:{
		AND:"PaymentAllocationWhereInput",
		OR:"PaymentAllocationWhereInput",
		NOT:"PaymentAllocationWhereInput",
		id:"StringFilter",
		paymentId:"StringFilter",
		bookingId:"StringFilter",
		subtotal:"FloatFilter",
		tax:"FloatFilter",
		discount:"FloatFilter",
		total:"FloatFilter",
		payment:"PaymentRelationFilter",
		booking:"BookingRelationFilter"
	},
	PaymentRelationFilter:{
		is:"PaymentWhereInput",
		isNot:"PaymentWhereInput"
	},
	PaymentWhereInput:{
		AND:"PaymentWhereInput",
		OR:"PaymentWhereInput",
		NOT:"PaymentWhereInput",
		id:"StringFilter",
		paymentIntentId:"StringFilter",
		checkoutSessionId:"StringFilter",
		eventId:"StringFilter",
		liveMode:"BoolFilter",
		paymentGateway:"EnumPaymentGatewayNameFilter",
		subtotal:"FloatFilter",
		total:"FloatFilter",
		tax:"FloatFilter",
		discount:"FloatFilter",
		campaignId:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		campaign:"CampaignNullableRelationFilter",
		paymentAllocations:"PaymentAllocationListRelationFilter"
	},
	CampaignNullableRelationFilter:{
		is:"CampaignWhereInput",
		isNot:"CampaignWhereInput"
	},
	AdBoardRelationFilter:{
		is:"AdBoardWhereInput",
		isNot:"AdBoardWhereInput"
	},
	ChangelogListRelationFilter:{
		every:"ChangelogWhereInput",
		some:"ChangelogWhereInput",
		none:"ChangelogWhereInput"
	},
	ChangelogWhereInput:{
		AND:"ChangelogWhereInput",
		OR:"ChangelogWhereInput",
		NOT:"ChangelogWhereInput",
		id:"StringFilter",
		createdAt:"DateTimeFilter",
		message:"StringFilter",
		action:"StringFilter",
		bookingId:"StringNullableFilter",
		userId:"StringFilter",
		updates:"JsonNullableFilter",
		booking:"BookingNullableRelationFilter",
		user:"UserRelationFilter"
	},
	SlotUsageListRelationFilter:{
		every:"SlotUsageWhereInput",
		some:"SlotUsageWhereInput",
		none:"SlotUsageWhereInput"
	},
	SlotUsageWhereInput:{
		AND:"SlotUsageWhereInput",
		OR:"SlotUsageWhereInput",
		NOT:"SlotUsageWhereInput",
		id:"StringFilter",
		bookingId:"StringFilter",
		date:"DateTimeFilter",
		slotUsed:"IntFilter",
		booking:"BookingRelationFilter"
	},
	AdBoardPublicReviewNullableRelationFilter:{
		is:"AdBoardPublicReviewWhereInput",
		isNot:"AdBoardPublicReviewWhereInput"
	},
	AdBoardPublicReviewWhereInput:{
		AND:"AdBoardPublicReviewWhereInput",
		OR:"AdBoardPublicReviewWhereInput",
		NOT:"AdBoardPublicReviewWhereInput",
		id:"StringFilter",
		rating:"FloatFilter",
		title:"StringFilter",
		description:"StringFilter",
		isVerified:"BoolFilter",
		helpfulYes:"IntFilter",
		helpfulNo:"IntFilter",
		imageUrls:"StringNullableListFilter",
		adBoardId:"StringFilter",
		userId:"StringFilter",
		createdAt:"DateTimeFilter",
		bookingId:"StringFilter",
		adBoard:"AdBoardRelationFilter",
		user:"UserRelationFilter",
		booking:"BookingRelationFilter"
	},
	BookingHistoryListRelationFilter:{
		every:"BookingHistoryWhereInput",
		some:"BookingHistoryWhereInput",
		none:"BookingHistoryWhereInput"
	},
	BookingHistoryWhereInput:{
		AND:"BookingHistoryWhereInput",
		OR:"BookingHistoryWhereInput",
		NOT:"BookingHistoryWhereInput",
		id:"StringFilter",
		bookingId:"StringFilter",
		status:"EnumBookingStatusFilter",
		createdBy:"StringFilter",
		timestamp:"DateTimeFilter",
		booking:"BookingRelationFilter"
	},
	RefundRequestNullableRelationFilter:{
		is:"RefundRequestWhereInput",
		isNot:"RefundRequestWhereInput"
	},
	RefundRequestWhereInput:{
		AND:"RefundRequestWhereInput",
		OR:"RefundRequestWhereInput",
		NOT:"RefundRequestWhereInput",
		id:"StringFilter",
		bookingId:"StringFilter",
		requestedAt:"DateTimeFilter",
		requestedBy:"StringFilter",
		reason:"StringFilter",
		amountRequested:"FloatFilter",
		booking:"BookingRelationFilter"
	},
	RefundApprovalNullableRelationFilter:{
		is:"RefundApprovalWhereInput",
		isNot:"RefundApprovalWhereInput"
	},
	RefundApprovalWhereInput:{
		AND:"RefundApprovalWhereInput",
		OR:"RefundApprovalWhereInput",
		NOT:"RefundApprovalWhereInput",
		id:"StringFilter",
		bookingId:"StringFilter",
		approvedAt:"DateTimeFilter",
		approvedBy:"StringFilter",
		amountApproved:"FloatFilter",
		notes:"StringNullableFilter",
		booking:"BookingRelationFilter"
	},
	RefundProcessedNullableRelationFilter:{
		is:"RefundProcessedWhereInput",
		isNot:"RefundProcessedWhereInput"
	},
	RefundProcessedWhereInput:{
		AND:"RefundProcessedWhereInput",
		OR:"RefundProcessedWhereInput",
		NOT:"RefundProcessedWhereInput",
		id:"StringFilter",
		bookingId:"StringFilter",
		processedAt:"DateTimeFilter",
		paymentMethod:"EnumPaymentGatewayNameFilter",
		transactionId:"StringFilter",
		booking:"BookingRelationFilter"
	},
	OrderListRelationFilter:{
		every:"OrderWhereInput",
		some:"OrderWhereInput",
		none:"OrderWhereInput"
	},
	OrderWhereInput:{
		AND:"OrderWhereInput",
		OR:"OrderWhereInput",
		NOT:"OrderWhereInput",
		id:"StringFilter",
		adBoardId:"StringFilter",
		createdDate:"DateTimeFilter",
		createdByUserId:"StringNullableFilter",
		origin:"StringFilter",
		paymentId:"StringNullableFilter",
		priceSummary:"PriceSummaryCompositeFilter",
		selectedDate:"OrderSelectedDateCompositeFilter",
		adBoard:"AdBoardRelationFilter",
		createdBy:"UserNullableRelationFilter"
	},
	PriceSummaryCompositeFilter:{
		equals:"PriceSummaryObjectEqualityInput",
		is:"PriceSummaryWhereInput",
		isNot:"PriceSummaryWhereInput"
	},
	NotificationListRelationFilter:{
		every:"NotificationWhereInput",
		some:"NotificationWhereInput",
		none:"NotificationWhereInput"
	},
	NotificationWhereInput:{
		AND:"NotificationWhereInput",
		OR:"NotificationWhereInput",
		NOT:"NotificationWhereInput",
		id:"StringFilter",
		type:"EnumNotificationTypeFilter",
		title:"StringFilter",
		content:"StringFilter",
		metadata:"JsonNullableFilter",
		createdAt:"DateTimeFilter",
		readAt:"DateTimeNullableFilter",
		recipientId:"StringFilter",
		channels:"EnumNotificationChannelNullableListFilter",
		recipient:"UserRelationFilter"
	},
	EnumNotificationTypeFilter:{
		equals:"NotificationType",
		in:"NotificationType",
		notIn:"NotificationType",
		not:"NestedEnumNotificationTypeFilter"
	},
	NestedEnumNotificationTypeFilter:{
		equals:"NotificationType",
		in:"NotificationType",
		notIn:"NotificationType",
		not:"NestedEnumNotificationTypeFilter"
	},
	AdBoardPublishHistoryListRelationFilter:{
		every:"AdBoardPublishHistoryWhereInput",
		some:"AdBoardPublishHistoryWhereInput",
		none:"AdBoardPublishHistoryWhereInput"
	},
	AdBoardPublishHistoryWhereInput:{
		AND:"AdBoardPublishHistoryWhereInput",
		OR:"AdBoardPublishHistoryWhereInput",
		NOT:"AdBoardPublishHistoryWhereInput",
		id:"StringFilter",
		adBoardId:"StringFilter",
		publishedAt:"DateTimeFilter",
		publishedByUserId:"StringFilter",
		changesSnapshot:"JsonFilter",
		adBoard:"AdBoardRelationFilter",
		publishedBy:"UserRelationFilter"
	},
	JsonFilter:{
		equals:"JSON",
		not:"JSON"
	},
	AdBoardReviewCommentListRelationFilter:{
		every:"AdBoardReviewCommentWhereInput",
		some:"AdBoardReviewCommentWhereInput",
		none:"AdBoardReviewCommentWhereInput"
	},
	AdBoardReviewCommentWhereInput:{
		AND:"AdBoardReviewCommentWhereInput",
		OR:"AdBoardReviewCommentWhereInput",
		NOT:"AdBoardReviewCommentWhereInput",
		id:"StringFilter",
		adBoardId:"StringFilter",
		userId:"StringFilter",
		comment:"StringFilter",
		action:"EnumReviewActionFilter",
		createdAt:"DateTimeFilter",
		adBoard:"AdBoardRelationFilter",
		user:"UserRelationFilter"
	},
	EnumReviewActionFilter:{
		equals:"ReviewAction",
		in:"ReviewAction",
		notIn:"ReviewAction",
		not:"NestedEnumReviewActionFilter"
	},
	ReviewAction: "enum" as const,
	NestedEnumReviewActionFilter:{
		equals:"ReviewAction",
		in:"ReviewAction",
		notIn:"ReviewAction",
		not:"NestedEnumReviewActionFilter"
	},
	WorkspaceListRelationFilter:{
		every:"WorkspaceWhereInput",
		some:"WorkspaceWhereInput",
		none:"WorkspaceWhereInput"
	},
	AdBoardPublicReviewListRelationFilter:{
		every:"AdBoardPublicReviewWhereInput",
		some:"AdBoardPublicReviewWhereInput",
		none:"AdBoardPublicReviewWhereInput"
	},
	UserPositionListRelationFilter:{
		every:"UserPositionWhereInput",
		some:"UserPositionWhereInput",
		none:"UserPositionWhereInput"
	},
	UserPositionWhereInput:{
		AND:"UserPositionWhereInput",
		OR:"UserPositionWhereInput",
		NOT:"UserPositionWhereInput",
		id:"StringFilter",
		timestamp:"DateTimeFilter",
		createdAt:"DateTimeFilter",
		userId:"StringFilter",
		coords:"UserPositionCoordsCompositeFilter",
		location:"UserPositionLocationNullableCompositeFilter",
		user:"UserRelationFilter"
	},
	UserPositionCoordsCompositeFilter:{
		equals:"UserPositionCoordsObjectEqualityInput",
		is:"UserPositionCoordsWhereInput",
		isNot:"UserPositionCoordsWhereInput"
	},
	UserPositionCoordsObjectEqualityInput:{

	},
	UserPositionCoordsWhereInput:{
		AND:"UserPositionCoordsWhereInput",
		OR:"UserPositionCoordsWhereInput",
		NOT:"UserPositionCoordsWhereInput",
		accuracy:"FloatNullableFilter",
		altitude:"FloatNullableFilter",
		altitudeAccuracy:"FloatNullableFilter",
		heading:"FloatNullableFilter",
		latitude:"FloatFilter",
		longitude:"FloatFilter",
		speed:"FloatNullableFilter"
	},
	UserPositionLocationNullableCompositeFilter:{
		equals:"UserPositionLocationObjectEqualityInput",
		is:"UserPositionLocationWhereInput",
		isNot:"UserPositionLocationWhereInput"
	},
	UserPositionLocationObjectEqualityInput:{

	},
	UserPositionLocationWhereInput:{
		AND:"UserPositionLocationWhereInput",
		OR:"UserPositionLocationWhereInput",
		NOT:"UserPositionLocationWhereInput",
		address:"StringNullableFilter",
		city:"StringNullableFilter",
		state:"StringNullableFilter",
		country:"StringNullableFilter"
	},
	WishlistListRelationFilter:{
		every:"WishlistWhereInput",
		some:"WishlistWhereInput",
		none:"WishlistWhereInput"
	},
	WishlistWhereInput:{
		AND:"WishlistWhereInput",
		OR:"WishlistWhereInput",
		NOT:"WishlistWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		userId:"StringFilter",
		adBoardIds:"StringNullableListFilter",
		createdAt:"DateTimeFilter",
		user:"UserRelationFilter",
		adBoards:"AdBoardListRelationFilter"
	},
	PaymentListRelationFilter:{
		every:"PaymentWhereInput",
		some:"PaymentWhereInput",
		none:"PaymentWhereInput"
	},
	BusinessCategoryListRelationFilter:{
		every:"BusinessCategoryWhereInput",
		some:"BusinessCategoryWhereInput",
		none:"BusinessCategoryWhereInput"
	},
	SlotConfigurationListRelationFilter:{
		every:"SlotConfigurationWhereInput",
		some:"SlotConfigurationWhereInput",
		none:"SlotConfigurationWhereInput"
	},
	SlotConfigurationWhereInput:{
		AND:"SlotConfigurationWhereInput",
		OR:"SlotConfigurationWhereInput",
		NOT:"SlotConfigurationWhereInput",
		id:"StringFilter",
		adBoardId:"StringFilter",
		date:"DateTimeFilter",
		availableSlots:"IntFilter",
		adBoard:"AdBoardRelationFilter"
	},
	AdBoardOrderByWithRelationInput:{
		id:"SortOrder",
		state:"SortOrder",
		city:"SortOrder",
		country:"SortOrder",
		outdoor:"SortOrder",
		locationCategoryId:"SortOrder",
		locationSubCategoryId:"SortOrder",
		alias:"SortOrder",
		title:"SortOrder",
		pricePerDay:"SortOrder",
		pricingTiers:"PricingTierOrderByCompositeAggregateInput",
		originalPricePerDay:"SortOrder",
		description:"SortOrder",
		aboutSpecifications:"SpecificationOrderByCompositeAggregateInput",
		adBoardTypeId:"SortOrder",
		tags:"SortOrder",
		featuredImage:"SortOrder",
		galleryImgs:"SortOrder",
		specifications:"SpecificationOrderByCompositeAggregateInput",
		notes:"SortOrder",
		impressionMultiplier:"SortOrder",
		resolution:"ResolutionOrderByInput",
		screenSize:"ScreenSizeOrderByInput",
		categoryId:"SortOrder",
		restrictedBusinessIds:"SortOrder",
		targetAudiences:"SortOrder",
		playbackTimes:"PlaybackTimeOrderByCompositeAggregateInput",
		acceptedMediaTypes:"SortOrder",
		status:"SortOrder",
		adboardDraftStatus:"SortOrder",
		isLive:"SortOrder",
		numberOfDisplays:"SortOrder",
		dailyOperationHours:"SortOrder",
		adsPerLoop:"SortOrder",
		adsDuration:"SortOrder",
		monthlyPrice:"SortOrder",
		offlineBookingsEnabled:"SortOrder",
		createdAt:"SortOrder",
		createdByUserId:"SortOrder",
		href:"SortOrder",
		workspaceId:"SortOrder",
		playerIds:"SortOrder",
		publisherScreenId:"SortOrder",
		additionalData:"SortOrder",
		publishedVersionId:"SortOrder",
		lastPublishedAt:"SortOrder",
		isArchived:"SortOrder",
		archivedAt:"SortOrder",
		archivedByUserId:"SortOrder",
		updatedAt:"SortOrder",
		wishlistIds:"SortOrder",
		locationCategory:"LocationCategoryOrderByWithRelationInput",
		locationSubCategory:"LocationSubCategoryOrderByWithRelationInput",
		type:"AdBoardTypeOrderByWithRelationInput",
		category:"BusinessCategoryOrderByWithRelationInput",
		restrictedBusines:"BusinessCategoryOrderByRelationAggregateInput",
		bookings:"BookingOrderByRelationAggregateInput",
		orders:"OrderOrderByRelationAggregateInput",
		slotConfigurations:"SlotConfigurationOrderByRelationAggregateInput",
		createdBy:"UserOrderByWithRelationInput",
		workspace:"WorkspaceOrderByWithRelationInput",
		players:"PlayerOrderByRelationAggregateInput",
		adBoardGroup:"AdBoardGroupOrderByWithRelationInput",
		publishedVersion:"AdBoardOrderByWithRelationInput",
		draftAdboard:"AdBoardOrderByWithRelationInput",
		history:"AdBoardPublishHistoryOrderByRelationAggregateInput",
		reviewComments:"AdBoardReviewCommentOrderByRelationAggregateInput",
		archivedBy:"UserOrderByWithRelationInput",
		publicReviews:"AdBoardPublicReviewOrderByRelationAggregateInput",
		wishlists:"WishlistOrderByRelationAggregateInput"
	},
	SortOrder: "enum" as const,
	PricingTierOrderByCompositeAggregateInput:{
		_count:"SortOrder"
	},
	SpecificationOrderByCompositeAggregateInput:{
		_count:"SortOrder"
	},
	ResolutionOrderByInput:{
		height:"SortOrder",
		width:"SortOrder"
	},
	ScreenSizeOrderByInput:{
		height:"SortOrder",
		unit:"SortOrder",
		width:"SortOrder"
	},
	PlaybackTimeOrderByCompositeAggregateInput:{
		_count:"SortOrder"
	},
	LocationCategoryOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		adBoards:"AdBoardOrderByRelationAggregateInput",
		locationSubCategory:"LocationSubCategoryOrderByRelationAggregateInput"
	},
	AdBoardOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	LocationSubCategoryOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	LocationSubCategoryOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		locationCategoryId:"SortOrder",
		locationCategory:"LocationCategoryOrderByWithRelationInput",
		adBoards:"AdBoardOrderByRelationAggregateInput"
	},
	AdBoardTypeOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder",
		adBoards:"AdBoardOrderByRelationAggregateInput"
	},
	BusinessCategoryOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder",
		restrictedByAdBoardIds:"SortOrder",
		adBoards:"AdBoardOrderByRelationAggregateInput",
		restrictedByAdBoards:"AdBoardOrderByRelationAggregateInput",
		campaigns:"CampaignOrderByRelationAggregateInput",
		bookings:"BookingOrderByRelationAggregateInput"
	},
	CampaignOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	BookingOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	BusinessCategoryOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	OrderOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	SlotConfigurationOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	UserOrderByWithRelationInput:{
		id:"SortOrder",
		uid:"SortOrder",
		email:"SortOrder",
		image:"SortOrder",
		phoneNumber:"SortOrder",
		displayName:"SortOrder",
		otherDetails:"SortOrder",
		stripe:"UserStripeOrderByInput",
		roles:"SortOrder",
		refunds:"BookingRefundOrderByCompositeAggregateInput",
		sharedBookingIds:"SortOrder",
		disclaimerAccepted:"SortOrder",
		notificationPreference:"NotificationPreferenceOrderByInput",
		leadWorkspaceIds:"SortOrder",
		bookings:"BookingOrderByRelationAggregateInput",
		createdFiles:"FileOrderByRelationAggregateInput",
		updatedFiles:"FileOrderByRelationAggregateInput",
		orders:"OrderOrderByRelationAggregateInput",
		changelogs:"ChangelogOrderByRelationAggregateInput",
		adBoards:"AdBoardOrderByRelationAggregateInput",
		audits:"AuditOrderByRelationAggregateInput",
		campaigns:"CampaignOrderByRelationAggregateInput",
		sharedBookings:"BookingOrderByRelationAggregateInput",
		memberships:"MembershipOrderByRelationAggregateInput",
		notifications:"NotificationOrderByRelationAggregateInput",
		publishAdboardVersion:"AdBoardPublishHistoryOrderByRelationAggregateInput",
		reviewComments:"AdBoardReviewCommentOrderByRelationAggregateInput",
		archivedAdboards:"AdBoardOrderByRelationAggregateInput",
		ownedWorkspaces:"WorkspaceOrderByRelationAggregateInput",
		leadWorspaces:"WorkspaceOrderByRelationAggregateInput",
		publicReviews:"AdBoardPublicReviewOrderByRelationAggregateInput",
		userPositions:"UserPositionOrderByRelationAggregateInput",
		wishlists:"WishlistOrderByRelationAggregateInput",
		deletedPlayerIds:"PlayerOrderByRelationAggregateInput",
		deployedContentVersions:"ContentVersionOrderByRelationAggregateInput",
		submittedContentVersions:"ContentVersionOrderByRelationAggregateInput",
		approvedContentVersions:"ContentVersionOrderByRelationAggregateInput"
	},
	UserStripeOrderByInput:{
		customerId:"SortOrder"
	},
	BookingRefundOrderByCompositeAggregateInput:{
		_count:"SortOrder"
	},
	NotificationPreferenceOrderByInput:{
		type:"SortOrder",
		channels:"SortOrder",
		pushSetting:"PushSettingOrderByInput",
		enabled:"SortOrder"
	},
	PushSettingOrderByInput:{
		fcmTokens:"SortOrder"
	},
	FileOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	ChangelogOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	AuditOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	MembershipOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	NotificationOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	AdBoardPublishHistoryOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	AdBoardReviewCommentOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	WorkspaceOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	AdBoardPublicReviewOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	UserPositionOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	WishlistOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	PlayerOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	ContentVersionOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	WorkspaceOrderByWithRelationInput:{
		id:"SortOrder",
		type:"SortOrder",
		name:"SortOrder",
		key:"SortOrder",
		userIds:"SortOrder",
		ownerId:"SortOrder",
		avatar:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		stripeSubscriptionId:"SortOrder",
		leadIds:"SortOrder",
		webhookAppId:"SortOrder",
		stackAuthTeamId:"SortOrder",
		owner:"UserOrderByWithRelationInput",
		memberships:"MembershipOrderByRelationAggregateInput",
		adBoards:"AdBoardOrderByRelationAggregateInput",
		playlists:"PlaylistOrderByRelationAggregateInput",
		adBoardGroups:"AdBoardGroupOrderByRelationAggregateInput",
		audits:"AuditOrderByRelationAggregateInput",
		bookings:"BookingOrderByRelationAggregateInput",
		files:"FileOrderByRelationAggregateInput",
		players:"PlayerOrderByRelationAggregateInput",
		transactions:"TransactionOrderByRelationAggregateInput",
		activeSubscription:"SubscriptionOrderByWithRelationInput",
		workspaceRoles:"WorkspaceRoleOrderByRelationAggregateInput",
		leads:"UserOrderByRelationAggregateInput",
		cameras:"CameraOrderByRelationAggregateInput",
		cameraStreamingDevices:"StreamingDeviceOrderByRelationAggregateInput"
	},
	PlaylistOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	AdBoardGroupOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	TransactionOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	SubscriptionOrderByWithRelationInput:{
		id:"SortOrder",
		packageId:"SortOrder",
		packageName:"SortOrder",
		priceLookupKey:"SortOrder",
		startDate:"SortOrder",
		endDate:"SortOrder",
		status:"SortOrder",
		stripePaymentIntentId:"SortOrder",
		stripeSubscriptionId:"SortOrder",
		stripeCheckoutSessionId:"SortOrder",
		cancellationDetails:"CancellationDetailsOrderByInput",
		activeWorkspaceId:"SortOrder",
		activeWorkspace:"WorkspaceOrderByWithRelationInput"
	},
	CancellationDetailsOrderByInput:{
		canceledAt:"SortOrder",
		cancelAt:"SortOrder",
		cancelAtPeriodEnd:"SortOrder",
		reason:"SortOrder"
	},
	WorkspaceRoleOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	UserOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	CameraOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	StreamingDeviceOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	AdBoardGroupOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		adBoardId:"SortOrder",
		schedules:"ScheduleOrderByCompositeAggregateInput",
		scheduledPlaylistsIDs:"SortOrder",
		adsPlaylistID:"SortOrder",
		pisignageGroupId:"SortOrder",
		fitImage:"SortOrder",
		fitVideo:"SortOrder",
		workspaceId:"SortOrder",
		adBoard:"AdBoardOrderByWithRelationInput",
		scheduledPlaylists:"PlaylistOrderByRelationAggregateInput",
		adsPlaylist:"PlaylistOrderByWithRelationInput",
		pisignagePlayers:"PlayerOrderByRelationAggregateInput",
		workspace:"WorkspaceOrderByWithRelationInput"
	},
	ScheduleOrderByCompositeAggregateInput:{
		_count:"SortOrder"
	},
	PlaylistOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		displayName:"SortOrder",
		assets:"PisignageFileOrderByCompositeAggregateInput",
		isAdsPlaylist:"SortOrder",
		footerPlaylistId:"SortOrder",
		sidebarPlaylistId:"SortOrder",
		layout:"SortOrder",
		isDeployed:"SortOrder",
		adBoardGroupIds:"SortOrder",
		workspaceId:"SortOrder",
		footerPlaylist:"PlaylistOrderByWithRelationInput",
		sidebarPlaylist:"PlaylistOrderByWithRelationInput",
		adBoardGroupsForAds:"AdBoardGroupOrderByRelationAggregateInput",
		adBoardGroups:"AdBoardGroupOrderByRelationAggregateInput",
		workspace:"WorkspaceOrderByWithRelationInput",
		footerParentPlaylists:"PlaylistOrderByRelationAggregateInput",
		sidebarParentPlaylists:"PlaylistOrderByRelationAggregateInput"
	},
	PisignageFileOrderByCompositeAggregateInput:{
		_count:"SortOrder"
	},
	AdBoardWhereUniqueInput:{
		workspaceId_alias:"AdBoardWorkspaceIdAliasCompoundUniqueInput",
		AND:"AdBoardWhereInput",
		OR:"AdBoardWhereInput",
		NOT:"AdBoardWhereInput",
		state:"StringFilter",
		city:"StringFilter",
		country:"StringFilter",
		outdoor:"BoolFilter",
		locationCategoryId:"StringNullableFilter",
		locationSubCategoryId:"StringNullableFilter",
		alias:"StringNullableFilter",
		title:"StringFilter",
		pricePerDay:"IntFilter",
		pricingTiers:"PricingTierObjectEqualityInput",
		originalPricePerDay:"IntNullableFilter",
		description:"StringNullableFilter",
		aboutSpecifications:"SpecificationObjectEqualityInput",
		adBoardTypeId:"StringNullableFilter",
		tags:"StringNullableListFilter",
		featuredImage:"StringNullableFilter",
		galleryImgs:"StringNullableListFilter",
		specifications:"SpecificationObjectEqualityInput",
		notes:"StringNullableListFilter",
		impressionMultiplier:"FloatNullableFilter",
		resolution:"ResolutionNullableCompositeFilter",
		screenSize:"ScreenSizeNullableCompositeFilter",
		categoryId:"StringNullableFilter",
		restrictedBusinessIds:"StringNullableListFilter",
		targetAudiences:"StringNullableListFilter",
		playbackTimes:"PlaybackTimeObjectEqualityInput",
		acceptedMediaTypes:"StringNullableListFilter",
		status:"EnumAdBoardStatusFilter",
		adboardDraftStatus:"EnumAdboardDraftStatusNullableFilter",
		isLive:"BoolFilter",
		numberOfDisplays:"IntFilter",
		dailyOperationHours:"IntFilter",
		adsPerLoop:"IntFilter",
		adsDuration:"IntFilter",
		monthlyPrice:"FloatNullableFilter",
		offlineBookingsEnabled:"BoolFilter",
		createdAt:"DateTimeNullableFilter",
		createdByUserId:"StringNullableFilter",
		href:"StringNullableFilter",
		workspaceId:"StringFilter",
		playerIds:"StringNullableListFilter",
		publisherScreenId:"StringNullableFilter",
		additionalData:"JsonNullableFilter",
		lastPublishedAt:"DateTimeNullableFilter",
		isArchived:"BoolFilter",
		archivedAt:"DateTimeNullableFilter",
		archivedByUserId:"StringNullableFilter",
		updatedAt:"DateTimeNullableFilter",
		wishlistIds:"StringNullableListFilter",
		locationCategory:"LocationCategoryNullableRelationFilter",
		locationSubCategory:"LocationSubCategoryNullableRelationFilter",
		type:"AdBoardTypeNullableRelationFilter",
		category:"BusinessCategoryNullableRelationFilter",
		restrictedBusines:"BusinessCategoryListRelationFilter",
		bookings:"BookingListRelationFilter",
		orders:"OrderListRelationFilter",
		slotConfigurations:"SlotConfigurationListRelationFilter",
		createdBy:"UserNullableRelationFilter",
		workspace:"WorkspaceRelationFilter",
		players:"PlayerListRelationFilter",
		adBoardGroup:"AdBoardGroupNullableRelationFilter",
		publishedVersion:"AdBoardNullableRelationFilter",
		draftAdboard:"AdBoardNullableRelationFilter",
		history:"AdBoardPublishHistoryListRelationFilter",
		reviewComments:"AdBoardReviewCommentListRelationFilter",
		archivedBy:"UserNullableRelationFilter",
		publicReviews:"AdBoardPublicReviewListRelationFilter",
		wishlists:"WishlistListRelationFilter"
	},
	AdBoardWorkspaceIdAliasCompoundUniqueInput:{

	},
	AdBoard:{
		locationCategory:{
			where:"LocationCategoryWhereInput"
		},
		locationSubCategory:{
			where:"LocationSubCategoryWhereInput"
		},
		type:{
			where:"AdBoardTypeWhereInput"
		},
		category:{
			where:"BusinessCategoryWhereInput"
		},
		restrictedBusines:{
			where:"BusinessCategoryWhereInput",
			orderBy:"BusinessCategoryOrderByWithRelationInput",
			cursor:"BusinessCategoryWhereUniqueInput",
			distinct:"BusinessCategoryScalarFieldEnum"
		},
		bookings:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithRelationInput",
			cursor:"BookingWhereUniqueInput",
			distinct:"BookingScalarFieldEnum"
		},
		orders:{
			where:"OrderWhereInput",
			orderBy:"OrderOrderByWithRelationInput",
			cursor:"OrderWhereUniqueInput",
			distinct:"OrderScalarFieldEnum"
		},
		slotConfigurations:{
			where:"SlotConfigurationWhereInput",
			orderBy:"SlotConfigurationOrderByWithRelationInput",
			cursor:"SlotConfigurationWhereUniqueInput",
			distinct:"SlotConfigurationScalarFieldEnum"
		},
		createdBy:{
			where:"UserWhereInput"
		},
		players:{
			where:"PlayerWhereInput",
			orderBy:"PlayerOrderByWithRelationInput",
			cursor:"PlayerWhereUniqueInput",
			distinct:"PlayerScalarFieldEnum"
		},
		adBoardGroup:{
			where:"AdBoardGroupWhereInput"
		},
		publishedVersion:{
			where:"AdBoardWhereInput"
		},
		draftAdboard:{
			where:"AdBoardWhereInput"
		},
		history:{
			where:"AdBoardPublishHistoryWhereInput",
			orderBy:"AdBoardPublishHistoryOrderByWithRelationInput",
			cursor:"AdBoardPublishHistoryWhereUniqueInput",
			distinct:"AdBoardPublishHistoryScalarFieldEnum"
		},
		reviewComments:{
			where:"AdBoardReviewCommentWhereInput",
			orderBy:"AdBoardReviewCommentOrderByWithRelationInput",
			cursor:"AdBoardReviewCommentWhereUniqueInput",
			distinct:"AdBoardReviewCommentScalarFieldEnum"
		},
		archivedBy:{
			where:"UserWhereInput"
		},
		publicReviews:{
			where:"AdBoardPublicReviewWhereInput",
			orderBy:"AdBoardPublicReviewOrderByWithRelationInput",
			cursor:"AdBoardPublicReviewWhereUniqueInput",
			distinct:"AdBoardPublicReviewScalarFieldEnum"
		},
		wishlists:{
			where:"WishlistWhereInput",
			orderBy:"WishlistOrderByWithRelationInput",
			cursor:"WishlistWhereUniqueInput",
			distinct:"WishlistScalarFieldEnum"
		}
	},
	AdBoardCount:{
		restrictedBusines:{
			where:"BusinessCategoryWhereInput"
		},
		bookings:{
			where:"BookingWhereInput"
		},
		orders:{
			where:"OrderWhereInput"
		},
		slotConfigurations:{
			where:"SlotConfigurationWhereInput"
		},
		players:{
			where:"PlayerWhereInput"
		},
		history:{
			where:"AdBoardPublishHistoryWhereInput"
		},
		reviewComments:{
			where:"AdBoardReviewCommentWhereInput"
		},
		publicReviews:{
			where:"AdBoardPublicReviewWhereInput"
		},
		wishlists:{
			where:"WishlistWhereInput"
		}
	},
	LocationCategory:{
		adBoards:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		},
		locationSubCategory:{
			where:"LocationSubCategoryWhereInput",
			orderBy:"LocationSubCategoryOrderByWithRelationInput",
			cursor:"LocationSubCategoryWhereUniqueInput",
			distinct:"LocationSubCategoryScalarFieldEnum"
		}
	},
	LocationCategoryCount:{
		adBoards:{
			where:"AdBoardWhereInput"
		},
		locationSubCategory:{
			where:"LocationSubCategoryWhereInput"
		}
	},
	AdBoardScalarFieldEnum: "enum" as const,
	LocationSubCategory:{
		locationCategory:{
			where:"LocationCategoryWhereInput"
		},
		adBoards:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		}
	},
	LocationSubCategoryCount:{
		adBoards:{
			where:"AdBoardWhereInput"
		}
	},
	LocationSubCategoryWhereUniqueInput:{
		AND:"LocationSubCategoryWhereInput",
		OR:"LocationSubCategoryWhereInput",
		NOT:"LocationSubCategoryWhereInput",
		name:"StringFilter",
		locationCategoryId:"StringNullableFilter",
		locationCategory:"LocationCategoryNullableRelationFilter",
		adBoards:"AdBoardListRelationFilter"
	},
	LocationSubCategoryScalarFieldEnum: "enum" as const,
	AdBoardType:{
		adBoards:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		}
	},
	AdBoardTypeCount:{
		adBoards:{
			where:"AdBoardWhereInput"
		}
	},
	BusinessCategory:{
		adBoards:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		},
		restrictedByAdBoards:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		},
		campaigns:{
			where:"CampaignWhereInput",
			orderBy:"CampaignOrderByWithRelationInput",
			cursor:"CampaignWhereUniqueInput",
			distinct:"CampaignScalarFieldEnum"
		},
		bookings:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithRelationInput",
			cursor:"BookingWhereUniqueInput",
			distinct:"BookingScalarFieldEnum"
		}
	},
	BusinessCategoryCount:{
		adBoards:{
			where:"AdBoardWhereInput"
		},
		restrictedByAdBoards:{
			where:"AdBoardWhereInput"
		},
		campaigns:{
			where:"CampaignWhereInput"
		},
		bookings:{
			where:"BookingWhereInput"
		}
	},
	Campaign:{
		adCategory:{
			where:"AdvertisementCategoryWhereInput",
			orderBy:"AdvertisementCategoryOrderByWithRelationInput",
			cursor:"AdvertisementCategoryWhereUniqueInput",
			distinct:"AdvertisementCategoryScalarFieldEnum"
		},
		bookings:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithRelationInput",
			cursor:"BookingWhereUniqueInput",
			distinct:"BookingScalarFieldEnum"
		},
		payments:{
			where:"PaymentWhereInput",
			orderBy:"PaymentOrderByWithRelationInput",
			cursor:"PaymentWhereUniqueInput",
			distinct:"PaymentScalarFieldEnum"
		},
		assets:{
			where:"FileWhereInput",
			orderBy:"FileOrderByWithRelationInput",
			cursor:"FileWhereUniqueInput",
			distinct:"FileScalarFieldEnum"
		}
	},
	CampaignCount:{
		adCategory:{
			where:"AdvertisementCategoryWhereInput"
		},
		bookings:{
			where:"BookingWhereInput"
		},
		payments:{
			where:"PaymentWhereInput"
		},
		assets:{
			where:"FileWhereInput"
		}
	},
	User:{
		bookings:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithRelationInput",
			cursor:"BookingWhereUniqueInput",
			distinct:"BookingScalarFieldEnum"
		},
		createdFiles:{
			where:"FileWhereInput",
			orderBy:"FileOrderByWithRelationInput",
			cursor:"FileWhereUniqueInput",
			distinct:"FileScalarFieldEnum"
		},
		updatedFiles:{
			where:"FileWhereInput",
			orderBy:"FileOrderByWithRelationInput",
			cursor:"FileWhereUniqueInput",
			distinct:"FileScalarFieldEnum"
		},
		orders:{
			where:"OrderWhereInput",
			orderBy:"OrderOrderByWithRelationInput",
			cursor:"OrderWhereUniqueInput",
			distinct:"OrderScalarFieldEnum"
		},
		changelogs:{
			where:"ChangelogWhereInput",
			orderBy:"ChangelogOrderByWithRelationInput",
			cursor:"ChangelogWhereUniqueInput",
			distinct:"ChangelogScalarFieldEnum"
		},
		adBoards:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		},
		audits:{
			where:"AuditWhereInput",
			orderBy:"AuditOrderByWithRelationInput",
			cursor:"AuditWhereUniqueInput",
			distinct:"AuditScalarFieldEnum"
		},
		campaigns:{
			where:"CampaignWhereInput",
			orderBy:"CampaignOrderByWithRelationInput",
			cursor:"CampaignWhereUniqueInput",
			distinct:"CampaignScalarFieldEnum"
		},
		sharedBookings:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithRelationInput",
			cursor:"BookingWhereUniqueInput",
			distinct:"BookingScalarFieldEnum"
		},
		memberships:{
			where:"MembershipWhereInput",
			orderBy:"MembershipOrderByWithRelationInput",
			cursor:"MembershipWhereUniqueInput",
			distinct:"MembershipScalarFieldEnum"
		},
		notifications:{
			where:"NotificationWhereInput",
			orderBy:"NotificationOrderByWithRelationInput",
			cursor:"NotificationWhereUniqueInput",
			distinct:"NotificationScalarFieldEnum"
		},
		publishAdboardVersion:{
			where:"AdBoardPublishHistoryWhereInput",
			orderBy:"AdBoardPublishHistoryOrderByWithRelationInput",
			cursor:"AdBoardPublishHistoryWhereUniqueInput",
			distinct:"AdBoardPublishHistoryScalarFieldEnum"
		},
		reviewComments:{
			where:"AdBoardReviewCommentWhereInput",
			orderBy:"AdBoardReviewCommentOrderByWithRelationInput",
			cursor:"AdBoardReviewCommentWhereUniqueInput",
			distinct:"AdBoardReviewCommentScalarFieldEnum"
		},
		archivedAdboards:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		},
		ownedWorkspaces:{
			where:"WorkspaceWhereInput",
			orderBy:"WorkspaceOrderByWithRelationInput",
			cursor:"WorkspaceWhereUniqueInput",
			distinct:"WorkspaceScalarFieldEnum"
		},
		leadWorspaces:{
			where:"WorkspaceWhereInput",
			orderBy:"WorkspaceOrderByWithRelationInput",
			cursor:"WorkspaceWhereUniqueInput",
			distinct:"WorkspaceScalarFieldEnum"
		},
		publicReviews:{
			where:"AdBoardPublicReviewWhereInput",
			orderBy:"AdBoardPublicReviewOrderByWithRelationInput",
			cursor:"AdBoardPublicReviewWhereUniqueInput",
			distinct:"AdBoardPublicReviewScalarFieldEnum"
		},
		userPositions:{
			where:"UserPositionWhereInput",
			orderBy:"UserPositionOrderByWithRelationInput",
			cursor:"UserPositionWhereUniqueInput",
			distinct:"UserPositionScalarFieldEnum"
		},
		wishlists:{
			where:"WishlistWhereInput",
			orderBy:"WishlistOrderByWithRelationInput",
			cursor:"WishlistWhereUniqueInput",
			distinct:"WishlistScalarFieldEnum"
		},
		deletedPlayerIds:{
			where:"PlayerWhereInput",
			orderBy:"PlayerOrderByWithRelationInput",
			cursor:"PlayerWhereUniqueInput",
			distinct:"PlayerScalarFieldEnum"
		},
		deployedContentVersions:{
			where:"ContentVersionWhereInput",
			orderBy:"ContentVersionOrderByWithRelationInput",
			cursor:"ContentVersionWhereUniqueInput",
			distinct:"ContentVersionScalarFieldEnum"
		},
		submittedContentVersions:{
			where:"ContentVersionWhereInput",
			orderBy:"ContentVersionOrderByWithRelationInput",
			cursor:"ContentVersionWhereUniqueInput",
			distinct:"ContentVersionScalarFieldEnum"
		},
		approvedContentVersions:{
			where:"ContentVersionWhereInput",
			orderBy:"ContentVersionOrderByWithRelationInput",
			cursor:"ContentVersionWhereUniqueInput",
			distinct:"ContentVersionScalarFieldEnum"
		}
	},
	UserCount:{
		bookings:{
			where:"BookingWhereInput"
		},
		createdFiles:{
			where:"FileWhereInput"
		},
		updatedFiles:{
			where:"FileWhereInput"
		},
		orders:{
			where:"OrderWhereInput"
		},
		changelogs:{
			where:"ChangelogWhereInput"
		},
		adBoards:{
			where:"AdBoardWhereInput"
		},
		audits:{
			where:"AuditWhereInput"
		},
		campaigns:{
			where:"CampaignWhereInput"
		},
		sharedBookings:{
			where:"BookingWhereInput"
		},
		memberships:{
			where:"MembershipWhereInput"
		},
		notifications:{
			where:"NotificationWhereInput"
		},
		publishAdboardVersion:{
			where:"AdBoardPublishHistoryWhereInput"
		},
		reviewComments:{
			where:"AdBoardReviewCommentWhereInput"
		},
		archivedAdboards:{
			where:"AdBoardWhereInput"
		},
		ownedWorkspaces:{
			where:"WorkspaceWhereInput"
		},
		leadWorspaces:{
			where:"WorkspaceWhereInput"
		},
		publicReviews:{
			where:"AdBoardPublicReviewWhereInput"
		},
		userPositions:{
			where:"UserPositionWhereInput"
		},
		wishlists:{
			where:"WishlistWhereInput"
		},
		deletedPlayerIds:{
			where:"PlayerWhereInput"
		},
		deployedContentVersions:{
			where:"ContentVersionWhereInput"
		},
		submittedContentVersions:{
			where:"ContentVersionWhereInput"
		},
		approvedContentVersions:{
			where:"ContentVersionWhereInput"
		}
	},
	Booking:{
		businessCategory:{
			where:"BusinessCategoryWhereInput"
		},
		adCategory:{
			where:"AdvertisementCategoryWhereInput",
			orderBy:"AdvertisementCategoryOrderByWithRelationInput",
			cursor:"AdvertisementCategoryWhereUniqueInput",
			distinct:"AdvertisementCategoryScalarFieldEnum"
		},
		assets:{
			where:"FileWhereInput",
			orderBy:"FileOrderByWithRelationInput",
			cursor:"FileWhereUniqueInput",
			distinct:"FileScalarFieldEnum"
		},
		contentVersions:{
			where:"ContentVersionWhereInput",
			orderBy:"ContentVersionOrderByWithRelationInput",
			cursor:"ContentVersionWhereUniqueInput",
			distinct:"ContentVersionScalarFieldEnum"
		},
		paymentAllocations:{
			where:"PaymentAllocationWhereInput",
			orderBy:"PaymentAllocationOrderByWithRelationInput",
			cursor:"PaymentAllocationWhereUniqueInput",
			distinct:"PaymentAllocationScalarFieldEnum"
		},
		proofs:{
			where:"FileWhereInput",
			orderBy:"FileOrderByWithRelationInput",
			cursor:"FileWhereUniqueInput",
			distinct:"FileScalarFieldEnum"
		},
		changelogs:{
			where:"ChangelogWhereInput",
			orderBy:"ChangelogOrderByWithRelationInput",
			cursor:"ChangelogWhereUniqueInput",
			distinct:"ChangelogScalarFieldEnum"
		},
		workspace:{
			where:"WorkspaceWhereInput"
		},
		campaign:{
			where:"CampaignWhereInput"
		},
		payouts:{
			where:"PayoutWhereInput",
			orderBy:"PayoutOrderByWithRelationInput",
			cursor:"PayoutWhereUniqueInput",
			distinct:"PayoutScalarFieldEnum"
		},
		sharedUsers:{
			where:"UserWhereInput",
			orderBy:"UserOrderByWithRelationInput",
			cursor:"UserWhereUniqueInput",
			distinct:"UserScalarFieldEnum"
		},
		slotUsage:{
			where:"SlotUsageWhereInput",
			orderBy:"SlotUsageOrderByWithRelationInput",
			cursor:"SlotUsageWhereUniqueInput",
			distinct:"SlotUsageScalarFieldEnum"
		},
		review:{
			where:"AdBoardPublicReviewWhereInput"
		},
		history:{
			where:"BookingHistoryWhereInput",
			orderBy:"BookingHistoryOrderByWithRelationInput",
			cursor:"BookingHistoryWhereUniqueInput",
			distinct:"BookingHistoryScalarFieldEnum"
		},
		refundRequest:{
			where:"RefundRequestWhereInput"
		},
		refundApproval:{
			where:"RefundApprovalWhereInput"
		},
		refundProcessed:{
			where:"RefundProcessedWhereInput"
		}
	},
	BookingCount:{
		adCategory:{
			where:"AdvertisementCategoryWhereInput"
		},
		assets:{
			where:"FileWhereInput"
		},
		contentVersions:{
			where:"ContentVersionWhereInput"
		},
		paymentAllocations:{
			where:"PaymentAllocationWhereInput"
		},
		proofs:{
			where:"FileWhereInput"
		},
		changelogs:{
			where:"ChangelogWhereInput"
		},
		payouts:{
			where:"PayoutWhereInput"
		},
		sharedUsers:{
			where:"UserWhereInput"
		},
		slotUsage:{
			where:"SlotUsageWhereInput"
		},
		history:{
			where:"BookingHistoryWhereInput"
		}
	},
	AdvertisementCategory:{
		campaigns:{
			where:"CampaignWhereInput",
			orderBy:"CampaignOrderByWithRelationInput",
			cursor:"CampaignWhereUniqueInput",
			distinct:"CampaignScalarFieldEnum"
		},
		bookings:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithRelationInput",
			cursor:"BookingWhereUniqueInput",
			distinct:"BookingScalarFieldEnum"
		}
	},
	AdvertisementCategoryCount:{
		campaigns:{
			where:"CampaignWhereInput"
		},
		bookings:{
			where:"BookingWhereInput"
		}
	},
	CampaignOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder",
		businessCategoryId:"SortOrder",
		purpose:"SortOrder",
		userId:"SortOrder",
		adCategoryId:"SortOrder",
		payment:"BookingPaymentOrderByInput",
		paymentStatus:"SortOrder",
		priceSummary:"PriceSummaryOrderByInput",
		selectedDates:"OrderSelectedDateOrderByInput",
		origin:"SortOrder",
		assetsIDs:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		businessCategory:"BusinessCategoryOrderByWithRelationInput",
		user:"UserOrderByWithRelationInput",
		adCategory:"AdvertisementCategoryOrderByRelationAggregateInput",
		bookings:"BookingOrderByRelationAggregateInput",
		payments:"PaymentOrderByRelationAggregateInput",
		assets:"FileOrderByRelationAggregateInput"
	},
	BookingPaymentOrderByInput:{
		liveMode:"SortOrder",
		checkoutSessionId:"SortOrder",
		customer:"BookingCustomerOrderByInput",
		paymentGateway:"SortOrder",
		paymentId:"SortOrder",
		sessionId:"SortOrder",
		totalDetails:"PaymentTotalDetailsOrderByInput",
		razorpay:"SortOrder",
		stripe:"SortOrder"
	},
	BookingCustomerOrderByInput:{
		customerId:"SortOrder",
		customerDetails:"PaymentCustomerDetailsOrderByInput"
	},
	PaymentCustomerDetailsOrderByInput:{
		email:"SortOrder",
		name:"SortOrder",
		phone:"SortOrder"
	},
	PaymentTotalDetailsOrderByInput:{
		discount:"SortOrder",
		shipping:"SortOrder",
		subtotal:"SortOrder",
		tax:"SortOrder",
		total:"SortOrder"
	},
	PriceSummaryOrderByInput:{
		days:"SortOrder",
		discount:"SortOrder",
		payableRent:"SortOrder",
		subtotal:"SortOrder",
		rentPerDay:"SortOrder",
		serviceCharge:"SortOrder",
		totalRent:"SortOrder"
	},
	OrderSelectedDateOrderByInput:{
		endDate:"SortOrder",
		startDate:"SortOrder"
	},
	AdvertisementCategoryOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	PaymentOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	CampaignWhereUniqueInput:{
		AND:"CampaignWhereInput",
		OR:"CampaignWhereInput",
		NOT:"CampaignWhereInput",
		name:"StringFilter",
		description:"StringNullableFilter",
		businessCategoryId:"StringFilter",
		purpose:"StringFilter",
		userId:"StringFilter",
		adCategoryId:"StringNullableListFilter",
		payment:"BookingPaymentNullableCompositeFilter",
		paymentStatus:"EnumPaymentStatusFilter",
		priceSummary:"PriceSummaryNullableCompositeFilter",
		selectedDates:"OrderSelectedDateCompositeFilter",
		origin:"StringFilter",
		assetsIDs:"StringNullableListFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		businessCategory:"BusinessCategoryRelationFilter",
		user:"UserRelationFilter",
		adCategory:"AdvertisementCategoryListRelationFilter",
		bookings:"BookingListRelationFilter",
		payments:"PaymentListRelationFilter",
		assets:"FileListRelationFilter"
	},
	CampaignScalarFieldEnum: "enum" as const,
	BookingOrderByWithRelationInput:{
		id:"SortOrder",
		additionalInformation:"SortOrder",
		origin:"SortOrder",
		bookingCode:"SortOrder",
		bookingDate:"SortOrder",
		bookingFor:"SortOrder",
		purpose:"SortOrder",
		adBoardId:"SortOrder",
		workspaceId:"SortOrder",
		campaignId:"SortOrder",
		businessCategoryId:"SortOrder",
		adCategoryId:"SortOrder",
		bookingDetails:"BookingUserDetailsOrderByInput",
		bookingStatus:"SortOrder",
		paymentStatus:"SortOrder",
		deploymentStatus:"SortOrder",
		assetsIDs:"SortOrder",
		currentDeployedVersionId:"SortOrder",
		selectedDates:"OrderSelectedDateOrderByInput",
		payment:"BookingPaymentOrderByInput",
		priceSummary:"PriceSummaryOrderByInput",
		pisignage:"BookingPisignageDataOrderByInput",
		userId:"SortOrder",
		sharedUserIds:"SortOrder",
		isOffline:"SortOrder",
		isEnquiry:"SortOrder",
		isPaid:"SortOrder",
		enquiryDate:"SortOrder",
		approvalDate:"SortOrder",
		paymentDate:"SortOrder",
		confirmationDate:"SortOrder",
		contentScheduledDate:"SortOrder",
		contentLiveDate:"SortOrder",
		completionDate:"SortOrder",
		refundStatus:"SortOrder",
		businessCategory:"BusinessCategoryOrderByWithRelationInput",
		adCategory:"AdvertisementCategoryOrderByRelationAggregateInput",
		assets:"FileOrderByRelationAggregateInput",
		contentVersions:"ContentVersionOrderByRelationAggregateInput",
		paymentAllocations:"PaymentAllocationOrderByRelationAggregateInput",
		proofs:"FileOrderByRelationAggregateInput",
		user:"UserOrderByWithRelationInput",
		adBoard:"AdBoardOrderByWithRelationInput",
		changelogs:"ChangelogOrderByRelationAggregateInput",
		workspace:"WorkspaceOrderByWithRelationInput",
		campaign:"CampaignOrderByWithRelationInput",
		payouts:"PayoutOrderByRelationAggregateInput",
		sharedUsers:"UserOrderByRelationAggregateInput",
		slotUsage:"SlotUsageOrderByRelationAggregateInput",
		review:"AdBoardPublicReviewOrderByWithRelationInput",
		history:"BookingHistoryOrderByRelationAggregateInput",
		refundRequest:"RefundRequestOrderByWithRelationInput",
		refundApproval:"RefundApprovalOrderByWithRelationInput",
		refundProcessed:"RefundProcessedOrderByWithRelationInput"
	},
	BookingUserDetailsOrderByInput:{
		email:"SortOrder",
		name:"SortOrder",
		phone:"SortOrder"
	},
	BookingPisignageDataOrderByInput:{
		deployedFileName:"SortOrder",
		playlistId:"SortOrder"
	},
	PaymentAllocationOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	PayoutOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	SlotUsageOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	AdBoardPublicReviewOrderByWithRelationInput:{
		id:"SortOrder",
		rating:"SortOrder",
		title:"SortOrder",
		description:"SortOrder",
		isVerified:"SortOrder",
		helpfulYes:"SortOrder",
		helpfulNo:"SortOrder",
		imageUrls:"SortOrder",
		adBoardId:"SortOrder",
		userId:"SortOrder",
		createdAt:"SortOrder",
		bookingId:"SortOrder",
		adBoard:"AdBoardOrderByWithRelationInput",
		user:"UserOrderByWithRelationInput",
		booking:"BookingOrderByWithRelationInput"
	},
	BookingHistoryOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	RefundRequestOrderByWithRelationInput:{
		id:"SortOrder",
		bookingId:"SortOrder",
		requestedAt:"SortOrder",
		requestedBy:"SortOrder",
		reason:"SortOrder",
		amountRequested:"SortOrder",
		booking:"BookingOrderByWithRelationInput"
	},
	RefundApprovalOrderByWithRelationInput:{
		id:"SortOrder",
		bookingId:"SortOrder",
		approvedAt:"SortOrder",
		approvedBy:"SortOrder",
		amountApproved:"SortOrder",
		notes:"SortOrder",
		booking:"BookingOrderByWithRelationInput"
	},
	RefundProcessedOrderByWithRelationInput:{
		id:"SortOrder",
		bookingId:"SortOrder",
		processedAt:"SortOrder",
		paymentMethod:"SortOrder",
		transactionId:"SortOrder",
		booking:"BookingOrderByWithRelationInput"
	},
	BookingWhereUniqueInput:{
		AND:"BookingWhereInput",
		OR:"BookingWhereInput",
		NOT:"BookingWhereInput",
		additionalInformation:"StringNullableFilter",
		origin:"StringNullableFilter",
		bookingDate:"DateTimeFilter",
		bookingFor:"StringFilter",
		purpose:"StringFilter",
		adBoardId:"StringFilter",
		workspaceId:"StringNullableFilter",
		campaignId:"StringNullableFilter",
		businessCategoryId:"StringNullableFilter",
		adCategoryId:"StringNullableListFilter",
		bookingDetails:"BookingUserDetailsCompositeFilter",
		bookingStatus:"EnumBookingStatusFilter",
		paymentStatus:"EnumPaymentStatusNullableFilter",
		deploymentStatus:"EnumDeploymentStatusFilter",
		assetsIDs:"StringNullableListFilter",
		currentDeployedVersionId:"StringNullableFilter",
		selectedDates:"OrderSelectedDateCompositeFilter",
		payment:"BookingPaymentNullableCompositeFilter",
		priceSummary:"PriceSummaryNullableCompositeFilter",
		pisignage:"BookingPisignageDataNullableCompositeFilter",
		userId:"StringFilter",
		sharedUserIds:"StringNullableListFilter",
		isOffline:"BoolFilter",
		isEnquiry:"BoolFilter",
		isPaid:"BoolFilter",
		enquiryDate:"DateTimeNullableFilter",
		approvalDate:"DateTimeNullableFilter",
		paymentDate:"DateTimeNullableFilter",
		confirmationDate:"DateTimeNullableFilter",
		contentScheduledDate:"DateTimeNullableFilter",
		contentLiveDate:"DateTimeNullableFilter",
		completionDate:"DateTimeNullableFilter",
		refundStatus:"EnumRefundStatusFilter",
		businessCategory:"BusinessCategoryNullableRelationFilter",
		adCategory:"AdvertisementCategoryListRelationFilter",
		assets:"FileListRelationFilter",
		contentVersions:"ContentVersionListRelationFilter",
		paymentAllocations:"PaymentAllocationListRelationFilter",
		proofs:"FileListRelationFilter",
		user:"UserRelationFilter",
		adBoard:"AdBoardRelationFilter",
		changelogs:"ChangelogListRelationFilter",
		workspace:"WorkspaceNullableRelationFilter",
		campaign:"CampaignNullableRelationFilter",
		payouts:"PayoutListRelationFilter",
		sharedUsers:"UserListRelationFilter",
		slotUsage:"SlotUsageListRelationFilter",
		review:"AdBoardPublicReviewNullableRelationFilter",
		history:"BookingHistoryListRelationFilter",
		refundRequest:"RefundRequestNullableRelationFilter",
		refundApproval:"RefundApprovalNullableRelationFilter",
		refundProcessed:"RefundProcessedNullableRelationFilter"
	},
	BookingScalarFieldEnum: "enum" as const,
	AdvertisementCategoryOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		type:"SortOrder",
		description:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		campaignIds:"SortOrder",
		bookingIds:"SortOrder",
		campaigns:"CampaignOrderByRelationAggregateInput",
		bookings:"BookingOrderByRelationAggregateInput"
	},
	AdvertisementCategoryWhereUniqueInput:{
		AND:"AdvertisementCategoryWhereInput",
		OR:"AdvertisementCategoryWhereInput",
		NOT:"AdvertisementCategoryWhereInput",
		name:"StringFilter",
		type:"EnumAdvertisementCategoryEnumFilter",
		description:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		campaignIds:"StringNullableListFilter",
		bookingIds:"StringNullableListFilter",
		campaigns:"CampaignListRelationFilter",
		bookings:"BookingListRelationFilter"
	},
	AdvertisementCategoryScalarFieldEnum: "enum" as const,
	File:{
		updatedBy:{
			where:"UserWhereInput"
		},
		bookings:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithRelationInput",
			cursor:"BookingWhereUniqueInput",
			distinct:"BookingScalarFieldEnum"
		},
		workspace:{
			where:"WorkspaceWhereInput"
		},
		proofBooking:{
			where:"BookingWhereInput"
		},
		campaigns:{
			where:"CampaignWhereInput",
			orderBy:"CampaignOrderByWithRelationInput",
			cursor:"CampaignWhereUniqueInput",
			distinct:"CampaignScalarFieldEnum"
		},
		contentVersions:{
			where:"ContentVersionWhereInput",
			orderBy:"ContentVersionOrderByWithRelationInput",
			cursor:"ContentVersionWhereUniqueInput",
			distinct:"ContentVersionScalarFieldEnum"
		}
	},
	FileCount:{
		bookings:{
			where:"BookingWhereInput"
		},
		campaigns:{
			where:"CampaignWhereInput"
		},
		contentVersions:{
			where:"ContentVersionWhereInput"
		}
	},
	Workspace:{
		owner:{
			where:"UserWhereInput"
		},
		memberships:{
			where:"MembershipWhereInput",
			orderBy:"MembershipOrderByWithRelationInput",
			cursor:"MembershipWhereUniqueInput",
			distinct:"MembershipScalarFieldEnum"
		},
		adBoards:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		},
		playlists:{
			where:"PlaylistWhereInput",
			orderBy:"PlaylistOrderByWithRelationInput",
			cursor:"PlaylistWhereUniqueInput",
			distinct:"PlaylistScalarFieldEnum"
		},
		adBoardGroups:{
			where:"AdBoardGroupWhereInput",
			orderBy:"AdBoardGroupOrderByWithRelationInput",
			cursor:"AdBoardGroupWhereUniqueInput",
			distinct:"AdBoardGroupScalarFieldEnum"
		},
		audits:{
			where:"AuditWhereInput",
			orderBy:"AuditOrderByWithRelationInput",
			cursor:"AuditWhereUniqueInput",
			distinct:"AuditScalarFieldEnum"
		},
		bookings:{
			where:"BookingWhereInput",
			orderBy:"BookingOrderByWithRelationInput",
			cursor:"BookingWhereUniqueInput",
			distinct:"BookingScalarFieldEnum"
		},
		files:{
			where:"FileWhereInput",
			orderBy:"FileOrderByWithRelationInput",
			cursor:"FileWhereUniqueInput",
			distinct:"FileScalarFieldEnum"
		},
		players:{
			where:"PlayerWhereInput",
			orderBy:"PlayerOrderByWithRelationInput",
			cursor:"PlayerWhereUniqueInput",
			distinct:"PlayerScalarFieldEnum"
		},
		transactions:{
			where:"TransactionWhereInput",
			orderBy:"TransactionOrderByWithRelationInput",
			cursor:"TransactionWhereUniqueInput",
			distinct:"TransactionScalarFieldEnum"
		},
		activeSubscription:{
			where:"SubscriptionWhereInput"
		},
		workspaceRoles:{
			where:"WorkspaceRoleWhereInput",
			orderBy:"WorkspaceRoleOrderByWithRelationInput",
			cursor:"WorkspaceRoleWhereUniqueInput",
			distinct:"WorkspaceRoleScalarFieldEnum"
		},
		leads:{
			where:"UserWhereInput",
			orderBy:"UserOrderByWithRelationInput",
			cursor:"UserWhereUniqueInput",
			distinct:"UserScalarFieldEnum"
		},
		cameras:{
			where:"CameraWhereInput",
			orderBy:"CameraOrderByWithRelationInput",
			cursor:"CameraWhereUniqueInput",
			distinct:"CameraScalarFieldEnum"
		},
		cameraStreamingDevices:{
			where:"StreamingDeviceWhereInput",
			orderBy:"StreamingDeviceOrderByWithRelationInput",
			cursor:"StreamingDeviceWhereUniqueInput",
			distinct:"StreamingDeviceScalarFieldEnum"
		}
	},
	WorkspaceCount:{
		memberships:{
			where:"MembershipWhereInput"
		},
		adBoards:{
			where:"AdBoardWhereInput"
		},
		playlists:{
			where:"PlaylistWhereInput"
		},
		adBoardGroups:{
			where:"AdBoardGroupWhereInput"
		},
		audits:{
			where:"AuditWhereInput"
		},
		bookings:{
			where:"BookingWhereInput"
		},
		files:{
			where:"FileWhereInput"
		},
		players:{
			where:"PlayerWhereInput"
		},
		transactions:{
			where:"TransactionWhereInput"
		},
		workspaceRoles:{
			where:"WorkspaceRoleWhereInput"
		},
		leads:{
			where:"UserWhereInput"
		},
		cameras:{
			where:"CameraWhereInput"
		},
		cameraStreamingDevices:{
			where:"StreamingDeviceWhereInput"
		}
	},
	WorkspaceRole:{
		workspace:{
			where:"WorkspaceWhereInput"
		},
		memberships:{
			where:"MembershipWhereInput",
			orderBy:"MembershipOrderByWithRelationInput",
			cursor:"MembershipWhereUniqueInput",
			distinct:"MembershipScalarFieldEnum"
		}
	},
	WorkspaceRoleCount:{
		memberships:{
			where:"MembershipWhereInput"
		}
	},
	MembershipOrderByWithRelationInput:{
		id:"SortOrder",
		createdAt:"SortOrder",
		userId:"SortOrder",
		workspaceId:"SortOrder",
		roleId:"SortOrder",
		user:"UserOrderByWithRelationInput",
		workspace:"WorkspaceOrderByWithRelationInput",
		role:"WorkspaceRoleOrderByWithRelationInput"
	},
	WorkspaceRoleOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		permissions:"SortOrder",
		workspaceId:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		workspace:"WorkspaceOrderByWithRelationInput",
		memberships:"MembershipOrderByRelationAggregateInput"
	},
	MembershipWhereUniqueInput:{
		userId_workspaceId:"MembershipUserIdWorkspaceIdCompoundUniqueInput",
		AND:"MembershipWhereInput",
		OR:"MembershipWhereInput",
		NOT:"MembershipWhereInput",
		createdAt:"DateTimeFilter",
		userId:"StringFilter",
		workspaceId:"StringFilter",
		roleId:"StringFilter",
		user:"UserRelationFilter",
		workspace:"WorkspaceRelationFilter",
		role:"WorkspaceRoleRelationFilter"
	},
	MembershipUserIdWorkspaceIdCompoundUniqueInput:{

	},
	MembershipScalarFieldEnum: "enum" as const,
	Playlist:{
		footerPlaylist:{
			where:"PlaylistWhereInput"
		},
		sidebarPlaylist:{
			where:"PlaylistWhereInput"
		},
		adBoardGroupsForAds:{
			where:"AdBoardGroupWhereInput",
			orderBy:"AdBoardGroupOrderByWithRelationInput",
			cursor:"AdBoardGroupWhereUniqueInput",
			distinct:"AdBoardGroupScalarFieldEnum"
		},
		adBoardGroups:{
			where:"AdBoardGroupWhereInput",
			orderBy:"AdBoardGroupOrderByWithRelationInput",
			cursor:"AdBoardGroupWhereUniqueInput",
			distinct:"AdBoardGroupScalarFieldEnum"
		},
		footerParentPlaylists:{
			where:"PlaylistWhereInput",
			orderBy:"PlaylistOrderByWithRelationInput",
			cursor:"PlaylistWhereUniqueInput",
			distinct:"PlaylistScalarFieldEnum"
		},
		sidebarParentPlaylists:{
			where:"PlaylistWhereInput",
			orderBy:"PlaylistOrderByWithRelationInput",
			cursor:"PlaylistWhereUniqueInput",
			distinct:"PlaylistScalarFieldEnum"
		}
	},
	PlaylistCount:{
		adBoardGroupsForAds:{
			where:"AdBoardGroupWhereInput"
		},
		adBoardGroups:{
			where:"AdBoardGroupWhereInput"
		},
		footerParentPlaylists:{
			where:"PlaylistWhereInput"
		},
		sidebarParentPlaylists:{
			where:"PlaylistWhereInput"
		}
	},
	AdBoardGroup:{
		adBoard:{
			where:"AdBoardWhereInput"
		},
		scheduledPlaylists:{
			where:"PlaylistWhereInput",
			orderBy:"PlaylistOrderByWithRelationInput",
			cursor:"PlaylistWhereUniqueInput",
			distinct:"PlaylistScalarFieldEnum"
		},
		adsPlaylist:{
			where:"PlaylistWhereInput"
		},
		pisignagePlayers:{
			where:"PlayerWhereInput",
			orderBy:"PlayerOrderByWithRelationInput",
			cursor:"PlayerWhereUniqueInput",
			distinct:"PlayerScalarFieldEnum"
		}
	},
	AdBoardGroupCount:{
		scheduledPlaylists:{
			where:"PlaylistWhereInput"
		},
		pisignagePlayers:{
			where:"PlayerWhereInput"
		}
	},
	PlaylistWhereUniqueInput:{
		AND:"PlaylistWhereInput",
		OR:"PlaylistWhereInput",
		NOT:"PlaylistWhereInput",
		displayName:"StringNullableFilter",
		assets:"PisignageFileObjectEqualityInput",
		isAdsPlaylist:"BoolNullableFilter",
		footerPlaylistId:"StringNullableFilter",
		sidebarPlaylistId:"StringNullableFilter",
		layout:"EnumScreenLayoutFilter",
		isDeployed:"BoolNullableFilter",
		adBoardGroupIds:"StringNullableListFilter",
		workspaceId:"StringFilter",
		footerPlaylist:"PlaylistNullableRelationFilter",
		sidebarPlaylist:"PlaylistNullableRelationFilter",
		adBoardGroupsForAds:"AdBoardGroupListRelationFilter",
		adBoardGroups:"AdBoardGroupListRelationFilter",
		workspace:"WorkspaceRelationFilter",
		footerParentPlaylists:"PlaylistListRelationFilter",
		sidebarParentPlaylists:"PlaylistListRelationFilter"
	},
	PlaylistScalarFieldEnum: "enum" as const,
	Player:{
		adBoardGroup:{
			where:"AdBoardGroupWhereInput"
		},
		workspace:{
			where:"WorkspaceWhereInput"
		},
		status:{
			where:"PlayerUptimeStatusWhereInput",
			orderBy:"PlayerUptimeStatusOrderByWithRelationInput",
			cursor:"PlayerUptimeStatusWhereUniqueInput",
			distinct:"PlayerUptimeStatusScalarFieldEnum"
		},
		cameras:{
			where:"CameraWhereInput",
			orderBy:"CameraOrderByWithRelationInput",
			cursor:"CameraWhereUniqueInput",
			distinct:"CameraScalarFieldEnum"
		},
		signageType:{
			where:"DigitalSignageWhereInput"
		},
		audienceType:{
			where:"AudienceWhereInput",
			orderBy:"AudienceOrderByWithRelationInput",
			cursor:"AudienceWhereUniqueInput",
			distinct:"AudienceScalarFieldEnum"
		},
		adBoards:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		},
		deletedBy:{
			where:"UserWhereInput"
		},
		cameraStreamingDevices:{
			where:"StreamingDeviceWhereInput",
			orderBy:"StreamingDeviceOrderByWithRelationInput",
			cursor:"StreamingDeviceWhereUniqueInput",
			distinct:"StreamingDeviceScalarFieldEnum"
		}
	},
	PlayerCount:{
		status:{
			where:"PlayerUptimeStatusWhereInput"
		},
		cameras:{
			where:"CameraWhereInput"
		},
		audienceType:{
			where:"AudienceWhereInput"
		},
		adBoards:{
			where:"AdBoardWhereInput"
		},
		cameraStreamingDevices:{
			where:"StreamingDeviceWhereInput"
		}
	},
	PlayerUptimeStatusOrderByWithRelationInput:{
		id:"SortOrder",
		playerId:"SortOrder",
		cpuSerialNumber:"SortOrder",
		date:"SortOrder",
		uptime:"SortOrder",
		player:"PlayerOrderByWithRelationInput"
	},
	PlayerOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		configLocation:"SortOrder",
		pisignagePlayerId:"SortOrder",
		pisignageGroupId:"SortOrder",
		cpuSerialNumber:"SortOrder",
		displayName:"SortOrder",
		adBoardGroupId:"SortOrder",
		playlistIds:"SortOrder",
		workpaceId:"SortOrder",
		resolution:"ResolutionOrderByInput",
		screenSize:"ScreenSizeOrderByInput",
		signageTypeId:"SortOrder",
		audienceTypeId:"SortOrder",
		playbackDetails:"PlaybackTimeOrderByCompositeAggregateInput",
		aspectRatioType:"SortOrder",
		customAspectRatioWidth:"SortOrder",
		customAspectRatioHeight:"SortOrder",
		map:"MapOrderByInput",
		isOnline:"SortOrder",
		adBoardIds:"SortOrder",
		galleryFiles:"GalleryFileOrderByCompositeAggregateInput",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		markForDeletion:"SortOrder",
		deletedAt:"SortOrder",
		deletedByUserId:"SortOrder",
		visible:"SortOrder",
		adBoardGroup:"AdBoardGroupOrderByWithRelationInput",
		workspace:"WorkspaceOrderByWithRelationInput",
		status:"PlayerUptimeStatusOrderByRelationAggregateInput",
		cameras:"CameraOrderByRelationAggregateInput",
		signageType:"DigitalSignageOrderByWithRelationInput",
		audienceType:"AudienceOrderByRelationAggregateInput",
		adBoards:"AdBoardOrderByRelationAggregateInput",
		deletedBy:"UserOrderByWithRelationInput",
		cameraStreamingDevices:"StreamingDeviceOrderByRelationAggregateInput"
	},
	MapOrderByInput:{
		lat:"SortOrder",
		lng:"SortOrder",
		address:"SortOrder",
		city:"SortOrder",
		state:"SortOrder",
		country:"SortOrder"
	},
	GalleryFileOrderByCompositeAggregateInput:{
		_count:"SortOrder"
	},
	PlayerUptimeStatusOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	DigitalSignageOrderByWithRelationInput:{
		id:"SortOrder",
		type:"SortOrder",
		name:"SortOrder",
		description:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		players:"PlayerOrderByRelationAggregateInput"
	},
	AudienceOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	PlayerUptimeStatusWhereUniqueInput:{
		cpuSerialNumber_date:"PlayerUptimeStatusCpuSerialNumberDateCompoundUniqueInput",
		AND:"PlayerUptimeStatusWhereInput",
		OR:"PlayerUptimeStatusWhereInput",
		NOT:"PlayerUptimeStatusWhereInput",
		playerId:"StringFilter",
		cpuSerialNumber:"StringFilter",
		date:"StringFilter",
		uptime:"FloatFilter",
		player:"PlayerRelationFilter"
	},
	PlayerUptimeStatusCpuSerialNumberDateCompoundUniqueInput:{

	},
	PlayerUptimeStatusScalarFieldEnum: "enum" as const,
	Camera:{
		player:{
			where:"PlayerWhereInput"
		},
		workspace:{
			where:"WorkspaceWhereInput"
		}
	},
	CameraOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		isOnline:"SortOrder",
		playerId:"SortOrder",
		workspaceId:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		isPublic:"SortOrder",
		player:"PlayerOrderByWithRelationInput",
		workspace:"WorkspaceOrderByWithRelationInput"
	},
	CameraWhereUniqueInput:{
		AND:"CameraWhereInput",
		OR:"CameraWhereInput",
		NOT:"CameraWhereInput",
		name:"StringNullableFilter",
		isOnline:"BoolFilter",
		playerId:"StringNullableFilter",
		workspaceId:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		isPublic:"BoolFilter",
		player:"PlayerNullableRelationFilter",
		workspace:"WorkspaceNullableRelationFilter"
	},
	CameraScalarFieldEnum: "enum" as const,
	DigitalSignage:{
		players:{
			where:"PlayerWhereInput",
			orderBy:"PlayerOrderByWithRelationInput",
			cursor:"PlayerWhereUniqueInput",
			distinct:"PlayerScalarFieldEnum"
		}
	},
	DigitalSignageCount:{
		players:{
			where:"PlayerWhereInput"
		}
	},
	PlayerWhereUniqueInput:{
		AND:"PlayerWhereInput",
		OR:"PlayerWhereInput",
		NOT:"PlayerWhereInput",
		name:"StringFilter",
		configLocation:"StringNullableFilter",
		pisignagePlayerId:"StringNullableFilter",
		pisignageGroupId:"StringNullableFilter",
		displayName:"StringNullableFilter",
		adBoardGroupId:"StringNullableFilter",
		playlistIds:"StringNullableListFilter",
		workpaceId:"StringNullableFilter",
		resolution:"ResolutionNullableCompositeFilter",
		screenSize:"ScreenSizeNullableCompositeFilter",
		signageTypeId:"StringNullableFilter",
		audienceTypeId:"StringNullableListFilter",
		playbackDetails:"PlaybackTimeObjectEqualityInput",
		aspectRatioType:"EnumAspectRatioTypeFilter",
		customAspectRatioWidth:"IntNullableFilter",
		customAspectRatioHeight:"IntNullableFilter",
		map:"MapNullableCompositeFilter",
		isOnline:"BoolFilter",
		adBoardIds:"StringNullableListFilter",
		galleryFiles:"GalleryFileObjectEqualityInput",
		createdAt:"DateTimeNullableFilter",
		updatedAt:"DateTimeNullableFilter",
		markForDeletion:"BoolFilter",
		deletedAt:"DateTimeNullableFilter",
		deletedByUserId:"StringNullableFilter",
		visible:"BoolFilter",
		adBoardGroup:"AdBoardGroupNullableRelationFilter",
		workspace:"WorkspaceNullableRelationFilter",
		status:"PlayerUptimeStatusListRelationFilter",
		cameras:"CameraListRelationFilter",
		signageType:"DigitalSignageNullableRelationFilter",
		audienceType:"AudienceListRelationFilter",
		adBoards:"AdBoardListRelationFilter",
		deletedBy:"UserNullableRelationFilter",
		cameraStreamingDevices:"StreamingDeviceListRelationFilter"
	},
	PlayerScalarFieldEnum: "enum" as const,
	Audience:{
		players:{
			where:"PlayerWhereInput",
			orderBy:"PlayerOrderByWithRelationInput",
			cursor:"PlayerWhereUniqueInput",
			distinct:"PlayerScalarFieldEnum"
		}
	},
	AudienceCount:{
		players:{
			where:"PlayerWhereInput"
		}
	},
	AudienceOrderByWithRelationInput:{
		id:"SortOrder",
		type:"SortOrder",
		name:"SortOrder",
		description:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		playerIDs:"SortOrder",
		players:"PlayerOrderByRelationAggregateInput"
	},
	AudienceWhereUniqueInput:{
		AND:"AudienceWhereInput",
		OR:"AudienceWhereInput",
		NOT:"AudienceWhereInput",
		type:"EnumAudienceTypeFilter",
		name:"StringFilter",
		description:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		playerIDs:"StringNullableListFilter",
		players:"PlayerListRelationFilter"
	},
	AudienceScalarFieldEnum: "enum" as const,
	StreamingDevice:{
		player:{
			where:"PlayerWhereInput"
		},
		workspace:{
			where:"WorkspaceWhereInput"
		},
		billboardMonitoringAlerts:{
			where:"BillboardMonitoringAlertWhereInput",
			orderBy:"BillboardMonitoringAlertOrderByWithRelationInput",
			cursor:"BillboardMonitoringAlertWhereUniqueInput",
			distinct:"BillboardMonitoringAlertScalarFieldEnum"
		}
	},
	StreamingDeviceCount:{
		billboardMonitoringAlerts:{
			where:"BillboardMonitoringAlertWhereInput"
		}
	},
	BillboardMonitoringAlertOrderByWithRelationInput:{
		id:"SortOrder",
		startTime:"SortOrder",
		endTime:"SortOrder",
		isActive:"SortOrder",
		isFalsePositive:"SortOrder",
		enabledAlerts:"AlertConfigOrderByCompositeAggregateInput",
		streamingDeviceId:"SortOrder",
		streamingDevice:"StreamingDeviceOrderByWithRelationInput"
	},
	AlertConfigOrderByCompositeAggregateInput:{
		_count:"SortOrder"
	},
	StreamingDeviceOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		deviceId:"SortOrder",
		socketId:"SortOrder",
		isConnected:"SortOrder",
		playerId:"SortOrder",
		connectionLogs:"ConnectionLogOrderByCompositeAggregateInput",
		workspaceId:"SortOrder",
		billboardMonitoring:"BillboardMonitoringOrderByInput",
		trafficMonitoring:"TrafficMonitoringOrderByInput",
		rtspStreamUrl:"SortOrder",
		publicWebUrl:"SortOrder",
		services:"StreamingServicesOrderByInput",
		player:"PlayerOrderByWithRelationInput",
		workspace:"WorkspaceOrderByWithRelationInput",
		billboardMonitoringAlerts:"BillboardMonitoringAlertOrderByRelationAggregateInput"
	},
	ConnectionLogOrderByCompositeAggregateInput:{
		_count:"SortOrder"
	},
	BillboardMonitoringOrderByInput:{
		customInstructions:"SortOrder",
		rtspStreamUrl:"SortOrder",
		aiApiKey:"SortOrder",
		apiCallInterval:"SortOrder",
		publicWebUrl:"SortOrder",
		alertsEnabled:"SortOrder",
		alertConfigs:"AlertConfigOrderByCompositeAggregateInput"
	},
	TrafficMonitoringOrderByInput:{
		enabled:"SortOrder",
		rtspStreamUrl:"SortOrder",
		metadata:"SortOrder",
		inferenceInterval:"SortOrder",
		longStayThreshold:"SortOrder",
		apiEndpoint:"SortOrder",
		batchSize:"SortOrder",
		apiCallInterval:"SortOrder"
	},
	StreamingServicesOrderByInput:{
		billboardMonitoring:"BillboardMonitoringOrderByInput",
		trafficMonitoring:"TrafficMonitoringOrderByInput",
		rtspStreamUrl:"SortOrder",
		publicWebUrl:"SortOrder"
	},
	BillboardMonitoringAlertOrderByRelationAggregateInput:{
		_count:"SortOrder"
	},
	BillboardMonitoringAlertWhereUniqueInput:{
		AND:"BillboardMonitoringAlertWhereInput",
		OR:"BillboardMonitoringAlertWhereInput",
		NOT:"BillboardMonitoringAlertWhereInput",
		startTime:"DateTimeFilter",
		endTime:"DateTimeNullableFilter",
		isActive:"BoolFilter",
		isFalsePositive:"BoolFilter",
		enabledAlerts:"AlertConfigObjectEqualityInput",
		streamingDeviceId:"StringFilter",
		streamingDevice:"StreamingDeviceRelationFilter"
	},
	BillboardMonitoringAlertScalarFieldEnum: "enum" as const,
	StreamingDeviceWhereUniqueInput:{
		AND:"StreamingDeviceWhereInput",
		OR:"StreamingDeviceWhereInput",
		NOT:"StreamingDeviceWhereInput",
		name:"StringNullableFilter",
		socketId:"StringNullableFilter",
		isConnected:"BoolNullableFilter",
		playerId:"StringNullableFilter",
		connectionLogs:"ConnectionLogObjectEqualityInput",
		workspaceId:"StringNullableFilter",
		billboardMonitoring:"BillboardMonitoringNullableCompositeFilter",
		trafficMonitoring:"TrafficMonitoringNullableCompositeFilter",
		rtspStreamUrl:"StringNullableFilter",
		publicWebUrl:"StringNullableFilter",
		services:"StreamingServicesNullableCompositeFilter",
		player:"PlayerNullableRelationFilter",
		workspace:"WorkspaceNullableRelationFilter",
		billboardMonitoringAlerts:"BillboardMonitoringAlertListRelationFilter"
	},
	StreamingDeviceScalarFieldEnum: "enum" as const,
	AdBoardGroupWhereUniqueInput:{
		AND:"AdBoardGroupWhereInput",
		OR:"AdBoardGroupWhereInput",
		NOT:"AdBoardGroupWhereInput",
		schedules:"ScheduleObjectEqualityInput",
		scheduledPlaylistsIDs:"StringNullableListFilter",
		adsPlaylistID:"StringNullableFilter",
		fitImage:"EnumFitTypeFilter",
		fitVideo:"EnumFitTypeFilter",
		workspaceId:"StringFilter",
		adBoard:"AdBoardNullableRelationFilter",
		scheduledPlaylists:"PlaylistListRelationFilter",
		adsPlaylist:"PlaylistNullableRelationFilter",
		pisignagePlayers:"PlayerListRelationFilter",
		workspace:"WorkspaceRelationFilter"
	},
	AdBoardGroupScalarFieldEnum: "enum" as const,
	Audit:{
		workspace:{
			where:"WorkspaceWhereInput"
		}
	},
	AuditOrderByWithRelationInput:{
		id:"SortOrder",
		createdAt:"SortOrder",
		message:"SortOrder",
		action:"SortOrder",
		entity:"EntityOrderByInput",
		userId:"SortOrder",
		workspaceId:"SortOrder",
		updates:"SortOrder",
		user:"UserOrderByWithRelationInput",
		workspace:"WorkspaceOrderByWithRelationInput"
	},
	EntityOrderByInput:{
		type:"SortOrder",
		id:"SortOrder",
		name:"SortOrder"
	},
	AuditWhereUniqueInput:{
		AND:"AuditWhereInput",
		OR:"AuditWhereInput",
		NOT:"AuditWhereInput",
		createdAt:"DateTimeFilter",
		message:"StringFilter",
		action:"StringFilter",
		entity:"EntityNullableCompositeFilter",
		userId:"StringFilter",
		workspaceId:"StringNullableFilter",
		updates:"JsonNullableFilter",
		user:"UserRelationFilter",
		workspace:"WorkspaceNullableRelationFilter"
	},
	AuditScalarFieldEnum: "enum" as const,
	FileOrderByWithRelationInput:{
		id:"SortOrder",
		contentType:"SortOrder",
		ctime:"SortOrder",
		filename:"SortOrder",
		filepath:"SortOrder",
		isDirectory:"SortOrder",
		meta:"FileMetaOrderByInput",
		mtime:"SortOrder",
		name:"SortOrder",
		size:"SortOrder",
		status:"SortOrder",
		type:"SortOrder",
		updatedAt:"SortOrder",
		createdAt:"SortOrder",
		updatedByUserId:"SortOrder",
		createdByUserId:"SortOrder",
		url:"SortOrder",
		bookingsIDs:"SortOrder",
		workspaceId:"SortOrder",
		proofBookingId:"SortOrder",
		campaignIds:"SortOrder",
		contentVersionId:"SortOrder",
		updatedBy:"UserOrderByWithRelationInput",
		createdBy:"UserOrderByWithRelationInput",
		bookings:"BookingOrderByRelationAggregateInput",
		workspace:"WorkspaceOrderByWithRelationInput",
		proofBooking:"BookingOrderByWithRelationInput",
		campaigns:"CampaignOrderByRelationAggregateInput",
		contentVersions:"ContentVersionOrderByRelationAggregateInput"
	},
	FileMetaOrderByInput:{
		duration:"SortOrder",
		height:"SortOrder",
		width:"SortOrder"
	},
	FileWhereUniqueInput:{
		AND:"FileWhereInput",
		OR:"FileWhereInput",
		NOT:"FileWhereInput",
		contentType:"StringFilter",
		ctime:"StringNullableFilter",
		filename:"StringFilter",
		filepath:"StringNullableFilter",
		isDirectory:"BoolFilter",
		meta:"FileMetaCompositeFilter",
		mtime:"StringFilter",
		name:"StringFilter",
		size:"IntFilter",
		status:"EnumFileStatusNullableFilter",
		type:"StringFilter",
		updatedAt:"DateTimeFilter",
		createdAt:"DateTimeFilter",
		updatedByUserId:"StringNullableFilter",
		createdByUserId:"StringFilter",
		bookingsIDs:"StringNullableListFilter",
		workspaceId:"StringNullableFilter",
		proofBookingId:"StringNullableFilter",
		campaignIds:"StringNullableListFilter",
		contentVersionId:"StringNullableListFilter",
		updatedBy:"UserNullableRelationFilter",
		createdBy:"UserRelationFilter",
		bookings:"BookingListRelationFilter",
		workspace:"WorkspaceNullableRelationFilter",
		proofBooking:"BookingNullableRelationFilter",
		campaigns:"CampaignListRelationFilter",
		contentVersions:"ContentVersionListRelationFilter"
	},
	FileScalarFieldEnum: "enum" as const,
	Transaction:{
		workspace:{
			where:"WorkspaceWhereInput"
		},
		payouts:{
			where:"PayoutWhereInput",
			orderBy:"PayoutOrderByWithRelationInput",
			cursor:"PayoutWhereUniqueInput",
			distinct:"PayoutScalarFieldEnum"
		}
	},
	TransactionCount:{
		payouts:{
			where:"PayoutWhereInput"
		}
	},
	Payout:{
		transaction:{
			where:"TransactionWhereInput"
		}
	},
	PayoutOrderByWithRelationInput:{
		id:"SortOrder",
		totalAmount:"SortOrder",
		commissionRate:"SortOrder",
		commissionAmount:"SortOrder",
		netAmount:"SortOrder",
		createdAt:"SortOrder",
		bookingId:"SortOrder",
		status:"SortOrder",
		transactionId:"SortOrder",
		booking:"BookingOrderByWithRelationInput",
		transaction:"TransactionOrderByWithRelationInput"
	},
	TransactionOrderByWithRelationInput:{
		workspaceId:"SortOrder",
		id:"SortOrder",
		amount:"SortOrder",
		createAt:"SortOrder",
		processedAt:"SortOrder",
		relatedEntityId:"SortOrder",
		transactionStatus:"SortOrder",
		details:"SortOrder",
		workspace:"WorkspaceOrderByWithRelationInput",
		payouts:"PayoutOrderByRelationAggregateInput"
	},
	PayoutWhereUniqueInput:{
		AND:"PayoutWhereInput",
		OR:"PayoutWhereInput",
		NOT:"PayoutWhereInput",
		totalAmount:"FloatFilter",
		commissionRate:"FloatFilter",
		commissionAmount:"FloatFilter",
		netAmount:"FloatFilter",
		createdAt:"DateTimeFilter",
		bookingId:"StringFilter",
		status:"EnumPayoutStatusFilter",
		transactionId:"StringNullableFilter",
		booking:"BookingRelationFilter",
		transaction:"TransactionNullableRelationFilter"
	},
	PayoutScalarFieldEnum: "enum" as const,
	TransactionWhereUniqueInput:{
		AND:"TransactionWhereInput",
		OR:"TransactionWhereInput",
		NOT:"TransactionWhereInput",
		workspaceId:"StringNullableFilter",
		amount:"FloatFilter",
		createAt:"DateTimeFilter",
		processedAt:"DateTimeNullableFilter",
		relatedEntityId:"StringFilter",
		transactionStatus:"EnumTransactionStatusFilter",
		details:"JsonNullableFilter",
		workspace:"WorkspaceNullableRelationFilter",
		payouts:"PayoutListRelationFilter"
	},
	TransactionScalarFieldEnum: "enum" as const,
	WorkspaceRoleWhereUniqueInput:{
		name_workspaceId:"WorkspaceRoleNameWorkspaceIdCompoundUniqueInput",
		AND:"WorkspaceRoleWhereInput",
		OR:"WorkspaceRoleWhereInput",
		NOT:"WorkspaceRoleWhereInput",
		permissions:"EnumPermissionNullableListFilter",
		workspaceId:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		workspace:"WorkspaceNullableRelationFilter",
		memberships:"MembershipListRelationFilter"
	},
	WorkspaceRoleNameWorkspaceIdCompoundUniqueInput:{

	},
	WorkspaceRoleScalarFieldEnum: "enum" as const,
	UserWhereUniqueInput:{
		AND:"UserWhereInput",
		OR:"UserWhereInput",
		NOT:"UserWhereInput",
		image:"StringNullableFilter",
		phoneNumber:"StringNullableFilter",
		displayName:"StringNullableFilter",
		otherDetails:"JsonNullableFilter",
		stripe:"UserStripeNullableCompositeFilter",
		roles:"EnumRoleNullableListFilter",
		refunds:"BookingRefundObjectEqualityInput",
		sharedBookingIds:"StringNullableListFilter",
		disclaimerAccepted:"BoolFilter",
		notificationPreference:"NotificationPreferenceNullableCompositeFilter",
		leadWorkspaceIds:"StringNullableListFilter",
		bookings:"BookingListRelationFilter",
		createdFiles:"FileListRelationFilter",
		updatedFiles:"FileListRelationFilter",
		orders:"OrderListRelationFilter",
		changelogs:"ChangelogListRelationFilter",
		adBoards:"AdBoardListRelationFilter",
		audits:"AuditListRelationFilter",
		campaigns:"CampaignListRelationFilter",
		sharedBookings:"BookingListRelationFilter",
		memberships:"MembershipListRelationFilter",
		notifications:"NotificationListRelationFilter",
		publishAdboardVersion:"AdBoardPublishHistoryListRelationFilter",
		reviewComments:"AdBoardReviewCommentListRelationFilter",
		archivedAdboards:"AdBoardListRelationFilter",
		ownedWorkspaces:"WorkspaceListRelationFilter",
		leadWorspaces:"WorkspaceListRelationFilter",
		publicReviews:"AdBoardPublicReviewListRelationFilter",
		userPositions:"UserPositionListRelationFilter",
		wishlists:"WishlistListRelationFilter",
		deletedPlayerIds:"PlayerListRelationFilter",
		deployedContentVersions:"ContentVersionListRelationFilter",
		submittedContentVersions:"ContentVersionListRelationFilter",
		approvedContentVersions:"ContentVersionListRelationFilter"
	},
	UserScalarFieldEnum: "enum" as const,
	ContentVersion:{
		approvedBy:{
			where:"UserWhereInput"
		},
		deployedBy:{
			where:"UserWhereInput"
		},
		assets:{
			where:"FileWhereInput",
			orderBy:"FileOrderByWithRelationInput",
			cursor:"FileWhereUniqueInput",
			distinct:"FileScalarFieldEnum"
		}
	},
	ContentVersionCount:{
		assets:{
			where:"FileWhereInput"
		}
	},
	ContentVersionOrderByWithRelationInput:{
		id:"SortOrder",
		bookingId:"SortOrder",
		versionNumber:"SortOrder",
		status:"SortOrder",
		submittedAt:"SortOrder",
		approvedAt:"SortOrder",
		deployedAt:"SortOrder",
		submittedByUserId:"SortOrder",
		approvedByUserId:"SortOrder",
		deployedByUserId:"SortOrder",
		assetIds:"SortOrder",
		comments:"SortOrder",
		createdAt:"SortOrder",
		booking:"BookingOrderByWithRelationInput",
		submittedBy:"UserOrderByWithRelationInput",
		approvedBy:"UserOrderByWithRelationInput",
		deployedBy:"UserOrderByWithRelationInput",
		assets:"FileOrderByRelationAggregateInput"
	},
	ContentVersionWhereUniqueInput:{
		AND:"ContentVersionWhereInput",
		OR:"ContentVersionWhereInput",
		NOT:"ContentVersionWhereInput",
		bookingId:"StringFilter",
		versionNumber:"IntFilter",
		status:"EnumContentApprovalStatusFilter",
		submittedAt:"DateTimeFilter",
		approvedAt:"DateTimeNullableFilter",
		deployedAt:"DateTimeNullableFilter",
		submittedByUserId:"StringFilter",
		approvedByUserId:"StringNullableFilter",
		deployedByUserId:"StringNullableFilter",
		assetIds:"StringNullableListFilter",
		comments:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		booking:"BookingRelationFilter",
		submittedBy:"UserRelationFilter",
		approvedBy:"UserNullableRelationFilter",
		deployedBy:"UserNullableRelationFilter",
		assets:"FileListRelationFilter"
	},
	ContentVersionScalarFieldEnum: "enum" as const,
	Payment:{
		campaign:{
			where:"CampaignWhereInput"
		},
		paymentAllocations:{
			where:"PaymentAllocationWhereInput",
			orderBy:"PaymentAllocationOrderByWithRelationInput",
			cursor:"PaymentAllocationWhereUniqueInput",
			distinct:"PaymentAllocationScalarFieldEnum"
		}
	},
	PaymentCount:{
		paymentAllocations:{
			where:"PaymentAllocationWhereInput"
		}
	},
	PaymentAllocationOrderByWithRelationInput:{
		id:"SortOrder",
		paymentId:"SortOrder",
		bookingId:"SortOrder",
		subtotal:"SortOrder",
		tax:"SortOrder",
		discount:"SortOrder",
		total:"SortOrder",
		payment:"PaymentOrderByWithRelationInput",
		booking:"BookingOrderByWithRelationInput"
	},
	PaymentOrderByWithRelationInput:{
		id:"SortOrder",
		paymentIntentId:"SortOrder",
		checkoutSessionId:"SortOrder",
		eventId:"SortOrder",
		liveMode:"SortOrder",
		paymentGateway:"SortOrder",
		subtotal:"SortOrder",
		total:"SortOrder",
		tax:"SortOrder",
		discount:"SortOrder",
		campaignId:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		campaign:"CampaignOrderByWithRelationInput",
		paymentAllocations:"PaymentAllocationOrderByRelationAggregateInput"
	},
	PaymentAllocationWhereUniqueInput:{
		AND:"PaymentAllocationWhereInput",
		OR:"PaymentAllocationWhereInput",
		NOT:"PaymentAllocationWhereInput",
		paymentId:"StringFilter",
		bookingId:"StringFilter",
		subtotal:"FloatFilter",
		tax:"FloatFilter",
		discount:"FloatFilter",
		total:"FloatFilter",
		payment:"PaymentRelationFilter",
		booking:"BookingRelationFilter"
	},
	PaymentAllocationScalarFieldEnum: "enum" as const,
	Changelog:{
		booking:{
			where:"BookingWhereInput"
		}
	},
	ChangelogOrderByWithRelationInput:{
		id:"SortOrder",
		createdAt:"SortOrder",
		message:"SortOrder",
		action:"SortOrder",
		bookingId:"SortOrder",
		userId:"SortOrder",
		updates:"SortOrder",
		booking:"BookingOrderByWithRelationInput",
		user:"UserOrderByWithRelationInput"
	},
	ChangelogWhereUniqueInput:{
		AND:"ChangelogWhereInput",
		OR:"ChangelogWhereInput",
		NOT:"ChangelogWhereInput",
		createdAt:"DateTimeFilter",
		message:"StringFilter",
		action:"StringFilter",
		bookingId:"StringNullableFilter",
		userId:"StringFilter",
		updates:"JsonNullableFilter",
		booking:"BookingNullableRelationFilter",
		user:"UserRelationFilter"
	},
	ChangelogScalarFieldEnum: "enum" as const,
	SlotUsageOrderByWithRelationInput:{
		id:"SortOrder",
		bookingId:"SortOrder",
		date:"SortOrder",
		slotUsed:"SortOrder",
		booking:"BookingOrderByWithRelationInput"
	},
	SlotUsageWhereUniqueInput:{
		bookingId_date:"SlotUsageBookingIdDateCompoundUniqueInput",
		AND:"SlotUsageWhereInput",
		OR:"SlotUsageWhereInput",
		NOT:"SlotUsageWhereInput",
		bookingId:"StringFilter",
		date:"DateTimeFilter",
		slotUsed:"IntFilter",
		booking:"BookingRelationFilter"
	},
	SlotUsageBookingIdDateCompoundUniqueInput:{
		date:"DateTime"
	},
	SlotUsageScalarFieldEnum: "enum" as const,
	BookingHistoryOrderByWithRelationInput:{
		id:"SortOrder",
		bookingId:"SortOrder",
		status:"SortOrder",
		createdBy:"SortOrder",
		timestamp:"SortOrder",
		booking:"BookingOrderByWithRelationInput"
	},
	BookingHistoryWhereUniqueInput:{
		AND:"BookingHistoryWhereInput",
		OR:"BookingHistoryWhereInput",
		NOT:"BookingHistoryWhereInput",
		bookingId:"StringFilter",
		status:"EnumBookingStatusFilter",
		createdBy:"StringFilter",
		timestamp:"DateTimeFilter",
		booking:"BookingRelationFilter"
	},
	BookingHistoryScalarFieldEnum: "enum" as const,
	Order:{
		createdBy:{
			where:"UserWhereInput"
		}
	},
	OrderOrderByWithRelationInput:{
		id:"SortOrder",
		adBoardId:"SortOrder",
		createdDate:"SortOrder",
		createdByUserId:"SortOrder",
		origin:"SortOrder",
		paymentId:"SortOrder",
		priceSummary:"PriceSummaryOrderByInput",
		selectedDate:"OrderSelectedDateOrderByInput",
		adBoard:"AdBoardOrderByWithRelationInput",
		createdBy:"UserOrderByWithRelationInput"
	},
	OrderWhereUniqueInput:{
		AND:"OrderWhereInput",
		OR:"OrderWhereInput",
		NOT:"OrderWhereInput",
		adBoardId:"StringFilter",
		createdDate:"DateTimeFilter",
		createdByUserId:"StringNullableFilter",
		origin:"StringFilter",
		paymentId:"StringNullableFilter",
		priceSummary:"PriceSummaryCompositeFilter",
		selectedDate:"OrderSelectedDateCompositeFilter",
		adBoard:"AdBoardRelationFilter",
		createdBy:"UserNullableRelationFilter"
	},
	OrderScalarFieldEnum: "enum" as const,
	NotificationOrderByWithRelationInput:{
		id:"SortOrder",
		type:"SortOrder",
		title:"SortOrder",
		content:"SortOrder",
		metadata:"SortOrder",
		createdAt:"SortOrder",
		readAt:"SortOrder",
		recipientId:"SortOrder",
		channels:"SortOrder",
		recipient:"UserOrderByWithRelationInput"
	},
	NotificationWhereUniqueInput:{
		AND:"NotificationWhereInput",
		OR:"NotificationWhereInput",
		NOT:"NotificationWhereInput",
		type:"EnumNotificationTypeFilter",
		title:"StringFilter",
		content:"StringFilter",
		metadata:"JsonNullableFilter",
		createdAt:"DateTimeFilter",
		readAt:"DateTimeNullableFilter",
		recipientId:"StringFilter",
		channels:"EnumNotificationChannelNullableListFilter",
		recipient:"UserRelationFilter"
	},
	NotificationScalarFieldEnum: "enum" as const,
	AdBoardPublishHistoryOrderByWithRelationInput:{
		id:"SortOrder",
		adBoardId:"SortOrder",
		publishedAt:"SortOrder",
		publishedByUserId:"SortOrder",
		changesSnapshot:"SortOrder",
		adBoard:"AdBoardOrderByWithRelationInput",
		publishedBy:"UserOrderByWithRelationInput"
	},
	AdBoardPublishHistoryWhereUniqueInput:{
		AND:"AdBoardPublishHistoryWhereInput",
		OR:"AdBoardPublishHistoryWhereInput",
		NOT:"AdBoardPublishHistoryWhereInput",
		adBoardId:"StringFilter",
		publishedAt:"DateTimeFilter",
		publishedByUserId:"StringFilter",
		changesSnapshot:"JsonFilter",
		adBoard:"AdBoardRelationFilter",
		publishedBy:"UserRelationFilter"
	},
	AdBoardPublishHistoryScalarFieldEnum: "enum" as const,
	AdBoardReviewCommentOrderByWithRelationInput:{
		id:"SortOrder",
		adBoardId:"SortOrder",
		userId:"SortOrder",
		comment:"SortOrder",
		action:"SortOrder",
		createdAt:"SortOrder",
		adBoard:"AdBoardOrderByWithRelationInput",
		user:"UserOrderByWithRelationInput"
	},
	AdBoardReviewCommentWhereUniqueInput:{
		AND:"AdBoardReviewCommentWhereInput",
		OR:"AdBoardReviewCommentWhereInput",
		NOT:"AdBoardReviewCommentWhereInput",
		adBoardId:"StringFilter",
		userId:"StringFilter",
		comment:"StringFilter",
		action:"EnumReviewActionFilter",
		createdAt:"DateTimeFilter",
		adBoard:"AdBoardRelationFilter",
		user:"UserRelationFilter"
	},
	AdBoardReviewCommentScalarFieldEnum: "enum" as const,
	WorkspaceWhereUniqueInput:{
		AND:"WorkspaceWhereInput",
		OR:"WorkspaceWhereInput",
		NOT:"WorkspaceWhereInput",
		type:"EnumWorkspaceTypeFilter",
		name:"StringFilter",
		userIds:"StringNullableListFilter",
		ownerId:"StringNullableFilter",
		avatar:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		leadIds:"StringNullableListFilter",
		webhookAppId:"StringNullableFilter",
		stackAuthTeamId:"StringNullableFilter",
		owner:"UserNullableRelationFilter",
		memberships:"MembershipListRelationFilter",
		adBoards:"AdBoardListRelationFilter",
		playlists:"PlaylistListRelationFilter",
		adBoardGroups:"AdBoardGroupListRelationFilter",
		audits:"AuditListRelationFilter",
		bookings:"BookingListRelationFilter",
		files:"FileListRelationFilter",
		players:"PlayerListRelationFilter",
		transactions:"TransactionListRelationFilter",
		activeSubscription:"SubscriptionNullableRelationFilter",
		workspaceRoles:"WorkspaceRoleListRelationFilter",
		leads:"UserListRelationFilter",
		cameras:"CameraListRelationFilter",
		cameraStreamingDevices:"StreamingDeviceListRelationFilter"
	},
	WorkspaceScalarFieldEnum: "enum" as const,
	AdBoardPublicReviewWhereUniqueInput:{
		AND:"AdBoardPublicReviewWhereInput",
		OR:"AdBoardPublicReviewWhereInput",
		NOT:"AdBoardPublicReviewWhereInput",
		rating:"FloatFilter",
		title:"StringFilter",
		description:"StringFilter",
		isVerified:"BoolFilter",
		helpfulYes:"IntFilter",
		helpfulNo:"IntFilter",
		imageUrls:"StringNullableListFilter",
		adBoardId:"StringFilter",
		userId:"StringFilter",
		createdAt:"DateTimeFilter",
		adBoard:"AdBoardRelationFilter",
		user:"UserRelationFilter",
		booking:"BookingRelationFilter"
	},
	AdBoardPublicReviewScalarFieldEnum: "enum" as const,
	UserPositionOrderByWithRelationInput:{
		id:"SortOrder",
		timestamp:"SortOrder",
		createdAt:"SortOrder",
		userId:"SortOrder",
		coords:"UserPositionCoordsOrderByInput",
		location:"UserPositionLocationOrderByInput",
		user:"UserOrderByWithRelationInput"
	},
	UserPositionCoordsOrderByInput:{
		accuracy:"SortOrder",
		altitude:"SortOrder",
		altitudeAccuracy:"SortOrder",
		heading:"SortOrder",
		latitude:"SortOrder",
		longitude:"SortOrder",
		speed:"SortOrder"
	},
	UserPositionLocationOrderByInput:{
		address:"SortOrder",
		city:"SortOrder",
		state:"SortOrder",
		country:"SortOrder"
	},
	UserPositionWhereUniqueInput:{
		AND:"UserPositionWhereInput",
		OR:"UserPositionWhereInput",
		NOT:"UserPositionWhereInput",
		timestamp:"DateTimeFilter",
		createdAt:"DateTimeFilter",
		userId:"StringFilter",
		coords:"UserPositionCoordsCompositeFilter",
		location:"UserPositionLocationNullableCompositeFilter",
		user:"UserRelationFilter"
	},
	UserPositionScalarFieldEnum: "enum" as const,
	Wishlist:{
		adBoards:{
			where:"AdBoardWhereInput",
			orderBy:"AdBoardOrderByWithRelationInput",
			cursor:"AdBoardWhereUniqueInput",
			distinct:"AdBoardScalarFieldEnum"
		}
	},
	WishlistCount:{
		adBoards:{
			where:"AdBoardWhereInput"
		}
	},
	WishlistOrderByWithRelationInput:{
		id:"SortOrder",
		name:"SortOrder",
		userId:"SortOrder",
		adBoardIds:"SortOrder",
		createdAt:"SortOrder",
		user:"UserOrderByWithRelationInput",
		adBoards:"AdBoardOrderByRelationAggregateInput"
	},
	WishlistWhereUniqueInput:{
		AND:"WishlistWhereInput",
		OR:"WishlistWhereInput",
		NOT:"WishlistWhereInput",
		name:"StringFilter",
		userId:"StringFilter",
		adBoardIds:"StringNullableListFilter",
		createdAt:"DateTimeFilter",
		user:"UserRelationFilter",
		adBoards:"AdBoardListRelationFilter"
	},
	WishlistScalarFieldEnum: "enum" as const,
	PaymentWhereUniqueInput:{
		AND:"PaymentWhereInput",
		OR:"PaymentWhereInput",
		NOT:"PaymentWhereInput",
		liveMode:"BoolFilter",
		paymentGateway:"EnumPaymentGatewayNameFilter",
		subtotal:"FloatFilter",
		total:"FloatFilter",
		tax:"FloatFilter",
		discount:"FloatFilter",
		campaignId:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		campaign:"CampaignNullableRelationFilter",
		paymentAllocations:"PaymentAllocationListRelationFilter"
	},
	PaymentScalarFieldEnum: "enum" as const,
	BusinessCategoryWhereUniqueInput:{
		AND:"BusinessCategoryWhereInput",
		OR:"BusinessCategoryWhereInput",
		NOT:"BusinessCategoryWhereInput",
		description:"StringNullableFilter",
		restrictedByAdBoardIds:"StringNullableListFilter",
		adBoards:"AdBoardListRelationFilter",
		restrictedByAdBoards:"AdBoardListRelationFilter",
		campaigns:"CampaignListRelationFilter",
		bookings:"BookingListRelationFilter"
	},
	BusinessCategoryScalarFieldEnum: "enum" as const,
	SlotConfigurationOrderByWithRelationInput:{
		id:"SortOrder",
		adBoardId:"SortOrder",
		date:"SortOrder",
		availableSlots:"SortOrder",
		adBoard:"AdBoardOrderByWithRelationInput"
	},
	SlotConfigurationWhereUniqueInput:{
		adBoardId_date:"SlotConfigurationAdBoardIdDateCompoundUniqueInput",
		AND:"SlotConfigurationWhereInput",
		OR:"SlotConfigurationWhereInput",
		NOT:"SlotConfigurationWhereInput",
		adBoardId:"StringFilter",
		date:"DateTimeFilter",
		availableSlots:"IntFilter",
		adBoard:"AdBoardRelationFilter"
	},
	SlotConfigurationAdBoardIdDateCompoundUniqueInput:{
		date:"DateTime"
	},
	SlotConfigurationScalarFieldEnum: "enum" as const,
	AdBoardOrderByWithAggregationInput:{
		id:"SortOrder",
		state:"SortOrder",
		city:"SortOrder",
		country:"SortOrder",
		outdoor:"SortOrder",
		locationCategoryId:"SortOrder",
		locationSubCategoryId:"SortOrder",
		alias:"SortOrder",
		title:"SortOrder",
		pricePerDay:"SortOrder",
		originalPricePerDay:"SortOrder",
		description:"SortOrder",
		adBoardTypeId:"SortOrder",
		tags:"SortOrder",
		featuredImage:"SortOrder",
		galleryImgs:"SortOrder",
		notes:"SortOrder",
		impressionMultiplier:"SortOrder",
		categoryId:"SortOrder",
		restrictedBusinessIds:"SortOrder",
		targetAudiences:"SortOrder",
		acceptedMediaTypes:"SortOrder",
		status:"SortOrder",
		adboardDraftStatus:"SortOrder",
		isLive:"SortOrder",
		numberOfDisplays:"SortOrder",
		dailyOperationHours:"SortOrder",
		adsPerLoop:"SortOrder",
		adsDuration:"SortOrder",
		monthlyPrice:"SortOrder",
		offlineBookingsEnabled:"SortOrder",
		createdAt:"SortOrder",
		createdByUserId:"SortOrder",
		href:"SortOrder",
		workspaceId:"SortOrder",
		playerIds:"SortOrder",
		publisherScreenId:"SortOrder",
		additionalData:"SortOrder",
		publishedVersionId:"SortOrder",
		lastPublishedAt:"SortOrder",
		isArchived:"SortOrder",
		archivedAt:"SortOrder",
		archivedByUserId:"SortOrder",
		updatedAt:"SortOrder",
		wishlistIds:"SortOrder",
		_count:"AdBoardCountOrderByAggregateInput",
		_avg:"AdBoardAvgOrderByAggregateInput",
		_max:"AdBoardMaxOrderByAggregateInput",
		_min:"AdBoardMinOrderByAggregateInput",
		_sum:"AdBoardSumOrderByAggregateInput"
	},
	AdBoardCountOrderByAggregateInput:{
		id:"SortOrder",
		state:"SortOrder",
		city:"SortOrder",
		country:"SortOrder",
		outdoor:"SortOrder",
		locationCategoryId:"SortOrder",
		locationSubCategoryId:"SortOrder",
		alias:"SortOrder",
		title:"SortOrder",
		pricePerDay:"SortOrder",
		originalPricePerDay:"SortOrder",
		description:"SortOrder",
		adBoardTypeId:"SortOrder",
		tags:"SortOrder",
		featuredImage:"SortOrder",
		galleryImgs:"SortOrder",
		notes:"SortOrder",
		impressionMultiplier:"SortOrder",
		categoryId:"SortOrder",
		restrictedBusinessIds:"SortOrder",
		targetAudiences:"SortOrder",
		acceptedMediaTypes:"SortOrder",
		status:"SortOrder",
		adboardDraftStatus:"SortOrder",
		isLive:"SortOrder",
		numberOfDisplays:"SortOrder",
		dailyOperationHours:"SortOrder",
		adsPerLoop:"SortOrder",
		adsDuration:"SortOrder",
		monthlyPrice:"SortOrder",
		offlineBookingsEnabled:"SortOrder",
		createdAt:"SortOrder",
		createdByUserId:"SortOrder",
		href:"SortOrder",
		workspaceId:"SortOrder",
		playerIds:"SortOrder",
		publisherScreenId:"SortOrder",
		additionalData:"SortOrder",
		publishedVersionId:"SortOrder",
		lastPublishedAt:"SortOrder",
		isArchived:"SortOrder",
		archivedAt:"SortOrder",
		archivedByUserId:"SortOrder",
		updatedAt:"SortOrder",
		wishlistIds:"SortOrder"
	},
	AdBoardAvgOrderByAggregateInput:{
		pricePerDay:"SortOrder",
		originalPricePerDay:"SortOrder",
		impressionMultiplier:"SortOrder",
		numberOfDisplays:"SortOrder",
		dailyOperationHours:"SortOrder",
		adsPerLoop:"SortOrder",
		adsDuration:"SortOrder",
		monthlyPrice:"SortOrder"
	},
	AdBoardMaxOrderByAggregateInput:{
		id:"SortOrder",
		state:"SortOrder",
		city:"SortOrder",
		country:"SortOrder",
		outdoor:"SortOrder",
		locationCategoryId:"SortOrder",
		locationSubCategoryId:"SortOrder",
		alias:"SortOrder",
		title:"SortOrder",
		pricePerDay:"SortOrder",
		originalPricePerDay:"SortOrder",
		description:"SortOrder",
		adBoardTypeId:"SortOrder",
		featuredImage:"SortOrder",
		impressionMultiplier:"SortOrder",
		categoryId:"SortOrder",
		status:"SortOrder",
		adboardDraftStatus:"SortOrder",
		isLive:"SortOrder",
		numberOfDisplays:"SortOrder",
		dailyOperationHours:"SortOrder",
		adsPerLoop:"SortOrder",
		adsDuration:"SortOrder",
		monthlyPrice:"SortOrder",
		offlineBookingsEnabled:"SortOrder",
		createdAt:"SortOrder",
		createdByUserId:"SortOrder",
		href:"SortOrder",
		workspaceId:"SortOrder",
		publisherScreenId:"SortOrder",
		publishedVersionId:"SortOrder",
		lastPublishedAt:"SortOrder",
		isArchived:"SortOrder",
		archivedAt:"SortOrder",
		archivedByUserId:"SortOrder",
		updatedAt:"SortOrder"
	},
	AdBoardMinOrderByAggregateInput:{
		id:"SortOrder",
		state:"SortOrder",
		city:"SortOrder",
		country:"SortOrder",
		outdoor:"SortOrder",
		locationCategoryId:"SortOrder",
		locationSubCategoryId:"SortOrder",
		alias:"SortOrder",
		title:"SortOrder",
		pricePerDay:"SortOrder",
		originalPricePerDay:"SortOrder",
		description:"SortOrder",
		adBoardTypeId:"SortOrder",
		featuredImage:"SortOrder",
		impressionMultiplier:"SortOrder",
		categoryId:"SortOrder",
		status:"SortOrder",
		adboardDraftStatus:"SortOrder",
		isLive:"SortOrder",
		numberOfDisplays:"SortOrder",
		dailyOperationHours:"SortOrder",
		adsPerLoop:"SortOrder",
		adsDuration:"SortOrder",
		monthlyPrice:"SortOrder",
		offlineBookingsEnabled:"SortOrder",
		createdAt:"SortOrder",
		createdByUserId:"SortOrder",
		href:"SortOrder",
		workspaceId:"SortOrder",
		publisherScreenId:"SortOrder",
		publishedVersionId:"SortOrder",
		lastPublishedAt:"SortOrder",
		isArchived:"SortOrder",
		archivedAt:"SortOrder",
		archivedByUserId:"SortOrder",
		updatedAt:"SortOrder"
	},
	AdBoardSumOrderByAggregateInput:{
		pricePerDay:"SortOrder",
		originalPricePerDay:"SortOrder",
		impressionMultiplier:"SortOrder",
		numberOfDisplays:"SortOrder",
		dailyOperationHours:"SortOrder",
		adsPerLoop:"SortOrder",
		adsDuration:"SortOrder",
		monthlyPrice:"SortOrder"
	},
	AdBoardScalarWhereWithAggregatesInput:{
		AND:"AdBoardScalarWhereWithAggregatesInput",
		OR:"AdBoardScalarWhereWithAggregatesInput",
		NOT:"AdBoardScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		state:"StringWithAggregatesFilter",
		city:"StringWithAggregatesFilter",
		country:"StringWithAggregatesFilter",
		outdoor:"BoolWithAggregatesFilter",
		locationCategoryId:"StringNullableWithAggregatesFilter",
		locationSubCategoryId:"StringNullableWithAggregatesFilter",
		alias:"StringNullableWithAggregatesFilter",
		title:"StringWithAggregatesFilter",
		pricePerDay:"IntWithAggregatesFilter",
		originalPricePerDay:"IntNullableWithAggregatesFilter",
		description:"StringNullableWithAggregatesFilter",
		adBoardTypeId:"StringNullableWithAggregatesFilter",
		tags:"StringNullableListFilter",
		featuredImage:"StringNullableWithAggregatesFilter",
		galleryImgs:"StringNullableListFilter",
		notes:"StringNullableListFilter",
		impressionMultiplier:"FloatNullableWithAggregatesFilter",
		categoryId:"StringNullableWithAggregatesFilter",
		restrictedBusinessIds:"StringNullableListFilter",
		targetAudiences:"StringNullableListFilter",
		acceptedMediaTypes:"StringNullableListFilter",
		status:"EnumAdBoardStatusWithAggregatesFilter",
		adboardDraftStatus:"EnumAdboardDraftStatusNullableWithAggregatesFilter",
		isLive:"BoolWithAggregatesFilter",
		numberOfDisplays:"IntWithAggregatesFilter",
		dailyOperationHours:"IntWithAggregatesFilter",
		adsPerLoop:"IntWithAggregatesFilter",
		adsDuration:"IntWithAggregatesFilter",
		monthlyPrice:"FloatNullableWithAggregatesFilter",
		offlineBookingsEnabled:"BoolWithAggregatesFilter",
		createdAt:"DateTimeNullableWithAggregatesFilter",
		createdByUserId:"StringNullableWithAggregatesFilter",
		href:"StringNullableWithAggregatesFilter",
		workspaceId:"StringWithAggregatesFilter",
		playerIds:"StringNullableListFilter",
		publisherScreenId:"StringNullableWithAggregatesFilter",
		additionalData:"JsonNullableWithAggregatesFilter",
		publishedVersionId:"StringNullableWithAggregatesFilter",
		lastPublishedAt:"DateTimeNullableWithAggregatesFilter",
		isArchived:"BoolWithAggregatesFilter",
		archivedAt:"DateTimeNullableWithAggregatesFilter",
		archivedByUserId:"StringNullableWithAggregatesFilter",
		updatedAt:"DateTimeNullableWithAggregatesFilter",
		wishlistIds:"StringNullableListFilter"
	},
	StringWithAggregatesFilter:{
		mode:"QueryMode",
		not:"NestedStringWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedStringFilter",
		_max:"NestedStringFilter"
	},
	NestedStringWithAggregatesFilter:{
		not:"NestedStringWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedStringFilter",
		_max:"NestedStringFilter"
	},
	BoolWithAggregatesFilter:{
		not:"NestedBoolWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedBoolFilter",
		_max:"NestedBoolFilter"
	},
	NestedBoolWithAggregatesFilter:{
		not:"NestedBoolWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedBoolFilter",
		_max:"NestedBoolFilter"
	},
	StringNullableWithAggregatesFilter:{
		mode:"QueryMode",
		not:"NestedStringNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_min:"NestedStringNullableFilter",
		_max:"NestedStringNullableFilter"
	},
	NestedStringNullableWithAggregatesFilter:{
		not:"NestedStringNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_min:"NestedStringNullableFilter",
		_max:"NestedStringNullableFilter"
	},
	IntWithAggregatesFilter:{
		not:"NestedIntWithAggregatesFilter",
		_count:"NestedIntFilter",
		_avg:"NestedFloatFilter",
		_sum:"NestedIntFilter",
		_min:"NestedIntFilter",
		_max:"NestedIntFilter"
	},
	NestedIntWithAggregatesFilter:{
		not:"NestedIntWithAggregatesFilter",
		_count:"NestedIntFilter",
		_avg:"NestedFloatFilter",
		_sum:"NestedIntFilter",
		_min:"NestedIntFilter",
		_max:"NestedIntFilter"
	},
	IntNullableWithAggregatesFilter:{
		not:"NestedIntNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_avg:"NestedFloatNullableFilter",
		_sum:"NestedIntNullableFilter",
		_min:"NestedIntNullableFilter",
		_max:"NestedIntNullableFilter"
	},
	NestedIntNullableWithAggregatesFilter:{
		not:"NestedIntNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_avg:"NestedFloatNullableFilter",
		_sum:"NestedIntNullableFilter",
		_min:"NestedIntNullableFilter",
		_max:"NestedIntNullableFilter"
	},
	FloatNullableWithAggregatesFilter:{
		not:"NestedFloatNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_avg:"NestedFloatNullableFilter",
		_sum:"NestedFloatNullableFilter",
		_min:"NestedFloatNullableFilter",
		_max:"NestedFloatNullableFilter"
	},
	NestedFloatNullableWithAggregatesFilter:{
		not:"NestedFloatNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_avg:"NestedFloatNullableFilter",
		_sum:"NestedFloatNullableFilter",
		_min:"NestedFloatNullableFilter",
		_max:"NestedFloatNullableFilter"
	},
	EnumAdBoardStatusWithAggregatesFilter:{
		equals:"AdBoardStatus",
		in:"AdBoardStatus",
		notIn:"AdBoardStatus",
		not:"NestedEnumAdBoardStatusWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumAdBoardStatusFilter",
		_max:"NestedEnumAdBoardStatusFilter"
	},
	NestedEnumAdBoardStatusWithAggregatesFilter:{
		equals:"AdBoardStatus",
		in:"AdBoardStatus",
		notIn:"AdBoardStatus",
		not:"NestedEnumAdBoardStatusWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumAdBoardStatusFilter",
		_max:"NestedEnumAdBoardStatusFilter"
	},
	EnumAdboardDraftStatusNullableWithAggregatesFilter:{
		equals:"AdboardDraftStatus",
		in:"AdboardDraftStatus",
		notIn:"AdboardDraftStatus",
		not:"NestedEnumAdboardDraftStatusNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_min:"NestedEnumAdboardDraftStatusNullableFilter",
		_max:"NestedEnumAdboardDraftStatusNullableFilter"
	},
	NestedEnumAdboardDraftStatusNullableWithAggregatesFilter:{
		equals:"AdboardDraftStatus",
		in:"AdboardDraftStatus",
		notIn:"AdboardDraftStatus",
		not:"NestedEnumAdboardDraftStatusNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_min:"NestedEnumAdboardDraftStatusNullableFilter",
		_max:"NestedEnumAdboardDraftStatusNullableFilter"
	},
	DateTimeNullableWithAggregatesFilter:{
		equals:"DateTime",
		in:"DateTime",
		notIn:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		gt:"DateTime",
		gte:"DateTime",
		not:"NestedDateTimeNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_min:"NestedDateTimeNullableFilter",
		_max:"NestedDateTimeNullableFilter"
	},
	NestedDateTimeNullableWithAggregatesFilter:{
		equals:"DateTime",
		in:"DateTime",
		notIn:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		gt:"DateTime",
		gte:"DateTime",
		not:"NestedDateTimeNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_min:"NestedDateTimeNullableFilter",
		_max:"NestedDateTimeNullableFilter"
	},
	JsonNullableWithAggregatesFilter:{
		equals:"JSON",
		not:"JSON",
		_count:"NestedIntNullableFilter",
		_min:"NestedJsonNullableFilter",
		_max:"NestedJsonNullableFilter"
	},
	NestedJsonNullableFilter:{
		equals:"JSON",
		not:"JSON"
	},
	AdBoardGroupOrderByWithAggregationInput:{
		id:"SortOrder",
		name:"SortOrder",
		adBoardId:"SortOrder",
		scheduledPlaylistsIDs:"SortOrder",
		adsPlaylistID:"SortOrder",
		pisignageGroupId:"SortOrder",
		fitImage:"SortOrder",
		fitVideo:"SortOrder",
		workspaceId:"SortOrder",
		_count:"AdBoardGroupCountOrderByAggregateInput",
		_max:"AdBoardGroupMaxOrderByAggregateInput",
		_min:"AdBoardGroupMinOrderByAggregateInput"
	},
	AdBoardGroupCountOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		adBoardId:"SortOrder",
		scheduledPlaylistsIDs:"SortOrder",
		adsPlaylistID:"SortOrder",
		pisignageGroupId:"SortOrder",
		fitImage:"SortOrder",
		fitVideo:"SortOrder",
		workspaceId:"SortOrder"
	},
	AdBoardGroupMaxOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		adBoardId:"SortOrder",
		adsPlaylistID:"SortOrder",
		pisignageGroupId:"SortOrder",
		fitImage:"SortOrder",
		fitVideo:"SortOrder",
		workspaceId:"SortOrder"
	},
	AdBoardGroupMinOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		adBoardId:"SortOrder",
		adsPlaylistID:"SortOrder",
		pisignageGroupId:"SortOrder",
		fitImage:"SortOrder",
		fitVideo:"SortOrder",
		workspaceId:"SortOrder"
	},
	AdBoardGroupScalarWhereWithAggregatesInput:{
		AND:"AdBoardGroupScalarWhereWithAggregatesInput",
		OR:"AdBoardGroupScalarWhereWithAggregatesInput",
		NOT:"AdBoardGroupScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		name:"StringWithAggregatesFilter",
		adBoardId:"StringNullableWithAggregatesFilter",
		scheduledPlaylistsIDs:"StringNullableListFilter",
		adsPlaylistID:"StringNullableWithAggregatesFilter",
		pisignageGroupId:"StringWithAggregatesFilter",
		fitImage:"EnumFitTypeWithAggregatesFilter",
		fitVideo:"EnumFitTypeWithAggregatesFilter",
		workspaceId:"StringWithAggregatesFilter"
	},
	EnumFitTypeWithAggregatesFilter:{
		equals:"FitType",
		in:"FitType",
		notIn:"FitType",
		not:"NestedEnumFitTypeWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumFitTypeFilter",
		_max:"NestedEnumFitTypeFilter"
	},
	NestedEnumFitTypeWithAggregatesFilter:{
		equals:"FitType",
		in:"FitType",
		notIn:"FitType",
		not:"NestedEnumFitTypeWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumFitTypeFilter",
		_max:"NestedEnumFitTypeFilter"
	},
	AdBoardTypeWhereUniqueInput:{
		AND:"AdBoardTypeWhereInput",
		OR:"AdBoardTypeWhereInput",
		NOT:"AdBoardTypeWhereInput",
		name:"StringFilter",
		description:"StringNullableFilter",
		adBoards:"AdBoardListRelationFilter"
	},
	AdBoardTypeScalarFieldEnum: "enum" as const,
	AdBoardTypeOrderByWithAggregationInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder",
		_count:"AdBoardTypeCountOrderByAggregateInput",
		_max:"AdBoardTypeMaxOrderByAggregateInput",
		_min:"AdBoardTypeMinOrderByAggregateInput"
	},
	AdBoardTypeCountOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder"
	},
	AdBoardTypeMaxOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder"
	},
	AdBoardTypeMinOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder"
	},
	AdBoardTypeScalarWhereWithAggregatesInput:{
		AND:"AdBoardTypeScalarWhereWithAggregatesInput",
		OR:"AdBoardTypeScalarWhereWithAggregatesInput",
		NOT:"AdBoardTypeScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		name:"StringWithAggregatesFilter",
		description:"StringNullableWithAggregatesFilter"
	},
	AdvertisementCategoryOrderByWithAggregationInput:{
		id:"SortOrder",
		name:"SortOrder",
		type:"SortOrder",
		description:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		campaignIds:"SortOrder",
		bookingIds:"SortOrder",
		_count:"AdvertisementCategoryCountOrderByAggregateInput",
		_max:"AdvertisementCategoryMaxOrderByAggregateInput",
		_min:"AdvertisementCategoryMinOrderByAggregateInput"
	},
	AdvertisementCategoryCountOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		type:"SortOrder",
		description:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		campaignIds:"SortOrder",
		bookingIds:"SortOrder"
	},
	AdvertisementCategoryMaxOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		type:"SortOrder",
		description:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder"
	},
	AdvertisementCategoryMinOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		type:"SortOrder",
		description:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder"
	},
	AdvertisementCategoryScalarWhereWithAggregatesInput:{
		AND:"AdvertisementCategoryScalarWhereWithAggregatesInput",
		OR:"AdvertisementCategoryScalarWhereWithAggregatesInput",
		NOT:"AdvertisementCategoryScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		name:"StringWithAggregatesFilter",
		type:"EnumAdvertisementCategoryEnumWithAggregatesFilter",
		description:"StringNullableWithAggregatesFilter",
		createdAt:"DateTimeWithAggregatesFilter",
		updatedAt:"DateTimeWithAggregatesFilter",
		campaignIds:"StringNullableListFilter",
		bookingIds:"StringNullableListFilter"
	},
	EnumAdvertisementCategoryEnumWithAggregatesFilter:{
		equals:"AdvertisementCategoryEnum",
		in:"AdvertisementCategoryEnum",
		notIn:"AdvertisementCategoryEnum",
		not:"NestedEnumAdvertisementCategoryEnumWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumAdvertisementCategoryEnumFilter",
		_max:"NestedEnumAdvertisementCategoryEnumFilter"
	},
	NestedEnumAdvertisementCategoryEnumWithAggregatesFilter:{
		equals:"AdvertisementCategoryEnum",
		in:"AdvertisementCategoryEnum",
		notIn:"AdvertisementCategoryEnum",
		not:"NestedEnumAdvertisementCategoryEnumWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumAdvertisementCategoryEnumFilter",
		_max:"NestedEnumAdvertisementCategoryEnumFilter"
	},
	DateTimeWithAggregatesFilter:{
		equals:"DateTime",
		in:"DateTime",
		notIn:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		gt:"DateTime",
		gte:"DateTime",
		not:"NestedDateTimeWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedDateTimeFilter",
		_max:"NestedDateTimeFilter"
	},
	NestedDateTimeWithAggregatesFilter:{
		equals:"DateTime",
		in:"DateTime",
		notIn:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		gt:"DateTime",
		gte:"DateTime",
		not:"NestedDateTimeWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedDateTimeFilter",
		_max:"NestedDateTimeFilter"
	},
	AuditOrderByWithAggregationInput:{
		id:"SortOrder",
		createdAt:"SortOrder",
		message:"SortOrder",
		action:"SortOrder",
		userId:"SortOrder",
		workspaceId:"SortOrder",
		updates:"SortOrder",
		_count:"AuditCountOrderByAggregateInput",
		_max:"AuditMaxOrderByAggregateInput",
		_min:"AuditMinOrderByAggregateInput"
	},
	AuditCountOrderByAggregateInput:{
		id:"SortOrder",
		createdAt:"SortOrder",
		message:"SortOrder",
		action:"SortOrder",
		userId:"SortOrder",
		workspaceId:"SortOrder",
		updates:"SortOrder"
	},
	AuditMaxOrderByAggregateInput:{
		id:"SortOrder",
		createdAt:"SortOrder",
		message:"SortOrder",
		action:"SortOrder",
		userId:"SortOrder",
		workspaceId:"SortOrder"
	},
	AuditMinOrderByAggregateInput:{
		id:"SortOrder",
		createdAt:"SortOrder",
		message:"SortOrder",
		action:"SortOrder",
		userId:"SortOrder",
		workspaceId:"SortOrder"
	},
	AuditScalarWhereWithAggregatesInput:{
		AND:"AuditScalarWhereWithAggregatesInput",
		OR:"AuditScalarWhereWithAggregatesInput",
		NOT:"AuditScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		createdAt:"DateTimeWithAggregatesFilter",
		message:"StringWithAggregatesFilter",
		action:"StringWithAggregatesFilter",
		userId:"StringWithAggregatesFilter",
		workspaceId:"StringNullableWithAggregatesFilter",
		updates:"JsonNullableWithAggregatesFilter"
	},
	BookingOrderByWithAggregationInput:{
		id:"SortOrder",
		additionalInformation:"SortOrder",
		origin:"SortOrder",
		bookingCode:"SortOrder",
		bookingDate:"SortOrder",
		bookingFor:"SortOrder",
		purpose:"SortOrder",
		adBoardId:"SortOrder",
		workspaceId:"SortOrder",
		campaignId:"SortOrder",
		businessCategoryId:"SortOrder",
		adCategoryId:"SortOrder",
		bookingStatus:"SortOrder",
		paymentStatus:"SortOrder",
		deploymentStatus:"SortOrder",
		assetsIDs:"SortOrder",
		currentDeployedVersionId:"SortOrder",
		userId:"SortOrder",
		sharedUserIds:"SortOrder",
		isOffline:"SortOrder",
		isEnquiry:"SortOrder",
		isPaid:"SortOrder",
		enquiryDate:"SortOrder",
		approvalDate:"SortOrder",
		paymentDate:"SortOrder",
		confirmationDate:"SortOrder",
		contentScheduledDate:"SortOrder",
		contentLiveDate:"SortOrder",
		completionDate:"SortOrder",
		refundStatus:"SortOrder",
		_count:"BookingCountOrderByAggregateInput",
		_max:"BookingMaxOrderByAggregateInput",
		_min:"BookingMinOrderByAggregateInput"
	},
	BookingCountOrderByAggregateInput:{
		id:"SortOrder",
		additionalInformation:"SortOrder",
		origin:"SortOrder",
		bookingCode:"SortOrder",
		bookingDate:"SortOrder",
		bookingFor:"SortOrder",
		purpose:"SortOrder",
		adBoardId:"SortOrder",
		workspaceId:"SortOrder",
		campaignId:"SortOrder",
		businessCategoryId:"SortOrder",
		adCategoryId:"SortOrder",
		bookingStatus:"SortOrder",
		paymentStatus:"SortOrder",
		deploymentStatus:"SortOrder",
		assetsIDs:"SortOrder",
		currentDeployedVersionId:"SortOrder",
		userId:"SortOrder",
		sharedUserIds:"SortOrder",
		isOffline:"SortOrder",
		isEnquiry:"SortOrder",
		isPaid:"SortOrder",
		enquiryDate:"SortOrder",
		approvalDate:"SortOrder",
		paymentDate:"SortOrder",
		confirmationDate:"SortOrder",
		contentScheduledDate:"SortOrder",
		contentLiveDate:"SortOrder",
		completionDate:"SortOrder",
		refundStatus:"SortOrder"
	},
	BookingMaxOrderByAggregateInput:{
		id:"SortOrder",
		additionalInformation:"SortOrder",
		origin:"SortOrder",
		bookingCode:"SortOrder",
		bookingDate:"SortOrder",
		bookingFor:"SortOrder",
		purpose:"SortOrder",
		adBoardId:"SortOrder",
		workspaceId:"SortOrder",
		campaignId:"SortOrder",
		businessCategoryId:"SortOrder",
		bookingStatus:"SortOrder",
		paymentStatus:"SortOrder",
		deploymentStatus:"SortOrder",
		currentDeployedVersionId:"SortOrder",
		userId:"SortOrder",
		isOffline:"SortOrder",
		isEnquiry:"SortOrder",
		isPaid:"SortOrder",
		enquiryDate:"SortOrder",
		approvalDate:"SortOrder",
		paymentDate:"SortOrder",
		confirmationDate:"SortOrder",
		contentScheduledDate:"SortOrder",
		contentLiveDate:"SortOrder",
		completionDate:"SortOrder",
		refundStatus:"SortOrder"
	},
	BookingMinOrderByAggregateInput:{
		id:"SortOrder",
		additionalInformation:"SortOrder",
		origin:"SortOrder",
		bookingCode:"SortOrder",
		bookingDate:"SortOrder",
		bookingFor:"SortOrder",
		purpose:"SortOrder",
		adBoardId:"SortOrder",
		workspaceId:"SortOrder",
		campaignId:"SortOrder",
		businessCategoryId:"SortOrder",
		bookingStatus:"SortOrder",
		paymentStatus:"SortOrder",
		deploymentStatus:"SortOrder",
		currentDeployedVersionId:"SortOrder",
		userId:"SortOrder",
		isOffline:"SortOrder",
		isEnquiry:"SortOrder",
		isPaid:"SortOrder",
		enquiryDate:"SortOrder",
		approvalDate:"SortOrder",
		paymentDate:"SortOrder",
		confirmationDate:"SortOrder",
		contentScheduledDate:"SortOrder",
		contentLiveDate:"SortOrder",
		completionDate:"SortOrder",
		refundStatus:"SortOrder"
	},
	BookingScalarWhereWithAggregatesInput:{
		AND:"BookingScalarWhereWithAggregatesInput",
		OR:"BookingScalarWhereWithAggregatesInput",
		NOT:"BookingScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		additionalInformation:"StringNullableWithAggregatesFilter",
		origin:"StringNullableWithAggregatesFilter",
		bookingCode:"StringWithAggregatesFilter",
		bookingDate:"DateTimeWithAggregatesFilter",
		bookingFor:"StringWithAggregatesFilter",
		purpose:"StringWithAggregatesFilter",
		adBoardId:"StringWithAggregatesFilter",
		workspaceId:"StringNullableWithAggregatesFilter",
		campaignId:"StringNullableWithAggregatesFilter",
		businessCategoryId:"StringNullableWithAggregatesFilter",
		adCategoryId:"StringNullableListFilter",
		bookingStatus:"EnumBookingStatusWithAggregatesFilter",
		paymentStatus:"EnumPaymentStatusNullableWithAggregatesFilter",
		deploymentStatus:"EnumDeploymentStatusWithAggregatesFilter",
		assetsIDs:"StringNullableListFilter",
		currentDeployedVersionId:"StringNullableWithAggregatesFilter",
		userId:"StringWithAggregatesFilter",
		sharedUserIds:"StringNullableListFilter",
		isOffline:"BoolWithAggregatesFilter",
		isEnquiry:"BoolWithAggregatesFilter",
		isPaid:"BoolWithAggregatesFilter",
		enquiryDate:"DateTimeNullableWithAggregatesFilter",
		approvalDate:"DateTimeNullableWithAggregatesFilter",
		paymentDate:"DateTimeNullableWithAggregatesFilter",
		confirmationDate:"DateTimeNullableWithAggregatesFilter",
		contentScheduledDate:"DateTimeNullableWithAggregatesFilter",
		contentLiveDate:"DateTimeNullableWithAggregatesFilter",
		completionDate:"DateTimeNullableWithAggregatesFilter",
		refundStatus:"EnumRefundStatusWithAggregatesFilter"
	},
	EnumBookingStatusWithAggregatesFilter:{
		equals:"BookingStatus",
		in:"BookingStatus",
		notIn:"BookingStatus",
		not:"NestedEnumBookingStatusWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumBookingStatusFilter",
		_max:"NestedEnumBookingStatusFilter"
	},
	NestedEnumBookingStatusWithAggregatesFilter:{
		equals:"BookingStatus",
		in:"BookingStatus",
		notIn:"BookingStatus",
		not:"NestedEnumBookingStatusWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumBookingStatusFilter",
		_max:"NestedEnumBookingStatusFilter"
	},
	EnumPaymentStatusNullableWithAggregatesFilter:{
		equals:"PaymentStatus",
		in:"PaymentStatus",
		notIn:"PaymentStatus",
		not:"NestedEnumPaymentStatusNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_min:"NestedEnumPaymentStatusNullableFilter",
		_max:"NestedEnumPaymentStatusNullableFilter"
	},
	NestedEnumPaymentStatusNullableWithAggregatesFilter:{
		equals:"PaymentStatus",
		in:"PaymentStatus",
		notIn:"PaymentStatus",
		not:"NestedEnumPaymentStatusNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_min:"NestedEnumPaymentStatusNullableFilter",
		_max:"NestedEnumPaymentStatusNullableFilter"
	},
	EnumDeploymentStatusWithAggregatesFilter:{
		equals:"DeploymentStatus",
		in:"DeploymentStatus",
		notIn:"DeploymentStatus",
		not:"NestedEnumDeploymentStatusWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumDeploymentStatusFilter",
		_max:"NestedEnumDeploymentStatusFilter"
	},
	NestedEnumDeploymentStatusWithAggregatesFilter:{
		equals:"DeploymentStatus",
		in:"DeploymentStatus",
		notIn:"DeploymentStatus",
		not:"NestedEnumDeploymentStatusWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumDeploymentStatusFilter",
		_max:"NestedEnumDeploymentStatusFilter"
	},
	EnumRefundStatusWithAggregatesFilter:{
		equals:"RefundStatus",
		in:"RefundStatus",
		notIn:"RefundStatus",
		not:"NestedEnumRefundStatusWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumRefundStatusFilter",
		_max:"NestedEnumRefundStatusFilter"
	},
	NestedEnumRefundStatusWithAggregatesFilter:{
		equals:"RefundStatus",
		in:"RefundStatus",
		notIn:"RefundStatus",
		not:"NestedEnumRefundStatusWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumRefundStatusFilter",
		_max:"NestedEnumRefundStatusFilter"
	},
	BusinessCategoryOrderByWithAggregationInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder",
		restrictedByAdBoardIds:"SortOrder",
		_count:"BusinessCategoryCountOrderByAggregateInput",
		_max:"BusinessCategoryMaxOrderByAggregateInput",
		_min:"BusinessCategoryMinOrderByAggregateInput"
	},
	BusinessCategoryCountOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder",
		restrictedByAdBoardIds:"SortOrder"
	},
	BusinessCategoryMaxOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder"
	},
	BusinessCategoryMinOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder"
	},
	BusinessCategoryScalarWhereWithAggregatesInput:{
		AND:"BusinessCategoryScalarWhereWithAggregatesInput",
		OR:"BusinessCategoryScalarWhereWithAggregatesInput",
		NOT:"BusinessCategoryScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		name:"StringWithAggregatesFilter",
		description:"StringNullableWithAggregatesFilter",
		restrictedByAdBoardIds:"StringNullableListFilter"
	},
	CameraOrderByWithAggregationInput:{
		id:"SortOrder",
		name:"SortOrder",
		isOnline:"SortOrder",
		playerId:"SortOrder",
		workspaceId:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		isPublic:"SortOrder",
		_count:"CameraCountOrderByAggregateInput",
		_max:"CameraMaxOrderByAggregateInput",
		_min:"CameraMinOrderByAggregateInput"
	},
	CameraCountOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		isOnline:"SortOrder",
		playerId:"SortOrder",
		workspaceId:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		isPublic:"SortOrder"
	},
	CameraMaxOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		isOnline:"SortOrder",
		playerId:"SortOrder",
		workspaceId:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		isPublic:"SortOrder"
	},
	CameraMinOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		isOnline:"SortOrder",
		playerId:"SortOrder",
		workspaceId:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		isPublic:"SortOrder"
	},
	CameraScalarWhereWithAggregatesInput:{
		AND:"CameraScalarWhereWithAggregatesInput",
		OR:"CameraScalarWhereWithAggregatesInput",
		NOT:"CameraScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		name:"StringNullableWithAggregatesFilter",
		isOnline:"BoolWithAggregatesFilter",
		playerId:"StringNullableWithAggregatesFilter",
		workspaceId:"StringNullableWithAggregatesFilter",
		createdAt:"DateTimeWithAggregatesFilter",
		updatedAt:"DateTimeWithAggregatesFilter",
		isPublic:"BoolWithAggregatesFilter"
	},
	CampaignOrderByWithAggregationInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder",
		businessCategoryId:"SortOrder",
		purpose:"SortOrder",
		userId:"SortOrder",
		adCategoryId:"SortOrder",
		paymentStatus:"SortOrder",
		origin:"SortOrder",
		assetsIDs:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		_count:"CampaignCountOrderByAggregateInput",
		_max:"CampaignMaxOrderByAggregateInput",
		_min:"CampaignMinOrderByAggregateInput"
	},
	CampaignCountOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder",
		businessCategoryId:"SortOrder",
		purpose:"SortOrder",
		userId:"SortOrder",
		adCategoryId:"SortOrder",
		paymentStatus:"SortOrder",
		origin:"SortOrder",
		assetsIDs:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder"
	},
	CampaignMaxOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder",
		businessCategoryId:"SortOrder",
		purpose:"SortOrder",
		userId:"SortOrder",
		paymentStatus:"SortOrder",
		origin:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder"
	},
	CampaignMinOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		description:"SortOrder",
		businessCategoryId:"SortOrder",
		purpose:"SortOrder",
		userId:"SortOrder",
		paymentStatus:"SortOrder",
		origin:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder"
	},
	CampaignScalarWhereWithAggregatesInput:{
		AND:"CampaignScalarWhereWithAggregatesInput",
		OR:"CampaignScalarWhereWithAggregatesInput",
		NOT:"CampaignScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		name:"StringWithAggregatesFilter",
		description:"StringNullableWithAggregatesFilter",
		businessCategoryId:"StringWithAggregatesFilter",
		purpose:"StringWithAggregatesFilter",
		userId:"StringWithAggregatesFilter",
		adCategoryId:"StringNullableListFilter",
		paymentStatus:"EnumPaymentStatusWithAggregatesFilter",
		origin:"StringWithAggregatesFilter",
		assetsIDs:"StringNullableListFilter",
		createdAt:"DateTimeWithAggregatesFilter",
		updatedAt:"DateTimeWithAggregatesFilter"
	},
	EnumPaymentStatusWithAggregatesFilter:{
		equals:"PaymentStatus",
		in:"PaymentStatus",
		notIn:"PaymentStatus",
		not:"NestedEnumPaymentStatusWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumPaymentStatusFilter",
		_max:"NestedEnumPaymentStatusFilter"
	},
	NestedEnumPaymentStatusWithAggregatesFilter:{
		equals:"PaymentStatus",
		in:"PaymentStatus",
		notIn:"PaymentStatus",
		not:"NestedEnumPaymentStatusWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumPaymentStatusFilter",
		_max:"NestedEnumPaymentStatusFilter"
	},
	FileOrderByWithAggregationInput:{
		id:"SortOrder",
		contentType:"SortOrder",
		ctime:"SortOrder",
		filename:"SortOrder",
		filepath:"SortOrder",
		isDirectory:"SortOrder",
		mtime:"SortOrder",
		name:"SortOrder",
		size:"SortOrder",
		status:"SortOrder",
		type:"SortOrder",
		updatedAt:"SortOrder",
		createdAt:"SortOrder",
		updatedByUserId:"SortOrder",
		createdByUserId:"SortOrder",
		url:"SortOrder",
		bookingsIDs:"SortOrder",
		workspaceId:"SortOrder",
		proofBookingId:"SortOrder",
		campaignIds:"SortOrder",
		contentVersionId:"SortOrder",
		_count:"FileCountOrderByAggregateInput",
		_avg:"FileAvgOrderByAggregateInput",
		_max:"FileMaxOrderByAggregateInput",
		_min:"FileMinOrderByAggregateInput",
		_sum:"FileSumOrderByAggregateInput"
	},
	FileCountOrderByAggregateInput:{
		id:"SortOrder",
		contentType:"SortOrder",
		ctime:"SortOrder",
		filename:"SortOrder",
		filepath:"SortOrder",
		isDirectory:"SortOrder",
		mtime:"SortOrder",
		name:"SortOrder",
		size:"SortOrder",
		status:"SortOrder",
		type:"SortOrder",
		updatedAt:"SortOrder",
		createdAt:"SortOrder",
		updatedByUserId:"SortOrder",
		createdByUserId:"SortOrder",
		url:"SortOrder",
		bookingsIDs:"SortOrder",
		workspaceId:"SortOrder",
		proofBookingId:"SortOrder",
		campaignIds:"SortOrder",
		contentVersionId:"SortOrder"
	},
	FileAvgOrderByAggregateInput:{
		size:"SortOrder"
	},
	FileMaxOrderByAggregateInput:{
		id:"SortOrder",
		contentType:"SortOrder",
		ctime:"SortOrder",
		filename:"SortOrder",
		filepath:"SortOrder",
		isDirectory:"SortOrder",
		mtime:"SortOrder",
		name:"SortOrder",
		size:"SortOrder",
		status:"SortOrder",
		type:"SortOrder",
		updatedAt:"SortOrder",
		createdAt:"SortOrder",
		updatedByUserId:"SortOrder",
		createdByUserId:"SortOrder",
		url:"SortOrder",
		workspaceId:"SortOrder",
		proofBookingId:"SortOrder"
	},
	FileMinOrderByAggregateInput:{
		id:"SortOrder",
		contentType:"SortOrder",
		ctime:"SortOrder",
		filename:"SortOrder",
		filepath:"SortOrder",
		isDirectory:"SortOrder",
		mtime:"SortOrder",
		name:"SortOrder",
		size:"SortOrder",
		status:"SortOrder",
		type:"SortOrder",
		updatedAt:"SortOrder",
		createdAt:"SortOrder",
		updatedByUserId:"SortOrder",
		createdByUserId:"SortOrder",
		url:"SortOrder",
		workspaceId:"SortOrder",
		proofBookingId:"SortOrder"
	},
	FileSumOrderByAggregateInput:{
		size:"SortOrder"
	},
	FileScalarWhereWithAggregatesInput:{
		AND:"FileScalarWhereWithAggregatesInput",
		OR:"FileScalarWhereWithAggregatesInput",
		NOT:"FileScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		contentType:"StringWithAggregatesFilter",
		ctime:"StringNullableWithAggregatesFilter",
		filename:"StringWithAggregatesFilter",
		filepath:"StringNullableWithAggregatesFilter",
		isDirectory:"BoolWithAggregatesFilter",
		mtime:"StringWithAggregatesFilter",
		name:"StringWithAggregatesFilter",
		size:"IntWithAggregatesFilter",
		status:"EnumFileStatusNullableWithAggregatesFilter",
		type:"StringWithAggregatesFilter",
		updatedAt:"DateTimeWithAggregatesFilter",
		createdAt:"DateTimeWithAggregatesFilter",
		updatedByUserId:"StringNullableWithAggregatesFilter",
		createdByUserId:"StringWithAggregatesFilter",
		url:"StringWithAggregatesFilter",
		bookingsIDs:"StringNullableListFilter",
		workspaceId:"StringNullableWithAggregatesFilter",
		proofBookingId:"StringNullableWithAggregatesFilter",
		campaignIds:"StringNullableListFilter",
		contentVersionId:"StringNullableListFilter"
	},
	EnumFileStatusNullableWithAggregatesFilter:{
		equals:"FileStatus",
		in:"FileStatus",
		notIn:"FileStatus",
		not:"NestedEnumFileStatusNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_min:"NestedEnumFileStatusNullableFilter",
		_max:"NestedEnumFileStatusNullableFilter"
	},
	NestedEnumFileStatusNullableWithAggregatesFilter:{
		equals:"FileStatus",
		in:"FileStatus",
		notIn:"FileStatus",
		not:"NestedEnumFileStatusNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_min:"NestedEnumFileStatusNullableFilter",
		_max:"NestedEnumFileStatusNullableFilter"
	},
	MembershipOrderByWithAggregationInput:{
		id:"SortOrder",
		createdAt:"SortOrder",
		userId:"SortOrder",
		workspaceId:"SortOrder",
		roleId:"SortOrder",
		_count:"MembershipCountOrderByAggregateInput",
		_max:"MembershipMaxOrderByAggregateInput",
		_min:"MembershipMinOrderByAggregateInput"
	},
	MembershipCountOrderByAggregateInput:{
		id:"SortOrder",
		createdAt:"SortOrder",
		userId:"SortOrder",
		workspaceId:"SortOrder",
		roleId:"SortOrder"
	},
	MembershipMaxOrderByAggregateInput:{
		id:"SortOrder",
		createdAt:"SortOrder",
		userId:"SortOrder",
		workspaceId:"SortOrder",
		roleId:"SortOrder"
	},
	MembershipMinOrderByAggregateInput:{
		id:"SortOrder",
		createdAt:"SortOrder",
		userId:"SortOrder",
		workspaceId:"SortOrder",
		roleId:"SortOrder"
	},
	MembershipScalarWhereWithAggregatesInput:{
		AND:"MembershipScalarWhereWithAggregatesInput",
		OR:"MembershipScalarWhereWithAggregatesInput",
		NOT:"MembershipScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		createdAt:"DateTimeWithAggregatesFilter",
		userId:"StringWithAggregatesFilter",
		workspaceId:"StringWithAggregatesFilter",
		roleId:"StringWithAggregatesFilter"
	},
	NotificationOrderByWithAggregationInput:{
		id:"SortOrder",
		type:"SortOrder",
		title:"SortOrder",
		content:"SortOrder",
		metadata:"SortOrder",
		createdAt:"SortOrder",
		readAt:"SortOrder",
		recipientId:"SortOrder",
		channels:"SortOrder",
		_count:"NotificationCountOrderByAggregateInput",
		_max:"NotificationMaxOrderByAggregateInput",
		_min:"NotificationMinOrderByAggregateInput"
	},
	NotificationCountOrderByAggregateInput:{
		id:"SortOrder",
		type:"SortOrder",
		title:"SortOrder",
		content:"SortOrder",
		metadata:"SortOrder",
		createdAt:"SortOrder",
		readAt:"SortOrder",
		recipientId:"SortOrder",
		channels:"SortOrder"
	},
	NotificationMaxOrderByAggregateInput:{
		id:"SortOrder",
		type:"SortOrder",
		title:"SortOrder",
		content:"SortOrder",
		createdAt:"SortOrder",
		readAt:"SortOrder",
		recipientId:"SortOrder"
	},
	NotificationMinOrderByAggregateInput:{
		id:"SortOrder",
		type:"SortOrder",
		title:"SortOrder",
		content:"SortOrder",
		createdAt:"SortOrder",
		readAt:"SortOrder",
		recipientId:"SortOrder"
	},
	NotificationScalarWhereWithAggregatesInput:{
		AND:"NotificationScalarWhereWithAggregatesInput",
		OR:"NotificationScalarWhereWithAggregatesInput",
		NOT:"NotificationScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		type:"EnumNotificationTypeWithAggregatesFilter",
		title:"StringWithAggregatesFilter",
		content:"StringWithAggregatesFilter",
		metadata:"JsonNullableWithAggregatesFilter",
		createdAt:"DateTimeWithAggregatesFilter",
		readAt:"DateTimeNullableWithAggregatesFilter",
		recipientId:"StringWithAggregatesFilter",
		channels:"EnumNotificationChannelNullableListFilter"
	},
	EnumNotificationTypeWithAggregatesFilter:{
		equals:"NotificationType",
		in:"NotificationType",
		notIn:"NotificationType",
		not:"NestedEnumNotificationTypeWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumNotificationTypeFilter",
		_max:"NestedEnumNotificationTypeFilter"
	},
	NestedEnumNotificationTypeWithAggregatesFilter:{
		equals:"NotificationType",
		in:"NotificationType",
		notIn:"NotificationType",
		not:"NestedEnumNotificationTypeWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumNotificationTypeFilter",
		_max:"NestedEnumNotificationTypeFilter"
	},
	OrderOrderByWithAggregationInput:{
		id:"SortOrder",
		adBoardId:"SortOrder",
		createdDate:"SortOrder",
		createdByUserId:"SortOrder",
		origin:"SortOrder",
		paymentId:"SortOrder",
		_count:"OrderCountOrderByAggregateInput",
		_max:"OrderMaxOrderByAggregateInput",
		_min:"OrderMinOrderByAggregateInput"
	},
	OrderCountOrderByAggregateInput:{
		id:"SortOrder",
		adBoardId:"SortOrder",
		createdDate:"SortOrder",
		createdByUserId:"SortOrder",
		origin:"SortOrder",
		paymentId:"SortOrder"
	},
	OrderMaxOrderByAggregateInput:{
		id:"SortOrder",
		adBoardId:"SortOrder",
		createdDate:"SortOrder",
		createdByUserId:"SortOrder",
		origin:"SortOrder",
		paymentId:"SortOrder"
	},
	OrderMinOrderByAggregateInput:{
		id:"SortOrder",
		adBoardId:"SortOrder",
		createdDate:"SortOrder",
		createdByUserId:"SortOrder",
		origin:"SortOrder",
		paymentId:"SortOrder"
	},
	OrderScalarWhereWithAggregatesInput:{
		AND:"OrderScalarWhereWithAggregatesInput",
		OR:"OrderScalarWhereWithAggregatesInput",
		NOT:"OrderScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		adBoardId:"StringWithAggregatesFilter",
		createdDate:"DateTimeWithAggregatesFilter",
		createdByUserId:"StringNullableWithAggregatesFilter",
		origin:"StringWithAggregatesFilter",
		paymentId:"StringNullableWithAggregatesFilter"
	},
	PlayerOrderByWithAggregationInput:{
		id:"SortOrder",
		name:"SortOrder",
		configLocation:"SortOrder",
		pisignagePlayerId:"SortOrder",
		pisignageGroupId:"SortOrder",
		cpuSerialNumber:"SortOrder",
		displayName:"SortOrder",
		adBoardGroupId:"SortOrder",
		playlistIds:"SortOrder",
		workpaceId:"SortOrder",
		signageTypeId:"SortOrder",
		audienceTypeId:"SortOrder",
		aspectRatioType:"SortOrder",
		customAspectRatioWidth:"SortOrder",
		customAspectRatioHeight:"SortOrder",
		isOnline:"SortOrder",
		adBoardIds:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		markForDeletion:"SortOrder",
		deletedAt:"SortOrder",
		deletedByUserId:"SortOrder",
		visible:"SortOrder",
		_count:"PlayerCountOrderByAggregateInput",
		_avg:"PlayerAvgOrderByAggregateInput",
		_max:"PlayerMaxOrderByAggregateInput",
		_min:"PlayerMinOrderByAggregateInput",
		_sum:"PlayerSumOrderByAggregateInput"
	},
	PlayerCountOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		configLocation:"SortOrder",
		pisignagePlayerId:"SortOrder",
		pisignageGroupId:"SortOrder",
		cpuSerialNumber:"SortOrder",
		displayName:"SortOrder",
		adBoardGroupId:"SortOrder",
		playlistIds:"SortOrder",
		workpaceId:"SortOrder",
		signageTypeId:"SortOrder",
		audienceTypeId:"SortOrder",
		aspectRatioType:"SortOrder",
		customAspectRatioWidth:"SortOrder",
		customAspectRatioHeight:"SortOrder",
		isOnline:"SortOrder",
		adBoardIds:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		markForDeletion:"SortOrder",
		deletedAt:"SortOrder",
		deletedByUserId:"SortOrder",
		visible:"SortOrder"
	},
	PlayerAvgOrderByAggregateInput:{
		customAspectRatioWidth:"SortOrder",
		customAspectRatioHeight:"SortOrder"
	},
	PlayerMaxOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		configLocation:"SortOrder",
		pisignagePlayerId:"SortOrder",
		pisignageGroupId:"SortOrder",
		cpuSerialNumber:"SortOrder",
		displayName:"SortOrder",
		adBoardGroupId:"SortOrder",
		workpaceId:"SortOrder",
		signageTypeId:"SortOrder",
		aspectRatioType:"SortOrder",
		customAspectRatioWidth:"SortOrder",
		customAspectRatioHeight:"SortOrder",
		isOnline:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		markForDeletion:"SortOrder",
		deletedAt:"SortOrder",
		deletedByUserId:"SortOrder",
		visible:"SortOrder"
	},
	PlayerMinOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		configLocation:"SortOrder",
		pisignagePlayerId:"SortOrder",
		pisignageGroupId:"SortOrder",
		cpuSerialNumber:"SortOrder",
		displayName:"SortOrder",
		adBoardGroupId:"SortOrder",
		workpaceId:"SortOrder",
		signageTypeId:"SortOrder",
		aspectRatioType:"SortOrder",
		customAspectRatioWidth:"SortOrder",
		customAspectRatioHeight:"SortOrder",
		isOnline:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		markForDeletion:"SortOrder",
		deletedAt:"SortOrder",
		deletedByUserId:"SortOrder",
		visible:"SortOrder"
	},
	PlayerSumOrderByAggregateInput:{
		customAspectRatioWidth:"SortOrder",
		customAspectRatioHeight:"SortOrder"
	},
	PlayerScalarWhereWithAggregatesInput:{
		AND:"PlayerScalarWhereWithAggregatesInput",
		OR:"PlayerScalarWhereWithAggregatesInput",
		NOT:"PlayerScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		name:"StringWithAggregatesFilter",
		configLocation:"StringNullableWithAggregatesFilter",
		pisignagePlayerId:"StringNullableWithAggregatesFilter",
		pisignageGroupId:"StringNullableWithAggregatesFilter",
		cpuSerialNumber:"StringNullableWithAggregatesFilter",
		displayName:"StringNullableWithAggregatesFilter",
		adBoardGroupId:"StringNullableWithAggregatesFilter",
		playlistIds:"StringNullableListFilter",
		workpaceId:"StringNullableWithAggregatesFilter",
		signageTypeId:"StringNullableWithAggregatesFilter",
		audienceTypeId:"StringNullableListFilter",
		aspectRatioType:"EnumAspectRatioTypeWithAggregatesFilter",
		customAspectRatioWidth:"IntNullableWithAggregatesFilter",
		customAspectRatioHeight:"IntNullableWithAggregatesFilter",
		isOnline:"BoolWithAggregatesFilter",
		adBoardIds:"StringNullableListFilter",
		createdAt:"DateTimeNullableWithAggregatesFilter",
		updatedAt:"DateTimeNullableWithAggregatesFilter",
		markForDeletion:"BoolWithAggregatesFilter",
		deletedAt:"DateTimeNullableWithAggregatesFilter",
		deletedByUserId:"StringNullableWithAggregatesFilter",
		visible:"BoolWithAggregatesFilter"
	},
	EnumAspectRatioTypeWithAggregatesFilter:{
		equals:"AspectRatioType",
		in:"AspectRatioType",
		notIn:"AspectRatioType",
		not:"NestedEnumAspectRatioTypeWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumAspectRatioTypeFilter",
		_max:"NestedEnumAspectRatioTypeFilter"
	},
	NestedEnumAspectRatioTypeWithAggregatesFilter:{
		equals:"AspectRatioType",
		in:"AspectRatioType",
		notIn:"AspectRatioType",
		not:"NestedEnumAspectRatioTypeWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumAspectRatioTypeFilter",
		_max:"NestedEnumAspectRatioTypeFilter"
	},
	Layout: "enum" as const,
	PlaylistOrderByWithAggregationInput:{
		id:"SortOrder",
		name:"SortOrder",
		displayName:"SortOrder",
		isAdsPlaylist:"SortOrder",
		footerPlaylistId:"SortOrder",
		sidebarPlaylistId:"SortOrder",
		layout:"SortOrder",
		isDeployed:"SortOrder",
		adBoardGroupIds:"SortOrder",
		workspaceId:"SortOrder",
		_count:"PlaylistCountOrderByAggregateInput",
		_max:"PlaylistMaxOrderByAggregateInput",
		_min:"PlaylistMinOrderByAggregateInput"
	},
	PlaylistCountOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		displayName:"SortOrder",
		isAdsPlaylist:"SortOrder",
		footerPlaylistId:"SortOrder",
		sidebarPlaylistId:"SortOrder",
		layout:"SortOrder",
		isDeployed:"SortOrder",
		adBoardGroupIds:"SortOrder",
		workspaceId:"SortOrder"
	},
	PlaylistMaxOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		displayName:"SortOrder",
		isAdsPlaylist:"SortOrder",
		footerPlaylistId:"SortOrder",
		sidebarPlaylistId:"SortOrder",
		layout:"SortOrder",
		isDeployed:"SortOrder",
		workspaceId:"SortOrder"
	},
	PlaylistMinOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		displayName:"SortOrder",
		isAdsPlaylist:"SortOrder",
		footerPlaylistId:"SortOrder",
		sidebarPlaylistId:"SortOrder",
		layout:"SortOrder",
		isDeployed:"SortOrder",
		workspaceId:"SortOrder"
	},
	PlaylistScalarWhereWithAggregatesInput:{
		AND:"PlaylistScalarWhereWithAggregatesInput",
		OR:"PlaylistScalarWhereWithAggregatesInput",
		NOT:"PlaylistScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		name:"StringWithAggregatesFilter",
		displayName:"StringNullableWithAggregatesFilter",
		isAdsPlaylist:"BoolNullableWithAggregatesFilter",
		footerPlaylistId:"StringNullableWithAggregatesFilter",
		sidebarPlaylistId:"StringNullableWithAggregatesFilter",
		layout:"EnumScreenLayoutWithAggregatesFilter",
		isDeployed:"BoolNullableWithAggregatesFilter",
		adBoardGroupIds:"StringNullableListFilter",
		workspaceId:"StringWithAggregatesFilter"
	},
	BoolNullableWithAggregatesFilter:{
		not:"NestedBoolNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_min:"NestedBoolNullableFilter",
		_max:"NestedBoolNullableFilter"
	},
	NestedBoolNullableWithAggregatesFilter:{
		not:"NestedBoolNullableWithAggregatesFilter",
		_count:"NestedIntNullableFilter",
		_min:"NestedBoolNullableFilter",
		_max:"NestedBoolNullableFilter"
	},
	EnumScreenLayoutWithAggregatesFilter:{
		equals:"ScreenLayout",
		in:"ScreenLayout",
		notIn:"ScreenLayout",
		not:"NestedEnumScreenLayoutWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumScreenLayoutFilter",
		_max:"NestedEnumScreenLayoutFilter"
	},
	NestedEnumScreenLayoutWithAggregatesFilter:{
		equals:"ScreenLayout",
		in:"ScreenLayout",
		notIn:"ScreenLayout",
		not:"NestedEnumScreenLayoutWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumScreenLayoutFilter",
		_max:"NestedEnumScreenLayoutFilter"
	},
	SlotConfigurationOrderByWithAggregationInput:{
		id:"SortOrder",
		adBoardId:"SortOrder",
		date:"SortOrder",
		availableSlots:"SortOrder",
		_count:"SlotConfigurationCountOrderByAggregateInput",
		_avg:"SlotConfigurationAvgOrderByAggregateInput",
		_max:"SlotConfigurationMaxOrderByAggregateInput",
		_min:"SlotConfigurationMinOrderByAggregateInput",
		_sum:"SlotConfigurationSumOrderByAggregateInput"
	},
	SlotConfigurationCountOrderByAggregateInput:{
		id:"SortOrder",
		adBoardId:"SortOrder",
		date:"SortOrder",
		availableSlots:"SortOrder"
	},
	SlotConfigurationAvgOrderByAggregateInput:{
		availableSlots:"SortOrder"
	},
	SlotConfigurationMaxOrderByAggregateInput:{
		id:"SortOrder",
		adBoardId:"SortOrder",
		date:"SortOrder",
		availableSlots:"SortOrder"
	},
	SlotConfigurationMinOrderByAggregateInput:{
		id:"SortOrder",
		adBoardId:"SortOrder",
		date:"SortOrder",
		availableSlots:"SortOrder"
	},
	SlotConfigurationSumOrderByAggregateInput:{
		availableSlots:"SortOrder"
	},
	SlotConfigurationScalarWhereWithAggregatesInput:{
		AND:"SlotConfigurationScalarWhereWithAggregatesInput",
		OR:"SlotConfigurationScalarWhereWithAggregatesInput",
		NOT:"SlotConfigurationScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		adBoardId:"StringWithAggregatesFilter",
		date:"DateTimeWithAggregatesFilter",
		availableSlots:"IntWithAggregatesFilter"
	},
	SubscriptionWhereUniqueInput:{
		AND:"SubscriptionWhereInput",
		OR:"SubscriptionWhereInput",
		NOT:"SubscriptionWhereInput",
		packageId:"StringNullableFilter",
		packageName:"StringNullableFilter",
		priceLookupKey:"StringNullableFilter",
		startDate:"DateTimeNullableFilter",
		endDate:"DateTimeNullableFilter",
		status:"StringFilter",
		stripePaymentIntentId:"StringNullableFilter",
		cancellationDetails:"CancellationDetailsNullableCompositeFilter",
		activeWorkspace:"WorkspaceRelationFilter"
	},
	SubscriptionScalarFieldEnum: "enum" as const,
	SubscriptionOrderByWithAggregationInput:{
		id:"SortOrder",
		packageId:"SortOrder",
		packageName:"SortOrder",
		priceLookupKey:"SortOrder",
		startDate:"SortOrder",
		endDate:"SortOrder",
		status:"SortOrder",
		stripePaymentIntentId:"SortOrder",
		stripeSubscriptionId:"SortOrder",
		stripeCheckoutSessionId:"SortOrder",
		activeWorkspaceId:"SortOrder",
		_count:"SubscriptionCountOrderByAggregateInput",
		_max:"SubscriptionMaxOrderByAggregateInput",
		_min:"SubscriptionMinOrderByAggregateInput"
	},
	SubscriptionCountOrderByAggregateInput:{
		id:"SortOrder",
		packageId:"SortOrder",
		packageName:"SortOrder",
		priceLookupKey:"SortOrder",
		startDate:"SortOrder",
		endDate:"SortOrder",
		status:"SortOrder",
		stripePaymentIntentId:"SortOrder",
		stripeSubscriptionId:"SortOrder",
		stripeCheckoutSessionId:"SortOrder",
		activeWorkspaceId:"SortOrder"
	},
	SubscriptionMaxOrderByAggregateInput:{
		id:"SortOrder",
		packageId:"SortOrder",
		packageName:"SortOrder",
		priceLookupKey:"SortOrder",
		startDate:"SortOrder",
		endDate:"SortOrder",
		status:"SortOrder",
		stripePaymentIntentId:"SortOrder",
		stripeSubscriptionId:"SortOrder",
		stripeCheckoutSessionId:"SortOrder",
		activeWorkspaceId:"SortOrder"
	},
	SubscriptionMinOrderByAggregateInput:{
		id:"SortOrder",
		packageId:"SortOrder",
		packageName:"SortOrder",
		priceLookupKey:"SortOrder",
		startDate:"SortOrder",
		endDate:"SortOrder",
		status:"SortOrder",
		stripePaymentIntentId:"SortOrder",
		stripeSubscriptionId:"SortOrder",
		stripeCheckoutSessionId:"SortOrder",
		activeWorkspaceId:"SortOrder"
	},
	SubscriptionScalarWhereWithAggregatesInput:{
		AND:"SubscriptionScalarWhereWithAggregatesInput",
		OR:"SubscriptionScalarWhereWithAggregatesInput",
		NOT:"SubscriptionScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		packageId:"StringNullableWithAggregatesFilter",
		packageName:"StringNullableWithAggregatesFilter",
		priceLookupKey:"StringNullableWithAggregatesFilter",
		startDate:"DateTimeNullableWithAggregatesFilter",
		endDate:"DateTimeNullableWithAggregatesFilter",
		status:"StringWithAggregatesFilter",
		stripePaymentIntentId:"StringNullableWithAggregatesFilter",
		stripeSubscriptionId:"StringWithAggregatesFilter",
		stripeCheckoutSessionId:"StringWithAggregatesFilter",
		activeWorkspaceId:"StringWithAggregatesFilter"
	},
	UserOrderByWithAggregationInput:{
		id:"SortOrder",
		uid:"SortOrder",
		email:"SortOrder",
		image:"SortOrder",
		phoneNumber:"SortOrder",
		displayName:"SortOrder",
		otherDetails:"SortOrder",
		roles:"SortOrder",
		sharedBookingIds:"SortOrder",
		disclaimerAccepted:"SortOrder",
		leadWorkspaceIds:"SortOrder",
		_count:"UserCountOrderByAggregateInput",
		_max:"UserMaxOrderByAggregateInput",
		_min:"UserMinOrderByAggregateInput"
	},
	UserCountOrderByAggregateInput:{
		id:"SortOrder",
		uid:"SortOrder",
		email:"SortOrder",
		image:"SortOrder",
		phoneNumber:"SortOrder",
		displayName:"SortOrder",
		otherDetails:"SortOrder",
		roles:"SortOrder",
		sharedBookingIds:"SortOrder",
		disclaimerAccepted:"SortOrder",
		leadWorkspaceIds:"SortOrder"
	},
	UserMaxOrderByAggregateInput:{
		id:"SortOrder",
		uid:"SortOrder",
		email:"SortOrder",
		image:"SortOrder",
		phoneNumber:"SortOrder",
		displayName:"SortOrder",
		disclaimerAccepted:"SortOrder"
	},
	UserMinOrderByAggregateInput:{
		id:"SortOrder",
		uid:"SortOrder",
		email:"SortOrder",
		image:"SortOrder",
		phoneNumber:"SortOrder",
		displayName:"SortOrder",
		disclaimerAccepted:"SortOrder"
	},
	UserScalarWhereWithAggregatesInput:{
		AND:"UserScalarWhereWithAggregatesInput",
		OR:"UserScalarWhereWithAggregatesInput",
		NOT:"UserScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		uid:"StringNullableWithAggregatesFilter",
		email:"StringWithAggregatesFilter",
		image:"StringNullableWithAggregatesFilter",
		phoneNumber:"StringNullableWithAggregatesFilter",
		displayName:"StringNullableWithAggregatesFilter",
		otherDetails:"JsonNullableWithAggregatesFilter",
		roles:"EnumRoleNullableListFilter",
		sharedBookingIds:"StringNullableListFilter",
		disclaimerAccepted:"BoolWithAggregatesFilter",
		leadWorkspaceIds:"StringNullableListFilter"
	},
	UserPositionOrderByWithAggregationInput:{
		id:"SortOrder",
		timestamp:"SortOrder",
		createdAt:"SortOrder",
		userId:"SortOrder",
		_count:"UserPositionCountOrderByAggregateInput",
		_max:"UserPositionMaxOrderByAggregateInput",
		_min:"UserPositionMinOrderByAggregateInput"
	},
	UserPositionCountOrderByAggregateInput:{
		id:"SortOrder",
		timestamp:"SortOrder",
		createdAt:"SortOrder",
		userId:"SortOrder"
	},
	UserPositionMaxOrderByAggregateInput:{
		id:"SortOrder",
		timestamp:"SortOrder",
		createdAt:"SortOrder",
		userId:"SortOrder"
	},
	UserPositionMinOrderByAggregateInput:{
		id:"SortOrder",
		timestamp:"SortOrder",
		createdAt:"SortOrder",
		userId:"SortOrder"
	},
	UserPositionScalarWhereWithAggregatesInput:{
		AND:"UserPositionScalarWhereWithAggregatesInput",
		OR:"UserPositionScalarWhereWithAggregatesInput",
		NOT:"UserPositionScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		timestamp:"DateTimeWithAggregatesFilter",
		createdAt:"DateTimeWithAggregatesFilter",
		userId:"StringWithAggregatesFilter"
	},
	WishlistOrderByWithAggregationInput:{
		id:"SortOrder",
		name:"SortOrder",
		userId:"SortOrder",
		adBoardIds:"SortOrder",
		createdAt:"SortOrder",
		_count:"WishlistCountOrderByAggregateInput",
		_max:"WishlistMaxOrderByAggregateInput",
		_min:"WishlistMinOrderByAggregateInput"
	},
	WishlistCountOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		userId:"SortOrder",
		adBoardIds:"SortOrder",
		createdAt:"SortOrder"
	},
	WishlistMaxOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		userId:"SortOrder",
		createdAt:"SortOrder"
	},
	WishlistMinOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		userId:"SortOrder",
		createdAt:"SortOrder"
	},
	WishlistScalarWhereWithAggregatesInput:{
		AND:"WishlistScalarWhereWithAggregatesInput",
		OR:"WishlistScalarWhereWithAggregatesInput",
		NOT:"WishlistScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		name:"StringWithAggregatesFilter",
		userId:"StringWithAggregatesFilter",
		adBoardIds:"StringNullableListFilter",
		createdAt:"DateTimeWithAggregatesFilter"
	},
	WorkspaceOrderByWithAggregationInput:{
		id:"SortOrder",
		type:"SortOrder",
		name:"SortOrder",
		key:"SortOrder",
		userIds:"SortOrder",
		ownerId:"SortOrder",
		avatar:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		stripeSubscriptionId:"SortOrder",
		leadIds:"SortOrder",
		webhookAppId:"SortOrder",
		stackAuthTeamId:"SortOrder",
		_count:"WorkspaceCountOrderByAggregateInput",
		_max:"WorkspaceMaxOrderByAggregateInput",
		_min:"WorkspaceMinOrderByAggregateInput"
	},
	WorkspaceCountOrderByAggregateInput:{
		id:"SortOrder",
		type:"SortOrder",
		name:"SortOrder",
		key:"SortOrder",
		userIds:"SortOrder",
		ownerId:"SortOrder",
		avatar:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		stripeSubscriptionId:"SortOrder",
		leadIds:"SortOrder",
		webhookAppId:"SortOrder",
		stackAuthTeamId:"SortOrder"
	},
	WorkspaceMaxOrderByAggregateInput:{
		id:"SortOrder",
		type:"SortOrder",
		name:"SortOrder",
		key:"SortOrder",
		ownerId:"SortOrder",
		avatar:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		stripeSubscriptionId:"SortOrder",
		webhookAppId:"SortOrder",
		stackAuthTeamId:"SortOrder"
	},
	WorkspaceMinOrderByAggregateInput:{
		id:"SortOrder",
		type:"SortOrder",
		name:"SortOrder",
		key:"SortOrder",
		ownerId:"SortOrder",
		avatar:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		stripeSubscriptionId:"SortOrder",
		webhookAppId:"SortOrder",
		stackAuthTeamId:"SortOrder"
	},
	WorkspaceScalarWhereWithAggregatesInput:{
		AND:"WorkspaceScalarWhereWithAggregatesInput",
		OR:"WorkspaceScalarWhereWithAggregatesInput",
		NOT:"WorkspaceScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		type:"EnumWorkspaceTypeWithAggregatesFilter",
		name:"StringWithAggregatesFilter",
		key:"StringWithAggregatesFilter",
		userIds:"StringNullableListFilter",
		ownerId:"StringNullableWithAggregatesFilter",
		avatar:"StringNullableWithAggregatesFilter",
		createdAt:"DateTimeWithAggregatesFilter",
		updatedAt:"DateTimeWithAggregatesFilter",
		stripeSubscriptionId:"StringNullableWithAggregatesFilter",
		leadIds:"StringNullableListFilter",
		webhookAppId:"StringNullableWithAggregatesFilter",
		stackAuthTeamId:"StringNullableWithAggregatesFilter"
	},
	EnumWorkspaceTypeWithAggregatesFilter:{
		equals:"WorkspaceType",
		in:"WorkspaceType",
		notIn:"WorkspaceType",
		not:"NestedEnumWorkspaceTypeWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumWorkspaceTypeFilter",
		_max:"NestedEnumWorkspaceTypeFilter"
	},
	NestedEnumWorkspaceTypeWithAggregatesFilter:{
		equals:"WorkspaceType",
		in:"WorkspaceType",
		notIn:"WorkspaceType",
		not:"NestedEnumWorkspaceTypeWithAggregatesFilter",
		_count:"NestedIntFilter",
		_min:"NestedEnumWorkspaceTypeFilter",
		_max:"NestedEnumWorkspaceTypeFilter"
	},
	WorkspaceRoleOrderByWithAggregationInput:{
		id:"SortOrder",
		name:"SortOrder",
		permissions:"SortOrder",
		workspaceId:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder",
		_count:"WorkspaceRoleCountOrderByAggregateInput",
		_max:"WorkspaceRoleMaxOrderByAggregateInput",
		_min:"WorkspaceRoleMinOrderByAggregateInput"
	},
	WorkspaceRoleCountOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		permissions:"SortOrder",
		workspaceId:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder"
	},
	WorkspaceRoleMaxOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		workspaceId:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder"
	},
	WorkspaceRoleMinOrderByAggregateInput:{
		id:"SortOrder",
		name:"SortOrder",
		workspaceId:"SortOrder",
		createdAt:"SortOrder",
		updatedAt:"SortOrder"
	},
	WorkspaceRoleScalarWhereWithAggregatesInput:{
		AND:"WorkspaceRoleScalarWhereWithAggregatesInput",
		OR:"WorkspaceRoleScalarWhereWithAggregatesInput",
		NOT:"WorkspaceRoleScalarWhereWithAggregatesInput",
		id:"StringWithAggregatesFilter",
		name:"StringWithAggregatesFilter",
		permissions:"EnumPermissionNullableListFilter",
		workspaceId:"StringNullableWithAggregatesFilter",
		createdAt:"DateTimeWithAggregatesFilter",
		updatedAt:"DateTimeWithAggregatesFilter"
	},
	BillboardAiCameraStatWhereInput:{
		AND:"BillboardAiCameraStatWhereInput",
		OR:"BillboardAiCameraStatWhereInput",
		NOT:"BillboardAiCameraStatWhereInput",
		id:"StringFilter",
		deviceId:"StringFilter",
		timestamp:"DateTimeFilter",
		hasScreenDefects:"BoolFilter",
		hasPatches:"BoolFilter",
		isOnline:"BoolFilter",
		details:"StringFilter"
	},
	BillboardAiCameraStatOrderByWithRelationInput:{
		id:"SortOrder",
		deviceId:"SortOrder",
		timestamp:"SortOrder",
		hasScreenDefects:"SortOrder",
		hasPatches:"SortOrder",
		isOnline:"SortOrder",
		details:"SortOrder"
	},
	BillboardAiCameraStatWhereUniqueInput:{
		AND:"BillboardAiCameraStatWhereInput",
		OR:"BillboardAiCameraStatWhereInput",
		NOT:"BillboardAiCameraStatWhereInput",
		deviceId:"StringFilter",
		timestamp:"DateTimeFilter",
		hasScreenDefects:"BoolFilter",
		hasPatches:"BoolFilter",
		isOnline:"BoolFilter",
		details:"StringFilter"
	},
	BillboardAiCameraStatScalarFieldEnum: "enum" as const,
	TrafficStatWhereInput:{
		AND:"TrafficStatWhereInput",
		OR:"TrafficStatWhereInput",
		NOT:"TrafficStatWhereInput",
		id:"StringFilter",
		deviceId:"StringFilter",
		timestamp:"DateTimeFilter",
		newCount:"JsonNullableFilter",
		stableCount:"JsonNullableFilter",
		passedCount:"JsonNullableFilter",
		newPeopleInfo:"PeopleInfoObjectEqualityInput"
	},
	PeopleInfoObjectEqualityInput:{

	},
	TrafficStatOrderByWithRelationInput:{
		id:"SortOrder",
		deviceId:"SortOrder",
		timestamp:"SortOrder",
		newCount:"SortOrder",
		stableCount:"SortOrder",
		passedCount:"SortOrder",
		newPeopleInfo:"PeopleInfoOrderByCompositeAggregateInput"
	},
	PeopleInfoOrderByCompositeAggregateInput:{
		_count:"SortOrder"
	},
	TrafficStatWhereUniqueInput:{
		AND:"TrafficStatWhereInput",
		OR:"TrafficStatWhereInput",
		NOT:"TrafficStatWhereInput",
		deviceId:"StringFilter",
		timestamp:"DateTimeFilter",
		newCount:"JsonNullableFilter",
		stableCount:"JsonNullableFilter",
		passedCount:"JsonNullableFilter",
		newPeopleInfo:"PeopleInfoObjectEqualityInput"
	},
	TrafficStatScalarFieldEnum: "enum" as const,
	Mutation:{
		createManyAdBoard:{
			data:"AdBoardCreateManyInput"
		},
		createOneAdBoard:{
			data:"AdBoardCreateInput"
		},
		deleteManyAdBoard:{
			where:"AdBoardWhereInput"
		},
		deleteOneAdBoard:{
			where:"AdBoardWhereUniqueInput"
		},
		updateManyAdBoard:{
			data:"AdBoardUpdateManyMutationInput",
			where:"AdBoardWhereInput"
		},
		updateOneAdBoard:{
			data:"AdBoardUpdateInput",
			where:"AdBoardWhereUniqueInput"
		},
		upsertOneAdBoard:{
			where:"AdBoardWhereUniqueInput",
			create:"AdBoardCreateInput",
			update:"AdBoardUpdateInput"
		},
		createManyAdBoardGroup:{
			data:"AdBoardGroupCreateManyInput"
		},
		createOneAdBoardGroup:{
			data:"AdBoardGroupCreateInput"
		},
		deleteManyAdBoardGroup:{
			where:"AdBoardGroupWhereInput"
		},
		deleteOneAdBoardGroup:{
			where:"AdBoardGroupWhereUniqueInput"
		},
		updateManyAdBoardGroup:{
			data:"AdBoardGroupUpdateManyMutationInput",
			where:"AdBoardGroupWhereInput"
		},
		updateOneAdBoardGroup:{
			data:"AdBoardGroupUpdateInput",
			where:"AdBoardGroupWhereUniqueInput"
		},
		upsertOneAdBoardGroup:{
			where:"AdBoardGroupWhereUniqueInput",
			create:"AdBoardGroupCreateInput",
			update:"AdBoardGroupUpdateInput"
		},
		createManyAdBoardType:{
			data:"AdBoardTypeCreateManyInput"
		},
		createOneAdBoardType:{
			data:"AdBoardTypeCreateInput"
		},
		deleteManyAdBoardType:{
			where:"AdBoardTypeWhereInput"
		},
		deleteOneAdBoardType:{
			where:"AdBoardTypeWhereUniqueInput"
		},
		updateManyAdBoardType:{
			data:"AdBoardTypeUpdateManyMutationInput",
			where:"AdBoardTypeWhereInput"
		},
		updateOneAdBoardType:{
			data:"AdBoardTypeUpdateInput",
			where:"AdBoardTypeWhereUniqueInput"
		},
		upsertOneAdBoardType:{
			where:"AdBoardTypeWhereUniqueInput",
			create:"AdBoardTypeCreateInput",
			update:"AdBoardTypeUpdateInput"
		},
		createManyAdvertisementCategory:{
			data:"AdvertisementCategoryCreateManyInput"
		},
		createOneAdvertisementCategory:{
			data:"AdvertisementCategoryCreateInput"
		},
		deleteManyAdvertisementCategory:{
			where:"AdvertisementCategoryWhereInput"
		},
		deleteOneAdvertisementCategory:{
			where:"AdvertisementCategoryWhereUniqueInput"
		},
		updateManyAdvertisementCategory:{
			data:"AdvertisementCategoryUpdateManyMutationInput",
			where:"AdvertisementCategoryWhereInput"
		},
		updateOneAdvertisementCategory:{
			data:"AdvertisementCategoryUpdateInput",
			where:"AdvertisementCategoryWhereUniqueInput"
		},
		upsertOneAdvertisementCategory:{
			where:"AdvertisementCategoryWhereUniqueInput",
			create:"AdvertisementCategoryCreateInput",
			update:"AdvertisementCategoryUpdateInput"
		},
		createManyAudit:{
			data:"AuditCreateManyInput"
		},
		createOneAudit:{
			data:"AuditCreateInput"
		},
		deleteManyAudit:{
			where:"AuditWhereInput"
		},
		deleteOneAudit:{
			where:"AuditWhereUniqueInput"
		},
		updateManyAudit:{
			data:"AuditUpdateManyMutationInput",
			where:"AuditWhereInput"
		},
		updateOneAudit:{
			data:"AuditUpdateInput",
			where:"AuditWhereUniqueInput"
		},
		upsertOneAudit:{
			where:"AuditWhereUniqueInput",
			create:"AuditCreateInput",
			update:"AuditUpdateInput"
		},
		createManyBooking:{
			data:"BookingCreateManyInput"
		},
		createOneBooking:{
			data:"BookingCreateInput"
		},
		deleteManyBooking:{
			where:"BookingWhereInput"
		},
		deleteOneBooking:{
			where:"BookingWhereUniqueInput"
		},
		updateManyBooking:{
			data:"BookingUpdateManyMutationInput",
			where:"BookingWhereInput"
		},
		updateOneBooking:{
			data:"BookingUpdateInput",
			where:"BookingWhereUniqueInput"
		},
		upsertOneBooking:{
			where:"BookingWhereUniqueInput",
			create:"BookingCreateInput",
			update:"BookingUpdateInput"
		},
		createManyBusinessCategory:{
			data:"BusinessCategoryCreateManyInput"
		},
		createOneBusinessCategory:{
			data:"BusinessCategoryCreateInput"
		},
		deleteManyBusinessCategory:{
			where:"BusinessCategoryWhereInput"
		},
		deleteOneBusinessCategory:{
			where:"BusinessCategoryWhereUniqueInput"
		},
		updateManyBusinessCategory:{
			data:"BusinessCategoryUpdateManyMutationInput",
			where:"BusinessCategoryWhereInput"
		},
		updateOneBusinessCategory:{
			data:"BusinessCategoryUpdateInput",
			where:"BusinessCategoryWhereUniqueInput"
		},
		upsertOneBusinessCategory:{
			where:"BusinessCategoryWhereUniqueInput",
			create:"BusinessCategoryCreateInput",
			update:"BusinessCategoryUpdateInput"
		},
		createManyCamera:{
			data:"CameraCreateManyInput"
		},
		createOneCamera:{
			data:"CameraCreateInput"
		},
		deleteManyCamera:{
			where:"CameraWhereInput"
		},
		deleteOneCamera:{
			where:"CameraWhereUniqueInput"
		},
		updateManyCamera:{
			data:"CameraUpdateManyMutationInput",
			where:"CameraWhereInput"
		},
		updateOneCamera:{
			data:"CameraUpdateInput",
			where:"CameraWhereUniqueInput"
		},
		upsertOneCamera:{
			where:"CameraWhereUniqueInput",
			create:"CameraCreateInput",
			update:"CameraUpdateInput"
		},
		createManyCampaign:{
			data:"CampaignCreateManyInput"
		},
		createOneCampaign:{
			data:"CampaignCreateInput"
		},
		deleteManyCampaign:{
			where:"CampaignWhereInput"
		},
		deleteOneCampaign:{
			where:"CampaignWhereUniqueInput"
		},
		updateManyCampaign:{
			data:"CampaignUpdateManyMutationInput",
			where:"CampaignWhereInput"
		},
		updateOneCampaign:{
			data:"CampaignUpdateInput",
			where:"CampaignWhereUniqueInput"
		},
		upsertOneCampaign:{
			where:"CampaignWhereUniqueInput",
			create:"CampaignCreateInput",
			update:"CampaignUpdateInput"
		},
		createManyFile:{
			data:"FileCreateManyInput"
		},
		createOneFile:{
			data:"FileCreateInput"
		},
		deleteManyFile:{
			where:"FileWhereInput"
		},
		deleteOneFile:{
			where:"FileWhereUniqueInput"
		},
		updateManyFile:{
			data:"FileUpdateManyMutationInput",
			where:"FileWhereInput"
		},
		updateOneFile:{
			data:"FileUpdateInput",
			where:"FileWhereUniqueInput"
		},
		upsertOneFile:{
			where:"FileWhereUniqueInput",
			create:"FileCreateInput",
			update:"FileUpdateInput"
		},
		createManyMembership:{
			data:"MembershipCreateManyInput"
		},
		createOneMembership:{
			data:"MembershipCreateInput"
		},
		deleteManyMembership:{
			where:"MembershipWhereInput"
		},
		deleteOneMembership:{
			where:"MembershipWhereUniqueInput"
		},
		updateManyMembership:{
			data:"MembershipUpdateManyMutationInput",
			where:"MembershipWhereInput"
		},
		updateOneMembership:{
			data:"MembershipUpdateInput",
			where:"MembershipWhereUniqueInput"
		},
		upsertOneMembership:{
			where:"MembershipWhereUniqueInput",
			create:"MembershipCreateInput",
			update:"MembershipUpdateInput"
		},
		createManyNotification:{
			data:"NotificationCreateManyInput"
		},
		createOneNotification:{
			data:"NotificationCreateInput"
		},
		deleteManyNotification:{
			where:"NotificationWhereInput"
		},
		deleteOneNotification:{
			where:"NotificationWhereUniqueInput"
		},
		updateManyNotification:{
			data:"NotificationUpdateManyMutationInput",
			where:"NotificationWhereInput"
		},
		updateOneNotification:{
			data:"NotificationUpdateInput",
			where:"NotificationWhereUniqueInput"
		},
		upsertOneNotification:{
			where:"NotificationWhereUniqueInput",
			create:"NotificationCreateInput",
			update:"NotificationUpdateInput"
		},
		createManyOrder:{
			data:"OrderCreateManyInput"
		},
		createOneOrder:{
			data:"OrderCreateInput"
		},
		deleteManyOrder:{
			where:"OrderWhereInput"
		},
		deleteOneOrder:{
			where:"OrderWhereUniqueInput"
		},
		updateManyOrder:{
			data:"OrderUpdateManyMutationInput",
			where:"OrderWhereInput"
		},
		updateOneOrder:{
			data:"OrderUpdateInput",
			where:"OrderWhereUniqueInput"
		},
		upsertOneOrder:{
			where:"OrderWhereUniqueInput",
			create:"OrderCreateInput",
			update:"OrderUpdateInput"
		},
		createManyPlayer:{
			data:"PlayerCreateManyInput"
		},
		createOnePlayer:{
			data:"PlayerCreateInput"
		},
		deleteManyPlayer:{
			where:"PlayerWhereInput"
		},
		deleteOnePlayer:{
			where:"PlayerWhereUniqueInput"
		},
		updateManyPlayer:{
			data:"PlayerUpdateManyMutationInput",
			where:"PlayerWhereInput"
		},
		updateOnePlayer:{
			data:"PlayerUpdateInput",
			where:"PlayerWhereUniqueInput"
		},
		upsertOnePlayer:{
			where:"PlayerWhereUniqueInput",
			create:"PlayerCreateInput",
			update:"PlayerUpdateInput"
		},
		createManyPlaylist:{
			data:"PlaylistCreateManyInput"
		},
		createOnePlaylist:{
			data:"PlaylistCreateInput"
		},
		deleteManyPlaylist:{
			where:"PlaylistWhereInput"
		},
		deleteOnePlaylist:{
			where:"PlaylistWhereUniqueInput"
		},
		updateManyPlaylist:{
			data:"PlaylistUpdateManyMutationInput",
			where:"PlaylistWhereInput"
		},
		updateOnePlaylist:{
			data:"PlaylistUpdateInput",
			where:"PlaylistWhereUniqueInput"
		},
		upsertOnePlaylist:{
			where:"PlaylistWhereUniqueInput",
			create:"PlaylistCreateInput",
			update:"PlaylistUpdateInput"
		},
		createManySlotConfiguration:{
			data:"SlotConfigurationCreateManyInput"
		},
		createOneSlotConfiguration:{
			data:"SlotConfigurationCreateInput"
		},
		deleteManySlotConfiguration:{
			where:"SlotConfigurationWhereInput"
		},
		deleteOneSlotConfiguration:{
			where:"SlotConfigurationWhereUniqueInput"
		},
		updateManySlotConfiguration:{
			data:"SlotConfigurationUpdateManyMutationInput",
			where:"SlotConfigurationWhereInput"
		},
		updateOneSlotConfiguration:{
			data:"SlotConfigurationUpdateInput",
			where:"SlotConfigurationWhereUniqueInput"
		},
		upsertOneSlotConfiguration:{
			where:"SlotConfigurationWhereUniqueInput",
			create:"SlotConfigurationCreateInput",
			update:"SlotConfigurationUpdateInput"
		},
		createManySubscription:{
			data:"SubscriptionCreateManyInput"
		},
		createOneSubscription:{
			data:"SubscriptionCreateInput"
		},
		deleteManySubscription:{
			where:"SubscriptionWhereInput"
		},
		deleteOneSubscription:{
			where:"SubscriptionWhereUniqueInput"
		},
		updateManySubscription:{
			data:"SubscriptionUpdateManyMutationInput",
			where:"SubscriptionWhereInput"
		},
		updateOneSubscription:{
			data:"SubscriptionUpdateInput",
			where:"SubscriptionWhereUniqueInput"
		},
		upsertOneSubscription:{
			where:"SubscriptionWhereUniqueInput",
			create:"SubscriptionCreateInput",
			update:"SubscriptionUpdateInput"
		},
		createManyUser:{
			data:"UserCreateManyInput"
		},
		createOneUser:{
			data:"UserCreateInput"
		},
		deleteManyUser:{
			where:"UserWhereInput"
		},
		deleteOneUser:{
			where:"UserWhereUniqueInput"
		},
		updateManyUser:{
			data:"UserUpdateManyMutationInput",
			where:"UserWhereInput"
		},
		updateOneUser:{
			data:"UserUpdateInput",
			where:"UserWhereUniqueInput"
		},
		upsertOneUser:{
			where:"UserWhereUniqueInput",
			create:"UserCreateInput",
			update:"UserUpdateInput"
		},
		createManyUserPosition:{
			data:"UserPositionCreateManyInput"
		},
		createOneUserPosition:{
			data:"UserPositionCreateInput"
		},
		deleteManyUserPosition:{
			where:"UserPositionWhereInput"
		},
		deleteOneUserPosition:{
			where:"UserPositionWhereUniqueInput"
		},
		updateManyUserPosition:{
			data:"UserPositionUpdateManyMutationInput",
			where:"UserPositionWhereInput"
		},
		updateOneUserPosition:{
			data:"UserPositionUpdateInput",
			where:"UserPositionWhereUniqueInput"
		},
		upsertOneUserPosition:{
			where:"UserPositionWhereUniqueInput",
			create:"UserPositionCreateInput",
			update:"UserPositionUpdateInput"
		},
		createManyWishlist:{
			data:"WishlistCreateManyInput"
		},
		createOneWishlist:{
			data:"WishlistCreateInput"
		},
		deleteManyWishlist:{
			where:"WishlistWhereInput"
		},
		deleteOneWishlist:{
			where:"WishlistWhereUniqueInput"
		},
		updateManyWishlist:{
			data:"WishlistUpdateManyMutationInput",
			where:"WishlistWhereInput"
		},
		updateOneWishlist:{
			data:"WishlistUpdateInput",
			where:"WishlistWhereUniqueInput"
		},
		upsertOneWishlist:{
			where:"WishlistWhereUniqueInput",
			create:"WishlistCreateInput",
			update:"WishlistUpdateInput"
		},
		createManyWorkspace:{
			data:"WorkspaceCreateManyInput"
		},
		createOneWorkspace:{
			data:"WorkspaceCreateInput"
		},
		deleteManyWorkspace:{
			where:"WorkspaceWhereInput"
		},
		deleteOneWorkspace:{
			where:"WorkspaceWhereUniqueInput"
		},
		updateManyWorkspace:{
			data:"WorkspaceUpdateManyMutationInput",
			where:"WorkspaceWhereInput"
		},
		updateOneWorkspace:{
			data:"WorkspaceUpdateInput",
			where:"WorkspaceWhereUniqueInput"
		},
		upsertOneWorkspace:{
			where:"WorkspaceWhereUniqueInput",
			create:"WorkspaceCreateInput",
			update:"WorkspaceUpdateInput"
		},
		createManyWorkspaceRole:{
			data:"WorkspaceRoleCreateManyInput"
		},
		createOneWorkspaceRole:{
			data:"WorkspaceRoleCreateInput"
		},
		deleteManyWorkspaceRole:{
			where:"WorkspaceRoleWhereInput"
		},
		deleteOneWorkspaceRole:{
			where:"WorkspaceRoleWhereUniqueInput"
		},
		updateManyWorkspaceRole:{
			data:"WorkspaceRoleUpdateManyMutationInput",
			where:"WorkspaceRoleWhereInput"
		},
		updateOneWorkspaceRole:{
			data:"WorkspaceRoleUpdateInput",
			where:"WorkspaceRoleWhereUniqueInput"
		},
		upsertOneWorkspaceRole:{
			where:"WorkspaceRoleWhereUniqueInput",
			create:"WorkspaceRoleCreateInput",
			update:"WorkspaceRoleUpdateInput"
		},
		updateUser:{
			accountDetails:"AccountDetails"
		},
		createCustomUser:{
			user:"UserInput"
		},
		deleteUserCustom:{

		},
		sendMail:{
			templateId:"TemplateIds"
		},
		createOneCampaignBooking:{
			data:"CampaignCreateInput"
		},
		createOneAdboardPublicReview:{
			data:"AdBoardPublicReviewCreateInput"
		},
		createOneCameraStreamingDevice:{
			data:"StreamingDeviceCreateInput"
		},
		updateOneCameraStreamingDevice:{
			data:"StreamingDeviceUpdateInput"
		},
		refreshSubscription:{

		},
		cancelSubscription:{

		},
		updateBookingStatus:{
			status:"BookingStatus",
			where:"BookingWhereUniqueInput"
		},
		cancelBooking:{
			where:"BookingWhereUniqueInput"
		},
		updateBookingAssets:{

		},
		approveBookingAsset:{

		},
		deployBookingAsset:{

		},
		updateAdboard:{
			data:"AdBoardUpdateInput"
		},
		addReviewComment:{
			action:"ReviewAction"
		},
		updateAdBoardStatus:{
			status:"AdBoardStatus"
		},
		publishApprovedDraft:{

		},
		addPlayersToAdboard:{

		},
		createOneAdboardWithGroup:{
			data:"AdBoardCreateInput"
		},
		deleteOneAdboardWithGroup:{

		},
		updateOneScheduler:{
			data:"AdBoardGroupUpdateInput",
			where:"AdBoardGroupWhereUniqueInput"
		},
		deployPlaylist:{
			currentAssets:"AssetRow"
		},
		setupOnePlayer:{

		},
		updatePlayerCode:{

		},
		updatePlayerPlaySettings:{
			playerPlaySetting:"PlayerPlaySettingInput"
		},
		addPlaylistToPlayer:{

		},
		setPlaylistToPlayer:{

		},
		resetTvCode:{

		}
	},
	AdBoardCreateManyInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime"
	},
	PricingTierCreateInput:{

	},
	SpecificationCreateInput:{

	},
	ResolutionCreateInput:{

	},
	ScreenSizeCreateInput:{
		unit:"MeasurementUnit"
	},
	PlaybackTimeCreateInput:{

	},
	AdBoardCreateInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	LocationCategoryCreateNestedOneWithoutAdBoardsInput:{
		create:"LocationCategoryCreateWithoutAdBoardsInput",
		connectOrCreate:"LocationCategoryCreateOrConnectWithoutAdBoardsInput",
		connect:"LocationCategoryWhereUniqueInput"
	},
	LocationCategoryCreateWithoutAdBoardsInput:{
		locationSubCategory:"LocationSubCategoryCreateNestedManyWithoutLocationCategoryInput"
	},
	LocationSubCategoryCreateNestedManyWithoutLocationCategoryInput:{
		create:"LocationSubCategoryCreateWithoutLocationCategoryInput",
		connectOrCreate:"LocationSubCategoryCreateOrConnectWithoutLocationCategoryInput",
		createMany:"LocationSubCategoryCreateManyLocationCategoryInputEnvelope",
		connect:"LocationSubCategoryWhereUniqueInput"
	},
	LocationSubCategoryCreateWithoutLocationCategoryInput:{
		adBoards:"AdBoardCreateNestedManyWithoutLocationSubCategoryInput"
	},
	AdBoardCreateNestedManyWithoutLocationSubCategoryInput:{
		create:"AdBoardCreateWithoutLocationSubCategoryInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutLocationSubCategoryInput",
		createMany:"AdBoardCreateManyLocationSubCategoryInputEnvelope",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutLocationSubCategoryInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	AdBoardTypeCreateNestedOneWithoutAdBoardsInput:{
		create:"AdBoardTypeCreateWithoutAdBoardsInput",
		connectOrCreate:"AdBoardTypeCreateOrConnectWithoutAdBoardsInput",
		connect:"AdBoardTypeWhereUniqueInput"
	},
	AdBoardTypeCreateWithoutAdBoardsInput:{

	},
	AdBoardTypeCreateOrConnectWithoutAdBoardsInput:{
		where:"AdBoardTypeWhereUniqueInput",
		create:"AdBoardTypeCreateWithoutAdBoardsInput"
	},
	BusinessCategoryCreateNestedOneWithoutAdBoardsInput:{
		create:"BusinessCategoryCreateWithoutAdBoardsInput",
		connectOrCreate:"BusinessCategoryCreateOrConnectWithoutAdBoardsInput",
		connect:"BusinessCategoryWhereUniqueInput"
	},
	BusinessCategoryCreateWithoutAdBoardsInput:{
		restrictedByAdBoards:"AdBoardCreateNestedManyWithoutRestrictedBusinesInput",
		campaigns:"CampaignCreateNestedManyWithoutBusinessCategoryInput",
		bookings:"BookingCreateNestedManyWithoutBusinessCategoryInput"
	},
	AdBoardCreateNestedManyWithoutRestrictedBusinesInput:{
		create:"AdBoardCreateWithoutRestrictedBusinesInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutRestrictedBusinesInput",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutRestrictedBusinesInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	LocationSubCategoryCreateNestedOneWithoutAdBoardsInput:{
		create:"LocationSubCategoryCreateWithoutAdBoardsInput",
		connectOrCreate:"LocationSubCategoryCreateOrConnectWithoutAdBoardsInput",
		connect:"LocationSubCategoryWhereUniqueInput"
	},
	LocationSubCategoryCreateWithoutAdBoardsInput:{
		locationCategory:"LocationCategoryCreateNestedOneWithoutLocationSubCategoryInput"
	},
	LocationCategoryCreateNestedOneWithoutLocationSubCategoryInput:{
		create:"LocationCategoryCreateWithoutLocationSubCategoryInput",
		connectOrCreate:"LocationCategoryCreateOrConnectWithoutLocationSubCategoryInput",
		connect:"LocationCategoryWhereUniqueInput"
	},
	LocationCategoryCreateWithoutLocationSubCategoryInput:{
		adBoards:"AdBoardCreateNestedManyWithoutLocationCategoryInput"
	},
	AdBoardCreateNestedManyWithoutLocationCategoryInput:{
		create:"AdBoardCreateWithoutLocationCategoryInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutLocationCategoryInput",
		createMany:"AdBoardCreateManyLocationCategoryInputEnvelope",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutLocationCategoryInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput:{
		create:"BusinessCategoryCreateWithoutRestrictedByAdBoardsInput",
		connectOrCreate:"BusinessCategoryCreateOrConnectWithoutRestrictedByAdBoardsInput",
		connect:"BusinessCategoryWhereUniqueInput"
	},
	BusinessCategoryCreateWithoutRestrictedByAdBoardsInput:{
		adBoards:"AdBoardCreateNestedManyWithoutCategoryInput",
		campaigns:"CampaignCreateNestedManyWithoutBusinessCategoryInput",
		bookings:"BookingCreateNestedManyWithoutBusinessCategoryInput"
	},
	AdBoardCreateNestedManyWithoutCategoryInput:{
		create:"AdBoardCreateWithoutCategoryInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutCategoryInput",
		createMany:"AdBoardCreateManyCategoryInputEnvelope",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutCategoryInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	BookingCreateNestedManyWithoutAdBoardInput:{
		create:"BookingCreateWithoutAdBoardInput",
		connectOrCreate:"BookingCreateOrConnectWithoutAdBoardInput",
		createMany:"BookingCreateManyAdBoardInputEnvelope",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutAdBoardInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	BookingUserDetailsCreateInput:{

	},
	OrderSelectedDateCreateInput:{
		endDate:"DateTime",
		startDate:"DateTime"
	},
	BookingPaymentCreateInput:{
		customer:"BookingCustomerCreateInput",
		paymentGateway:"PaymentGatewayName",
		totalDetails:"PaymentTotalDetailsCreateInput",
		razorpay:"JSON",
		stripe:"JSON"
	},
	BookingCustomerCreateInput:{
		customerDetails:"PaymentCustomerDetailsCreateInput"
	},
	PaymentCustomerDetailsCreateInput:{

	},
	PaymentTotalDetailsCreateInput:{

	},
	PriceSummaryCreateInput:{

	},
	BookingPisignageDataCreateInput:{

	},
	BusinessCategoryCreateNestedOneWithoutBookingsInput:{
		create:"BusinessCategoryCreateWithoutBookingsInput",
		connectOrCreate:"BusinessCategoryCreateOrConnectWithoutBookingsInput",
		connect:"BusinessCategoryWhereUniqueInput"
	},
	BusinessCategoryCreateWithoutBookingsInput:{
		adBoards:"AdBoardCreateNestedManyWithoutCategoryInput",
		restrictedByAdBoards:"AdBoardCreateNestedManyWithoutRestrictedBusinesInput",
		campaigns:"CampaignCreateNestedManyWithoutBusinessCategoryInput"
	},
	CampaignCreateNestedManyWithoutBusinessCategoryInput:{
		create:"CampaignCreateWithoutBusinessCategoryInput",
		connectOrCreate:"CampaignCreateOrConnectWithoutBusinessCategoryInput",
		createMany:"CampaignCreateManyBusinessCategoryInputEnvelope",
		connect:"CampaignWhereUniqueInput"
	},
	CampaignCreateWithoutBusinessCategoryInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		user:"UserCreateNestedOneWithoutCampaignsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutCampaignsInput",
		bookings:"BookingCreateNestedManyWithoutCampaignInput",
		payments:"PaymentCreateNestedManyWithoutCampaignInput",
		assets:"FileCreateNestedManyWithoutCampaignsInput"
	},
	UserCreateNestedOneWithoutCampaignsInput:{
		create:"UserCreateWithoutCampaignsInput",
		connectOrCreate:"UserCreateOrConnectWithoutCampaignsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutCampaignsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	UserStripeCreateInput:{

	},
	BookingRefundCreateInput:{
		razorpay:"JSON",
		stripe:"JSON"
	},
	NotificationPreferenceCreateInput:{
		type:"NotificationType",
		channels:"NotificationChannel",
		pushSetting:"PushSettingCreateInput"
	},
	PushSettingCreateInput:{

	},
	BookingCreateNestedManyWithoutUserInput:{
		create:"BookingCreateWithoutUserInput",
		connectOrCreate:"BookingCreateOrConnectWithoutUserInput",
		createMany:"BookingCreateManyUserInputEnvelope",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutUserInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	AdvertisementCategoryCreateNestedManyWithoutBookingsInput:{
		create:"AdvertisementCategoryCreateWithoutBookingsInput",
		connectOrCreate:"AdvertisementCategoryCreateOrConnectWithoutBookingsInput",
		connect:"AdvertisementCategoryWhereUniqueInput"
	},
	AdvertisementCategoryCreateWithoutBookingsInput:{
		type:"AdvertisementCategoryEnum",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		campaigns:"CampaignCreateNestedManyWithoutAdCategoryInput"
	},
	CampaignCreateNestedManyWithoutAdCategoryInput:{
		create:"CampaignCreateWithoutAdCategoryInput",
		connectOrCreate:"CampaignCreateOrConnectWithoutAdCategoryInput",
		connect:"CampaignWhereUniqueInput"
	},
	CampaignCreateWithoutAdCategoryInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutCampaignsInput",
		user:"UserCreateNestedOneWithoutCampaignsInput",
		bookings:"BookingCreateNestedManyWithoutCampaignInput",
		payments:"PaymentCreateNestedManyWithoutCampaignInput",
		assets:"FileCreateNestedManyWithoutCampaignsInput"
	},
	BusinessCategoryCreateNestedOneWithoutCampaignsInput:{
		create:"BusinessCategoryCreateWithoutCampaignsInput",
		connectOrCreate:"BusinessCategoryCreateOrConnectWithoutCampaignsInput",
		connect:"BusinessCategoryWhereUniqueInput"
	},
	BusinessCategoryCreateWithoutCampaignsInput:{
		adBoards:"AdBoardCreateNestedManyWithoutCategoryInput",
		restrictedByAdBoards:"AdBoardCreateNestedManyWithoutRestrictedBusinesInput",
		bookings:"BookingCreateNestedManyWithoutBusinessCategoryInput"
	},
	BookingCreateNestedManyWithoutBusinessCategoryInput:{
		create:"BookingCreateWithoutBusinessCategoryInput",
		connectOrCreate:"BookingCreateOrConnectWithoutBusinessCategoryInput",
		createMany:"BookingCreateManyBusinessCategoryInputEnvelope",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutBusinessCategoryInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	FileCreateNestedManyWithoutBookingsInput:{
		create:"FileCreateWithoutBookingsInput",
		connectOrCreate:"FileCreateOrConnectWithoutBookingsInput",
		connect:"FileWhereUniqueInput"
	},
	FileCreateWithoutBookingsInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserCreateNestedOneWithoutUpdatedFilesInput",
		createdBy:"UserCreateNestedOneWithoutCreatedFilesInput",
		workspace:"WorkspaceCreateNestedOneWithoutFilesInput",
		proofBooking:"BookingCreateNestedOneWithoutProofsInput",
		campaigns:"CampaignCreateNestedManyWithoutAssetsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutAssetsInput"
	},
	FileMetaCreateInput:{

	},
	UserCreateNestedOneWithoutUpdatedFilesInput:{
		create:"UserCreateWithoutUpdatedFilesInput",
		connectOrCreate:"UserCreateOrConnectWithoutUpdatedFilesInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutUpdatedFilesInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	FileCreateNestedManyWithoutCreatedByInput:{
		create:"FileCreateWithoutCreatedByInput",
		connectOrCreate:"FileCreateOrConnectWithoutCreatedByInput",
		createMany:"FileCreateManyCreatedByInputEnvelope",
		connect:"FileWhereUniqueInput"
	},
	FileCreateWithoutCreatedByInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserCreateNestedOneWithoutUpdatedFilesInput",
		bookings:"BookingCreateNestedManyWithoutAssetsInput",
		workspace:"WorkspaceCreateNestedOneWithoutFilesInput",
		proofBooking:"BookingCreateNestedOneWithoutProofsInput",
		campaigns:"CampaignCreateNestedManyWithoutAssetsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutAssetsInput"
	},
	BookingCreateNestedManyWithoutAssetsInput:{
		create:"BookingCreateWithoutAssetsInput",
		connectOrCreate:"BookingCreateOrConnectWithoutAssetsInput",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutAssetsInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	ContentVersionCreateNestedManyWithoutBookingInput:{
		create:"ContentVersionCreateWithoutBookingInput",
		connectOrCreate:"ContentVersionCreateOrConnectWithoutBookingInput",
		createMany:"ContentVersionCreateManyBookingInputEnvelope",
		connect:"ContentVersionWhereUniqueInput"
	},
	ContentVersionCreateWithoutBookingInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime",
		submittedBy:"UserCreateNestedOneWithoutSubmittedContentVersionsInput",
		approvedBy:"UserCreateNestedOneWithoutApprovedContentVersionsInput",
		deployedBy:"UserCreateNestedOneWithoutDeployedContentVersionsInput",
		assets:"FileCreateNestedManyWithoutContentVersionsInput"
	},
	UserCreateNestedOneWithoutSubmittedContentVersionsInput:{
		create:"UserCreateWithoutSubmittedContentVersionsInput",
		connectOrCreate:"UserCreateOrConnectWithoutSubmittedContentVersionsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutSubmittedContentVersionsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	FileCreateNestedManyWithoutUpdatedByInput:{
		create:"FileCreateWithoutUpdatedByInput",
		connectOrCreate:"FileCreateOrConnectWithoutUpdatedByInput",
		createMany:"FileCreateManyUpdatedByInputEnvelope",
		connect:"FileWhereUniqueInput"
	},
	FileCreateWithoutUpdatedByInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		createdBy:"UserCreateNestedOneWithoutCreatedFilesInput",
		bookings:"BookingCreateNestedManyWithoutAssetsInput",
		workspace:"WorkspaceCreateNestedOneWithoutFilesInput",
		proofBooking:"BookingCreateNestedOneWithoutProofsInput",
		campaigns:"CampaignCreateNestedManyWithoutAssetsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutAssetsInput"
	},
	UserCreateNestedOneWithoutCreatedFilesInput:{
		create:"UserCreateWithoutCreatedFilesInput",
		connectOrCreate:"UserCreateOrConnectWithoutCreatedFilesInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutCreatedFilesInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	OrderCreateNestedManyWithoutCreatedByInput:{
		create:"OrderCreateWithoutCreatedByInput",
		connectOrCreate:"OrderCreateOrConnectWithoutCreatedByInput",
		createMany:"OrderCreateManyCreatedByInputEnvelope",
		connect:"OrderWhereUniqueInput"
	},
	OrderCreateWithoutCreatedByInput:{
		createdDate:"DateTime",
		priceSummary:"PriceSummaryCreateInput",
		selectedDate:"OrderSelectedDateCreateInput",
		adBoard:"AdBoardCreateNestedOneWithoutOrdersInput"
	},
	AdBoardCreateNestedOneWithoutOrdersInput:{
		create:"AdBoardCreateWithoutOrdersInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutOrdersInput",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutOrdersInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	SlotConfigurationCreateNestedManyWithoutAdBoardInput:{
		create:"SlotConfigurationCreateWithoutAdBoardInput",
		connectOrCreate:"SlotConfigurationCreateOrConnectWithoutAdBoardInput",
		createMany:"SlotConfigurationCreateManyAdBoardInputEnvelope",
		connect:"SlotConfigurationWhereUniqueInput"
	},
	SlotConfigurationCreateWithoutAdBoardInput:{
		date:"DateTime"
	},
	SlotConfigurationCreateOrConnectWithoutAdBoardInput:{
		where:"SlotConfigurationWhereUniqueInput",
		create:"SlotConfigurationCreateWithoutAdBoardInput"
	},
	SlotConfigurationCreateManyAdBoardInputEnvelope:{
		data:"SlotConfigurationCreateManyAdBoardInput"
	},
	SlotConfigurationCreateManyAdBoardInput:{
		date:"DateTime"
	},
	UserCreateNestedOneWithoutAdBoardsInput:{
		create:"UserCreateWithoutAdBoardsInput",
		connectOrCreate:"UserCreateOrConnectWithoutAdBoardsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutAdBoardsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	ChangelogCreateNestedManyWithoutUserInput:{
		create:"ChangelogCreateWithoutUserInput",
		connectOrCreate:"ChangelogCreateOrConnectWithoutUserInput",
		createMany:"ChangelogCreateManyUserInputEnvelope",
		connect:"ChangelogWhereUniqueInput"
	},
	ChangelogCreateWithoutUserInput:{
		createdAt:"DateTime",
		updates:"JSON",
		booking:"BookingCreateNestedOneWithoutChangelogsInput"
	},
	BookingCreateNestedOneWithoutChangelogsInput:{
		create:"BookingCreateWithoutChangelogsInput",
		connectOrCreate:"BookingCreateOrConnectWithoutChangelogsInput",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutChangelogsInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	PaymentAllocationCreateNestedManyWithoutBookingInput:{
		create:"PaymentAllocationCreateWithoutBookingInput",
		connectOrCreate:"PaymentAllocationCreateOrConnectWithoutBookingInput",
		createMany:"PaymentAllocationCreateManyBookingInputEnvelope",
		connect:"PaymentAllocationWhereUniqueInput"
	},
	PaymentAllocationCreateWithoutBookingInput:{
		payment:"PaymentCreateNestedOneWithoutPaymentAllocationsInput"
	},
	PaymentCreateNestedOneWithoutPaymentAllocationsInput:{
		create:"PaymentCreateWithoutPaymentAllocationsInput",
		connectOrCreate:"PaymentCreateOrConnectWithoutPaymentAllocationsInput",
		connect:"PaymentWhereUniqueInput"
	},
	PaymentCreateWithoutPaymentAllocationsInput:{
		paymentGateway:"PaymentGatewayName",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		campaign:"CampaignCreateNestedOneWithoutPaymentsInput"
	},
	CampaignCreateNestedOneWithoutPaymentsInput:{
		create:"CampaignCreateWithoutPaymentsInput",
		connectOrCreate:"CampaignCreateOrConnectWithoutPaymentsInput",
		connect:"CampaignWhereUniqueInput"
	},
	CampaignCreateWithoutPaymentsInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutCampaignsInput",
		user:"UserCreateNestedOneWithoutCampaignsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutCampaignsInput",
		bookings:"BookingCreateNestedManyWithoutCampaignInput",
		assets:"FileCreateNestedManyWithoutCampaignsInput"
	},
	AdvertisementCategoryCreateNestedManyWithoutCampaignsInput:{
		create:"AdvertisementCategoryCreateWithoutCampaignsInput",
		connectOrCreate:"AdvertisementCategoryCreateOrConnectWithoutCampaignsInput",
		connect:"AdvertisementCategoryWhereUniqueInput"
	},
	AdvertisementCategoryCreateWithoutCampaignsInput:{
		type:"AdvertisementCategoryEnum",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		bookings:"BookingCreateNestedManyWithoutAdCategoryInput"
	},
	BookingCreateNestedManyWithoutAdCategoryInput:{
		create:"BookingCreateWithoutAdCategoryInput",
		connectOrCreate:"BookingCreateOrConnectWithoutAdCategoryInput",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutAdCategoryInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	FileCreateNestedManyWithoutProofBookingInput:{
		create:"FileCreateWithoutProofBookingInput",
		connectOrCreate:"FileCreateOrConnectWithoutProofBookingInput",
		createMany:"FileCreateManyProofBookingInputEnvelope",
		connect:"FileWhereUniqueInput"
	},
	FileCreateWithoutProofBookingInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserCreateNestedOneWithoutUpdatedFilesInput",
		createdBy:"UserCreateNestedOneWithoutCreatedFilesInput",
		bookings:"BookingCreateNestedManyWithoutAssetsInput",
		workspace:"WorkspaceCreateNestedOneWithoutFilesInput",
		campaigns:"CampaignCreateNestedManyWithoutAssetsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutAssetsInput"
	},
	WorkspaceCreateNestedOneWithoutFilesInput:{
		create:"WorkspaceCreateWithoutFilesInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutFilesInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutFilesInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	UserCreateNestedOneWithoutOwnedWorkspacesInput:{
		create:"UserCreateWithoutOwnedWorkspacesInput",
		connectOrCreate:"UserCreateOrConnectWithoutOwnedWorkspacesInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutOwnedWorkspacesInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	AdBoardCreateNestedManyWithoutCreatedByInput:{
		create:"AdBoardCreateWithoutCreatedByInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutCreatedByInput",
		createMany:"AdBoardCreateManyCreatedByInputEnvelope",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutCreatedByInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	OrderCreateNestedManyWithoutAdBoardInput:{
		create:"OrderCreateWithoutAdBoardInput",
		connectOrCreate:"OrderCreateOrConnectWithoutAdBoardInput",
		createMany:"OrderCreateManyAdBoardInputEnvelope",
		connect:"OrderWhereUniqueInput"
	},
	OrderCreateWithoutAdBoardInput:{
		createdDate:"DateTime",
		priceSummary:"PriceSummaryCreateInput",
		selectedDate:"OrderSelectedDateCreateInput",
		createdBy:"UserCreateNestedOneWithoutOrdersInput"
	},
	UserCreateNestedOneWithoutOrdersInput:{
		create:"UserCreateWithoutOrdersInput",
		connectOrCreate:"UserCreateOrConnectWithoutOrdersInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutOrdersInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	AuditCreateNestedManyWithoutUserInput:{
		create:"AuditCreateWithoutUserInput",
		connectOrCreate:"AuditCreateOrConnectWithoutUserInput",
		createMany:"AuditCreateManyUserInputEnvelope",
		connect:"AuditWhereUniqueInput"
	},
	AuditCreateWithoutUserInput:{
		createdAt:"DateTime",
		entity:"EntityCreateInput",
		updates:"JSON",
		workspace:"WorkspaceCreateNestedOneWithoutAuditsInput"
	},
	EntityCreateInput:{

	},
	WorkspaceCreateNestedOneWithoutAuditsInput:{
		create:"WorkspaceCreateWithoutAuditsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutAuditsInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutAuditsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	MembershipCreateNestedManyWithoutWorkspaceInput:{
		create:"MembershipCreateWithoutWorkspaceInput",
		connectOrCreate:"MembershipCreateOrConnectWithoutWorkspaceInput",
		createMany:"MembershipCreateManyWorkspaceInputEnvelope",
		connect:"MembershipWhereUniqueInput"
	},
	MembershipCreateWithoutWorkspaceInput:{
		createdAt:"DateTime",
		user:"UserCreateNestedOneWithoutMembershipsInput",
		role:"WorkspaceRoleCreateNestedOneWithoutMembershipsInput"
	},
	UserCreateNestedOneWithoutMembershipsInput:{
		create:"UserCreateWithoutMembershipsInput",
		connectOrCreate:"UserCreateOrConnectWithoutMembershipsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutMembershipsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	CampaignCreateNestedManyWithoutUserInput:{
		create:"CampaignCreateWithoutUserInput",
		connectOrCreate:"CampaignCreateOrConnectWithoutUserInput",
		createMany:"CampaignCreateManyUserInputEnvelope",
		connect:"CampaignWhereUniqueInput"
	},
	CampaignCreateWithoutUserInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutCampaignsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutCampaignsInput",
		bookings:"BookingCreateNestedManyWithoutCampaignInput",
		payments:"PaymentCreateNestedManyWithoutCampaignInput",
		assets:"FileCreateNestedManyWithoutCampaignsInput"
	},
	BookingCreateNestedManyWithoutCampaignInput:{
		create:"BookingCreateWithoutCampaignInput",
		connectOrCreate:"BookingCreateOrConnectWithoutCampaignInput",
		createMany:"BookingCreateManyCampaignInputEnvelope",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutCampaignInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	UserCreateNestedOneWithoutBookingsInput:{
		create:"UserCreateWithoutBookingsInput",
		connectOrCreate:"UserCreateOrConnectWithoutBookingsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutBookingsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	BookingCreateNestedManyWithoutSharedUsersInput:{
		create:"BookingCreateWithoutSharedUsersInput",
		connectOrCreate:"BookingCreateOrConnectWithoutSharedUsersInput",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutSharedUsersInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	AdBoardCreateNestedOneWithoutBookingsInput:{
		create:"AdBoardCreateWithoutBookingsInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutBookingsInput",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutBookingsInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	WorkspaceCreateNestedOneWithoutAdBoardsInput:{
		create:"WorkspaceCreateWithoutAdBoardsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutAdBoardsInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutAdBoardsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	PlaylistCreateNestedManyWithoutWorkspaceInput:{
		create:"PlaylistCreateWithoutWorkspaceInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutWorkspaceInput",
		createMany:"PlaylistCreateManyWorkspaceInputEnvelope",
		connect:"PlaylistWhereUniqueInput"
	},
	PlaylistCreateWithoutWorkspaceInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistCreateNestedOneWithoutFooterParentPlaylistsInput",
		sidebarPlaylist:"PlaylistCreateNestedOneWithoutSidebarParentPlaylistsInput",
		adBoardGroupsForAds:"AdBoardGroupCreateNestedManyWithoutAdsPlaylistInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutScheduledPlaylistsInput",
		footerParentPlaylists:"PlaylistCreateNestedManyWithoutFooterPlaylistInput",
		sidebarParentPlaylists:"PlaylistCreateNestedManyWithoutSidebarPlaylistInput"
	},
	PisignageFileCreateInput:{

	},
	PlaylistCreateNestedOneWithoutFooterParentPlaylistsInput:{
		create:"PlaylistCreateWithoutFooterParentPlaylistsInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutFooterParentPlaylistsInput",
		connect:"PlaylistWhereUniqueInput"
	},
	PlaylistCreateWithoutFooterParentPlaylistsInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistCreateNestedOneWithoutFooterParentPlaylistsInput",
		sidebarPlaylist:"PlaylistCreateNestedOneWithoutSidebarParentPlaylistsInput",
		adBoardGroupsForAds:"AdBoardGroupCreateNestedManyWithoutAdsPlaylistInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutScheduledPlaylistsInput",
		workspace:"WorkspaceCreateNestedOneWithoutPlaylistsInput",
		sidebarParentPlaylists:"PlaylistCreateNestedManyWithoutSidebarPlaylistInput"
	},
	PlaylistCreateNestedOneWithoutSidebarParentPlaylistsInput:{
		create:"PlaylistCreateWithoutSidebarParentPlaylistsInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutSidebarParentPlaylistsInput",
		connect:"PlaylistWhereUniqueInput"
	},
	PlaylistCreateWithoutSidebarParentPlaylistsInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistCreateNestedOneWithoutFooterParentPlaylistsInput",
		sidebarPlaylist:"PlaylistCreateNestedOneWithoutSidebarParentPlaylistsInput",
		adBoardGroupsForAds:"AdBoardGroupCreateNestedManyWithoutAdsPlaylistInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutScheduledPlaylistsInput",
		workspace:"WorkspaceCreateNestedOneWithoutPlaylistsInput",
		footerParentPlaylists:"PlaylistCreateNestedManyWithoutFooterPlaylistInput"
	},
	AdBoardGroupCreateNestedManyWithoutAdsPlaylistInput:{
		create:"AdBoardGroupCreateWithoutAdsPlaylistInput",
		connectOrCreate:"AdBoardGroupCreateOrConnectWithoutAdsPlaylistInput",
		createMany:"AdBoardGroupCreateManyAdsPlaylistInputEnvelope",
		connect:"AdBoardGroupWhereUniqueInput"
	},
	AdBoardGroupCreateWithoutAdsPlaylistInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType",
		adBoard:"AdBoardCreateNestedOneWithoutAdBoardGroupInput",
		scheduledPlaylists:"PlaylistCreateNestedManyWithoutAdBoardGroupsInput",
		pisignagePlayers:"PlayerCreateNestedManyWithoutAdBoardGroupInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardGroupsInput"
	},
	ScheduleCreateInput:{

	},
	AdBoardCreateNestedOneWithoutAdBoardGroupInput:{
		create:"AdBoardCreateWithoutAdBoardGroupInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutAdBoardGroupInput",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutAdBoardGroupInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	PlayerCreateNestedManyWithoutAdBoardsInput:{
		create:"PlayerCreateWithoutAdBoardsInput",
		connectOrCreate:"PlayerCreateOrConnectWithoutAdBoardsInput",
		connect:"PlayerWhereUniqueInput"
	},
	PlayerCreateWithoutAdBoardsInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutPisignagePlayersInput",
		workspace:"WorkspaceCreateNestedOneWithoutPlayersInput",
		status:"PlayerUptimeStatusCreateNestedManyWithoutPlayerInput",
		cameras:"CameraCreateNestedManyWithoutPlayerInput",
		signageType:"DigitalSignageCreateNestedOneWithoutPlayersInput",
		audienceType:"AudienceCreateNestedManyWithoutPlayersInput",
		deletedBy:"UserCreateNestedOneWithoutDeletedPlayerIdsInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutPlayerInput"
	},
	MapCreateInput:{

	},
	GalleryFileCreateInput:{

	},
	AdBoardGroupCreateNestedOneWithoutPisignagePlayersInput:{
		create:"AdBoardGroupCreateWithoutPisignagePlayersInput",
		connectOrCreate:"AdBoardGroupCreateOrConnectWithoutPisignagePlayersInput",
		connect:"AdBoardGroupWhereUniqueInput"
	},
	AdBoardGroupCreateWithoutPisignagePlayersInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType",
		adBoard:"AdBoardCreateNestedOneWithoutAdBoardGroupInput",
		scheduledPlaylists:"PlaylistCreateNestedManyWithoutAdBoardGroupsInput",
		adsPlaylist:"PlaylistCreateNestedOneWithoutAdBoardGroupsForAdsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardGroupsInput"
	},
	PlaylistCreateNestedManyWithoutAdBoardGroupsInput:{
		create:"PlaylistCreateWithoutAdBoardGroupsInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutAdBoardGroupsInput",
		connect:"PlaylistWhereUniqueInput"
	},
	PlaylistCreateWithoutAdBoardGroupsInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistCreateNestedOneWithoutFooterParentPlaylistsInput",
		sidebarPlaylist:"PlaylistCreateNestedOneWithoutSidebarParentPlaylistsInput",
		adBoardGroupsForAds:"AdBoardGroupCreateNestedManyWithoutAdsPlaylistInput",
		workspace:"WorkspaceCreateNestedOneWithoutPlaylistsInput",
		footerParentPlaylists:"PlaylistCreateNestedManyWithoutFooterPlaylistInput",
		sidebarParentPlaylists:"PlaylistCreateNestedManyWithoutSidebarPlaylistInput"
	},
	WorkspaceCreateNestedOneWithoutPlaylistsInput:{
		create:"WorkspaceCreateWithoutPlaylistsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutPlaylistsInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutPlaylistsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	AdBoardCreateNestedManyWithoutWorkspaceInput:{
		create:"AdBoardCreateWithoutWorkspaceInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutWorkspaceInput",
		createMany:"AdBoardCreateManyWorkspaceInputEnvelope",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutWorkspaceInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	AdBoardGroupCreateNestedOneWithoutAdBoardInput:{
		create:"AdBoardGroupCreateWithoutAdBoardInput",
		connectOrCreate:"AdBoardGroupCreateOrConnectWithoutAdBoardInput",
		connect:"AdBoardGroupWhereUniqueInput"
	},
	AdBoardGroupCreateWithoutAdBoardInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType",
		scheduledPlaylists:"PlaylistCreateNestedManyWithoutAdBoardGroupsInput",
		adsPlaylist:"PlaylistCreateNestedOneWithoutAdBoardGroupsForAdsInput",
		pisignagePlayers:"PlayerCreateNestedManyWithoutAdBoardGroupInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardGroupsInput"
	},
	PlaylistCreateNestedOneWithoutAdBoardGroupsForAdsInput:{
		create:"PlaylistCreateWithoutAdBoardGroupsForAdsInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutAdBoardGroupsForAdsInput",
		connect:"PlaylistWhereUniqueInput"
	},
	PlaylistCreateWithoutAdBoardGroupsForAdsInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistCreateNestedOneWithoutFooterParentPlaylistsInput",
		sidebarPlaylist:"PlaylistCreateNestedOneWithoutSidebarParentPlaylistsInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutScheduledPlaylistsInput",
		workspace:"WorkspaceCreateNestedOneWithoutPlaylistsInput",
		footerParentPlaylists:"PlaylistCreateNestedManyWithoutFooterPlaylistInput",
		sidebarParentPlaylists:"PlaylistCreateNestedManyWithoutSidebarPlaylistInput"
	},
	AdBoardGroupCreateNestedManyWithoutScheduledPlaylistsInput:{
		create:"AdBoardGroupCreateWithoutScheduledPlaylistsInput",
		connectOrCreate:"AdBoardGroupCreateOrConnectWithoutScheduledPlaylistsInput",
		connect:"AdBoardGroupWhereUniqueInput"
	},
	AdBoardGroupCreateWithoutScheduledPlaylistsInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType",
		adBoard:"AdBoardCreateNestedOneWithoutAdBoardGroupInput",
		adsPlaylist:"PlaylistCreateNestedOneWithoutAdBoardGroupsForAdsInput",
		pisignagePlayers:"PlayerCreateNestedManyWithoutAdBoardGroupInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardGroupsInput"
	},
	PlayerCreateNestedManyWithoutAdBoardGroupInput:{
		create:"PlayerCreateWithoutAdBoardGroupInput",
		connectOrCreate:"PlayerCreateOrConnectWithoutAdBoardGroupInput",
		createMany:"PlayerCreateManyAdBoardGroupInputEnvelope",
		connect:"PlayerWhereUniqueInput"
	},
	PlayerCreateWithoutAdBoardGroupInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		workspace:"WorkspaceCreateNestedOneWithoutPlayersInput",
		status:"PlayerUptimeStatusCreateNestedManyWithoutPlayerInput",
		cameras:"CameraCreateNestedManyWithoutPlayerInput",
		signageType:"DigitalSignageCreateNestedOneWithoutPlayersInput",
		audienceType:"AudienceCreateNestedManyWithoutPlayersInput",
		adBoards:"AdBoardCreateNestedManyWithoutPlayersInput",
		deletedBy:"UserCreateNestedOneWithoutDeletedPlayerIdsInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutPlayerInput"
	},
	WorkspaceCreateNestedOneWithoutPlayersInput:{
		create:"WorkspaceCreateWithoutPlayersInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutPlayersInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutPlayersInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	AdBoardGroupCreateNestedManyWithoutWorkspaceInput:{
		create:"AdBoardGroupCreateWithoutWorkspaceInput",
		connectOrCreate:"AdBoardGroupCreateOrConnectWithoutWorkspaceInput",
		createMany:"AdBoardGroupCreateManyWorkspaceInputEnvelope",
		connect:"AdBoardGroupWhereUniqueInput"
	},
	AdBoardGroupCreateWithoutWorkspaceInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType",
		adBoard:"AdBoardCreateNestedOneWithoutAdBoardGroupInput",
		scheduledPlaylists:"PlaylistCreateNestedManyWithoutAdBoardGroupsInput",
		adsPlaylist:"PlaylistCreateNestedOneWithoutAdBoardGroupsForAdsInput",
		pisignagePlayers:"PlayerCreateNestedManyWithoutAdBoardGroupInput"
	},
	AdBoardGroupCreateOrConnectWithoutWorkspaceInput:{
		where:"AdBoardGroupWhereUniqueInput",
		create:"AdBoardGroupCreateWithoutWorkspaceInput"
	},
	AdBoardGroupCreateManyWorkspaceInputEnvelope:{
		data:"AdBoardGroupCreateManyWorkspaceInput"
	},
	AdBoardGroupCreateManyWorkspaceInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType"
	},
	AuditCreateNestedManyWithoutWorkspaceInput:{
		create:"AuditCreateWithoutWorkspaceInput",
		connectOrCreate:"AuditCreateOrConnectWithoutWorkspaceInput",
		createMany:"AuditCreateManyWorkspaceInputEnvelope",
		connect:"AuditWhereUniqueInput"
	},
	AuditCreateWithoutWorkspaceInput:{
		createdAt:"DateTime",
		entity:"EntityCreateInput",
		updates:"JSON",
		user:"UserCreateNestedOneWithoutAuditsInput"
	},
	UserCreateNestedOneWithoutAuditsInput:{
		create:"UserCreateWithoutAuditsInput",
		connectOrCreate:"UserCreateOrConnectWithoutAuditsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutAuditsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	MembershipCreateNestedManyWithoutUserInput:{
		create:"MembershipCreateWithoutUserInput",
		connectOrCreate:"MembershipCreateOrConnectWithoutUserInput",
		createMany:"MembershipCreateManyUserInputEnvelope",
		connect:"MembershipWhereUniqueInput"
	},
	MembershipCreateWithoutUserInput:{
		createdAt:"DateTime",
		workspace:"WorkspaceCreateNestedOneWithoutMembershipsInput",
		role:"WorkspaceRoleCreateNestedOneWithoutMembershipsInput"
	},
	WorkspaceCreateNestedOneWithoutMembershipsInput:{
		create:"WorkspaceCreateWithoutMembershipsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutMembershipsInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutMembershipsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	BookingCreateNestedManyWithoutWorkspaceInput:{
		create:"BookingCreateWithoutWorkspaceInput",
		connectOrCreate:"BookingCreateOrConnectWithoutWorkspaceInput",
		createMany:"BookingCreateManyWorkspaceInputEnvelope",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutWorkspaceInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	ChangelogCreateNestedManyWithoutBookingInput:{
		create:"ChangelogCreateWithoutBookingInput",
		connectOrCreate:"ChangelogCreateOrConnectWithoutBookingInput",
		createMany:"ChangelogCreateManyBookingInputEnvelope",
		connect:"ChangelogWhereUniqueInput"
	},
	ChangelogCreateWithoutBookingInput:{
		createdAt:"DateTime",
		updates:"JSON",
		user:"UserCreateNestedOneWithoutChangelogsInput"
	},
	UserCreateNestedOneWithoutChangelogsInput:{
		create:"UserCreateWithoutChangelogsInput",
		connectOrCreate:"UserCreateOrConnectWithoutChangelogsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutChangelogsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	NotificationCreateNestedManyWithoutRecipientInput:{
		create:"NotificationCreateWithoutRecipientInput",
		connectOrCreate:"NotificationCreateOrConnectWithoutRecipientInput",
		createMany:"NotificationCreateManyRecipientInputEnvelope",
		connect:"NotificationWhereUniqueInput"
	},
	NotificationCreateWithoutRecipientInput:{
		type:"NotificationType",
		metadata:"JSON",
		createdAt:"DateTime",
		readAt:"DateTime",
		channels:"NotificationChannel"
	},
	NotificationCreateOrConnectWithoutRecipientInput:{
		where:"NotificationWhereUniqueInput",
		create:"NotificationCreateWithoutRecipientInput"
	},
	NotificationCreateManyRecipientInputEnvelope:{
		data:"NotificationCreateManyRecipientInput"
	},
	NotificationCreateManyRecipientInput:{
		type:"NotificationType",
		metadata:"JSON",
		createdAt:"DateTime",
		readAt:"DateTime",
		channels:"NotificationChannel"
	},
	AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput:{
		create:"AdBoardPublishHistoryCreateWithoutPublishedByInput",
		connectOrCreate:"AdBoardPublishHistoryCreateOrConnectWithoutPublishedByInput",
		createMany:"AdBoardPublishHistoryCreateManyPublishedByInputEnvelope",
		connect:"AdBoardPublishHistoryWhereUniqueInput"
	},
	AdBoardPublishHistoryCreateWithoutPublishedByInput:{
		publishedAt:"DateTime",
		changesSnapshot:"JSON",
		adBoard:"AdBoardCreateNestedOneWithoutHistoryInput"
	},
	AdBoardCreateNestedOneWithoutHistoryInput:{
		create:"AdBoardCreateWithoutHistoryInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutHistoryInput",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutHistoryInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	AdBoardCreateNestedOneWithoutDraftAdboardInput:{
		create:"AdBoardCreateWithoutDraftAdboardInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutDraftAdboardInput",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutDraftAdboardInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput:{
		create:"AdBoardPublishHistoryCreateWithoutAdBoardInput",
		connectOrCreate:"AdBoardPublishHistoryCreateOrConnectWithoutAdBoardInput",
		createMany:"AdBoardPublishHistoryCreateManyAdBoardInputEnvelope",
		connect:"AdBoardPublishHistoryWhereUniqueInput"
	},
	AdBoardPublishHistoryCreateWithoutAdBoardInput:{
		publishedAt:"DateTime",
		changesSnapshot:"JSON",
		publishedBy:"UserCreateNestedOneWithoutPublishAdboardVersionInput"
	},
	UserCreateNestedOneWithoutPublishAdboardVersionInput:{
		create:"UserCreateWithoutPublishAdboardVersionInput",
		connectOrCreate:"UserCreateOrConnectWithoutPublishAdboardVersionInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutPublishAdboardVersionInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	AdBoardReviewCommentCreateNestedManyWithoutUserInput:{
		create:"AdBoardReviewCommentCreateWithoutUserInput",
		connectOrCreate:"AdBoardReviewCommentCreateOrConnectWithoutUserInput",
		createMany:"AdBoardReviewCommentCreateManyUserInputEnvelope",
		connect:"AdBoardReviewCommentWhereUniqueInput"
	},
	AdBoardReviewCommentCreateWithoutUserInput:{
		action:"ReviewAction",
		createdAt:"DateTime",
		adBoard:"AdBoardCreateNestedOneWithoutReviewCommentsInput"
	},
	AdBoardCreateNestedOneWithoutReviewCommentsInput:{
		create:"AdBoardCreateWithoutReviewCommentsInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutReviewCommentsInput",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutReviewCommentsInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	AdBoardCreateNestedOneWithoutPublishedVersionInput:{
		create:"AdBoardCreateWithoutPublishedVersionInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutPublishedVersionInput",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutPublishedVersionInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput:{
		create:"AdBoardReviewCommentCreateWithoutAdBoardInput",
		connectOrCreate:"AdBoardReviewCommentCreateOrConnectWithoutAdBoardInput",
		createMany:"AdBoardReviewCommentCreateManyAdBoardInputEnvelope",
		connect:"AdBoardReviewCommentWhereUniqueInput"
	},
	AdBoardReviewCommentCreateWithoutAdBoardInput:{
		action:"ReviewAction",
		createdAt:"DateTime",
		user:"UserCreateNestedOneWithoutReviewCommentsInput"
	},
	UserCreateNestedOneWithoutReviewCommentsInput:{
		create:"UserCreateWithoutReviewCommentsInput",
		connectOrCreate:"UserCreateOrConnectWithoutReviewCommentsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutReviewCommentsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	AdBoardCreateNestedManyWithoutArchivedByInput:{
		create:"AdBoardCreateWithoutArchivedByInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutArchivedByInput",
		createMany:"AdBoardCreateManyArchivedByInputEnvelope",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutArchivedByInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput:{
		create:"AdBoardPublicReviewCreateWithoutAdBoardInput",
		connectOrCreate:"AdBoardPublicReviewCreateOrConnectWithoutAdBoardInput",
		createMany:"AdBoardPublicReviewCreateManyAdBoardInputEnvelope",
		connect:"AdBoardPublicReviewWhereUniqueInput"
	},
	AdBoardPublicReviewCreateWithoutAdBoardInput:{
		createdAt:"DateTime",
		user:"UserCreateNestedOneWithoutPublicReviewsInput",
		booking:"BookingCreateNestedOneWithoutReviewInput"
	},
	UserCreateNestedOneWithoutPublicReviewsInput:{
		create:"UserCreateWithoutPublicReviewsInput",
		connectOrCreate:"UserCreateOrConnectWithoutPublicReviewsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutPublicReviewsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	WorkspaceCreateNestedManyWithoutOwnerInput:{
		create:"WorkspaceCreateWithoutOwnerInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutOwnerInput",
		createMany:"WorkspaceCreateManyOwnerInputEnvelope",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutOwnerInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	FileCreateNestedManyWithoutWorkspaceInput:{
		create:"FileCreateWithoutWorkspaceInput",
		connectOrCreate:"FileCreateOrConnectWithoutWorkspaceInput",
		createMany:"FileCreateManyWorkspaceInputEnvelope",
		connect:"FileWhereUniqueInput"
	},
	FileCreateWithoutWorkspaceInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserCreateNestedOneWithoutUpdatedFilesInput",
		createdBy:"UserCreateNestedOneWithoutCreatedFilesInput",
		bookings:"BookingCreateNestedManyWithoutAssetsInput",
		proofBooking:"BookingCreateNestedOneWithoutProofsInput",
		campaigns:"CampaignCreateNestedManyWithoutAssetsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutAssetsInput"
	},
	BookingCreateNestedOneWithoutProofsInput:{
		create:"BookingCreateWithoutProofsInput",
		connectOrCreate:"BookingCreateOrConnectWithoutProofsInput",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutProofsInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	WorkspaceCreateNestedOneWithoutBookingsInput:{
		create:"WorkspaceCreateWithoutBookingsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutBookingsInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutBookingsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	PlayerCreateNestedManyWithoutWorkspaceInput:{
		create:"PlayerCreateWithoutWorkspaceInput",
		connectOrCreate:"PlayerCreateOrConnectWithoutWorkspaceInput",
		createMany:"PlayerCreateManyWorkspaceInputEnvelope",
		connect:"PlayerWhereUniqueInput"
	},
	PlayerCreateWithoutWorkspaceInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutPisignagePlayersInput",
		status:"PlayerUptimeStatusCreateNestedManyWithoutPlayerInput",
		cameras:"CameraCreateNestedManyWithoutPlayerInput",
		signageType:"DigitalSignageCreateNestedOneWithoutPlayersInput",
		audienceType:"AudienceCreateNestedManyWithoutPlayersInput",
		adBoards:"AdBoardCreateNestedManyWithoutPlayersInput",
		deletedBy:"UserCreateNestedOneWithoutDeletedPlayerIdsInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutPlayerInput"
	},
	PlayerUptimeStatusCreateNestedManyWithoutPlayerInput:{
		create:"PlayerUptimeStatusCreateWithoutPlayerInput",
		connectOrCreate:"PlayerUptimeStatusCreateOrConnectWithoutPlayerInput",
		createMany:"PlayerUptimeStatusCreateManyPlayerInputEnvelope",
		connect:"PlayerUptimeStatusWhereUniqueInput"
	},
	PlayerUptimeStatusCreateWithoutPlayerInput:{

	},
	PlayerUptimeStatusCreateOrConnectWithoutPlayerInput:{
		where:"PlayerUptimeStatusWhereUniqueInput",
		create:"PlayerUptimeStatusCreateWithoutPlayerInput"
	},
	PlayerUptimeStatusCreateManyPlayerInputEnvelope:{
		data:"PlayerUptimeStatusCreateManyPlayerInput"
	},
	PlayerUptimeStatusCreateManyPlayerInput:{

	},
	CameraCreateNestedManyWithoutPlayerInput:{
		create:"CameraCreateWithoutPlayerInput",
		connectOrCreate:"CameraCreateOrConnectWithoutPlayerInput",
		createMany:"CameraCreateManyPlayerInputEnvelope",
		connect:"CameraWhereUniqueInput"
	},
	CameraCreateWithoutPlayerInput:{
		createdAt:"DateTime",
		updatedAt:"DateTime",
		workspace:"WorkspaceCreateNestedOneWithoutCamerasInput"
	},
	WorkspaceCreateNestedOneWithoutCamerasInput:{
		create:"WorkspaceCreateWithoutCamerasInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutCamerasInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutCamerasInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	TransactionCreateNestedManyWithoutWorkspaceInput:{
		create:"TransactionCreateWithoutWorkspaceInput",
		connectOrCreate:"TransactionCreateOrConnectWithoutWorkspaceInput",
		createMany:"TransactionCreateManyWorkspaceInputEnvelope",
		connect:"TransactionWhereUniqueInput"
	},
	TransactionCreateWithoutWorkspaceInput:{
		createAt:"DateTime",
		processedAt:"DateTime",
		transactionStatus:"TransactionStatus",
		details:"JSON",
		payouts:"PayoutCreateNestedManyWithoutTransactionInput"
	},
	PayoutCreateNestedManyWithoutTransactionInput:{
		create:"PayoutCreateWithoutTransactionInput",
		connectOrCreate:"PayoutCreateOrConnectWithoutTransactionInput",
		createMany:"PayoutCreateManyTransactionInputEnvelope",
		connect:"PayoutWhereUniqueInput"
	},
	PayoutCreateWithoutTransactionInput:{
		createdAt:"DateTime",
		status:"PayoutStatus",
		booking:"BookingCreateNestedOneWithoutPayoutsInput"
	},
	BookingCreateNestedOneWithoutPayoutsInput:{
		create:"BookingCreateWithoutPayoutsInput",
		connectOrCreate:"BookingCreateOrConnectWithoutPayoutsInput",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutPayoutsInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	CampaignCreateNestedOneWithoutBookingsInput:{
		create:"CampaignCreateWithoutBookingsInput",
		connectOrCreate:"CampaignCreateOrConnectWithoutBookingsInput",
		connect:"CampaignWhereUniqueInput"
	},
	CampaignCreateWithoutBookingsInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutCampaignsInput",
		user:"UserCreateNestedOneWithoutCampaignsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutCampaignsInput",
		payments:"PaymentCreateNestedManyWithoutCampaignInput",
		assets:"FileCreateNestedManyWithoutCampaignsInput"
	},
	PaymentCreateNestedManyWithoutCampaignInput:{
		create:"PaymentCreateWithoutCampaignInput",
		connectOrCreate:"PaymentCreateOrConnectWithoutCampaignInput",
		createMany:"PaymentCreateManyCampaignInputEnvelope",
		connect:"PaymentWhereUniqueInput"
	},
	PaymentCreateWithoutCampaignInput:{
		paymentGateway:"PaymentGatewayName",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutPaymentInput"
	},
	PaymentAllocationCreateNestedManyWithoutPaymentInput:{
		create:"PaymentAllocationCreateWithoutPaymentInput",
		connectOrCreate:"PaymentAllocationCreateOrConnectWithoutPaymentInput",
		createMany:"PaymentAllocationCreateManyPaymentInputEnvelope",
		connect:"PaymentAllocationWhereUniqueInput"
	},
	PaymentAllocationCreateWithoutPaymentInput:{
		booking:"BookingCreateNestedOneWithoutPaymentAllocationsInput"
	},
	BookingCreateNestedOneWithoutPaymentAllocationsInput:{
		create:"BookingCreateWithoutPaymentAllocationsInput",
		connectOrCreate:"BookingCreateOrConnectWithoutPaymentAllocationsInput",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutPaymentAllocationsInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	PayoutCreateNestedManyWithoutBookingInput:{
		create:"PayoutCreateWithoutBookingInput",
		connectOrCreate:"PayoutCreateOrConnectWithoutBookingInput",
		createMany:"PayoutCreateManyBookingInputEnvelope",
		connect:"PayoutWhereUniqueInput"
	},
	PayoutCreateWithoutBookingInput:{
		createdAt:"DateTime",
		status:"PayoutStatus",
		transaction:"TransactionCreateNestedOneWithoutPayoutsInput"
	},
	TransactionCreateNestedOneWithoutPayoutsInput:{
		create:"TransactionCreateWithoutPayoutsInput",
		connectOrCreate:"TransactionCreateOrConnectWithoutPayoutsInput",
		connect:"TransactionWhereUniqueInput"
	},
	TransactionCreateWithoutPayoutsInput:{
		createAt:"DateTime",
		processedAt:"DateTime",
		transactionStatus:"TransactionStatus",
		details:"JSON",
		workspace:"WorkspaceCreateNestedOneWithoutTransactionsInput"
	},
	WorkspaceCreateNestedOneWithoutTransactionsInput:{
		create:"WorkspaceCreateWithoutTransactionsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutTransactionsInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutTransactionsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	SubscriptionCreateNestedOneWithoutActiveWorkspaceInput:{
		create:"SubscriptionCreateWithoutActiveWorkspaceInput",
		connectOrCreate:"SubscriptionCreateOrConnectWithoutActiveWorkspaceInput",
		connect:"SubscriptionWhereUniqueInput"
	},
	SubscriptionCreateWithoutActiveWorkspaceInput:{
		startDate:"DateTime",
		endDate:"DateTime",
		cancellationDetails:"CancellationDetailsCreateInput"
	},
	CancellationDetailsCreateInput:{
		canceledAt:"DateTime",
		cancelAt:"DateTime"
	},
	SubscriptionCreateOrConnectWithoutActiveWorkspaceInput:{
		where:"SubscriptionWhereUniqueInput",
		create:"SubscriptionCreateWithoutActiveWorkspaceInput"
	},
	WorkspaceRoleCreateNestedManyWithoutWorkspaceInput:{
		create:"WorkspaceRoleCreateWithoutWorkspaceInput",
		connectOrCreate:"WorkspaceRoleCreateOrConnectWithoutWorkspaceInput",
		createMany:"WorkspaceRoleCreateManyWorkspaceInputEnvelope",
		connect:"WorkspaceRoleWhereUniqueInput"
	},
	WorkspaceRoleCreateWithoutWorkspaceInput:{
		permissions:"Permission",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		memberships:"MembershipCreateNestedManyWithoutRoleInput"
	},
	MembershipCreateNestedManyWithoutRoleInput:{
		create:"MembershipCreateWithoutRoleInput",
		connectOrCreate:"MembershipCreateOrConnectWithoutRoleInput",
		createMany:"MembershipCreateManyRoleInputEnvelope",
		connect:"MembershipWhereUniqueInput"
	},
	MembershipCreateWithoutRoleInput:{
		createdAt:"DateTime",
		user:"UserCreateNestedOneWithoutMembershipsInput",
		workspace:"WorkspaceCreateNestedOneWithoutMembershipsInput"
	},
	MembershipCreateOrConnectWithoutRoleInput:{
		where:"MembershipWhereUniqueInput",
		create:"MembershipCreateWithoutRoleInput"
	},
	MembershipCreateManyRoleInputEnvelope:{
		data:"MembershipCreateManyRoleInput"
	},
	MembershipCreateManyRoleInput:{
		createdAt:"DateTime"
	},
	WorkspaceRoleCreateOrConnectWithoutWorkspaceInput:{
		where:"WorkspaceRoleWhereUniqueInput",
		create:"WorkspaceRoleCreateWithoutWorkspaceInput"
	},
	WorkspaceRoleCreateManyWorkspaceInputEnvelope:{
		data:"WorkspaceRoleCreateManyWorkspaceInput"
	},
	WorkspaceRoleCreateManyWorkspaceInput:{
		permissions:"Permission",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	UserCreateNestedManyWithoutLeadWorspacesInput:{
		create:"UserCreateWithoutLeadWorspacesInput",
		connectOrCreate:"UserCreateOrConnectWithoutLeadWorspacesInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutLeadWorspacesInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	AdBoardPublicReviewCreateNestedManyWithoutUserInput:{
		create:"AdBoardPublicReviewCreateWithoutUserInput",
		connectOrCreate:"AdBoardPublicReviewCreateOrConnectWithoutUserInput",
		createMany:"AdBoardPublicReviewCreateManyUserInputEnvelope",
		connect:"AdBoardPublicReviewWhereUniqueInput"
	},
	AdBoardPublicReviewCreateWithoutUserInput:{
		createdAt:"DateTime",
		adBoard:"AdBoardCreateNestedOneWithoutPublicReviewsInput",
		booking:"BookingCreateNestedOneWithoutReviewInput"
	},
	AdBoardCreateNestedOneWithoutPublicReviewsInput:{
		create:"AdBoardCreateWithoutPublicReviewsInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutPublicReviewsInput",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutPublicReviewsInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	UserCreateNestedOneWithoutArchivedAdboardsInput:{
		create:"UserCreateWithoutArchivedAdboardsInput",
		connectOrCreate:"UserCreateOrConnectWithoutArchivedAdboardsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutArchivedAdboardsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	WorkspaceCreateNestedManyWithoutLeadsInput:{
		create:"WorkspaceCreateWithoutLeadsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutLeadsInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutLeadsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	CameraCreateNestedManyWithoutWorkspaceInput:{
		create:"CameraCreateWithoutWorkspaceInput",
		connectOrCreate:"CameraCreateOrConnectWithoutWorkspaceInput",
		createMany:"CameraCreateManyWorkspaceInputEnvelope",
		connect:"CameraWhereUniqueInput"
	},
	CameraCreateWithoutWorkspaceInput:{
		createdAt:"DateTime",
		updatedAt:"DateTime",
		player:"PlayerCreateNestedOneWithoutCamerasInput"
	},
	PlayerCreateNestedOneWithoutCamerasInput:{
		create:"PlayerCreateWithoutCamerasInput",
		connectOrCreate:"PlayerCreateOrConnectWithoutCamerasInput",
		connect:"PlayerWhereUniqueInput"
	},
	PlayerCreateWithoutCamerasInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutPisignagePlayersInput",
		workspace:"WorkspaceCreateNestedOneWithoutPlayersInput",
		status:"PlayerUptimeStatusCreateNestedManyWithoutPlayerInput",
		signageType:"DigitalSignageCreateNestedOneWithoutPlayersInput",
		audienceType:"AudienceCreateNestedManyWithoutPlayersInput",
		adBoards:"AdBoardCreateNestedManyWithoutPlayersInput",
		deletedBy:"UserCreateNestedOneWithoutDeletedPlayerIdsInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutPlayerInput"
	},
	DigitalSignageCreateNestedOneWithoutPlayersInput:{
		create:"DigitalSignageCreateWithoutPlayersInput",
		connectOrCreate:"DigitalSignageCreateOrConnectWithoutPlayersInput",
		connect:"DigitalSignageWhereUniqueInput"
	},
	DigitalSignageCreateWithoutPlayersInput:{
		type:"SignageType",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	DigitalSignageCreateOrConnectWithoutPlayersInput:{
		where:"DigitalSignageWhereUniqueInput",
		create:"DigitalSignageCreateWithoutPlayersInput"
	},
	DigitalSignageWhereUniqueInput:{
		AND:"DigitalSignageWhereInput",
		OR:"DigitalSignageWhereInput",
		NOT:"DigitalSignageWhereInput",
		type:"EnumSignageTypeFilter",
		name:"StringFilter",
		description:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		players:"PlayerListRelationFilter"
	},
	AudienceCreateNestedManyWithoutPlayersInput:{
		create:"AudienceCreateWithoutPlayersInput",
		connectOrCreate:"AudienceCreateOrConnectWithoutPlayersInput",
		connect:"AudienceWhereUniqueInput"
	},
	AudienceCreateWithoutPlayersInput:{
		type:"AudienceType",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	AudienceCreateOrConnectWithoutPlayersInput:{
		where:"AudienceWhereUniqueInput",
		create:"AudienceCreateWithoutPlayersInput"
	},
	AdBoardCreateNestedManyWithoutPlayersInput:{
		create:"AdBoardCreateWithoutPlayersInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutPlayersInput",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutPlayersInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	WishlistCreateNestedManyWithoutAdBoardsInput:{
		create:"WishlistCreateWithoutAdBoardsInput",
		connectOrCreate:"WishlistCreateOrConnectWithoutAdBoardsInput",
		connect:"WishlistWhereUniqueInput"
	},
	WishlistCreateWithoutAdBoardsInput:{
		createdAt:"DateTime",
		user:"UserCreateNestedOneWithoutWishlistsInput"
	},
	UserCreateNestedOneWithoutWishlistsInput:{
		create:"UserCreateWithoutWishlistsInput",
		connectOrCreate:"UserCreateOrConnectWithoutWishlistsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutWishlistsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	UserPositionCreateNestedManyWithoutUserInput:{
		create:"UserPositionCreateWithoutUserInput",
		connectOrCreate:"UserPositionCreateOrConnectWithoutUserInput",
		createMany:"UserPositionCreateManyUserInputEnvelope",
		connect:"UserPositionWhereUniqueInput"
	},
	UserPositionCreateWithoutUserInput:{
		timestamp:"DateTime",
		createdAt:"DateTime",
		coords:"UserPositionCoordsCreateInput",
		location:"UserPositionLocationCreateInput"
	},
	UserPositionCoordsCreateInput:{

	},
	UserPositionLocationCreateInput:{

	},
	UserPositionCreateOrConnectWithoutUserInput:{
		where:"UserPositionWhereUniqueInput",
		create:"UserPositionCreateWithoutUserInput"
	},
	UserPositionCreateManyUserInputEnvelope:{
		data:"UserPositionCreateManyUserInput"
	},
	UserPositionCreateManyUserInput:{
		timestamp:"DateTime",
		createdAt:"DateTime",
		coords:"UserPositionCoordsCreateInput",
		location:"UserPositionLocationCreateInput"
	},
	PlayerCreateNestedManyWithoutDeletedByInput:{
		create:"PlayerCreateWithoutDeletedByInput",
		connectOrCreate:"PlayerCreateOrConnectWithoutDeletedByInput",
		createMany:"PlayerCreateManyDeletedByInputEnvelope",
		connect:"PlayerWhereUniqueInput"
	},
	PlayerCreateWithoutDeletedByInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutPisignagePlayersInput",
		workspace:"WorkspaceCreateNestedOneWithoutPlayersInput",
		status:"PlayerUptimeStatusCreateNestedManyWithoutPlayerInput",
		cameras:"CameraCreateNestedManyWithoutPlayerInput",
		signageType:"DigitalSignageCreateNestedOneWithoutPlayersInput",
		audienceType:"AudienceCreateNestedManyWithoutPlayersInput",
		adBoards:"AdBoardCreateNestedManyWithoutPlayersInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutPlayerInput"
	},
	StreamingDeviceCreateNestedManyWithoutPlayerInput:{
		create:"StreamingDeviceCreateWithoutPlayerInput",
		connectOrCreate:"StreamingDeviceCreateOrConnectWithoutPlayerInput",
		createMany:"StreamingDeviceCreateManyPlayerInputEnvelope",
		connect:"StreamingDeviceWhereUniqueInput"
	},
	StreamingDeviceCreateWithoutPlayerInput:{
		connectionLogs:"ConnectionLogCreateInput",
		billboardMonitoring:"BillboardMonitoringCreateInput",
		trafficMonitoring:"TrafficMonitoringCreateInput",
		services:"StreamingServicesCreateInput",
		workspace:"WorkspaceCreateNestedOneWithoutCameraStreamingDevicesInput",
		billboardMonitoringAlerts:"BillboardMonitoringAlertCreateNestedManyWithoutStreamingDeviceInput"
	},
	ConnectionLogCreateInput:{
		timestamp:"DateTime",
		data:"JSON"
	},
	BillboardMonitoringCreateInput:{
		alertConfigs:"AlertConfigCreateInput"
	},
	AlertConfigCreateInput:{
		channel:"AlertChannel"
	},
	TrafficMonitoringCreateInput:{
		metadata:"JSON"
	},
	StreamingServicesCreateInput:{
		billboardMonitoring:"BillboardMonitoringCreateInput",
		trafficMonitoring:"TrafficMonitoringCreateInput"
	},
	WorkspaceCreateNestedOneWithoutCameraStreamingDevicesInput:{
		create:"WorkspaceCreateWithoutCameraStreamingDevicesInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutCameraStreamingDevicesInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutCameraStreamingDevicesInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput"
	},
	WorkspaceCreateOrConnectWithoutCameraStreamingDevicesInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutCameraStreamingDevicesInput"
	},
	BillboardMonitoringAlertCreateNestedManyWithoutStreamingDeviceInput:{
		create:"BillboardMonitoringAlertCreateWithoutStreamingDeviceInput",
		connectOrCreate:"BillboardMonitoringAlertCreateOrConnectWithoutStreamingDeviceInput",
		createMany:"BillboardMonitoringAlertCreateManyStreamingDeviceInputEnvelope",
		connect:"BillboardMonitoringAlertWhereUniqueInput"
	},
	BillboardMonitoringAlertCreateWithoutStreamingDeviceInput:{
		startTime:"DateTime",
		endTime:"DateTime",
		enabledAlerts:"AlertConfigCreateInput"
	},
	BillboardMonitoringAlertCreateOrConnectWithoutStreamingDeviceInput:{
		where:"BillboardMonitoringAlertWhereUniqueInput",
		create:"BillboardMonitoringAlertCreateWithoutStreamingDeviceInput"
	},
	BillboardMonitoringAlertCreateManyStreamingDeviceInputEnvelope:{
		data:"BillboardMonitoringAlertCreateManyStreamingDeviceInput"
	},
	BillboardMonitoringAlertCreateManyStreamingDeviceInput:{
		startTime:"DateTime",
		endTime:"DateTime",
		enabledAlerts:"AlertConfigCreateInput"
	},
	StreamingDeviceCreateOrConnectWithoutPlayerInput:{
		where:"StreamingDeviceWhereUniqueInput",
		create:"StreamingDeviceCreateWithoutPlayerInput"
	},
	StreamingDeviceCreateManyPlayerInputEnvelope:{
		data:"StreamingDeviceCreateManyPlayerInput"
	},
	StreamingDeviceCreateManyPlayerInput:{
		connectionLogs:"ConnectionLogCreateInput",
		billboardMonitoring:"BillboardMonitoringCreateInput",
		trafficMonitoring:"TrafficMonitoringCreateInput",
		services:"StreamingServicesCreateInput"
	},
	PlayerCreateOrConnectWithoutDeletedByInput:{
		where:"PlayerWhereUniqueInput",
		create:"PlayerCreateWithoutDeletedByInput"
	},
	PlayerCreateManyDeletedByInputEnvelope:{
		data:"PlayerCreateManyDeletedByInput"
	},
	PlayerCreateManyDeletedByInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime"
	},
	ContentVersionCreateNestedManyWithoutDeployedByInput:{
		create:"ContentVersionCreateWithoutDeployedByInput",
		connectOrCreate:"ContentVersionCreateOrConnectWithoutDeployedByInput",
		createMany:"ContentVersionCreateManyDeployedByInputEnvelope",
		connect:"ContentVersionWhereUniqueInput"
	},
	ContentVersionCreateWithoutDeployedByInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime",
		booking:"BookingCreateNestedOneWithoutContentVersionsInput",
		submittedBy:"UserCreateNestedOneWithoutSubmittedContentVersionsInput",
		approvedBy:"UserCreateNestedOneWithoutApprovedContentVersionsInput",
		assets:"FileCreateNestedManyWithoutContentVersionsInput"
	},
	BookingCreateNestedOneWithoutContentVersionsInput:{
		create:"BookingCreateWithoutContentVersionsInput",
		connectOrCreate:"BookingCreateOrConnectWithoutContentVersionsInput",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutContentVersionsInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	UserCreateNestedManyWithoutSharedBookingsInput:{
		create:"UserCreateWithoutSharedBookingsInput",
		connectOrCreate:"UserCreateOrConnectWithoutSharedBookingsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutSharedBookingsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	WishlistCreateNestedManyWithoutUserInput:{
		create:"WishlistCreateWithoutUserInput",
		connectOrCreate:"WishlistCreateOrConnectWithoutUserInput",
		createMany:"WishlistCreateManyUserInputEnvelope",
		connect:"WishlistWhereUniqueInput"
	},
	WishlistCreateWithoutUserInput:{
		createdAt:"DateTime",
		adBoards:"AdBoardCreateNestedManyWithoutWishlistsInput"
	},
	AdBoardCreateNestedManyWithoutWishlistsInput:{
		create:"AdBoardCreateWithoutWishlistsInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutWishlistsInput",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutWishlistsInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput"
	},
	AdBoardCreateOrConnectWithoutWishlistsInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutWishlistsInput"
	},
	WishlistCreateOrConnectWithoutUserInput:{
		where:"WishlistWhereUniqueInput",
		create:"WishlistCreateWithoutUserInput"
	},
	WishlistCreateManyUserInputEnvelope:{
		data:"WishlistCreateManyUserInput"
	},
	WishlistCreateManyUserInput:{
		createdAt:"DateTime"
	},
	ContentVersionCreateNestedManyWithoutSubmittedByInput:{
		create:"ContentVersionCreateWithoutSubmittedByInput",
		connectOrCreate:"ContentVersionCreateOrConnectWithoutSubmittedByInput",
		createMany:"ContentVersionCreateManySubmittedByInputEnvelope",
		connect:"ContentVersionWhereUniqueInput"
	},
	ContentVersionCreateWithoutSubmittedByInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime",
		booking:"BookingCreateNestedOneWithoutContentVersionsInput",
		approvedBy:"UserCreateNestedOneWithoutApprovedContentVersionsInput",
		deployedBy:"UserCreateNestedOneWithoutDeployedContentVersionsInput",
		assets:"FileCreateNestedManyWithoutContentVersionsInput"
	},
	UserCreateNestedOneWithoutApprovedContentVersionsInput:{
		create:"UserCreateWithoutApprovedContentVersionsInput",
		connectOrCreate:"UserCreateOrConnectWithoutApprovedContentVersionsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutApprovedContentVersionsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput"
	},
	UserCreateOrConnectWithoutApprovedContentVersionsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutApprovedContentVersionsInput"
	},
	UserCreateNestedOneWithoutDeployedContentVersionsInput:{
		create:"UserCreateWithoutDeployedContentVersionsInput",
		connectOrCreate:"UserCreateOrConnectWithoutDeployedContentVersionsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutDeployedContentVersionsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	ContentVersionCreateNestedManyWithoutApprovedByInput:{
		create:"ContentVersionCreateWithoutApprovedByInput",
		connectOrCreate:"ContentVersionCreateOrConnectWithoutApprovedByInput",
		createMany:"ContentVersionCreateManyApprovedByInputEnvelope",
		connect:"ContentVersionWhereUniqueInput"
	},
	ContentVersionCreateWithoutApprovedByInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime",
		booking:"BookingCreateNestedOneWithoutContentVersionsInput",
		submittedBy:"UserCreateNestedOneWithoutSubmittedContentVersionsInput",
		deployedBy:"UserCreateNestedOneWithoutDeployedContentVersionsInput",
		assets:"FileCreateNestedManyWithoutContentVersionsInput"
	},
	FileCreateNestedManyWithoutContentVersionsInput:{
		create:"FileCreateWithoutContentVersionsInput",
		connectOrCreate:"FileCreateOrConnectWithoutContentVersionsInput",
		connect:"FileWhereUniqueInput"
	},
	FileCreateWithoutContentVersionsInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserCreateNestedOneWithoutUpdatedFilesInput",
		createdBy:"UserCreateNestedOneWithoutCreatedFilesInput",
		bookings:"BookingCreateNestedManyWithoutAssetsInput",
		workspace:"WorkspaceCreateNestedOneWithoutFilesInput",
		proofBooking:"BookingCreateNestedOneWithoutProofsInput",
		campaigns:"CampaignCreateNestedManyWithoutAssetsInput"
	},
	CampaignCreateNestedManyWithoutAssetsInput:{
		create:"CampaignCreateWithoutAssetsInput",
		connectOrCreate:"CampaignCreateOrConnectWithoutAssetsInput",
		connect:"CampaignWhereUniqueInput"
	},
	CampaignCreateWithoutAssetsInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutCampaignsInput",
		user:"UserCreateNestedOneWithoutCampaignsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutCampaignsInput",
		bookings:"BookingCreateNestedManyWithoutCampaignInput",
		payments:"PaymentCreateNestedManyWithoutCampaignInput"
	},
	CampaignCreateOrConnectWithoutAssetsInput:{
		where:"CampaignWhereUniqueInput",
		create:"CampaignCreateWithoutAssetsInput"
	},
	FileCreateOrConnectWithoutContentVersionsInput:{
		where:"FileWhereUniqueInput",
		create:"FileCreateWithoutContentVersionsInput"
	},
	ContentVersionCreateOrConnectWithoutApprovedByInput:{
		where:"ContentVersionWhereUniqueInput",
		create:"ContentVersionCreateWithoutApprovedByInput"
	},
	ContentVersionCreateManyApprovedByInputEnvelope:{
		data:"ContentVersionCreateManyApprovedByInput"
	},
	ContentVersionCreateManyApprovedByInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime"
	},
	UserCreateOrConnectWithoutDeployedContentVersionsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutDeployedContentVersionsInput"
	},
	ContentVersionCreateOrConnectWithoutSubmittedByInput:{
		where:"ContentVersionWhereUniqueInput",
		create:"ContentVersionCreateWithoutSubmittedByInput"
	},
	ContentVersionCreateManySubmittedByInputEnvelope:{
		data:"ContentVersionCreateManySubmittedByInput"
	},
	ContentVersionCreateManySubmittedByInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime"
	},
	UserCreateOrConnectWithoutSharedBookingsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutSharedBookingsInput"
	},
	SlotUsageCreateNestedManyWithoutBookingInput:{
		create:"SlotUsageCreateWithoutBookingInput",
		connectOrCreate:"SlotUsageCreateOrConnectWithoutBookingInput",
		createMany:"SlotUsageCreateManyBookingInputEnvelope",
		connect:"SlotUsageWhereUniqueInput"
	},
	SlotUsageCreateWithoutBookingInput:{
		date:"DateTime"
	},
	SlotUsageCreateOrConnectWithoutBookingInput:{
		where:"SlotUsageWhereUniqueInput",
		create:"SlotUsageCreateWithoutBookingInput"
	},
	SlotUsageCreateManyBookingInputEnvelope:{
		data:"SlotUsageCreateManyBookingInput"
	},
	SlotUsageCreateManyBookingInput:{
		date:"DateTime"
	},
	AdBoardPublicReviewCreateNestedOneWithoutBookingInput:{
		create:"AdBoardPublicReviewCreateWithoutBookingInput",
		connectOrCreate:"AdBoardPublicReviewCreateOrConnectWithoutBookingInput",
		connect:"AdBoardPublicReviewWhereUniqueInput"
	},
	AdBoardPublicReviewCreateWithoutBookingInput:{
		createdAt:"DateTime",
		adBoard:"AdBoardCreateNestedOneWithoutPublicReviewsInput",
		user:"UserCreateNestedOneWithoutPublicReviewsInput"
	},
	AdBoardPublicReviewCreateOrConnectWithoutBookingInput:{
		where:"AdBoardPublicReviewWhereUniqueInput",
		create:"AdBoardPublicReviewCreateWithoutBookingInput"
	},
	BookingHistoryCreateNestedManyWithoutBookingInput:{
		create:"BookingHistoryCreateWithoutBookingInput",
		connectOrCreate:"BookingHistoryCreateOrConnectWithoutBookingInput",
		createMany:"BookingHistoryCreateManyBookingInputEnvelope",
		connect:"BookingHistoryWhereUniqueInput"
	},
	BookingHistoryCreateWithoutBookingInput:{
		status:"BookingStatus",
		timestamp:"DateTime"
	},
	BookingHistoryCreateOrConnectWithoutBookingInput:{
		where:"BookingHistoryWhereUniqueInput",
		create:"BookingHistoryCreateWithoutBookingInput"
	},
	BookingHistoryCreateManyBookingInputEnvelope:{
		data:"BookingHistoryCreateManyBookingInput"
	},
	BookingHistoryCreateManyBookingInput:{
		status:"BookingStatus",
		timestamp:"DateTime"
	},
	RefundRequestCreateNestedOneWithoutBookingInput:{
		create:"RefundRequestCreateWithoutBookingInput",
		connectOrCreate:"RefundRequestCreateOrConnectWithoutBookingInput",
		connect:"RefundRequestWhereUniqueInput"
	},
	RefundRequestCreateWithoutBookingInput:{
		requestedAt:"DateTime"
	},
	RefundRequestCreateOrConnectWithoutBookingInput:{
		where:"RefundRequestWhereUniqueInput",
		create:"RefundRequestCreateWithoutBookingInput"
	},
	RefundRequestWhereUniqueInput:{
		AND:"RefundRequestWhereInput",
		OR:"RefundRequestWhereInput",
		NOT:"RefundRequestWhereInput",
		requestedAt:"DateTimeFilter",
		requestedBy:"StringFilter",
		reason:"StringFilter",
		amountRequested:"FloatFilter",
		booking:"BookingRelationFilter"
	},
	RefundApprovalCreateNestedOneWithoutBookingInput:{
		create:"RefundApprovalCreateWithoutBookingInput",
		connectOrCreate:"RefundApprovalCreateOrConnectWithoutBookingInput",
		connect:"RefundApprovalWhereUniqueInput"
	},
	RefundApprovalCreateWithoutBookingInput:{
		approvedAt:"DateTime"
	},
	RefundApprovalCreateOrConnectWithoutBookingInput:{
		where:"RefundApprovalWhereUniqueInput",
		create:"RefundApprovalCreateWithoutBookingInput"
	},
	RefundApprovalWhereUniqueInput:{
		AND:"RefundApprovalWhereInput",
		OR:"RefundApprovalWhereInput",
		NOT:"RefundApprovalWhereInput",
		approvedAt:"DateTimeFilter",
		approvedBy:"StringFilter",
		amountApproved:"FloatFilter",
		notes:"StringNullableFilter",
		booking:"BookingRelationFilter"
	},
	RefundProcessedCreateNestedOneWithoutBookingInput:{
		create:"RefundProcessedCreateWithoutBookingInput",
		connectOrCreate:"RefundProcessedCreateOrConnectWithoutBookingInput",
		connect:"RefundProcessedWhereUniqueInput"
	},
	RefundProcessedCreateWithoutBookingInput:{
		processedAt:"DateTime",
		paymentMethod:"PaymentGatewayName"
	},
	RefundProcessedCreateOrConnectWithoutBookingInput:{
		where:"RefundProcessedWhereUniqueInput",
		create:"RefundProcessedCreateWithoutBookingInput"
	},
	RefundProcessedWhereUniqueInput:{
		AND:"RefundProcessedWhereInput",
		OR:"RefundProcessedWhereInput",
		NOT:"RefundProcessedWhereInput",
		processedAt:"DateTimeFilter",
		paymentMethod:"EnumPaymentGatewayNameFilter",
		transactionId:"StringFilter",
		booking:"BookingRelationFilter"
	},
	BookingCreateOrConnectWithoutContentVersionsInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutContentVersionsInput"
	},
	ContentVersionCreateOrConnectWithoutDeployedByInput:{
		where:"ContentVersionWhereUniqueInput",
		create:"ContentVersionCreateWithoutDeployedByInput"
	},
	ContentVersionCreateManyDeployedByInputEnvelope:{
		data:"ContentVersionCreateManyDeployedByInput"
	},
	ContentVersionCreateManyDeployedByInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime"
	},
	UserCreateOrConnectWithoutWishlistsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutWishlistsInput"
	},
	WishlistCreateOrConnectWithoutAdBoardsInput:{
		where:"WishlistWhereUniqueInput",
		create:"WishlistCreateWithoutAdBoardsInput"
	},
	AdBoardCreateOrConnectWithoutPlayersInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutPlayersInput"
	},
	UserCreateNestedOneWithoutDeletedPlayerIdsInput:{
		create:"UserCreateWithoutDeletedPlayerIdsInput",
		connectOrCreate:"UserCreateOrConnectWithoutDeletedPlayerIdsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutDeletedPlayerIdsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	UserCreateOrConnectWithoutDeletedPlayerIdsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutDeletedPlayerIdsInput"
	},
	PlayerCreateOrConnectWithoutCamerasInput:{
		where:"PlayerWhereUniqueInput",
		create:"PlayerCreateWithoutCamerasInput"
	},
	CameraCreateOrConnectWithoutWorkspaceInput:{
		where:"CameraWhereUniqueInput",
		create:"CameraCreateWithoutWorkspaceInput"
	},
	CameraCreateManyWorkspaceInputEnvelope:{
		data:"CameraCreateManyWorkspaceInput"
	},
	CameraCreateManyWorkspaceInput:{
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	StreamingDeviceCreateNestedManyWithoutWorkspaceInput:{
		create:"StreamingDeviceCreateWithoutWorkspaceInput",
		connectOrCreate:"StreamingDeviceCreateOrConnectWithoutWorkspaceInput",
		createMany:"StreamingDeviceCreateManyWorkspaceInputEnvelope",
		connect:"StreamingDeviceWhereUniqueInput"
	},
	StreamingDeviceCreateWithoutWorkspaceInput:{
		connectionLogs:"ConnectionLogCreateInput",
		billboardMonitoring:"BillboardMonitoringCreateInput",
		trafficMonitoring:"TrafficMonitoringCreateInput",
		services:"StreamingServicesCreateInput",
		player:"PlayerCreateNestedOneWithoutCameraStreamingDevicesInput",
		billboardMonitoringAlerts:"BillboardMonitoringAlertCreateNestedManyWithoutStreamingDeviceInput"
	},
	PlayerCreateNestedOneWithoutCameraStreamingDevicesInput:{
		create:"PlayerCreateWithoutCameraStreamingDevicesInput",
		connectOrCreate:"PlayerCreateOrConnectWithoutCameraStreamingDevicesInput",
		connect:"PlayerWhereUniqueInput"
	},
	PlayerCreateWithoutCameraStreamingDevicesInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutPisignagePlayersInput",
		workspace:"WorkspaceCreateNestedOneWithoutPlayersInput",
		status:"PlayerUptimeStatusCreateNestedManyWithoutPlayerInput",
		cameras:"CameraCreateNestedManyWithoutPlayerInput",
		signageType:"DigitalSignageCreateNestedOneWithoutPlayersInput",
		audienceType:"AudienceCreateNestedManyWithoutPlayersInput",
		adBoards:"AdBoardCreateNestedManyWithoutPlayersInput",
		deletedBy:"UserCreateNestedOneWithoutDeletedPlayerIdsInput"
	},
	PlayerCreateOrConnectWithoutCameraStreamingDevicesInput:{
		where:"PlayerWhereUniqueInput",
		create:"PlayerCreateWithoutCameraStreamingDevicesInput"
	},
	StreamingDeviceCreateOrConnectWithoutWorkspaceInput:{
		where:"StreamingDeviceWhereUniqueInput",
		create:"StreamingDeviceCreateWithoutWorkspaceInput"
	},
	StreamingDeviceCreateManyWorkspaceInputEnvelope:{
		data:"StreamingDeviceCreateManyWorkspaceInput"
	},
	StreamingDeviceCreateManyWorkspaceInput:{
		connectionLogs:"ConnectionLogCreateInput",
		billboardMonitoring:"BillboardMonitoringCreateInput",
		trafficMonitoring:"TrafficMonitoringCreateInput",
		services:"StreamingServicesCreateInput"
	},
	WorkspaceCreateOrConnectWithoutLeadsInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutLeadsInput"
	},
	UserCreateOrConnectWithoutArchivedAdboardsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutArchivedAdboardsInput"
	},
	AdBoardCreateOrConnectWithoutPublicReviewsInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutPublicReviewsInput"
	},
	BookingCreateNestedOneWithoutReviewInput:{
		create:"BookingCreateWithoutReviewInput",
		connectOrCreate:"BookingCreateOrConnectWithoutReviewInput",
		connect:"BookingWhereUniqueInput"
	},
	BookingCreateWithoutReviewInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	BookingCreateOrConnectWithoutReviewInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutReviewInput"
	},
	AdBoardPublicReviewCreateOrConnectWithoutUserInput:{
		where:"AdBoardPublicReviewWhereUniqueInput",
		create:"AdBoardPublicReviewCreateWithoutUserInput"
	},
	AdBoardPublicReviewCreateManyUserInputEnvelope:{
		data:"AdBoardPublicReviewCreateManyUserInput"
	},
	AdBoardPublicReviewCreateManyUserInput:{
		createdAt:"DateTime"
	},
	UserCreateOrConnectWithoutLeadWorspacesInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutLeadWorspacesInput"
	},
	WorkspaceCreateOrConnectWithoutTransactionsInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutTransactionsInput"
	},
	TransactionCreateOrConnectWithoutPayoutsInput:{
		where:"TransactionWhereUniqueInput",
		create:"TransactionCreateWithoutPayoutsInput"
	},
	PayoutCreateOrConnectWithoutBookingInput:{
		where:"PayoutWhereUniqueInput",
		create:"PayoutCreateWithoutBookingInput"
	},
	PayoutCreateManyBookingInputEnvelope:{
		data:"PayoutCreateManyBookingInput"
	},
	PayoutCreateManyBookingInput:{
		createdAt:"DateTime",
		status:"PayoutStatus"
	},
	BookingCreateOrConnectWithoutPaymentAllocationsInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutPaymentAllocationsInput"
	},
	PaymentAllocationCreateOrConnectWithoutPaymentInput:{
		where:"PaymentAllocationWhereUniqueInput",
		create:"PaymentAllocationCreateWithoutPaymentInput"
	},
	PaymentAllocationCreateManyPaymentInputEnvelope:{
		data:"PaymentAllocationCreateManyPaymentInput"
	},
	PaymentAllocationCreateManyPaymentInput:{

	},
	PaymentCreateOrConnectWithoutCampaignInput:{
		where:"PaymentWhereUniqueInput",
		create:"PaymentCreateWithoutCampaignInput"
	},
	PaymentCreateManyCampaignInputEnvelope:{
		data:"PaymentCreateManyCampaignInput"
	},
	PaymentCreateManyCampaignInput:{
		paymentGateway:"PaymentGatewayName",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	FileCreateNestedManyWithoutCampaignsInput:{
		create:"FileCreateWithoutCampaignsInput",
		connectOrCreate:"FileCreateOrConnectWithoutCampaignsInput",
		connect:"FileWhereUniqueInput"
	},
	FileCreateWithoutCampaignsInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserCreateNestedOneWithoutUpdatedFilesInput",
		createdBy:"UserCreateNestedOneWithoutCreatedFilesInput",
		bookings:"BookingCreateNestedManyWithoutAssetsInput",
		workspace:"WorkspaceCreateNestedOneWithoutFilesInput",
		proofBooking:"BookingCreateNestedOneWithoutProofsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutAssetsInput"
	},
	ContentVersionCreateNestedManyWithoutAssetsInput:{
		create:"ContentVersionCreateWithoutAssetsInput",
		connectOrCreate:"ContentVersionCreateOrConnectWithoutAssetsInput",
		connect:"ContentVersionWhereUniqueInput"
	},
	ContentVersionCreateWithoutAssetsInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime",
		booking:"BookingCreateNestedOneWithoutContentVersionsInput",
		submittedBy:"UserCreateNestedOneWithoutSubmittedContentVersionsInput",
		approvedBy:"UserCreateNestedOneWithoutApprovedContentVersionsInput",
		deployedBy:"UserCreateNestedOneWithoutDeployedContentVersionsInput"
	},
	ContentVersionCreateOrConnectWithoutAssetsInput:{
		where:"ContentVersionWhereUniqueInput",
		create:"ContentVersionCreateWithoutAssetsInput"
	},
	FileCreateOrConnectWithoutCampaignsInput:{
		where:"FileWhereUniqueInput",
		create:"FileCreateWithoutCampaignsInput"
	},
	CampaignCreateOrConnectWithoutBookingsInput:{
		where:"CampaignWhereUniqueInput",
		create:"CampaignCreateWithoutBookingsInput"
	},
	BookingCreateOrConnectWithoutPayoutsInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutPayoutsInput"
	},
	PayoutCreateOrConnectWithoutTransactionInput:{
		where:"PayoutWhereUniqueInput",
		create:"PayoutCreateWithoutTransactionInput"
	},
	PayoutCreateManyTransactionInputEnvelope:{
		data:"PayoutCreateManyTransactionInput"
	},
	PayoutCreateManyTransactionInput:{
		createdAt:"DateTime",
		status:"PayoutStatus"
	},
	TransactionCreateOrConnectWithoutWorkspaceInput:{
		where:"TransactionWhereUniqueInput",
		create:"TransactionCreateWithoutWorkspaceInput"
	},
	TransactionCreateManyWorkspaceInputEnvelope:{
		data:"TransactionCreateManyWorkspaceInput"
	},
	TransactionCreateManyWorkspaceInput:{
		createAt:"DateTime",
		processedAt:"DateTime",
		transactionStatus:"TransactionStatus",
		details:"JSON"
	},
	WorkspaceCreateOrConnectWithoutCamerasInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutCamerasInput"
	},
	CameraCreateOrConnectWithoutPlayerInput:{
		where:"CameraWhereUniqueInput",
		create:"CameraCreateWithoutPlayerInput"
	},
	CameraCreateManyPlayerInputEnvelope:{
		data:"CameraCreateManyPlayerInput"
	},
	CameraCreateManyPlayerInput:{
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	PlayerCreateOrConnectWithoutWorkspaceInput:{
		where:"PlayerWhereUniqueInput",
		create:"PlayerCreateWithoutWorkspaceInput"
	},
	PlayerCreateManyWorkspaceInputEnvelope:{
		data:"PlayerCreateManyWorkspaceInput"
	},
	PlayerCreateManyWorkspaceInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime"
	},
	WorkspaceCreateOrConnectWithoutBookingsInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutBookingsInput"
	},
	BookingCreateOrConnectWithoutProofsInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutProofsInput"
	},
	FileCreateOrConnectWithoutWorkspaceInput:{
		where:"FileWhereUniqueInput",
		create:"FileCreateWithoutWorkspaceInput"
	},
	FileCreateManyWorkspaceInputEnvelope:{
		data:"FileCreateManyWorkspaceInput"
	},
	FileCreateManyWorkspaceInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime"
	},
	WorkspaceCreateOrConnectWithoutOwnerInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutOwnerInput"
	},
	WorkspaceCreateManyOwnerInputEnvelope:{
		data:"WorkspaceCreateManyOwnerInput"
	},
	WorkspaceCreateManyOwnerInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	UserCreateOrConnectWithoutPublicReviewsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutPublicReviewsInput"
	},
	AdBoardPublicReviewCreateOrConnectWithoutAdBoardInput:{
		where:"AdBoardPublicReviewWhereUniqueInput",
		create:"AdBoardPublicReviewCreateWithoutAdBoardInput"
	},
	AdBoardPublicReviewCreateManyAdBoardInputEnvelope:{
		data:"AdBoardPublicReviewCreateManyAdBoardInput"
	},
	AdBoardPublicReviewCreateManyAdBoardInput:{
		createdAt:"DateTime"
	},
	AdBoardCreateOrConnectWithoutArchivedByInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutArchivedByInput"
	},
	AdBoardCreateManyArchivedByInputEnvelope:{
		data:"AdBoardCreateManyArchivedByInput"
	},
	AdBoardCreateManyArchivedByInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime"
	},
	UserCreateOrConnectWithoutReviewCommentsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutReviewCommentsInput"
	},
	AdBoardReviewCommentCreateOrConnectWithoutAdBoardInput:{
		where:"AdBoardReviewCommentWhereUniqueInput",
		create:"AdBoardReviewCommentCreateWithoutAdBoardInput"
	},
	AdBoardReviewCommentCreateManyAdBoardInputEnvelope:{
		data:"AdBoardReviewCommentCreateManyAdBoardInput"
	},
	AdBoardReviewCommentCreateManyAdBoardInput:{
		action:"ReviewAction",
		createdAt:"DateTime"
	},
	AdBoardCreateOrConnectWithoutPublishedVersionInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutPublishedVersionInput"
	},
	AdBoardCreateOrConnectWithoutReviewCommentsInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutReviewCommentsInput"
	},
	AdBoardReviewCommentCreateOrConnectWithoutUserInput:{
		where:"AdBoardReviewCommentWhereUniqueInput",
		create:"AdBoardReviewCommentCreateWithoutUserInput"
	},
	AdBoardReviewCommentCreateManyUserInputEnvelope:{
		data:"AdBoardReviewCommentCreateManyUserInput"
	},
	AdBoardReviewCommentCreateManyUserInput:{
		action:"ReviewAction",
		createdAt:"DateTime"
	},
	UserCreateOrConnectWithoutPublishAdboardVersionInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutPublishAdboardVersionInput"
	},
	AdBoardPublishHistoryCreateOrConnectWithoutAdBoardInput:{
		where:"AdBoardPublishHistoryWhereUniqueInput",
		create:"AdBoardPublishHistoryCreateWithoutAdBoardInput"
	},
	AdBoardPublishHistoryCreateManyAdBoardInputEnvelope:{
		data:"AdBoardPublishHistoryCreateManyAdBoardInput"
	},
	AdBoardPublishHistoryCreateManyAdBoardInput:{
		publishedAt:"DateTime",
		changesSnapshot:"JSON"
	},
	AdBoardCreateOrConnectWithoutDraftAdboardInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutDraftAdboardInput"
	},
	AdBoardCreateOrConnectWithoutHistoryInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutHistoryInput"
	},
	AdBoardPublishHistoryCreateOrConnectWithoutPublishedByInput:{
		where:"AdBoardPublishHistoryWhereUniqueInput",
		create:"AdBoardPublishHistoryCreateWithoutPublishedByInput"
	},
	AdBoardPublishHistoryCreateManyPublishedByInputEnvelope:{
		data:"AdBoardPublishHistoryCreateManyPublishedByInput"
	},
	AdBoardPublishHistoryCreateManyPublishedByInput:{
		publishedAt:"DateTime",
		changesSnapshot:"JSON"
	},
	UserCreateOrConnectWithoutChangelogsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutChangelogsInput"
	},
	ChangelogCreateOrConnectWithoutBookingInput:{
		where:"ChangelogWhereUniqueInput",
		create:"ChangelogCreateWithoutBookingInput"
	},
	ChangelogCreateManyBookingInputEnvelope:{
		data:"ChangelogCreateManyBookingInput"
	},
	ChangelogCreateManyBookingInput:{
		createdAt:"DateTime",
		updates:"JSON"
	},
	BookingCreateOrConnectWithoutWorkspaceInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutWorkspaceInput"
	},
	BookingCreateManyWorkspaceInputEnvelope:{
		data:"BookingCreateManyWorkspaceInput"
	},
	BookingCreateManyWorkspaceInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus"
	},
	WorkspaceCreateOrConnectWithoutMembershipsInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutMembershipsInput"
	},
	WorkspaceRoleCreateNestedOneWithoutMembershipsInput:{
		create:"WorkspaceRoleCreateWithoutMembershipsInput",
		connectOrCreate:"WorkspaceRoleCreateOrConnectWithoutMembershipsInput",
		connect:"WorkspaceRoleWhereUniqueInput"
	},
	WorkspaceRoleCreateWithoutMembershipsInput:{
		permissions:"Permission",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		workspace:"WorkspaceCreateNestedOneWithoutWorkspaceRolesInput"
	},
	WorkspaceCreateNestedOneWithoutWorkspaceRolesInput:{
		create:"WorkspaceCreateWithoutWorkspaceRolesInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutWorkspaceRolesInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutWorkspaceRolesInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	WorkspaceCreateOrConnectWithoutWorkspaceRolesInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutWorkspaceRolesInput"
	},
	WorkspaceRoleCreateOrConnectWithoutMembershipsInput:{
		where:"WorkspaceRoleWhereUniqueInput",
		create:"WorkspaceRoleCreateWithoutMembershipsInput"
	},
	MembershipCreateOrConnectWithoutUserInput:{
		where:"MembershipWhereUniqueInput",
		create:"MembershipCreateWithoutUserInput"
	},
	MembershipCreateManyUserInputEnvelope:{
		data:"MembershipCreateManyUserInput"
	},
	MembershipCreateManyUserInput:{
		createdAt:"DateTime"
	},
	UserCreateOrConnectWithoutAuditsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutAuditsInput"
	},
	AuditCreateOrConnectWithoutWorkspaceInput:{
		where:"AuditWhereUniqueInput",
		create:"AuditCreateWithoutWorkspaceInput"
	},
	AuditCreateManyWorkspaceInputEnvelope:{
		data:"AuditCreateManyWorkspaceInput"
	},
	AuditCreateManyWorkspaceInput:{
		createdAt:"DateTime",
		entity:"EntityCreateInput",
		updates:"JSON"
	},
	WorkspaceCreateOrConnectWithoutPlayersInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutPlayersInput"
	},
	PlayerCreateOrConnectWithoutAdBoardGroupInput:{
		where:"PlayerWhereUniqueInput",
		create:"PlayerCreateWithoutAdBoardGroupInput"
	},
	PlayerCreateManyAdBoardGroupInputEnvelope:{
		data:"PlayerCreateManyAdBoardGroupInput"
	},
	PlayerCreateManyAdBoardGroupInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime"
	},
	WorkspaceCreateNestedOneWithoutAdBoardGroupsInput:{
		create:"WorkspaceCreateWithoutAdBoardGroupsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutAdBoardGroupsInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutAdBoardGroupsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	WorkspaceCreateOrConnectWithoutAdBoardGroupsInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutAdBoardGroupsInput"
	},
	AdBoardGroupCreateOrConnectWithoutScheduledPlaylistsInput:{
		where:"AdBoardGroupWhereUniqueInput",
		create:"AdBoardGroupCreateWithoutScheduledPlaylistsInput"
	},
	PlaylistCreateNestedManyWithoutFooterPlaylistInput:{
		create:"PlaylistCreateWithoutFooterPlaylistInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutFooterPlaylistInput",
		createMany:"PlaylistCreateManyFooterPlaylistInputEnvelope",
		connect:"PlaylistWhereUniqueInput"
	},
	PlaylistCreateWithoutFooterPlaylistInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		sidebarPlaylist:"PlaylistCreateNestedOneWithoutSidebarParentPlaylistsInput",
		adBoardGroupsForAds:"AdBoardGroupCreateNestedManyWithoutAdsPlaylistInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutScheduledPlaylistsInput",
		workspace:"WorkspaceCreateNestedOneWithoutPlaylistsInput",
		footerParentPlaylists:"PlaylistCreateNestedManyWithoutFooterPlaylistInput",
		sidebarParentPlaylists:"PlaylistCreateNestedManyWithoutSidebarPlaylistInput"
	},
	PlaylistCreateNestedManyWithoutSidebarPlaylistInput:{
		create:"PlaylistCreateWithoutSidebarPlaylistInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutSidebarPlaylistInput",
		createMany:"PlaylistCreateManySidebarPlaylistInputEnvelope",
		connect:"PlaylistWhereUniqueInput"
	},
	PlaylistCreateWithoutSidebarPlaylistInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistCreateNestedOneWithoutFooterParentPlaylistsInput",
		adBoardGroupsForAds:"AdBoardGroupCreateNestedManyWithoutAdsPlaylistInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutScheduledPlaylistsInput",
		workspace:"WorkspaceCreateNestedOneWithoutPlaylistsInput",
		footerParentPlaylists:"PlaylistCreateNestedManyWithoutFooterPlaylistInput",
		sidebarParentPlaylists:"PlaylistCreateNestedManyWithoutSidebarPlaylistInput"
	},
	PlaylistCreateOrConnectWithoutSidebarPlaylistInput:{
		where:"PlaylistWhereUniqueInput",
		create:"PlaylistCreateWithoutSidebarPlaylistInput"
	},
	PlaylistCreateManySidebarPlaylistInputEnvelope:{
		data:"PlaylistCreateManySidebarPlaylistInput"
	},
	PlaylistCreateManySidebarPlaylistInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout"
	},
	PlaylistCreateOrConnectWithoutFooterPlaylistInput:{
		where:"PlaylistWhereUniqueInput",
		create:"PlaylistCreateWithoutFooterPlaylistInput"
	},
	PlaylistCreateManyFooterPlaylistInputEnvelope:{
		data:"PlaylistCreateManyFooterPlaylistInput"
	},
	PlaylistCreateManyFooterPlaylistInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout"
	},
	PlaylistCreateOrConnectWithoutAdBoardGroupsForAdsInput:{
		where:"PlaylistWhereUniqueInput",
		create:"PlaylistCreateWithoutAdBoardGroupsForAdsInput"
	},
	AdBoardGroupCreateOrConnectWithoutAdBoardInput:{
		where:"AdBoardGroupWhereUniqueInput",
		create:"AdBoardGroupCreateWithoutAdBoardInput"
	},
	AdBoardCreateOrConnectWithoutWorkspaceInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutWorkspaceInput"
	},
	AdBoardCreateManyWorkspaceInputEnvelope:{
		data:"AdBoardCreateManyWorkspaceInput"
	},
	AdBoardCreateManyWorkspaceInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime"
	},
	WorkspaceCreateOrConnectWithoutPlaylistsInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutPlaylistsInput"
	},
	PlaylistCreateOrConnectWithoutAdBoardGroupsInput:{
		where:"PlaylistWhereUniqueInput",
		create:"PlaylistCreateWithoutAdBoardGroupsInput"
	},
	AdBoardGroupCreateOrConnectWithoutPisignagePlayersInput:{
		where:"AdBoardGroupWhereUniqueInput",
		create:"AdBoardGroupCreateWithoutPisignagePlayersInput"
	},
	PlayerCreateOrConnectWithoutAdBoardsInput:{
		where:"PlayerWhereUniqueInput",
		create:"PlayerCreateWithoutAdBoardsInput"
	},
	AdBoardCreateOrConnectWithoutAdBoardGroupInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutAdBoardGroupInput"
	},
	AdBoardGroupCreateOrConnectWithoutAdsPlaylistInput:{
		where:"AdBoardGroupWhereUniqueInput",
		create:"AdBoardGroupCreateWithoutAdsPlaylistInput"
	},
	AdBoardGroupCreateManyAdsPlaylistInputEnvelope:{
		data:"AdBoardGroupCreateManyAdsPlaylistInput"
	},
	AdBoardGroupCreateManyAdsPlaylistInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType"
	},
	PlaylistCreateOrConnectWithoutSidebarParentPlaylistsInput:{
		where:"PlaylistWhereUniqueInput",
		create:"PlaylistCreateWithoutSidebarParentPlaylistsInput"
	},
	PlaylistCreateOrConnectWithoutFooterParentPlaylistsInput:{
		where:"PlaylistWhereUniqueInput",
		create:"PlaylistCreateWithoutFooterParentPlaylistsInput"
	},
	PlaylistCreateOrConnectWithoutWorkspaceInput:{
		where:"PlaylistWhereUniqueInput",
		create:"PlaylistCreateWithoutWorkspaceInput"
	},
	PlaylistCreateManyWorkspaceInputEnvelope:{
		data:"PlaylistCreateManyWorkspaceInput"
	},
	PlaylistCreateManyWorkspaceInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout"
	},
	WorkspaceCreateOrConnectWithoutAdBoardsInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutAdBoardsInput"
	},
	AdBoardCreateOrConnectWithoutBookingsInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutBookingsInput"
	},
	BookingCreateOrConnectWithoutSharedUsersInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutSharedUsersInput"
	},
	UserCreateOrConnectWithoutBookingsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutBookingsInput"
	},
	BookingCreateOrConnectWithoutCampaignInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutCampaignInput"
	},
	BookingCreateManyCampaignInputEnvelope:{
		data:"BookingCreateManyCampaignInput"
	},
	BookingCreateManyCampaignInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus"
	},
	CampaignCreateOrConnectWithoutUserInput:{
		where:"CampaignWhereUniqueInput",
		create:"CampaignCreateWithoutUserInput"
	},
	CampaignCreateManyUserInputEnvelope:{
		data:"CampaignCreateManyUserInput"
	},
	CampaignCreateManyUserInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	UserCreateOrConnectWithoutMembershipsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutMembershipsInput"
	},
	MembershipCreateOrConnectWithoutWorkspaceInput:{
		where:"MembershipWhereUniqueInput",
		create:"MembershipCreateWithoutWorkspaceInput"
	},
	MembershipCreateManyWorkspaceInputEnvelope:{
		data:"MembershipCreateManyWorkspaceInput"
	},
	MembershipCreateManyWorkspaceInput:{
		createdAt:"DateTime"
	},
	WorkspaceCreateOrConnectWithoutAuditsInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutAuditsInput"
	},
	AuditCreateOrConnectWithoutUserInput:{
		where:"AuditWhereUniqueInput",
		create:"AuditCreateWithoutUserInput"
	},
	AuditCreateManyUserInputEnvelope:{
		data:"AuditCreateManyUserInput"
	},
	AuditCreateManyUserInput:{
		createdAt:"DateTime",
		entity:"EntityCreateInput",
		updates:"JSON"
	},
	UserCreateOrConnectWithoutOrdersInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutOrdersInput"
	},
	OrderCreateOrConnectWithoutAdBoardInput:{
		where:"OrderWhereUniqueInput",
		create:"OrderCreateWithoutAdBoardInput"
	},
	OrderCreateManyAdBoardInputEnvelope:{
		data:"OrderCreateManyAdBoardInput"
	},
	OrderCreateManyAdBoardInput:{
		createdDate:"DateTime",
		priceSummary:"PriceSummaryCreateInput",
		selectedDate:"OrderSelectedDateCreateInput"
	},
	AdBoardCreateOrConnectWithoutCreatedByInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutCreatedByInput"
	},
	AdBoardCreateManyCreatedByInputEnvelope:{
		data:"AdBoardCreateManyCreatedByInput"
	},
	AdBoardCreateManyCreatedByInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime"
	},
	UserCreateOrConnectWithoutOwnedWorkspacesInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutOwnedWorkspacesInput"
	},
	WorkspaceCreateOrConnectWithoutFilesInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutFilesInput"
	},
	FileCreateOrConnectWithoutProofBookingInput:{
		where:"FileWhereUniqueInput",
		create:"FileCreateWithoutProofBookingInput"
	},
	FileCreateManyProofBookingInputEnvelope:{
		data:"FileCreateManyProofBookingInput"
	},
	FileCreateManyProofBookingInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime"
	},
	BookingCreateOrConnectWithoutAdCategoryInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutAdCategoryInput"
	},
	AdvertisementCategoryCreateOrConnectWithoutCampaignsInput:{
		where:"AdvertisementCategoryWhereUniqueInput",
		create:"AdvertisementCategoryCreateWithoutCampaignsInput"
	},
	CampaignCreateOrConnectWithoutPaymentsInput:{
		where:"CampaignWhereUniqueInput",
		create:"CampaignCreateWithoutPaymentsInput"
	},
	PaymentCreateOrConnectWithoutPaymentAllocationsInput:{
		where:"PaymentWhereUniqueInput",
		create:"PaymentCreateWithoutPaymentAllocationsInput"
	},
	PaymentAllocationCreateOrConnectWithoutBookingInput:{
		where:"PaymentAllocationWhereUniqueInput",
		create:"PaymentAllocationCreateWithoutBookingInput"
	},
	PaymentAllocationCreateManyBookingInputEnvelope:{
		data:"PaymentAllocationCreateManyBookingInput"
	},
	PaymentAllocationCreateManyBookingInput:{

	},
	BookingCreateOrConnectWithoutChangelogsInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutChangelogsInput"
	},
	ChangelogCreateOrConnectWithoutUserInput:{
		where:"ChangelogWhereUniqueInput",
		create:"ChangelogCreateWithoutUserInput"
	},
	ChangelogCreateManyUserInputEnvelope:{
		data:"ChangelogCreateManyUserInput"
	},
	ChangelogCreateManyUserInput:{
		createdAt:"DateTime",
		updates:"JSON"
	},
	UserCreateOrConnectWithoutAdBoardsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutAdBoardsInput"
	},
	AdBoardCreateOrConnectWithoutOrdersInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutOrdersInput"
	},
	OrderCreateOrConnectWithoutCreatedByInput:{
		where:"OrderWhereUniqueInput",
		create:"OrderCreateWithoutCreatedByInput"
	},
	OrderCreateManyCreatedByInputEnvelope:{
		data:"OrderCreateManyCreatedByInput"
	},
	OrderCreateManyCreatedByInput:{
		createdDate:"DateTime",
		priceSummary:"PriceSummaryCreateInput",
		selectedDate:"OrderSelectedDateCreateInput"
	},
	UserCreateOrConnectWithoutCreatedFilesInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutCreatedFilesInput"
	},
	FileCreateOrConnectWithoutUpdatedByInput:{
		where:"FileWhereUniqueInput",
		create:"FileCreateWithoutUpdatedByInput"
	},
	FileCreateManyUpdatedByInputEnvelope:{
		data:"FileCreateManyUpdatedByInput"
	},
	FileCreateManyUpdatedByInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime"
	},
	UserCreateOrConnectWithoutSubmittedContentVersionsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutSubmittedContentVersionsInput"
	},
	ContentVersionCreateOrConnectWithoutBookingInput:{
		where:"ContentVersionWhereUniqueInput",
		create:"ContentVersionCreateWithoutBookingInput"
	},
	ContentVersionCreateManyBookingInputEnvelope:{
		data:"ContentVersionCreateManyBookingInput"
	},
	ContentVersionCreateManyBookingInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime"
	},
	BookingCreateOrConnectWithoutAssetsInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutAssetsInput"
	},
	FileCreateOrConnectWithoutCreatedByInput:{
		where:"FileWhereUniqueInput",
		create:"FileCreateWithoutCreatedByInput"
	},
	FileCreateManyCreatedByInputEnvelope:{
		data:"FileCreateManyCreatedByInput"
	},
	FileCreateManyCreatedByInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime"
	},
	UserCreateOrConnectWithoutUpdatedFilesInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutUpdatedFilesInput"
	},
	FileCreateOrConnectWithoutBookingsInput:{
		where:"FileWhereUniqueInput",
		create:"FileCreateWithoutBookingsInput"
	},
	BookingCreateOrConnectWithoutBusinessCategoryInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutBusinessCategoryInput"
	},
	BookingCreateManyBusinessCategoryInputEnvelope:{
		data:"BookingCreateManyBusinessCategoryInput"
	},
	BookingCreateManyBusinessCategoryInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus"
	},
	BusinessCategoryCreateOrConnectWithoutCampaignsInput:{
		where:"BusinessCategoryWhereUniqueInput",
		create:"BusinessCategoryCreateWithoutCampaignsInput"
	},
	CampaignCreateOrConnectWithoutAdCategoryInput:{
		where:"CampaignWhereUniqueInput",
		create:"CampaignCreateWithoutAdCategoryInput"
	},
	AdvertisementCategoryCreateOrConnectWithoutBookingsInput:{
		where:"AdvertisementCategoryWhereUniqueInput",
		create:"AdvertisementCategoryCreateWithoutBookingsInput"
	},
	BookingCreateOrConnectWithoutUserInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutUserInput"
	},
	BookingCreateManyUserInputEnvelope:{
		data:"BookingCreateManyUserInput"
	},
	BookingCreateManyUserInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus"
	},
	UserCreateOrConnectWithoutCampaignsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutCampaignsInput"
	},
	CampaignCreateOrConnectWithoutBusinessCategoryInput:{
		where:"CampaignWhereUniqueInput",
		create:"CampaignCreateWithoutBusinessCategoryInput"
	},
	CampaignCreateManyBusinessCategoryInputEnvelope:{
		data:"CampaignCreateManyBusinessCategoryInput"
	},
	CampaignCreateManyBusinessCategoryInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	BusinessCategoryCreateOrConnectWithoutBookingsInput:{
		where:"BusinessCategoryWhereUniqueInput",
		create:"BusinessCategoryCreateWithoutBookingsInput"
	},
	BookingCreateOrConnectWithoutAdBoardInput:{
		where:"BookingWhereUniqueInput",
		create:"BookingCreateWithoutAdBoardInput"
	},
	BookingCreateManyAdBoardInputEnvelope:{
		data:"BookingCreateManyAdBoardInput"
	},
	BookingCreateManyAdBoardInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus"
	},
	AdBoardCreateOrConnectWithoutCategoryInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutCategoryInput"
	},
	AdBoardCreateManyCategoryInputEnvelope:{
		data:"AdBoardCreateManyCategoryInput"
	},
	AdBoardCreateManyCategoryInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime"
	},
	BusinessCategoryCreateOrConnectWithoutRestrictedByAdBoardsInput:{
		where:"BusinessCategoryWhereUniqueInput",
		create:"BusinessCategoryCreateWithoutRestrictedByAdBoardsInput"
	},
	AdBoardCreateOrConnectWithoutLocationCategoryInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutLocationCategoryInput"
	},
	AdBoardCreateManyLocationCategoryInputEnvelope:{
		data:"AdBoardCreateManyLocationCategoryInput"
	},
	AdBoardCreateManyLocationCategoryInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime"
	},
	LocationCategoryCreateOrConnectWithoutLocationSubCategoryInput:{
		where:"LocationCategoryWhereUniqueInput",
		create:"LocationCategoryCreateWithoutLocationSubCategoryInput"
	},
	LocationCategoryWhereUniqueInput:{
		AND:"LocationCategoryWhereInput",
		OR:"LocationCategoryWhereInput",
		NOT:"LocationCategoryWhereInput",
		name:"StringFilter",
		adBoards:"AdBoardListRelationFilter",
		locationSubCategory:"LocationSubCategoryListRelationFilter"
	},
	LocationSubCategoryCreateOrConnectWithoutAdBoardsInput:{
		where:"LocationSubCategoryWhereUniqueInput",
		create:"LocationSubCategoryCreateWithoutAdBoardsInput"
	},
	AdBoardCreateOrConnectWithoutRestrictedBusinesInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutRestrictedBusinesInput"
	},
	BusinessCategoryCreateOrConnectWithoutAdBoardsInput:{
		where:"BusinessCategoryWhereUniqueInput",
		create:"BusinessCategoryCreateWithoutAdBoardsInput"
	},
	AdBoardCreateOrConnectWithoutLocationSubCategoryInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutLocationSubCategoryInput"
	},
	AdBoardCreateManyLocationSubCategoryInputEnvelope:{
		data:"AdBoardCreateManyLocationSubCategoryInput"
	},
	AdBoardCreateManyLocationSubCategoryInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime"
	},
	LocationSubCategoryCreateOrConnectWithoutLocationCategoryInput:{
		where:"LocationSubCategoryWhereUniqueInput",
		create:"LocationSubCategoryCreateWithoutLocationCategoryInput"
	},
	LocationSubCategoryCreateManyLocationCategoryInputEnvelope:{
		data:"LocationSubCategoryCreateManyLocationCategoryInput"
	},
	LocationSubCategoryCreateManyLocationCategoryInput:{

	},
	LocationCategoryCreateOrConnectWithoutAdBoardsInput:{
		where:"LocationCategoryWhereUniqueInput",
		create:"LocationCategoryCreateWithoutAdBoardsInput"
	},
	AdBoardUpdateManyMutationInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime"
	},
	AdBoardUpdateInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	LocationCategoryUpdateOneWithoutAdBoardsNestedInput:{
		create:"LocationCategoryCreateWithoutAdBoardsInput",
		connectOrCreate:"LocationCategoryCreateOrConnectWithoutAdBoardsInput",
		upsert:"LocationCategoryUpsertWithoutAdBoardsInput",
		delete:"LocationCategoryWhereInput",
		connect:"LocationCategoryWhereUniqueInput",
		update:"LocationCategoryUpdateToOneWithWhereWithoutAdBoardsInput"
	},
	LocationCategoryUpsertWithoutAdBoardsInput:{
		update:"LocationCategoryUpdateWithoutAdBoardsInput",
		create:"LocationCategoryCreateWithoutAdBoardsInput",
		where:"LocationCategoryWhereInput"
	},
	LocationCategoryUpdateWithoutAdBoardsInput:{
		locationSubCategory:"LocationSubCategoryUpdateManyWithoutLocationCategoryNestedInput"
	},
	LocationSubCategoryUpdateManyWithoutLocationCategoryNestedInput:{
		create:"LocationSubCategoryCreateWithoutLocationCategoryInput",
		connectOrCreate:"LocationSubCategoryCreateOrConnectWithoutLocationCategoryInput",
		upsert:"LocationSubCategoryUpsertWithWhereUniqueWithoutLocationCategoryInput",
		createMany:"LocationSubCategoryCreateManyLocationCategoryInputEnvelope",
		set:"LocationSubCategoryWhereUniqueInput",
		disconnect:"LocationSubCategoryWhereUniqueInput",
		delete:"LocationSubCategoryWhereUniqueInput",
		connect:"LocationSubCategoryWhereUniqueInput",
		update:"LocationSubCategoryUpdateWithWhereUniqueWithoutLocationCategoryInput",
		updateMany:"LocationSubCategoryUpdateManyWithWhereWithoutLocationCategoryInput",
		deleteMany:"LocationSubCategoryScalarWhereInput"
	},
	LocationSubCategoryUpsertWithWhereUniqueWithoutLocationCategoryInput:{
		where:"LocationSubCategoryWhereUniqueInput",
		update:"LocationSubCategoryUpdateWithoutLocationCategoryInput",
		create:"LocationSubCategoryCreateWithoutLocationCategoryInput"
	},
	LocationSubCategoryUpdateWithoutLocationCategoryInput:{
		adBoards:"AdBoardUpdateManyWithoutLocationSubCategoryNestedInput"
	},
	AdBoardUpdateManyWithoutLocationSubCategoryNestedInput:{
		create:"AdBoardCreateWithoutLocationSubCategoryInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutLocationSubCategoryInput",
		upsert:"AdBoardUpsertWithWhereUniqueWithoutLocationSubCategoryInput",
		createMany:"AdBoardCreateManyLocationSubCategoryInputEnvelope",
		set:"AdBoardWhereUniqueInput",
		disconnect:"AdBoardWhereUniqueInput",
		delete:"AdBoardWhereUniqueInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithWhereUniqueWithoutLocationSubCategoryInput",
		updateMany:"AdBoardUpdateManyWithWhereWithoutLocationSubCategoryInput",
		deleteMany:"AdBoardScalarWhereInput"
	},
	AdBoardUpsertWithWhereUniqueWithoutLocationSubCategoryInput:{
		where:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithoutLocationSubCategoryInput",
		create:"AdBoardCreateWithoutLocationSubCategoryInput"
	},
	AdBoardUpdateWithoutLocationSubCategoryInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	AdBoardTypeUpdateOneWithoutAdBoardsNestedInput:{
		create:"AdBoardTypeCreateWithoutAdBoardsInput",
		connectOrCreate:"AdBoardTypeCreateOrConnectWithoutAdBoardsInput",
		upsert:"AdBoardTypeUpsertWithoutAdBoardsInput",
		delete:"AdBoardTypeWhereInput",
		connect:"AdBoardTypeWhereUniqueInput",
		update:"AdBoardTypeUpdateToOneWithWhereWithoutAdBoardsInput"
	},
	AdBoardTypeUpsertWithoutAdBoardsInput:{
		update:"AdBoardTypeUpdateWithoutAdBoardsInput",
		create:"AdBoardTypeCreateWithoutAdBoardsInput",
		where:"AdBoardTypeWhereInput"
	},
	AdBoardTypeUpdateWithoutAdBoardsInput:{

	},
	AdBoardTypeUpdateToOneWithWhereWithoutAdBoardsInput:{
		where:"AdBoardTypeWhereInput",
		data:"AdBoardTypeUpdateWithoutAdBoardsInput"
	},
	BusinessCategoryUpdateOneWithoutAdBoardsNestedInput:{
		create:"BusinessCategoryCreateWithoutAdBoardsInput",
		connectOrCreate:"BusinessCategoryCreateOrConnectWithoutAdBoardsInput",
		upsert:"BusinessCategoryUpsertWithoutAdBoardsInput",
		delete:"BusinessCategoryWhereInput",
		connect:"BusinessCategoryWhereUniqueInput",
		update:"BusinessCategoryUpdateToOneWithWhereWithoutAdBoardsInput"
	},
	BusinessCategoryUpsertWithoutAdBoardsInput:{
		update:"BusinessCategoryUpdateWithoutAdBoardsInput",
		create:"BusinessCategoryCreateWithoutAdBoardsInput",
		where:"BusinessCategoryWhereInput"
	},
	BusinessCategoryUpdateWithoutAdBoardsInput:{
		restrictedByAdBoards:"AdBoardUpdateManyWithoutRestrictedBusinesNestedInput",
		campaigns:"CampaignUpdateManyWithoutBusinessCategoryNestedInput",
		bookings:"BookingUpdateManyWithoutBusinessCategoryNestedInput"
	},
	AdBoardUpdateManyWithoutRestrictedBusinesNestedInput:{
		create:"AdBoardCreateWithoutRestrictedBusinesInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutRestrictedBusinesInput",
		upsert:"AdBoardUpsertWithWhereUniqueWithoutRestrictedBusinesInput",
		set:"AdBoardWhereUniqueInput",
		disconnect:"AdBoardWhereUniqueInput",
		delete:"AdBoardWhereUniqueInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithWhereUniqueWithoutRestrictedBusinesInput",
		updateMany:"AdBoardUpdateManyWithWhereWithoutRestrictedBusinesInput",
		deleteMany:"AdBoardScalarWhereInput"
	},
	AdBoardUpsertWithWhereUniqueWithoutRestrictedBusinesInput:{
		where:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithoutRestrictedBusinesInput",
		create:"AdBoardCreateWithoutRestrictedBusinesInput"
	},
	AdBoardUpdateWithoutRestrictedBusinesInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput:{
		create:"LocationSubCategoryCreateWithoutAdBoardsInput",
		connectOrCreate:"LocationSubCategoryCreateOrConnectWithoutAdBoardsInput",
		upsert:"LocationSubCategoryUpsertWithoutAdBoardsInput",
		delete:"LocationSubCategoryWhereInput",
		connect:"LocationSubCategoryWhereUniqueInput",
		update:"LocationSubCategoryUpdateToOneWithWhereWithoutAdBoardsInput"
	},
	LocationSubCategoryUpsertWithoutAdBoardsInput:{
		update:"LocationSubCategoryUpdateWithoutAdBoardsInput",
		create:"LocationSubCategoryCreateWithoutAdBoardsInput",
		where:"LocationSubCategoryWhereInput"
	},
	LocationSubCategoryUpdateWithoutAdBoardsInput:{
		locationCategory:"LocationCategoryUpdateOneWithoutLocationSubCategoryNestedInput"
	},
	LocationCategoryUpdateOneWithoutLocationSubCategoryNestedInput:{
		create:"LocationCategoryCreateWithoutLocationSubCategoryInput",
		connectOrCreate:"LocationCategoryCreateOrConnectWithoutLocationSubCategoryInput",
		upsert:"LocationCategoryUpsertWithoutLocationSubCategoryInput",
		delete:"LocationCategoryWhereInput",
		connect:"LocationCategoryWhereUniqueInput",
		update:"LocationCategoryUpdateToOneWithWhereWithoutLocationSubCategoryInput"
	},
	LocationCategoryUpsertWithoutLocationSubCategoryInput:{
		update:"LocationCategoryUpdateWithoutLocationSubCategoryInput",
		create:"LocationCategoryCreateWithoutLocationSubCategoryInput",
		where:"LocationCategoryWhereInput"
	},
	LocationCategoryUpdateWithoutLocationSubCategoryInput:{
		adBoards:"AdBoardUpdateManyWithoutLocationCategoryNestedInput"
	},
	AdBoardUpdateManyWithoutLocationCategoryNestedInput:{
		create:"AdBoardCreateWithoutLocationCategoryInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutLocationCategoryInput",
		upsert:"AdBoardUpsertWithWhereUniqueWithoutLocationCategoryInput",
		createMany:"AdBoardCreateManyLocationCategoryInputEnvelope",
		set:"AdBoardWhereUniqueInput",
		disconnect:"AdBoardWhereUniqueInput",
		delete:"AdBoardWhereUniqueInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithWhereUniqueWithoutLocationCategoryInput",
		updateMany:"AdBoardUpdateManyWithWhereWithoutLocationCategoryInput",
		deleteMany:"AdBoardScalarWhereInput"
	},
	AdBoardUpsertWithWhereUniqueWithoutLocationCategoryInput:{
		where:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithoutLocationCategoryInput",
		create:"AdBoardCreateWithoutLocationCategoryInput"
	},
	AdBoardUpdateWithoutLocationCategoryInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput:{
		create:"BusinessCategoryCreateWithoutRestrictedByAdBoardsInput",
		connectOrCreate:"BusinessCategoryCreateOrConnectWithoutRestrictedByAdBoardsInput",
		upsert:"BusinessCategoryUpsertWithWhereUniqueWithoutRestrictedByAdBoardsInput",
		set:"BusinessCategoryWhereUniqueInput",
		disconnect:"BusinessCategoryWhereUniqueInput",
		delete:"BusinessCategoryWhereUniqueInput",
		connect:"BusinessCategoryWhereUniqueInput",
		update:"BusinessCategoryUpdateWithWhereUniqueWithoutRestrictedByAdBoardsInput",
		updateMany:"BusinessCategoryUpdateManyWithWhereWithoutRestrictedByAdBoardsInput",
		deleteMany:"BusinessCategoryScalarWhereInput"
	},
	BusinessCategoryUpsertWithWhereUniqueWithoutRestrictedByAdBoardsInput:{
		where:"BusinessCategoryWhereUniqueInput",
		update:"BusinessCategoryUpdateWithoutRestrictedByAdBoardsInput",
		create:"BusinessCategoryCreateWithoutRestrictedByAdBoardsInput"
	},
	BusinessCategoryUpdateWithoutRestrictedByAdBoardsInput:{
		adBoards:"AdBoardUpdateManyWithoutCategoryNestedInput",
		campaigns:"CampaignUpdateManyWithoutBusinessCategoryNestedInput",
		bookings:"BookingUpdateManyWithoutBusinessCategoryNestedInput"
	},
	AdBoardUpdateManyWithoutCategoryNestedInput:{
		create:"AdBoardCreateWithoutCategoryInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutCategoryInput",
		upsert:"AdBoardUpsertWithWhereUniqueWithoutCategoryInput",
		createMany:"AdBoardCreateManyCategoryInputEnvelope",
		set:"AdBoardWhereUniqueInput",
		disconnect:"AdBoardWhereUniqueInput",
		delete:"AdBoardWhereUniqueInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithWhereUniqueWithoutCategoryInput",
		updateMany:"AdBoardUpdateManyWithWhereWithoutCategoryInput",
		deleteMany:"AdBoardScalarWhereInput"
	},
	AdBoardUpsertWithWhereUniqueWithoutCategoryInput:{
		where:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithoutCategoryInput",
		create:"AdBoardCreateWithoutCategoryInput"
	},
	AdBoardUpdateWithoutCategoryInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	BookingUpdateManyWithoutAdBoardNestedInput:{
		create:"BookingCreateWithoutAdBoardInput",
		connectOrCreate:"BookingCreateOrConnectWithoutAdBoardInput",
		upsert:"BookingUpsertWithWhereUniqueWithoutAdBoardInput",
		createMany:"BookingCreateManyAdBoardInputEnvelope",
		set:"BookingWhereUniqueInput",
		disconnect:"BookingWhereUniqueInput",
		delete:"BookingWhereUniqueInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateWithWhereUniqueWithoutAdBoardInput",
		updateMany:"BookingUpdateManyWithWhereWithoutAdBoardInput",
		deleteMany:"BookingScalarWhereInput"
	},
	BookingUpsertWithWhereUniqueWithoutAdBoardInput:{
		where:"BookingWhereUniqueInput",
		update:"BookingUpdateWithoutAdBoardInput",
		create:"BookingCreateWithoutAdBoardInput"
	},
	BookingUpdateWithoutAdBoardInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	BusinessCategoryUpdateOneWithoutBookingsNestedInput:{
		create:"BusinessCategoryCreateWithoutBookingsInput",
		connectOrCreate:"BusinessCategoryCreateOrConnectWithoutBookingsInput",
		upsert:"BusinessCategoryUpsertWithoutBookingsInput",
		delete:"BusinessCategoryWhereInput",
		connect:"BusinessCategoryWhereUniqueInput",
		update:"BusinessCategoryUpdateToOneWithWhereWithoutBookingsInput"
	},
	BusinessCategoryUpsertWithoutBookingsInput:{
		update:"BusinessCategoryUpdateWithoutBookingsInput",
		create:"BusinessCategoryCreateWithoutBookingsInput",
		where:"BusinessCategoryWhereInput"
	},
	BusinessCategoryUpdateWithoutBookingsInput:{
		adBoards:"AdBoardUpdateManyWithoutCategoryNestedInput",
		restrictedByAdBoards:"AdBoardUpdateManyWithoutRestrictedBusinesNestedInput",
		campaigns:"CampaignUpdateManyWithoutBusinessCategoryNestedInput"
	},
	CampaignUpdateManyWithoutBusinessCategoryNestedInput:{
		create:"CampaignCreateWithoutBusinessCategoryInput",
		connectOrCreate:"CampaignCreateOrConnectWithoutBusinessCategoryInput",
		upsert:"CampaignUpsertWithWhereUniqueWithoutBusinessCategoryInput",
		createMany:"CampaignCreateManyBusinessCategoryInputEnvelope",
		set:"CampaignWhereUniqueInput",
		disconnect:"CampaignWhereUniqueInput",
		delete:"CampaignWhereUniqueInput",
		connect:"CampaignWhereUniqueInput",
		update:"CampaignUpdateWithWhereUniqueWithoutBusinessCategoryInput",
		updateMany:"CampaignUpdateManyWithWhereWithoutBusinessCategoryInput",
		deleteMany:"CampaignScalarWhereInput"
	},
	CampaignUpsertWithWhereUniqueWithoutBusinessCategoryInput:{
		where:"CampaignWhereUniqueInput",
		update:"CampaignUpdateWithoutBusinessCategoryInput",
		create:"CampaignCreateWithoutBusinessCategoryInput"
	},
	CampaignUpdateWithoutBusinessCategoryInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		user:"UserUpdateOneRequiredWithoutCampaignsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutCampaignsNestedInput",
		bookings:"BookingUpdateManyWithoutCampaignNestedInput",
		payments:"PaymentUpdateManyWithoutCampaignNestedInput",
		assets:"FileUpdateManyWithoutCampaignsNestedInput"
	},
	UserUpdateOneRequiredWithoutCampaignsNestedInput:{
		create:"UserCreateWithoutCampaignsInput",
		connectOrCreate:"UserCreateOrConnectWithoutCampaignsInput",
		upsert:"UserUpsertWithoutCampaignsInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutCampaignsInput"
	},
	UserUpsertWithoutCampaignsInput:{
		update:"UserUpdateWithoutCampaignsInput",
		create:"UserCreateWithoutCampaignsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutCampaignsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	BookingUpdateManyWithoutUserNestedInput:{
		create:"BookingCreateWithoutUserInput",
		connectOrCreate:"BookingCreateOrConnectWithoutUserInput",
		upsert:"BookingUpsertWithWhereUniqueWithoutUserInput",
		createMany:"BookingCreateManyUserInputEnvelope",
		set:"BookingWhereUniqueInput",
		disconnect:"BookingWhereUniqueInput",
		delete:"BookingWhereUniqueInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateWithWhereUniqueWithoutUserInput",
		updateMany:"BookingUpdateManyWithWhereWithoutUserInput",
		deleteMany:"BookingScalarWhereInput"
	},
	BookingUpsertWithWhereUniqueWithoutUserInput:{
		where:"BookingWhereUniqueInput",
		update:"BookingUpdateWithoutUserInput",
		create:"BookingCreateWithoutUserInput"
	},
	BookingUpdateWithoutUserInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	AdvertisementCategoryUpdateManyWithoutBookingsNestedInput:{
		create:"AdvertisementCategoryCreateWithoutBookingsInput",
		connectOrCreate:"AdvertisementCategoryCreateOrConnectWithoutBookingsInput",
		upsert:"AdvertisementCategoryUpsertWithWhereUniqueWithoutBookingsInput",
		set:"AdvertisementCategoryWhereUniqueInput",
		disconnect:"AdvertisementCategoryWhereUniqueInput",
		delete:"AdvertisementCategoryWhereUniqueInput",
		connect:"AdvertisementCategoryWhereUniqueInput",
		update:"AdvertisementCategoryUpdateWithWhereUniqueWithoutBookingsInput",
		updateMany:"AdvertisementCategoryUpdateManyWithWhereWithoutBookingsInput",
		deleteMany:"AdvertisementCategoryScalarWhereInput"
	},
	AdvertisementCategoryUpsertWithWhereUniqueWithoutBookingsInput:{
		where:"AdvertisementCategoryWhereUniqueInput",
		update:"AdvertisementCategoryUpdateWithoutBookingsInput",
		create:"AdvertisementCategoryCreateWithoutBookingsInput"
	},
	AdvertisementCategoryUpdateWithoutBookingsInput:{
		type:"AdvertisementCategoryEnum",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		campaigns:"CampaignUpdateManyWithoutAdCategoryNestedInput"
	},
	CampaignUpdateManyWithoutAdCategoryNestedInput:{
		create:"CampaignCreateWithoutAdCategoryInput",
		connectOrCreate:"CampaignCreateOrConnectWithoutAdCategoryInput",
		upsert:"CampaignUpsertWithWhereUniqueWithoutAdCategoryInput",
		set:"CampaignWhereUniqueInput",
		disconnect:"CampaignWhereUniqueInput",
		delete:"CampaignWhereUniqueInput",
		connect:"CampaignWhereUniqueInput",
		update:"CampaignUpdateWithWhereUniqueWithoutAdCategoryInput",
		updateMany:"CampaignUpdateManyWithWhereWithoutAdCategoryInput",
		deleteMany:"CampaignScalarWhereInput"
	},
	CampaignUpsertWithWhereUniqueWithoutAdCategoryInput:{
		where:"CampaignWhereUniqueInput",
		update:"CampaignUpdateWithoutAdCategoryInput",
		create:"CampaignCreateWithoutAdCategoryInput"
	},
	CampaignUpdateWithoutAdCategoryInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		businessCategory:"BusinessCategoryUpdateOneRequiredWithoutCampaignsNestedInput",
		user:"UserUpdateOneRequiredWithoutCampaignsNestedInput",
		bookings:"BookingUpdateManyWithoutCampaignNestedInput",
		payments:"PaymentUpdateManyWithoutCampaignNestedInput",
		assets:"FileUpdateManyWithoutCampaignsNestedInput"
	},
	BusinessCategoryUpdateOneRequiredWithoutCampaignsNestedInput:{
		create:"BusinessCategoryCreateWithoutCampaignsInput",
		connectOrCreate:"BusinessCategoryCreateOrConnectWithoutCampaignsInput",
		upsert:"BusinessCategoryUpsertWithoutCampaignsInput",
		connect:"BusinessCategoryWhereUniqueInput",
		update:"BusinessCategoryUpdateToOneWithWhereWithoutCampaignsInput"
	},
	BusinessCategoryUpsertWithoutCampaignsInput:{
		update:"BusinessCategoryUpdateWithoutCampaignsInput",
		create:"BusinessCategoryCreateWithoutCampaignsInput",
		where:"BusinessCategoryWhereInput"
	},
	BusinessCategoryUpdateWithoutCampaignsInput:{
		adBoards:"AdBoardUpdateManyWithoutCategoryNestedInput",
		restrictedByAdBoards:"AdBoardUpdateManyWithoutRestrictedBusinesNestedInput",
		bookings:"BookingUpdateManyWithoutBusinessCategoryNestedInput"
	},
	BookingUpdateManyWithoutBusinessCategoryNestedInput:{
		create:"BookingCreateWithoutBusinessCategoryInput",
		connectOrCreate:"BookingCreateOrConnectWithoutBusinessCategoryInput",
		upsert:"BookingUpsertWithWhereUniqueWithoutBusinessCategoryInput",
		createMany:"BookingCreateManyBusinessCategoryInputEnvelope",
		set:"BookingWhereUniqueInput",
		disconnect:"BookingWhereUniqueInput",
		delete:"BookingWhereUniqueInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateWithWhereUniqueWithoutBusinessCategoryInput",
		updateMany:"BookingUpdateManyWithWhereWithoutBusinessCategoryInput",
		deleteMany:"BookingScalarWhereInput"
	},
	BookingUpsertWithWhereUniqueWithoutBusinessCategoryInput:{
		where:"BookingWhereUniqueInput",
		update:"BookingUpdateWithoutBusinessCategoryInput",
		create:"BookingCreateWithoutBusinessCategoryInput"
	},
	BookingUpdateWithoutBusinessCategoryInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	FileUpdateManyWithoutBookingsNestedInput:{
		create:"FileCreateWithoutBookingsInput",
		connectOrCreate:"FileCreateOrConnectWithoutBookingsInput",
		upsert:"FileUpsertWithWhereUniqueWithoutBookingsInput",
		set:"FileWhereUniqueInput",
		disconnect:"FileWhereUniqueInput",
		delete:"FileWhereUniqueInput",
		connect:"FileWhereUniqueInput",
		update:"FileUpdateWithWhereUniqueWithoutBookingsInput",
		updateMany:"FileUpdateManyWithWhereWithoutBookingsInput",
		deleteMany:"FileScalarWhereInput"
	},
	FileUpsertWithWhereUniqueWithoutBookingsInput:{
		where:"FileWhereUniqueInput",
		update:"FileUpdateWithoutBookingsInput",
		create:"FileCreateWithoutBookingsInput"
	},
	FileUpdateWithoutBookingsInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserUpdateOneWithoutUpdatedFilesNestedInput",
		createdBy:"UserUpdateOneRequiredWithoutCreatedFilesNestedInput",
		workspace:"WorkspaceUpdateOneWithoutFilesNestedInput",
		proofBooking:"BookingUpdateOneWithoutProofsNestedInput",
		campaigns:"CampaignUpdateManyWithoutAssetsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutAssetsNestedInput"
	},
	UserUpdateOneWithoutUpdatedFilesNestedInput:{
		create:"UserCreateWithoutUpdatedFilesInput",
		connectOrCreate:"UserCreateOrConnectWithoutUpdatedFilesInput",
		upsert:"UserUpsertWithoutUpdatedFilesInput",
		delete:"UserWhereInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutUpdatedFilesInput"
	},
	UserUpsertWithoutUpdatedFilesInput:{
		update:"UserUpdateWithoutUpdatedFilesInput",
		create:"UserCreateWithoutUpdatedFilesInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutUpdatedFilesInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	FileUpdateManyWithoutCreatedByNestedInput:{
		create:"FileCreateWithoutCreatedByInput",
		connectOrCreate:"FileCreateOrConnectWithoutCreatedByInput",
		upsert:"FileUpsertWithWhereUniqueWithoutCreatedByInput",
		createMany:"FileCreateManyCreatedByInputEnvelope",
		set:"FileWhereUniqueInput",
		disconnect:"FileWhereUniqueInput",
		delete:"FileWhereUniqueInput",
		connect:"FileWhereUniqueInput",
		update:"FileUpdateWithWhereUniqueWithoutCreatedByInput",
		updateMany:"FileUpdateManyWithWhereWithoutCreatedByInput",
		deleteMany:"FileScalarWhereInput"
	},
	FileUpsertWithWhereUniqueWithoutCreatedByInput:{
		where:"FileWhereUniqueInput",
		update:"FileUpdateWithoutCreatedByInput",
		create:"FileCreateWithoutCreatedByInput"
	},
	FileUpdateWithoutCreatedByInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserUpdateOneWithoutUpdatedFilesNestedInput",
		bookings:"BookingUpdateManyWithoutAssetsNestedInput",
		workspace:"WorkspaceUpdateOneWithoutFilesNestedInput",
		proofBooking:"BookingUpdateOneWithoutProofsNestedInput",
		campaigns:"CampaignUpdateManyWithoutAssetsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutAssetsNestedInput"
	},
	BookingUpdateManyWithoutAssetsNestedInput:{
		create:"BookingCreateWithoutAssetsInput",
		connectOrCreate:"BookingCreateOrConnectWithoutAssetsInput",
		upsert:"BookingUpsertWithWhereUniqueWithoutAssetsInput",
		set:"BookingWhereUniqueInput",
		disconnect:"BookingWhereUniqueInput",
		delete:"BookingWhereUniqueInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateWithWhereUniqueWithoutAssetsInput",
		updateMany:"BookingUpdateManyWithWhereWithoutAssetsInput",
		deleteMany:"BookingScalarWhereInput"
	},
	BookingUpsertWithWhereUniqueWithoutAssetsInput:{
		where:"BookingWhereUniqueInput",
		update:"BookingUpdateWithoutAssetsInput",
		create:"BookingCreateWithoutAssetsInput"
	},
	BookingUpdateWithoutAssetsInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	ContentVersionUpdateManyWithoutBookingNestedInput:{
		create:"ContentVersionCreateWithoutBookingInput",
		connectOrCreate:"ContentVersionCreateOrConnectWithoutBookingInput",
		upsert:"ContentVersionUpsertWithWhereUniqueWithoutBookingInput",
		createMany:"ContentVersionCreateManyBookingInputEnvelope",
		set:"ContentVersionWhereUniqueInput",
		disconnect:"ContentVersionWhereUniqueInput",
		delete:"ContentVersionWhereUniqueInput",
		connect:"ContentVersionWhereUniqueInput",
		update:"ContentVersionUpdateWithWhereUniqueWithoutBookingInput",
		updateMany:"ContentVersionUpdateManyWithWhereWithoutBookingInput",
		deleteMany:"ContentVersionScalarWhereInput"
	},
	ContentVersionUpsertWithWhereUniqueWithoutBookingInput:{
		where:"ContentVersionWhereUniqueInput",
		update:"ContentVersionUpdateWithoutBookingInput",
		create:"ContentVersionCreateWithoutBookingInput"
	},
	ContentVersionUpdateWithoutBookingInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime",
		submittedBy:"UserUpdateOneRequiredWithoutSubmittedContentVersionsNestedInput",
		approvedBy:"UserUpdateOneWithoutApprovedContentVersionsNestedInput",
		deployedBy:"UserUpdateOneWithoutDeployedContentVersionsNestedInput",
		assets:"FileUpdateManyWithoutContentVersionsNestedInput"
	},
	UserUpdateOneRequiredWithoutSubmittedContentVersionsNestedInput:{
		create:"UserCreateWithoutSubmittedContentVersionsInput",
		connectOrCreate:"UserCreateOrConnectWithoutSubmittedContentVersionsInput",
		upsert:"UserUpsertWithoutSubmittedContentVersionsInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutSubmittedContentVersionsInput"
	},
	UserUpsertWithoutSubmittedContentVersionsInput:{
		update:"UserUpdateWithoutSubmittedContentVersionsInput",
		create:"UserCreateWithoutSubmittedContentVersionsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutSubmittedContentVersionsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	FileUpdateManyWithoutUpdatedByNestedInput:{
		create:"FileCreateWithoutUpdatedByInput",
		connectOrCreate:"FileCreateOrConnectWithoutUpdatedByInput",
		upsert:"FileUpsertWithWhereUniqueWithoutUpdatedByInput",
		createMany:"FileCreateManyUpdatedByInputEnvelope",
		set:"FileWhereUniqueInput",
		disconnect:"FileWhereUniqueInput",
		delete:"FileWhereUniqueInput",
		connect:"FileWhereUniqueInput",
		update:"FileUpdateWithWhereUniqueWithoutUpdatedByInput",
		updateMany:"FileUpdateManyWithWhereWithoutUpdatedByInput",
		deleteMany:"FileScalarWhereInput"
	},
	FileUpsertWithWhereUniqueWithoutUpdatedByInput:{
		where:"FileWhereUniqueInput",
		update:"FileUpdateWithoutUpdatedByInput",
		create:"FileCreateWithoutUpdatedByInput"
	},
	FileUpdateWithoutUpdatedByInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		createdBy:"UserUpdateOneRequiredWithoutCreatedFilesNestedInput",
		bookings:"BookingUpdateManyWithoutAssetsNestedInput",
		workspace:"WorkspaceUpdateOneWithoutFilesNestedInput",
		proofBooking:"BookingUpdateOneWithoutProofsNestedInput",
		campaigns:"CampaignUpdateManyWithoutAssetsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutAssetsNestedInput"
	},
	UserUpdateOneRequiredWithoutCreatedFilesNestedInput:{
		create:"UserCreateWithoutCreatedFilesInput",
		connectOrCreate:"UserCreateOrConnectWithoutCreatedFilesInput",
		upsert:"UserUpsertWithoutCreatedFilesInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutCreatedFilesInput"
	},
	UserUpsertWithoutCreatedFilesInput:{
		update:"UserUpdateWithoutCreatedFilesInput",
		create:"UserCreateWithoutCreatedFilesInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutCreatedFilesInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	OrderUpdateManyWithoutCreatedByNestedInput:{
		create:"OrderCreateWithoutCreatedByInput",
		connectOrCreate:"OrderCreateOrConnectWithoutCreatedByInput",
		upsert:"OrderUpsertWithWhereUniqueWithoutCreatedByInput",
		createMany:"OrderCreateManyCreatedByInputEnvelope",
		set:"OrderWhereUniqueInput",
		disconnect:"OrderWhereUniqueInput",
		delete:"OrderWhereUniqueInput",
		connect:"OrderWhereUniqueInput",
		update:"OrderUpdateWithWhereUniqueWithoutCreatedByInput",
		updateMany:"OrderUpdateManyWithWhereWithoutCreatedByInput",
		deleteMany:"OrderScalarWhereInput"
	},
	OrderUpsertWithWhereUniqueWithoutCreatedByInput:{
		where:"OrderWhereUniqueInput",
		update:"OrderUpdateWithoutCreatedByInput",
		create:"OrderCreateWithoutCreatedByInput"
	},
	OrderUpdateWithoutCreatedByInput:{
		createdDate:"DateTime",
		priceSummary:"PriceSummaryCreateInput",
		selectedDate:"OrderSelectedDateCreateInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutOrdersNestedInput"
	},
	AdBoardUpdateOneRequiredWithoutOrdersNestedInput:{
		create:"AdBoardCreateWithoutOrdersInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutOrdersInput",
		upsert:"AdBoardUpsertWithoutOrdersInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateToOneWithWhereWithoutOrdersInput"
	},
	AdBoardUpsertWithoutOrdersInput:{
		update:"AdBoardUpdateWithoutOrdersInput",
		create:"AdBoardCreateWithoutOrdersInput",
		where:"AdBoardWhereInput"
	},
	AdBoardUpdateWithoutOrdersInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	SlotConfigurationUpdateManyWithoutAdBoardNestedInput:{
		create:"SlotConfigurationCreateWithoutAdBoardInput",
		connectOrCreate:"SlotConfigurationCreateOrConnectWithoutAdBoardInput",
		upsert:"SlotConfigurationUpsertWithWhereUniqueWithoutAdBoardInput",
		createMany:"SlotConfigurationCreateManyAdBoardInputEnvelope",
		set:"SlotConfigurationWhereUniqueInput",
		disconnect:"SlotConfigurationWhereUniqueInput",
		delete:"SlotConfigurationWhereUniqueInput",
		connect:"SlotConfigurationWhereUniqueInput",
		update:"SlotConfigurationUpdateWithWhereUniqueWithoutAdBoardInput",
		updateMany:"SlotConfigurationUpdateManyWithWhereWithoutAdBoardInput",
		deleteMany:"SlotConfigurationScalarWhereInput"
	},
	SlotConfigurationUpsertWithWhereUniqueWithoutAdBoardInput:{
		where:"SlotConfigurationWhereUniqueInput",
		update:"SlotConfigurationUpdateWithoutAdBoardInput",
		create:"SlotConfigurationCreateWithoutAdBoardInput"
	},
	SlotConfigurationUpdateWithoutAdBoardInput:{
		date:"DateTime"
	},
	SlotConfigurationUpdateWithWhereUniqueWithoutAdBoardInput:{
		where:"SlotConfigurationWhereUniqueInput",
		data:"SlotConfigurationUpdateWithoutAdBoardInput"
	},
	SlotConfigurationUpdateManyWithWhereWithoutAdBoardInput:{
		where:"SlotConfigurationScalarWhereInput",
		data:"SlotConfigurationUpdateManyMutationInput"
	},
	SlotConfigurationScalarWhereInput:{
		AND:"SlotConfigurationScalarWhereInput",
		OR:"SlotConfigurationScalarWhereInput",
		NOT:"SlotConfigurationScalarWhereInput",
		id:"StringFilter",
		adBoardId:"StringFilter",
		date:"DateTimeFilter",
		availableSlots:"IntFilter"
	},
	SlotConfigurationUpdateManyMutationInput:{
		date:"DateTime"
	},
	UserUpdateOneWithoutAdBoardsNestedInput:{
		create:"UserCreateWithoutAdBoardsInput",
		connectOrCreate:"UserCreateOrConnectWithoutAdBoardsInput",
		upsert:"UserUpsertWithoutAdBoardsInput",
		delete:"UserWhereInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutAdBoardsInput"
	},
	UserUpsertWithoutAdBoardsInput:{
		update:"UserUpdateWithoutAdBoardsInput",
		create:"UserCreateWithoutAdBoardsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutAdBoardsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	ChangelogUpdateManyWithoutUserNestedInput:{
		create:"ChangelogCreateWithoutUserInput",
		connectOrCreate:"ChangelogCreateOrConnectWithoutUserInput",
		upsert:"ChangelogUpsertWithWhereUniqueWithoutUserInput",
		createMany:"ChangelogCreateManyUserInputEnvelope",
		set:"ChangelogWhereUniqueInput",
		disconnect:"ChangelogWhereUniqueInput",
		delete:"ChangelogWhereUniqueInput",
		connect:"ChangelogWhereUniqueInput",
		update:"ChangelogUpdateWithWhereUniqueWithoutUserInput",
		updateMany:"ChangelogUpdateManyWithWhereWithoutUserInput",
		deleteMany:"ChangelogScalarWhereInput"
	},
	ChangelogUpsertWithWhereUniqueWithoutUserInput:{
		where:"ChangelogWhereUniqueInput",
		update:"ChangelogUpdateWithoutUserInput",
		create:"ChangelogCreateWithoutUserInput"
	},
	ChangelogUpdateWithoutUserInput:{
		createdAt:"DateTime",
		updates:"JSON",
		booking:"BookingUpdateOneWithoutChangelogsNestedInput"
	},
	BookingUpdateOneWithoutChangelogsNestedInput:{
		create:"BookingCreateWithoutChangelogsInput",
		connectOrCreate:"BookingCreateOrConnectWithoutChangelogsInput",
		upsert:"BookingUpsertWithoutChangelogsInput",
		delete:"BookingWhereInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateToOneWithWhereWithoutChangelogsInput"
	},
	BookingUpsertWithoutChangelogsInput:{
		update:"BookingUpdateWithoutChangelogsInput",
		create:"BookingCreateWithoutChangelogsInput",
		where:"BookingWhereInput"
	},
	BookingUpdateWithoutChangelogsInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	PaymentAllocationUpdateManyWithoutBookingNestedInput:{
		create:"PaymentAllocationCreateWithoutBookingInput",
		connectOrCreate:"PaymentAllocationCreateOrConnectWithoutBookingInput",
		upsert:"PaymentAllocationUpsertWithWhereUniqueWithoutBookingInput",
		createMany:"PaymentAllocationCreateManyBookingInputEnvelope",
		set:"PaymentAllocationWhereUniqueInput",
		disconnect:"PaymentAllocationWhereUniqueInput",
		delete:"PaymentAllocationWhereUniqueInput",
		connect:"PaymentAllocationWhereUniqueInput",
		update:"PaymentAllocationUpdateWithWhereUniqueWithoutBookingInput",
		updateMany:"PaymentAllocationUpdateManyWithWhereWithoutBookingInput",
		deleteMany:"PaymentAllocationScalarWhereInput"
	},
	PaymentAllocationUpsertWithWhereUniqueWithoutBookingInput:{
		where:"PaymentAllocationWhereUniqueInput",
		update:"PaymentAllocationUpdateWithoutBookingInput",
		create:"PaymentAllocationCreateWithoutBookingInput"
	},
	PaymentAllocationUpdateWithoutBookingInput:{
		payment:"PaymentUpdateOneRequiredWithoutPaymentAllocationsNestedInput"
	},
	PaymentUpdateOneRequiredWithoutPaymentAllocationsNestedInput:{
		create:"PaymentCreateWithoutPaymentAllocationsInput",
		connectOrCreate:"PaymentCreateOrConnectWithoutPaymentAllocationsInput",
		upsert:"PaymentUpsertWithoutPaymentAllocationsInput",
		connect:"PaymentWhereUniqueInput",
		update:"PaymentUpdateToOneWithWhereWithoutPaymentAllocationsInput"
	},
	PaymentUpsertWithoutPaymentAllocationsInput:{
		update:"PaymentUpdateWithoutPaymentAllocationsInput",
		create:"PaymentCreateWithoutPaymentAllocationsInput",
		where:"PaymentWhereInput"
	},
	PaymentUpdateWithoutPaymentAllocationsInput:{
		paymentGateway:"PaymentGatewayName",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		campaign:"CampaignUpdateOneWithoutPaymentsNestedInput"
	},
	CampaignUpdateOneWithoutPaymentsNestedInput:{
		create:"CampaignCreateWithoutPaymentsInput",
		connectOrCreate:"CampaignCreateOrConnectWithoutPaymentsInput",
		upsert:"CampaignUpsertWithoutPaymentsInput",
		delete:"CampaignWhereInput",
		connect:"CampaignWhereUniqueInput",
		update:"CampaignUpdateToOneWithWhereWithoutPaymentsInput"
	},
	CampaignUpsertWithoutPaymentsInput:{
		update:"CampaignUpdateWithoutPaymentsInput",
		create:"CampaignCreateWithoutPaymentsInput",
		where:"CampaignWhereInput"
	},
	CampaignUpdateWithoutPaymentsInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		businessCategory:"BusinessCategoryUpdateOneRequiredWithoutCampaignsNestedInput",
		user:"UserUpdateOneRequiredWithoutCampaignsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutCampaignsNestedInput",
		bookings:"BookingUpdateManyWithoutCampaignNestedInput",
		assets:"FileUpdateManyWithoutCampaignsNestedInput"
	},
	AdvertisementCategoryUpdateManyWithoutCampaignsNestedInput:{
		create:"AdvertisementCategoryCreateWithoutCampaignsInput",
		connectOrCreate:"AdvertisementCategoryCreateOrConnectWithoutCampaignsInput",
		upsert:"AdvertisementCategoryUpsertWithWhereUniqueWithoutCampaignsInput",
		set:"AdvertisementCategoryWhereUniqueInput",
		disconnect:"AdvertisementCategoryWhereUniqueInput",
		delete:"AdvertisementCategoryWhereUniqueInput",
		connect:"AdvertisementCategoryWhereUniqueInput",
		update:"AdvertisementCategoryUpdateWithWhereUniqueWithoutCampaignsInput",
		updateMany:"AdvertisementCategoryUpdateManyWithWhereWithoutCampaignsInput",
		deleteMany:"AdvertisementCategoryScalarWhereInput"
	},
	AdvertisementCategoryUpsertWithWhereUniqueWithoutCampaignsInput:{
		where:"AdvertisementCategoryWhereUniqueInput",
		update:"AdvertisementCategoryUpdateWithoutCampaignsInput",
		create:"AdvertisementCategoryCreateWithoutCampaignsInput"
	},
	AdvertisementCategoryUpdateWithoutCampaignsInput:{
		type:"AdvertisementCategoryEnum",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		bookings:"BookingUpdateManyWithoutAdCategoryNestedInput"
	},
	BookingUpdateManyWithoutAdCategoryNestedInput:{
		create:"BookingCreateWithoutAdCategoryInput",
		connectOrCreate:"BookingCreateOrConnectWithoutAdCategoryInput",
		upsert:"BookingUpsertWithWhereUniqueWithoutAdCategoryInput",
		set:"BookingWhereUniqueInput",
		disconnect:"BookingWhereUniqueInput",
		delete:"BookingWhereUniqueInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateWithWhereUniqueWithoutAdCategoryInput",
		updateMany:"BookingUpdateManyWithWhereWithoutAdCategoryInput",
		deleteMany:"BookingScalarWhereInput"
	},
	BookingUpsertWithWhereUniqueWithoutAdCategoryInput:{
		where:"BookingWhereUniqueInput",
		update:"BookingUpdateWithoutAdCategoryInput",
		create:"BookingCreateWithoutAdCategoryInput"
	},
	BookingUpdateWithoutAdCategoryInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	FileUpdateManyWithoutProofBookingNestedInput:{
		create:"FileCreateWithoutProofBookingInput",
		connectOrCreate:"FileCreateOrConnectWithoutProofBookingInput",
		upsert:"FileUpsertWithWhereUniqueWithoutProofBookingInput",
		createMany:"FileCreateManyProofBookingInputEnvelope",
		set:"FileWhereUniqueInput",
		disconnect:"FileWhereUniqueInput",
		delete:"FileWhereUniqueInput",
		connect:"FileWhereUniqueInput",
		update:"FileUpdateWithWhereUniqueWithoutProofBookingInput",
		updateMany:"FileUpdateManyWithWhereWithoutProofBookingInput",
		deleteMany:"FileScalarWhereInput"
	},
	FileUpsertWithWhereUniqueWithoutProofBookingInput:{
		where:"FileWhereUniqueInput",
		update:"FileUpdateWithoutProofBookingInput",
		create:"FileCreateWithoutProofBookingInput"
	},
	FileUpdateWithoutProofBookingInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserUpdateOneWithoutUpdatedFilesNestedInput",
		createdBy:"UserUpdateOneRequiredWithoutCreatedFilesNestedInput",
		bookings:"BookingUpdateManyWithoutAssetsNestedInput",
		workspace:"WorkspaceUpdateOneWithoutFilesNestedInput",
		campaigns:"CampaignUpdateManyWithoutAssetsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutAssetsNestedInput"
	},
	WorkspaceUpdateOneWithoutFilesNestedInput:{
		create:"WorkspaceCreateWithoutFilesInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutFilesInput",
		upsert:"WorkspaceUpsertWithoutFilesInput",
		delete:"WorkspaceWhereInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutFilesInput"
	},
	WorkspaceUpsertWithoutFilesInput:{
		update:"WorkspaceUpdateWithoutFilesInput",
		create:"WorkspaceCreateWithoutFilesInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutFilesInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	UserUpdateOneWithoutOwnedWorkspacesNestedInput:{
		create:"UserCreateWithoutOwnedWorkspacesInput",
		connectOrCreate:"UserCreateOrConnectWithoutOwnedWorkspacesInput",
		upsert:"UserUpsertWithoutOwnedWorkspacesInput",
		delete:"UserWhereInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutOwnedWorkspacesInput"
	},
	UserUpsertWithoutOwnedWorkspacesInput:{
		update:"UserUpdateWithoutOwnedWorkspacesInput",
		create:"UserCreateWithoutOwnedWorkspacesInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutOwnedWorkspacesInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	AdBoardUpdateManyWithoutCreatedByNestedInput:{
		create:"AdBoardCreateWithoutCreatedByInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutCreatedByInput",
		upsert:"AdBoardUpsertWithWhereUniqueWithoutCreatedByInput",
		createMany:"AdBoardCreateManyCreatedByInputEnvelope",
		set:"AdBoardWhereUniqueInput",
		disconnect:"AdBoardWhereUniqueInput",
		delete:"AdBoardWhereUniqueInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithWhereUniqueWithoutCreatedByInput",
		updateMany:"AdBoardUpdateManyWithWhereWithoutCreatedByInput",
		deleteMany:"AdBoardScalarWhereInput"
	},
	AdBoardUpsertWithWhereUniqueWithoutCreatedByInput:{
		where:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithoutCreatedByInput",
		create:"AdBoardCreateWithoutCreatedByInput"
	},
	AdBoardUpdateWithoutCreatedByInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	OrderUpdateManyWithoutAdBoardNestedInput:{
		create:"OrderCreateWithoutAdBoardInput",
		connectOrCreate:"OrderCreateOrConnectWithoutAdBoardInput",
		upsert:"OrderUpsertWithWhereUniqueWithoutAdBoardInput",
		createMany:"OrderCreateManyAdBoardInputEnvelope",
		set:"OrderWhereUniqueInput",
		disconnect:"OrderWhereUniqueInput",
		delete:"OrderWhereUniqueInput",
		connect:"OrderWhereUniqueInput",
		update:"OrderUpdateWithWhereUniqueWithoutAdBoardInput",
		updateMany:"OrderUpdateManyWithWhereWithoutAdBoardInput",
		deleteMany:"OrderScalarWhereInput"
	},
	OrderUpsertWithWhereUniqueWithoutAdBoardInput:{
		where:"OrderWhereUniqueInput",
		update:"OrderUpdateWithoutAdBoardInput",
		create:"OrderCreateWithoutAdBoardInput"
	},
	OrderUpdateWithoutAdBoardInput:{
		createdDate:"DateTime",
		priceSummary:"PriceSummaryCreateInput",
		selectedDate:"OrderSelectedDateCreateInput",
		createdBy:"UserUpdateOneWithoutOrdersNestedInput"
	},
	UserUpdateOneWithoutOrdersNestedInput:{
		create:"UserCreateWithoutOrdersInput",
		connectOrCreate:"UserCreateOrConnectWithoutOrdersInput",
		upsert:"UserUpsertWithoutOrdersInput",
		delete:"UserWhereInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutOrdersInput"
	},
	UserUpsertWithoutOrdersInput:{
		update:"UserUpdateWithoutOrdersInput",
		create:"UserCreateWithoutOrdersInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutOrdersInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	AuditUpdateManyWithoutUserNestedInput:{
		create:"AuditCreateWithoutUserInput",
		connectOrCreate:"AuditCreateOrConnectWithoutUserInput",
		upsert:"AuditUpsertWithWhereUniqueWithoutUserInput",
		createMany:"AuditCreateManyUserInputEnvelope",
		set:"AuditWhereUniqueInput",
		disconnect:"AuditWhereUniqueInput",
		delete:"AuditWhereUniqueInput",
		connect:"AuditWhereUniqueInput",
		update:"AuditUpdateWithWhereUniqueWithoutUserInput",
		updateMany:"AuditUpdateManyWithWhereWithoutUserInput",
		deleteMany:"AuditScalarWhereInput"
	},
	AuditUpsertWithWhereUniqueWithoutUserInput:{
		where:"AuditWhereUniqueInput",
		update:"AuditUpdateWithoutUserInput",
		create:"AuditCreateWithoutUserInput"
	},
	AuditUpdateWithoutUserInput:{
		createdAt:"DateTime",
		entity:"EntityCreateInput",
		updates:"JSON",
		workspace:"WorkspaceUpdateOneWithoutAuditsNestedInput"
	},
	WorkspaceUpdateOneWithoutAuditsNestedInput:{
		create:"WorkspaceCreateWithoutAuditsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutAuditsInput",
		upsert:"WorkspaceUpsertWithoutAuditsInput",
		delete:"WorkspaceWhereInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutAuditsInput"
	},
	WorkspaceUpsertWithoutAuditsInput:{
		update:"WorkspaceUpdateWithoutAuditsInput",
		create:"WorkspaceCreateWithoutAuditsInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutAuditsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	MembershipUpdateManyWithoutWorkspaceNestedInput:{
		create:"MembershipCreateWithoutWorkspaceInput",
		connectOrCreate:"MembershipCreateOrConnectWithoutWorkspaceInput",
		upsert:"MembershipUpsertWithWhereUniqueWithoutWorkspaceInput",
		createMany:"MembershipCreateManyWorkspaceInputEnvelope",
		set:"MembershipWhereUniqueInput",
		disconnect:"MembershipWhereUniqueInput",
		delete:"MembershipWhereUniqueInput",
		connect:"MembershipWhereUniqueInput",
		update:"MembershipUpdateWithWhereUniqueWithoutWorkspaceInput",
		updateMany:"MembershipUpdateManyWithWhereWithoutWorkspaceInput",
		deleteMany:"MembershipScalarWhereInput"
	},
	MembershipUpsertWithWhereUniqueWithoutWorkspaceInput:{
		where:"MembershipWhereUniqueInput",
		update:"MembershipUpdateWithoutWorkspaceInput",
		create:"MembershipCreateWithoutWorkspaceInput"
	},
	MembershipUpdateWithoutWorkspaceInput:{
		createdAt:"DateTime",
		user:"UserUpdateOneRequiredWithoutMembershipsNestedInput",
		role:"WorkspaceRoleUpdateOneRequiredWithoutMembershipsNestedInput"
	},
	UserUpdateOneRequiredWithoutMembershipsNestedInput:{
		create:"UserCreateWithoutMembershipsInput",
		connectOrCreate:"UserCreateOrConnectWithoutMembershipsInput",
		upsert:"UserUpsertWithoutMembershipsInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutMembershipsInput"
	},
	UserUpsertWithoutMembershipsInput:{
		update:"UserUpdateWithoutMembershipsInput",
		create:"UserCreateWithoutMembershipsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutMembershipsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	CampaignUpdateManyWithoutUserNestedInput:{
		create:"CampaignCreateWithoutUserInput",
		connectOrCreate:"CampaignCreateOrConnectWithoutUserInput",
		upsert:"CampaignUpsertWithWhereUniqueWithoutUserInput",
		createMany:"CampaignCreateManyUserInputEnvelope",
		set:"CampaignWhereUniqueInput",
		disconnect:"CampaignWhereUniqueInput",
		delete:"CampaignWhereUniqueInput",
		connect:"CampaignWhereUniqueInput",
		update:"CampaignUpdateWithWhereUniqueWithoutUserInput",
		updateMany:"CampaignUpdateManyWithWhereWithoutUserInput",
		deleteMany:"CampaignScalarWhereInput"
	},
	CampaignUpsertWithWhereUniqueWithoutUserInput:{
		where:"CampaignWhereUniqueInput",
		update:"CampaignUpdateWithoutUserInput",
		create:"CampaignCreateWithoutUserInput"
	},
	CampaignUpdateWithoutUserInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		businessCategory:"BusinessCategoryUpdateOneRequiredWithoutCampaignsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutCampaignsNestedInput",
		bookings:"BookingUpdateManyWithoutCampaignNestedInput",
		payments:"PaymentUpdateManyWithoutCampaignNestedInput",
		assets:"FileUpdateManyWithoutCampaignsNestedInput"
	},
	BookingUpdateManyWithoutCampaignNestedInput:{
		create:"BookingCreateWithoutCampaignInput",
		connectOrCreate:"BookingCreateOrConnectWithoutCampaignInput",
		upsert:"BookingUpsertWithWhereUniqueWithoutCampaignInput",
		createMany:"BookingCreateManyCampaignInputEnvelope",
		set:"BookingWhereUniqueInput",
		disconnect:"BookingWhereUniqueInput",
		delete:"BookingWhereUniqueInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateWithWhereUniqueWithoutCampaignInput",
		updateMany:"BookingUpdateManyWithWhereWithoutCampaignInput",
		deleteMany:"BookingScalarWhereInput"
	},
	BookingUpsertWithWhereUniqueWithoutCampaignInput:{
		where:"BookingWhereUniqueInput",
		update:"BookingUpdateWithoutCampaignInput",
		create:"BookingCreateWithoutCampaignInput"
	},
	BookingUpdateWithoutCampaignInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	UserUpdateOneRequiredWithoutBookingsNestedInput:{
		create:"UserCreateWithoutBookingsInput",
		connectOrCreate:"UserCreateOrConnectWithoutBookingsInput",
		upsert:"UserUpsertWithoutBookingsInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutBookingsInput"
	},
	UserUpsertWithoutBookingsInput:{
		update:"UserUpdateWithoutBookingsInput",
		create:"UserCreateWithoutBookingsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutBookingsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	BookingUpdateManyWithoutSharedUsersNestedInput:{
		create:"BookingCreateWithoutSharedUsersInput",
		connectOrCreate:"BookingCreateOrConnectWithoutSharedUsersInput",
		upsert:"BookingUpsertWithWhereUniqueWithoutSharedUsersInput",
		set:"BookingWhereUniqueInput",
		disconnect:"BookingWhereUniqueInput",
		delete:"BookingWhereUniqueInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateWithWhereUniqueWithoutSharedUsersInput",
		updateMany:"BookingUpdateManyWithWhereWithoutSharedUsersInput",
		deleteMany:"BookingScalarWhereInput"
	},
	BookingUpsertWithWhereUniqueWithoutSharedUsersInput:{
		where:"BookingWhereUniqueInput",
		update:"BookingUpdateWithoutSharedUsersInput",
		create:"BookingCreateWithoutSharedUsersInput"
	},
	BookingUpdateWithoutSharedUsersInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	AdBoardUpdateOneRequiredWithoutBookingsNestedInput:{
		create:"AdBoardCreateWithoutBookingsInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutBookingsInput",
		upsert:"AdBoardUpsertWithoutBookingsInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateToOneWithWhereWithoutBookingsInput"
	},
	AdBoardUpsertWithoutBookingsInput:{
		update:"AdBoardUpdateWithoutBookingsInput",
		create:"AdBoardCreateWithoutBookingsInput",
		where:"AdBoardWhereInput"
	},
	AdBoardUpdateWithoutBookingsInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput:{
		create:"WorkspaceCreateWithoutAdBoardsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutAdBoardsInput",
		upsert:"WorkspaceUpsertWithoutAdBoardsInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutAdBoardsInput"
	},
	WorkspaceUpsertWithoutAdBoardsInput:{
		update:"WorkspaceUpdateWithoutAdBoardsInput",
		create:"WorkspaceCreateWithoutAdBoardsInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutAdBoardsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	PlaylistUpdateManyWithoutWorkspaceNestedInput:{
		create:"PlaylistCreateWithoutWorkspaceInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutWorkspaceInput",
		upsert:"PlaylistUpsertWithWhereUniqueWithoutWorkspaceInput",
		createMany:"PlaylistCreateManyWorkspaceInputEnvelope",
		set:"PlaylistWhereUniqueInput",
		disconnect:"PlaylistWhereUniqueInput",
		delete:"PlaylistWhereUniqueInput",
		connect:"PlaylistWhereUniqueInput",
		update:"PlaylistUpdateWithWhereUniqueWithoutWorkspaceInput",
		updateMany:"PlaylistUpdateManyWithWhereWithoutWorkspaceInput",
		deleteMany:"PlaylistScalarWhereInput"
	},
	PlaylistUpsertWithWhereUniqueWithoutWorkspaceInput:{
		where:"PlaylistWhereUniqueInput",
		update:"PlaylistUpdateWithoutWorkspaceInput",
		create:"PlaylistCreateWithoutWorkspaceInput"
	},
	PlaylistUpdateWithoutWorkspaceInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistUpdateOneWithoutFooterParentPlaylistsNestedInput",
		sidebarPlaylist:"PlaylistUpdateOneWithoutSidebarParentPlaylistsNestedInput",
		adBoardGroupsForAds:"AdBoardGroupUpdateManyWithoutAdsPlaylistNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutScheduledPlaylistsNestedInput",
		footerParentPlaylists:"PlaylistUpdateManyWithoutFooterPlaylistNestedInput",
		sidebarParentPlaylists:"PlaylistUpdateManyWithoutSidebarPlaylistNestedInput"
	},
	PlaylistUpdateOneWithoutFooterParentPlaylistsNestedInput:{
		create:"PlaylistCreateWithoutFooterParentPlaylistsInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutFooterParentPlaylistsInput",
		upsert:"PlaylistUpsertWithoutFooterParentPlaylistsInput",
		delete:"PlaylistWhereInput",
		connect:"PlaylistWhereUniqueInput",
		update:"PlaylistUpdateToOneWithWhereWithoutFooterParentPlaylistsInput"
	},
	PlaylistUpsertWithoutFooterParentPlaylistsInput:{
		update:"PlaylistUpdateWithoutFooterParentPlaylistsInput",
		create:"PlaylistCreateWithoutFooterParentPlaylistsInput",
		where:"PlaylistWhereInput"
	},
	PlaylistUpdateWithoutFooterParentPlaylistsInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistUpdateOneWithoutFooterParentPlaylistsNestedInput",
		sidebarPlaylist:"PlaylistUpdateOneWithoutSidebarParentPlaylistsNestedInput",
		adBoardGroupsForAds:"AdBoardGroupUpdateManyWithoutAdsPlaylistNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutScheduledPlaylistsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutPlaylistsNestedInput",
		sidebarParentPlaylists:"PlaylistUpdateManyWithoutSidebarPlaylistNestedInput"
	},
	PlaylistUpdateOneWithoutSidebarParentPlaylistsNestedInput:{
		create:"PlaylistCreateWithoutSidebarParentPlaylistsInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutSidebarParentPlaylistsInput",
		upsert:"PlaylistUpsertWithoutSidebarParentPlaylistsInput",
		delete:"PlaylistWhereInput",
		connect:"PlaylistWhereUniqueInput",
		update:"PlaylistUpdateToOneWithWhereWithoutSidebarParentPlaylistsInput"
	},
	PlaylistUpsertWithoutSidebarParentPlaylistsInput:{
		update:"PlaylistUpdateWithoutSidebarParentPlaylistsInput",
		create:"PlaylistCreateWithoutSidebarParentPlaylistsInput",
		where:"PlaylistWhereInput"
	},
	PlaylistUpdateWithoutSidebarParentPlaylistsInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistUpdateOneWithoutFooterParentPlaylistsNestedInput",
		sidebarPlaylist:"PlaylistUpdateOneWithoutSidebarParentPlaylistsNestedInput",
		adBoardGroupsForAds:"AdBoardGroupUpdateManyWithoutAdsPlaylistNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutScheduledPlaylistsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutPlaylistsNestedInput",
		footerParentPlaylists:"PlaylistUpdateManyWithoutFooterPlaylistNestedInput"
	},
	AdBoardGroupUpdateManyWithoutAdsPlaylistNestedInput:{
		create:"AdBoardGroupCreateWithoutAdsPlaylistInput",
		connectOrCreate:"AdBoardGroupCreateOrConnectWithoutAdsPlaylistInput",
		upsert:"AdBoardGroupUpsertWithWhereUniqueWithoutAdsPlaylistInput",
		createMany:"AdBoardGroupCreateManyAdsPlaylistInputEnvelope",
		set:"AdBoardGroupWhereUniqueInput",
		disconnect:"AdBoardGroupWhereUniqueInput",
		delete:"AdBoardGroupWhereUniqueInput",
		connect:"AdBoardGroupWhereUniqueInput",
		update:"AdBoardGroupUpdateWithWhereUniqueWithoutAdsPlaylistInput",
		updateMany:"AdBoardGroupUpdateManyWithWhereWithoutAdsPlaylistInput",
		deleteMany:"AdBoardGroupScalarWhereInput"
	},
	AdBoardGroupUpsertWithWhereUniqueWithoutAdsPlaylistInput:{
		where:"AdBoardGroupWhereUniqueInput",
		update:"AdBoardGroupUpdateWithoutAdsPlaylistInput",
		create:"AdBoardGroupCreateWithoutAdsPlaylistInput"
	},
	AdBoardGroupUpdateWithoutAdsPlaylistInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType",
		adBoard:"AdBoardUpdateOneWithoutAdBoardGroupNestedInput",
		scheduledPlaylists:"PlaylistUpdateManyWithoutAdBoardGroupsNestedInput",
		pisignagePlayers:"PlayerUpdateManyWithoutAdBoardGroupNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardGroupsNestedInput"
	},
	AdBoardUpdateOneWithoutAdBoardGroupNestedInput:{
		create:"AdBoardCreateWithoutAdBoardGroupInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutAdBoardGroupInput",
		upsert:"AdBoardUpsertWithoutAdBoardGroupInput",
		delete:"AdBoardWhereInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateToOneWithWhereWithoutAdBoardGroupInput"
	},
	AdBoardUpsertWithoutAdBoardGroupInput:{
		update:"AdBoardUpdateWithoutAdBoardGroupInput",
		create:"AdBoardCreateWithoutAdBoardGroupInput",
		where:"AdBoardWhereInput"
	},
	AdBoardUpdateWithoutAdBoardGroupInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	PlayerUpdateManyWithoutAdBoardsNestedInput:{
		create:"PlayerCreateWithoutAdBoardsInput",
		connectOrCreate:"PlayerCreateOrConnectWithoutAdBoardsInput",
		upsert:"PlayerUpsertWithWhereUniqueWithoutAdBoardsInput",
		set:"PlayerWhereUniqueInput",
		disconnect:"PlayerWhereUniqueInput",
		delete:"PlayerWhereUniqueInput",
		connect:"PlayerWhereUniqueInput",
		update:"PlayerUpdateWithWhereUniqueWithoutAdBoardsInput",
		updateMany:"PlayerUpdateManyWithWhereWithoutAdBoardsInput",
		deleteMany:"PlayerScalarWhereInput"
	},
	PlayerUpsertWithWhereUniqueWithoutAdBoardsInput:{
		where:"PlayerWhereUniqueInput",
		update:"PlayerUpdateWithoutAdBoardsInput",
		create:"PlayerCreateWithoutAdBoardsInput"
	},
	PlayerUpdateWithoutAdBoardsInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutPisignagePlayersNestedInput",
		workspace:"WorkspaceUpdateOneWithoutPlayersNestedInput",
		status:"PlayerUptimeStatusUpdateManyWithoutPlayerNestedInput",
		cameras:"CameraUpdateManyWithoutPlayerNestedInput",
		signageType:"DigitalSignageUpdateOneWithoutPlayersNestedInput",
		audienceType:"AudienceUpdateManyWithoutPlayersNestedInput",
		deletedBy:"UserUpdateOneWithoutDeletedPlayerIdsNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutPlayerNestedInput"
	},
	AdBoardGroupUpdateOneWithoutPisignagePlayersNestedInput:{
		create:"AdBoardGroupCreateWithoutPisignagePlayersInput",
		connectOrCreate:"AdBoardGroupCreateOrConnectWithoutPisignagePlayersInput",
		upsert:"AdBoardGroupUpsertWithoutPisignagePlayersInput",
		delete:"AdBoardGroupWhereInput",
		connect:"AdBoardGroupWhereUniqueInput",
		update:"AdBoardGroupUpdateToOneWithWhereWithoutPisignagePlayersInput"
	},
	AdBoardGroupUpsertWithoutPisignagePlayersInput:{
		update:"AdBoardGroupUpdateWithoutPisignagePlayersInput",
		create:"AdBoardGroupCreateWithoutPisignagePlayersInput",
		where:"AdBoardGroupWhereInput"
	},
	AdBoardGroupUpdateWithoutPisignagePlayersInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType",
		adBoard:"AdBoardUpdateOneWithoutAdBoardGroupNestedInput",
		scheduledPlaylists:"PlaylistUpdateManyWithoutAdBoardGroupsNestedInput",
		adsPlaylist:"PlaylistUpdateOneWithoutAdBoardGroupsForAdsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardGroupsNestedInput"
	},
	PlaylistUpdateManyWithoutAdBoardGroupsNestedInput:{
		create:"PlaylistCreateWithoutAdBoardGroupsInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutAdBoardGroupsInput",
		upsert:"PlaylistUpsertWithWhereUniqueWithoutAdBoardGroupsInput",
		set:"PlaylistWhereUniqueInput",
		disconnect:"PlaylistWhereUniqueInput",
		delete:"PlaylistWhereUniqueInput",
		connect:"PlaylistWhereUniqueInput",
		update:"PlaylistUpdateWithWhereUniqueWithoutAdBoardGroupsInput",
		updateMany:"PlaylistUpdateManyWithWhereWithoutAdBoardGroupsInput",
		deleteMany:"PlaylistScalarWhereInput"
	},
	PlaylistUpsertWithWhereUniqueWithoutAdBoardGroupsInput:{
		where:"PlaylistWhereUniqueInput",
		update:"PlaylistUpdateWithoutAdBoardGroupsInput",
		create:"PlaylistCreateWithoutAdBoardGroupsInput"
	},
	PlaylistUpdateWithoutAdBoardGroupsInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistUpdateOneWithoutFooterParentPlaylistsNestedInput",
		sidebarPlaylist:"PlaylistUpdateOneWithoutSidebarParentPlaylistsNestedInput",
		adBoardGroupsForAds:"AdBoardGroupUpdateManyWithoutAdsPlaylistNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutPlaylistsNestedInput",
		footerParentPlaylists:"PlaylistUpdateManyWithoutFooterPlaylistNestedInput",
		sidebarParentPlaylists:"PlaylistUpdateManyWithoutSidebarPlaylistNestedInput"
	},
	WorkspaceUpdateOneRequiredWithoutPlaylistsNestedInput:{
		create:"WorkspaceCreateWithoutPlaylistsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutPlaylistsInput",
		upsert:"WorkspaceUpsertWithoutPlaylistsInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutPlaylistsInput"
	},
	WorkspaceUpsertWithoutPlaylistsInput:{
		update:"WorkspaceUpdateWithoutPlaylistsInput",
		create:"WorkspaceCreateWithoutPlaylistsInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutPlaylistsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	AdBoardUpdateManyWithoutWorkspaceNestedInput:{
		create:"AdBoardCreateWithoutWorkspaceInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutWorkspaceInput",
		upsert:"AdBoardUpsertWithWhereUniqueWithoutWorkspaceInput",
		createMany:"AdBoardCreateManyWorkspaceInputEnvelope",
		set:"AdBoardWhereUniqueInput",
		disconnect:"AdBoardWhereUniqueInput",
		delete:"AdBoardWhereUniqueInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithWhereUniqueWithoutWorkspaceInput",
		updateMany:"AdBoardUpdateManyWithWhereWithoutWorkspaceInput",
		deleteMany:"AdBoardScalarWhereInput"
	},
	AdBoardUpsertWithWhereUniqueWithoutWorkspaceInput:{
		where:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithoutWorkspaceInput",
		create:"AdBoardCreateWithoutWorkspaceInput"
	},
	AdBoardUpdateWithoutWorkspaceInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	AdBoardGroupUpdateOneWithoutAdBoardNestedInput:{
		create:"AdBoardGroupCreateWithoutAdBoardInput",
		connectOrCreate:"AdBoardGroupCreateOrConnectWithoutAdBoardInput",
		upsert:"AdBoardGroupUpsertWithoutAdBoardInput",
		disconnect:"AdBoardGroupWhereInput",
		delete:"AdBoardGroupWhereInput",
		connect:"AdBoardGroupWhereUniqueInput",
		update:"AdBoardGroupUpdateToOneWithWhereWithoutAdBoardInput"
	},
	AdBoardGroupUpsertWithoutAdBoardInput:{
		update:"AdBoardGroupUpdateWithoutAdBoardInput",
		create:"AdBoardGroupCreateWithoutAdBoardInput",
		where:"AdBoardGroupWhereInput"
	},
	AdBoardGroupUpdateWithoutAdBoardInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType",
		scheduledPlaylists:"PlaylistUpdateManyWithoutAdBoardGroupsNestedInput",
		adsPlaylist:"PlaylistUpdateOneWithoutAdBoardGroupsForAdsNestedInput",
		pisignagePlayers:"PlayerUpdateManyWithoutAdBoardGroupNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardGroupsNestedInput"
	},
	PlaylistUpdateOneWithoutAdBoardGroupsForAdsNestedInput:{
		create:"PlaylistCreateWithoutAdBoardGroupsForAdsInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutAdBoardGroupsForAdsInput",
		upsert:"PlaylistUpsertWithoutAdBoardGroupsForAdsInput",
		delete:"PlaylistWhereInput",
		connect:"PlaylistWhereUniqueInput",
		update:"PlaylistUpdateToOneWithWhereWithoutAdBoardGroupsForAdsInput"
	},
	PlaylistUpsertWithoutAdBoardGroupsForAdsInput:{
		update:"PlaylistUpdateWithoutAdBoardGroupsForAdsInput",
		create:"PlaylistCreateWithoutAdBoardGroupsForAdsInput",
		where:"PlaylistWhereInput"
	},
	PlaylistUpdateWithoutAdBoardGroupsForAdsInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistUpdateOneWithoutFooterParentPlaylistsNestedInput",
		sidebarPlaylist:"PlaylistUpdateOneWithoutSidebarParentPlaylistsNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutScheduledPlaylistsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutPlaylistsNestedInput",
		footerParentPlaylists:"PlaylistUpdateManyWithoutFooterPlaylistNestedInput",
		sidebarParentPlaylists:"PlaylistUpdateManyWithoutSidebarPlaylistNestedInput"
	},
	AdBoardGroupUpdateManyWithoutScheduledPlaylistsNestedInput:{
		create:"AdBoardGroupCreateWithoutScheduledPlaylistsInput",
		connectOrCreate:"AdBoardGroupCreateOrConnectWithoutScheduledPlaylistsInput",
		upsert:"AdBoardGroupUpsertWithWhereUniqueWithoutScheduledPlaylistsInput",
		set:"AdBoardGroupWhereUniqueInput",
		disconnect:"AdBoardGroupWhereUniqueInput",
		delete:"AdBoardGroupWhereUniqueInput",
		connect:"AdBoardGroupWhereUniqueInput",
		update:"AdBoardGroupUpdateWithWhereUniqueWithoutScheduledPlaylistsInput",
		updateMany:"AdBoardGroupUpdateManyWithWhereWithoutScheduledPlaylistsInput",
		deleteMany:"AdBoardGroupScalarWhereInput"
	},
	AdBoardGroupUpsertWithWhereUniqueWithoutScheduledPlaylistsInput:{
		where:"AdBoardGroupWhereUniqueInput",
		update:"AdBoardGroupUpdateWithoutScheduledPlaylistsInput",
		create:"AdBoardGroupCreateWithoutScheduledPlaylistsInput"
	},
	AdBoardGroupUpdateWithoutScheduledPlaylistsInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType",
		adBoard:"AdBoardUpdateOneWithoutAdBoardGroupNestedInput",
		adsPlaylist:"PlaylistUpdateOneWithoutAdBoardGroupsForAdsNestedInput",
		pisignagePlayers:"PlayerUpdateManyWithoutAdBoardGroupNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardGroupsNestedInput"
	},
	PlayerUpdateManyWithoutAdBoardGroupNestedInput:{
		create:"PlayerCreateWithoutAdBoardGroupInput",
		connectOrCreate:"PlayerCreateOrConnectWithoutAdBoardGroupInput",
		upsert:"PlayerUpsertWithWhereUniqueWithoutAdBoardGroupInput",
		createMany:"PlayerCreateManyAdBoardGroupInputEnvelope",
		set:"PlayerWhereUniqueInput",
		disconnect:"PlayerWhereUniqueInput",
		delete:"PlayerWhereUniqueInput",
		connect:"PlayerWhereUniqueInput",
		update:"PlayerUpdateWithWhereUniqueWithoutAdBoardGroupInput",
		updateMany:"PlayerUpdateManyWithWhereWithoutAdBoardGroupInput",
		deleteMany:"PlayerScalarWhereInput"
	},
	PlayerUpsertWithWhereUniqueWithoutAdBoardGroupInput:{
		where:"PlayerWhereUniqueInput",
		update:"PlayerUpdateWithoutAdBoardGroupInput",
		create:"PlayerCreateWithoutAdBoardGroupInput"
	},
	PlayerUpdateWithoutAdBoardGroupInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		workspace:"WorkspaceUpdateOneWithoutPlayersNestedInput",
		status:"PlayerUptimeStatusUpdateManyWithoutPlayerNestedInput",
		cameras:"CameraUpdateManyWithoutPlayerNestedInput",
		signageType:"DigitalSignageUpdateOneWithoutPlayersNestedInput",
		audienceType:"AudienceUpdateManyWithoutPlayersNestedInput",
		adBoards:"AdBoardUpdateManyWithoutPlayersNestedInput",
		deletedBy:"UserUpdateOneWithoutDeletedPlayerIdsNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutPlayerNestedInput"
	},
	WorkspaceUpdateOneWithoutPlayersNestedInput:{
		create:"WorkspaceCreateWithoutPlayersInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutPlayersInput",
		upsert:"WorkspaceUpsertWithoutPlayersInput",
		delete:"WorkspaceWhereInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutPlayersInput"
	},
	WorkspaceUpsertWithoutPlayersInput:{
		update:"WorkspaceUpdateWithoutPlayersInput",
		create:"WorkspaceCreateWithoutPlayersInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutPlayersInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	AdBoardGroupUpdateManyWithoutWorkspaceNestedInput:{
		create:"AdBoardGroupCreateWithoutWorkspaceInput",
		connectOrCreate:"AdBoardGroupCreateOrConnectWithoutWorkspaceInput",
		upsert:"AdBoardGroupUpsertWithWhereUniqueWithoutWorkspaceInput",
		createMany:"AdBoardGroupCreateManyWorkspaceInputEnvelope",
		set:"AdBoardGroupWhereUniqueInput",
		disconnect:"AdBoardGroupWhereUniqueInput",
		delete:"AdBoardGroupWhereUniqueInput",
		connect:"AdBoardGroupWhereUniqueInput",
		update:"AdBoardGroupUpdateWithWhereUniqueWithoutWorkspaceInput",
		updateMany:"AdBoardGroupUpdateManyWithWhereWithoutWorkspaceInput",
		deleteMany:"AdBoardGroupScalarWhereInput"
	},
	AdBoardGroupUpsertWithWhereUniqueWithoutWorkspaceInput:{
		where:"AdBoardGroupWhereUniqueInput",
		update:"AdBoardGroupUpdateWithoutWorkspaceInput",
		create:"AdBoardGroupCreateWithoutWorkspaceInput"
	},
	AdBoardGroupUpdateWithoutWorkspaceInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType",
		adBoard:"AdBoardUpdateOneWithoutAdBoardGroupNestedInput",
		scheduledPlaylists:"PlaylistUpdateManyWithoutAdBoardGroupsNestedInput",
		adsPlaylist:"PlaylistUpdateOneWithoutAdBoardGroupsForAdsNestedInput",
		pisignagePlayers:"PlayerUpdateManyWithoutAdBoardGroupNestedInput"
	},
	AdBoardGroupUpdateWithWhereUniqueWithoutWorkspaceInput:{
		where:"AdBoardGroupWhereUniqueInput",
		data:"AdBoardGroupUpdateWithoutWorkspaceInput"
	},
	AdBoardGroupUpdateManyWithWhereWithoutWorkspaceInput:{
		where:"AdBoardGroupScalarWhereInput",
		data:"AdBoardGroupUpdateManyMutationInput"
	},
	AdBoardGroupScalarWhereInput:{
		AND:"AdBoardGroupScalarWhereInput",
		OR:"AdBoardGroupScalarWhereInput",
		NOT:"AdBoardGroupScalarWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		adBoardId:"StringNullableFilter",
		scheduledPlaylistsIDs:"StringNullableListFilter",
		adsPlaylistID:"StringNullableFilter",
		pisignageGroupId:"StringFilter",
		fitImage:"EnumFitTypeFilter",
		fitVideo:"EnumFitTypeFilter",
		workspaceId:"StringFilter"
	},
	AdBoardGroupUpdateManyMutationInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType"
	},
	AuditUpdateManyWithoutWorkspaceNestedInput:{
		create:"AuditCreateWithoutWorkspaceInput",
		connectOrCreate:"AuditCreateOrConnectWithoutWorkspaceInput",
		upsert:"AuditUpsertWithWhereUniqueWithoutWorkspaceInput",
		createMany:"AuditCreateManyWorkspaceInputEnvelope",
		set:"AuditWhereUniqueInput",
		disconnect:"AuditWhereUniqueInput",
		delete:"AuditWhereUniqueInput",
		connect:"AuditWhereUniqueInput",
		update:"AuditUpdateWithWhereUniqueWithoutWorkspaceInput",
		updateMany:"AuditUpdateManyWithWhereWithoutWorkspaceInput",
		deleteMany:"AuditScalarWhereInput"
	},
	AuditUpsertWithWhereUniqueWithoutWorkspaceInput:{
		where:"AuditWhereUniqueInput",
		update:"AuditUpdateWithoutWorkspaceInput",
		create:"AuditCreateWithoutWorkspaceInput"
	},
	AuditUpdateWithoutWorkspaceInput:{
		createdAt:"DateTime",
		entity:"EntityCreateInput",
		updates:"JSON",
		user:"UserUpdateOneRequiredWithoutAuditsNestedInput"
	},
	UserUpdateOneRequiredWithoutAuditsNestedInput:{
		create:"UserCreateWithoutAuditsInput",
		connectOrCreate:"UserCreateOrConnectWithoutAuditsInput",
		upsert:"UserUpsertWithoutAuditsInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutAuditsInput"
	},
	UserUpsertWithoutAuditsInput:{
		update:"UserUpdateWithoutAuditsInput",
		create:"UserCreateWithoutAuditsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutAuditsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	MembershipUpdateManyWithoutUserNestedInput:{
		create:"MembershipCreateWithoutUserInput",
		connectOrCreate:"MembershipCreateOrConnectWithoutUserInput",
		upsert:"MembershipUpsertWithWhereUniqueWithoutUserInput",
		createMany:"MembershipCreateManyUserInputEnvelope",
		set:"MembershipWhereUniqueInput",
		disconnect:"MembershipWhereUniqueInput",
		delete:"MembershipWhereUniqueInput",
		connect:"MembershipWhereUniqueInput",
		update:"MembershipUpdateWithWhereUniqueWithoutUserInput",
		updateMany:"MembershipUpdateManyWithWhereWithoutUserInput",
		deleteMany:"MembershipScalarWhereInput"
	},
	MembershipUpsertWithWhereUniqueWithoutUserInput:{
		where:"MembershipWhereUniqueInput",
		update:"MembershipUpdateWithoutUserInput",
		create:"MembershipCreateWithoutUserInput"
	},
	MembershipUpdateWithoutUserInput:{
		createdAt:"DateTime",
		workspace:"WorkspaceUpdateOneRequiredWithoutMembershipsNestedInput",
		role:"WorkspaceRoleUpdateOneRequiredWithoutMembershipsNestedInput"
	},
	WorkspaceUpdateOneRequiredWithoutMembershipsNestedInput:{
		create:"WorkspaceCreateWithoutMembershipsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutMembershipsInput",
		upsert:"WorkspaceUpsertWithoutMembershipsInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutMembershipsInput"
	},
	WorkspaceUpsertWithoutMembershipsInput:{
		update:"WorkspaceUpdateWithoutMembershipsInput",
		create:"WorkspaceCreateWithoutMembershipsInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutMembershipsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	BookingUpdateManyWithoutWorkspaceNestedInput:{
		create:"BookingCreateWithoutWorkspaceInput",
		connectOrCreate:"BookingCreateOrConnectWithoutWorkspaceInput",
		upsert:"BookingUpsertWithWhereUniqueWithoutWorkspaceInput",
		createMany:"BookingCreateManyWorkspaceInputEnvelope",
		set:"BookingWhereUniqueInput",
		disconnect:"BookingWhereUniqueInput",
		delete:"BookingWhereUniqueInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateWithWhereUniqueWithoutWorkspaceInput",
		updateMany:"BookingUpdateManyWithWhereWithoutWorkspaceInput",
		deleteMany:"BookingScalarWhereInput"
	},
	BookingUpsertWithWhereUniqueWithoutWorkspaceInput:{
		where:"BookingWhereUniqueInput",
		update:"BookingUpdateWithoutWorkspaceInput",
		create:"BookingCreateWithoutWorkspaceInput"
	},
	BookingUpdateWithoutWorkspaceInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	ChangelogUpdateManyWithoutBookingNestedInput:{
		create:"ChangelogCreateWithoutBookingInput",
		connectOrCreate:"ChangelogCreateOrConnectWithoutBookingInput",
		upsert:"ChangelogUpsertWithWhereUniqueWithoutBookingInput",
		createMany:"ChangelogCreateManyBookingInputEnvelope",
		set:"ChangelogWhereUniqueInput",
		disconnect:"ChangelogWhereUniqueInput",
		delete:"ChangelogWhereUniqueInput",
		connect:"ChangelogWhereUniqueInput",
		update:"ChangelogUpdateWithWhereUniqueWithoutBookingInput",
		updateMany:"ChangelogUpdateManyWithWhereWithoutBookingInput",
		deleteMany:"ChangelogScalarWhereInput"
	},
	ChangelogUpsertWithWhereUniqueWithoutBookingInput:{
		where:"ChangelogWhereUniqueInput",
		update:"ChangelogUpdateWithoutBookingInput",
		create:"ChangelogCreateWithoutBookingInput"
	},
	ChangelogUpdateWithoutBookingInput:{
		createdAt:"DateTime",
		updates:"JSON",
		user:"UserUpdateOneRequiredWithoutChangelogsNestedInput"
	},
	UserUpdateOneRequiredWithoutChangelogsNestedInput:{
		create:"UserCreateWithoutChangelogsInput",
		connectOrCreate:"UserCreateOrConnectWithoutChangelogsInput",
		upsert:"UserUpsertWithoutChangelogsInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutChangelogsInput"
	},
	UserUpsertWithoutChangelogsInput:{
		update:"UserUpdateWithoutChangelogsInput",
		create:"UserCreateWithoutChangelogsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutChangelogsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	NotificationUpdateManyWithoutRecipientNestedInput:{
		create:"NotificationCreateWithoutRecipientInput",
		connectOrCreate:"NotificationCreateOrConnectWithoutRecipientInput",
		upsert:"NotificationUpsertWithWhereUniqueWithoutRecipientInput",
		createMany:"NotificationCreateManyRecipientInputEnvelope",
		set:"NotificationWhereUniqueInput",
		disconnect:"NotificationWhereUniqueInput",
		delete:"NotificationWhereUniqueInput",
		connect:"NotificationWhereUniqueInput",
		update:"NotificationUpdateWithWhereUniqueWithoutRecipientInput",
		updateMany:"NotificationUpdateManyWithWhereWithoutRecipientInput",
		deleteMany:"NotificationScalarWhereInput"
	},
	NotificationUpsertWithWhereUniqueWithoutRecipientInput:{
		where:"NotificationWhereUniqueInput",
		update:"NotificationUpdateWithoutRecipientInput",
		create:"NotificationCreateWithoutRecipientInput"
	},
	NotificationUpdateWithoutRecipientInput:{
		type:"NotificationType",
		metadata:"JSON",
		createdAt:"DateTime",
		readAt:"DateTime",
		channels:"NotificationChannel"
	},
	NotificationUpdateWithWhereUniqueWithoutRecipientInput:{
		where:"NotificationWhereUniqueInput",
		data:"NotificationUpdateWithoutRecipientInput"
	},
	NotificationUpdateManyWithWhereWithoutRecipientInput:{
		where:"NotificationScalarWhereInput",
		data:"NotificationUpdateManyMutationInput"
	},
	NotificationScalarWhereInput:{
		AND:"NotificationScalarWhereInput",
		OR:"NotificationScalarWhereInput",
		NOT:"NotificationScalarWhereInput",
		id:"StringFilter",
		type:"EnumNotificationTypeFilter",
		title:"StringFilter",
		content:"StringFilter",
		metadata:"JsonNullableFilter",
		createdAt:"DateTimeFilter",
		readAt:"DateTimeNullableFilter",
		recipientId:"StringFilter",
		channels:"EnumNotificationChannelNullableListFilter"
	},
	NotificationUpdateManyMutationInput:{
		type:"NotificationType",
		metadata:"JSON",
		createdAt:"DateTime",
		readAt:"DateTime",
		channels:"NotificationChannel"
	},
	AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput:{
		create:"AdBoardPublishHistoryCreateWithoutPublishedByInput",
		connectOrCreate:"AdBoardPublishHistoryCreateOrConnectWithoutPublishedByInput",
		upsert:"AdBoardPublishHistoryUpsertWithWhereUniqueWithoutPublishedByInput",
		createMany:"AdBoardPublishHistoryCreateManyPublishedByInputEnvelope",
		set:"AdBoardPublishHistoryWhereUniqueInput",
		disconnect:"AdBoardPublishHistoryWhereUniqueInput",
		delete:"AdBoardPublishHistoryWhereUniqueInput",
		connect:"AdBoardPublishHistoryWhereUniqueInput",
		update:"AdBoardPublishHistoryUpdateWithWhereUniqueWithoutPublishedByInput",
		updateMany:"AdBoardPublishHistoryUpdateManyWithWhereWithoutPublishedByInput",
		deleteMany:"AdBoardPublishHistoryScalarWhereInput"
	},
	AdBoardPublishHistoryUpsertWithWhereUniqueWithoutPublishedByInput:{
		where:"AdBoardPublishHistoryWhereUniqueInput",
		update:"AdBoardPublishHistoryUpdateWithoutPublishedByInput",
		create:"AdBoardPublishHistoryCreateWithoutPublishedByInput"
	},
	AdBoardPublishHistoryUpdateWithoutPublishedByInput:{
		publishedAt:"DateTime",
		changesSnapshot:"JSON",
		adBoard:"AdBoardUpdateOneRequiredWithoutHistoryNestedInput"
	},
	AdBoardUpdateOneRequiredWithoutHistoryNestedInput:{
		create:"AdBoardCreateWithoutHistoryInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutHistoryInput",
		upsert:"AdBoardUpsertWithoutHistoryInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateToOneWithWhereWithoutHistoryInput"
	},
	AdBoardUpsertWithoutHistoryInput:{
		update:"AdBoardUpdateWithoutHistoryInput",
		create:"AdBoardCreateWithoutHistoryInput",
		where:"AdBoardWhereInput"
	},
	AdBoardUpdateWithoutHistoryInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	AdBoardUpdateOneWithoutDraftAdboardNestedInput:{
		create:"AdBoardCreateWithoutDraftAdboardInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutDraftAdboardInput",
		upsert:"AdBoardUpsertWithoutDraftAdboardInput",
		delete:"AdBoardWhereInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateToOneWithWhereWithoutDraftAdboardInput"
	},
	AdBoardUpsertWithoutDraftAdboardInput:{
		update:"AdBoardUpdateWithoutDraftAdboardInput",
		create:"AdBoardCreateWithoutDraftAdboardInput",
		where:"AdBoardWhereInput"
	},
	AdBoardUpdateWithoutDraftAdboardInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput:{
		create:"AdBoardPublishHistoryCreateWithoutAdBoardInput",
		connectOrCreate:"AdBoardPublishHistoryCreateOrConnectWithoutAdBoardInput",
		upsert:"AdBoardPublishHistoryUpsertWithWhereUniqueWithoutAdBoardInput",
		createMany:"AdBoardPublishHistoryCreateManyAdBoardInputEnvelope",
		set:"AdBoardPublishHistoryWhereUniqueInput",
		disconnect:"AdBoardPublishHistoryWhereUniqueInput",
		delete:"AdBoardPublishHistoryWhereUniqueInput",
		connect:"AdBoardPublishHistoryWhereUniqueInput",
		update:"AdBoardPublishHistoryUpdateWithWhereUniqueWithoutAdBoardInput",
		updateMany:"AdBoardPublishHistoryUpdateManyWithWhereWithoutAdBoardInput",
		deleteMany:"AdBoardPublishHistoryScalarWhereInput"
	},
	AdBoardPublishHistoryUpsertWithWhereUniqueWithoutAdBoardInput:{
		where:"AdBoardPublishHistoryWhereUniqueInput",
		update:"AdBoardPublishHistoryUpdateWithoutAdBoardInput",
		create:"AdBoardPublishHistoryCreateWithoutAdBoardInput"
	},
	AdBoardPublishHistoryUpdateWithoutAdBoardInput:{
		publishedAt:"DateTime",
		changesSnapshot:"JSON",
		publishedBy:"UserUpdateOneRequiredWithoutPublishAdboardVersionNestedInput"
	},
	UserUpdateOneRequiredWithoutPublishAdboardVersionNestedInput:{
		create:"UserCreateWithoutPublishAdboardVersionInput",
		connectOrCreate:"UserCreateOrConnectWithoutPublishAdboardVersionInput",
		upsert:"UserUpsertWithoutPublishAdboardVersionInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutPublishAdboardVersionInput"
	},
	UserUpsertWithoutPublishAdboardVersionInput:{
		update:"UserUpdateWithoutPublishAdboardVersionInput",
		create:"UserCreateWithoutPublishAdboardVersionInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutPublishAdboardVersionInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	AdBoardReviewCommentUpdateManyWithoutUserNestedInput:{
		create:"AdBoardReviewCommentCreateWithoutUserInput",
		connectOrCreate:"AdBoardReviewCommentCreateOrConnectWithoutUserInput",
		upsert:"AdBoardReviewCommentUpsertWithWhereUniqueWithoutUserInput",
		createMany:"AdBoardReviewCommentCreateManyUserInputEnvelope",
		set:"AdBoardReviewCommentWhereUniqueInput",
		disconnect:"AdBoardReviewCommentWhereUniqueInput",
		delete:"AdBoardReviewCommentWhereUniqueInput",
		connect:"AdBoardReviewCommentWhereUniqueInput",
		update:"AdBoardReviewCommentUpdateWithWhereUniqueWithoutUserInput",
		updateMany:"AdBoardReviewCommentUpdateManyWithWhereWithoutUserInput",
		deleteMany:"AdBoardReviewCommentScalarWhereInput"
	},
	AdBoardReviewCommentUpsertWithWhereUniqueWithoutUserInput:{
		where:"AdBoardReviewCommentWhereUniqueInput",
		update:"AdBoardReviewCommentUpdateWithoutUserInput",
		create:"AdBoardReviewCommentCreateWithoutUserInput"
	},
	AdBoardReviewCommentUpdateWithoutUserInput:{
		action:"ReviewAction",
		createdAt:"DateTime",
		adBoard:"AdBoardUpdateOneRequiredWithoutReviewCommentsNestedInput"
	},
	AdBoardUpdateOneRequiredWithoutReviewCommentsNestedInput:{
		create:"AdBoardCreateWithoutReviewCommentsInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutReviewCommentsInput",
		upsert:"AdBoardUpsertWithoutReviewCommentsInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateToOneWithWhereWithoutReviewCommentsInput"
	},
	AdBoardUpsertWithoutReviewCommentsInput:{
		update:"AdBoardUpdateWithoutReviewCommentsInput",
		create:"AdBoardCreateWithoutReviewCommentsInput",
		where:"AdBoardWhereInput"
	},
	AdBoardUpdateWithoutReviewCommentsInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	AdBoardUpdateOneWithoutPublishedVersionNestedInput:{
		create:"AdBoardCreateWithoutPublishedVersionInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutPublishedVersionInput",
		upsert:"AdBoardUpsertWithoutPublishedVersionInput",
		disconnect:"AdBoardWhereInput",
		delete:"AdBoardWhereInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateToOneWithWhereWithoutPublishedVersionInput"
	},
	AdBoardUpsertWithoutPublishedVersionInput:{
		update:"AdBoardUpdateWithoutPublishedVersionInput",
		create:"AdBoardCreateWithoutPublishedVersionInput",
		where:"AdBoardWhereInput"
	},
	AdBoardUpdateWithoutPublishedVersionInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput:{
		create:"AdBoardReviewCommentCreateWithoutAdBoardInput",
		connectOrCreate:"AdBoardReviewCommentCreateOrConnectWithoutAdBoardInput",
		upsert:"AdBoardReviewCommentUpsertWithWhereUniqueWithoutAdBoardInput",
		createMany:"AdBoardReviewCommentCreateManyAdBoardInputEnvelope",
		set:"AdBoardReviewCommentWhereUniqueInput",
		disconnect:"AdBoardReviewCommentWhereUniqueInput",
		delete:"AdBoardReviewCommentWhereUniqueInput",
		connect:"AdBoardReviewCommentWhereUniqueInput",
		update:"AdBoardReviewCommentUpdateWithWhereUniqueWithoutAdBoardInput",
		updateMany:"AdBoardReviewCommentUpdateManyWithWhereWithoutAdBoardInput",
		deleteMany:"AdBoardReviewCommentScalarWhereInput"
	},
	AdBoardReviewCommentUpsertWithWhereUniqueWithoutAdBoardInput:{
		where:"AdBoardReviewCommentWhereUniqueInput",
		update:"AdBoardReviewCommentUpdateWithoutAdBoardInput",
		create:"AdBoardReviewCommentCreateWithoutAdBoardInput"
	},
	AdBoardReviewCommentUpdateWithoutAdBoardInput:{
		action:"ReviewAction",
		createdAt:"DateTime",
		user:"UserUpdateOneRequiredWithoutReviewCommentsNestedInput"
	},
	UserUpdateOneRequiredWithoutReviewCommentsNestedInput:{
		create:"UserCreateWithoutReviewCommentsInput",
		connectOrCreate:"UserCreateOrConnectWithoutReviewCommentsInput",
		upsert:"UserUpsertWithoutReviewCommentsInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutReviewCommentsInput"
	},
	UserUpsertWithoutReviewCommentsInput:{
		update:"UserUpdateWithoutReviewCommentsInput",
		create:"UserCreateWithoutReviewCommentsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutReviewCommentsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	AdBoardUpdateManyWithoutArchivedByNestedInput:{
		create:"AdBoardCreateWithoutArchivedByInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutArchivedByInput",
		upsert:"AdBoardUpsertWithWhereUniqueWithoutArchivedByInput",
		createMany:"AdBoardCreateManyArchivedByInputEnvelope",
		set:"AdBoardWhereUniqueInput",
		disconnect:"AdBoardWhereUniqueInput",
		delete:"AdBoardWhereUniqueInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithWhereUniqueWithoutArchivedByInput",
		updateMany:"AdBoardUpdateManyWithWhereWithoutArchivedByInput",
		deleteMany:"AdBoardScalarWhereInput"
	},
	AdBoardUpsertWithWhereUniqueWithoutArchivedByInput:{
		where:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithoutArchivedByInput",
		create:"AdBoardCreateWithoutArchivedByInput"
	},
	AdBoardUpdateWithoutArchivedByInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput:{
		create:"AdBoardPublicReviewCreateWithoutAdBoardInput",
		connectOrCreate:"AdBoardPublicReviewCreateOrConnectWithoutAdBoardInput",
		upsert:"AdBoardPublicReviewUpsertWithWhereUniqueWithoutAdBoardInput",
		createMany:"AdBoardPublicReviewCreateManyAdBoardInputEnvelope",
		set:"AdBoardPublicReviewWhereUniqueInput",
		disconnect:"AdBoardPublicReviewWhereUniqueInput",
		delete:"AdBoardPublicReviewWhereUniqueInput",
		connect:"AdBoardPublicReviewWhereUniqueInput",
		update:"AdBoardPublicReviewUpdateWithWhereUniqueWithoutAdBoardInput",
		updateMany:"AdBoardPublicReviewUpdateManyWithWhereWithoutAdBoardInput",
		deleteMany:"AdBoardPublicReviewScalarWhereInput"
	},
	AdBoardPublicReviewUpsertWithWhereUniqueWithoutAdBoardInput:{
		where:"AdBoardPublicReviewWhereUniqueInput",
		update:"AdBoardPublicReviewUpdateWithoutAdBoardInput",
		create:"AdBoardPublicReviewCreateWithoutAdBoardInput"
	},
	AdBoardPublicReviewUpdateWithoutAdBoardInput:{
		createdAt:"DateTime",
		user:"UserUpdateOneRequiredWithoutPublicReviewsNestedInput",
		booking:"BookingUpdateOneRequiredWithoutReviewNestedInput"
	},
	UserUpdateOneRequiredWithoutPublicReviewsNestedInput:{
		create:"UserCreateWithoutPublicReviewsInput",
		connectOrCreate:"UserCreateOrConnectWithoutPublicReviewsInput",
		upsert:"UserUpsertWithoutPublicReviewsInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutPublicReviewsInput"
	},
	UserUpsertWithoutPublicReviewsInput:{
		update:"UserUpdateWithoutPublicReviewsInput",
		create:"UserCreateWithoutPublicReviewsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutPublicReviewsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	WorkspaceUpdateManyWithoutOwnerNestedInput:{
		create:"WorkspaceCreateWithoutOwnerInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutOwnerInput",
		upsert:"WorkspaceUpsertWithWhereUniqueWithoutOwnerInput",
		createMany:"WorkspaceCreateManyOwnerInputEnvelope",
		set:"WorkspaceWhereUniqueInput",
		disconnect:"WorkspaceWhereUniqueInput",
		delete:"WorkspaceWhereUniqueInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateWithWhereUniqueWithoutOwnerInput",
		updateMany:"WorkspaceUpdateManyWithWhereWithoutOwnerInput",
		deleteMany:"WorkspaceScalarWhereInput"
	},
	WorkspaceUpsertWithWhereUniqueWithoutOwnerInput:{
		where:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateWithoutOwnerInput",
		create:"WorkspaceCreateWithoutOwnerInput"
	},
	WorkspaceUpdateWithoutOwnerInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	FileUpdateManyWithoutWorkspaceNestedInput:{
		create:"FileCreateWithoutWorkspaceInput",
		connectOrCreate:"FileCreateOrConnectWithoutWorkspaceInput",
		upsert:"FileUpsertWithWhereUniqueWithoutWorkspaceInput",
		createMany:"FileCreateManyWorkspaceInputEnvelope",
		set:"FileWhereUniqueInput",
		disconnect:"FileWhereUniqueInput",
		delete:"FileWhereUniqueInput",
		connect:"FileWhereUniqueInput",
		update:"FileUpdateWithWhereUniqueWithoutWorkspaceInput",
		updateMany:"FileUpdateManyWithWhereWithoutWorkspaceInput",
		deleteMany:"FileScalarWhereInput"
	},
	FileUpsertWithWhereUniqueWithoutWorkspaceInput:{
		where:"FileWhereUniqueInput",
		update:"FileUpdateWithoutWorkspaceInput",
		create:"FileCreateWithoutWorkspaceInput"
	},
	FileUpdateWithoutWorkspaceInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserUpdateOneWithoutUpdatedFilesNestedInput",
		createdBy:"UserUpdateOneRequiredWithoutCreatedFilesNestedInput",
		bookings:"BookingUpdateManyWithoutAssetsNestedInput",
		proofBooking:"BookingUpdateOneWithoutProofsNestedInput",
		campaigns:"CampaignUpdateManyWithoutAssetsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutAssetsNestedInput"
	},
	BookingUpdateOneWithoutProofsNestedInput:{
		create:"BookingCreateWithoutProofsInput",
		connectOrCreate:"BookingCreateOrConnectWithoutProofsInput",
		upsert:"BookingUpsertWithoutProofsInput",
		delete:"BookingWhereInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateToOneWithWhereWithoutProofsInput"
	},
	BookingUpsertWithoutProofsInput:{
		update:"BookingUpdateWithoutProofsInput",
		create:"BookingCreateWithoutProofsInput",
		where:"BookingWhereInput"
	},
	BookingUpdateWithoutProofsInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	WorkspaceUpdateOneWithoutBookingsNestedInput:{
		create:"WorkspaceCreateWithoutBookingsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutBookingsInput",
		upsert:"WorkspaceUpsertWithoutBookingsInput",
		delete:"WorkspaceWhereInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutBookingsInput"
	},
	WorkspaceUpsertWithoutBookingsInput:{
		update:"WorkspaceUpdateWithoutBookingsInput",
		create:"WorkspaceCreateWithoutBookingsInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutBookingsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	PlayerUpdateManyWithoutWorkspaceNestedInput:{
		create:"PlayerCreateWithoutWorkspaceInput",
		connectOrCreate:"PlayerCreateOrConnectWithoutWorkspaceInput",
		upsert:"PlayerUpsertWithWhereUniqueWithoutWorkspaceInput",
		createMany:"PlayerCreateManyWorkspaceInputEnvelope",
		set:"PlayerWhereUniqueInput",
		disconnect:"PlayerWhereUniqueInput",
		delete:"PlayerWhereUniqueInput",
		connect:"PlayerWhereUniqueInput",
		update:"PlayerUpdateWithWhereUniqueWithoutWorkspaceInput",
		updateMany:"PlayerUpdateManyWithWhereWithoutWorkspaceInput",
		deleteMany:"PlayerScalarWhereInput"
	},
	PlayerUpsertWithWhereUniqueWithoutWorkspaceInput:{
		where:"PlayerWhereUniqueInput",
		update:"PlayerUpdateWithoutWorkspaceInput",
		create:"PlayerCreateWithoutWorkspaceInput"
	},
	PlayerUpdateWithoutWorkspaceInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutPisignagePlayersNestedInput",
		status:"PlayerUptimeStatusUpdateManyWithoutPlayerNestedInput",
		cameras:"CameraUpdateManyWithoutPlayerNestedInput",
		signageType:"DigitalSignageUpdateOneWithoutPlayersNestedInput",
		audienceType:"AudienceUpdateManyWithoutPlayersNestedInput",
		adBoards:"AdBoardUpdateManyWithoutPlayersNestedInput",
		deletedBy:"UserUpdateOneWithoutDeletedPlayerIdsNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutPlayerNestedInput"
	},
	PlayerUptimeStatusUpdateManyWithoutPlayerNestedInput:{
		create:"PlayerUptimeStatusCreateWithoutPlayerInput",
		connectOrCreate:"PlayerUptimeStatusCreateOrConnectWithoutPlayerInput",
		upsert:"PlayerUptimeStatusUpsertWithWhereUniqueWithoutPlayerInput",
		createMany:"PlayerUptimeStatusCreateManyPlayerInputEnvelope",
		set:"PlayerUptimeStatusWhereUniqueInput",
		disconnect:"PlayerUptimeStatusWhereUniqueInput",
		delete:"PlayerUptimeStatusWhereUniqueInput",
		connect:"PlayerUptimeStatusWhereUniqueInput",
		update:"PlayerUptimeStatusUpdateWithWhereUniqueWithoutPlayerInput",
		updateMany:"PlayerUptimeStatusUpdateManyWithWhereWithoutPlayerInput",
		deleteMany:"PlayerUptimeStatusScalarWhereInput"
	},
	PlayerUptimeStatusUpsertWithWhereUniqueWithoutPlayerInput:{
		where:"PlayerUptimeStatusWhereUniqueInput",
		update:"PlayerUptimeStatusUpdateWithoutPlayerInput",
		create:"PlayerUptimeStatusCreateWithoutPlayerInput"
	},
	PlayerUptimeStatusUpdateWithoutPlayerInput:{

	},
	PlayerUptimeStatusUpdateWithWhereUniqueWithoutPlayerInput:{
		where:"PlayerUptimeStatusWhereUniqueInput",
		data:"PlayerUptimeStatusUpdateWithoutPlayerInput"
	},
	PlayerUptimeStatusUpdateManyWithWhereWithoutPlayerInput:{
		where:"PlayerUptimeStatusScalarWhereInput",
		data:"PlayerUptimeStatusUpdateManyMutationInput"
	},
	PlayerUptimeStatusScalarWhereInput:{
		AND:"PlayerUptimeStatusScalarWhereInput",
		OR:"PlayerUptimeStatusScalarWhereInput",
		NOT:"PlayerUptimeStatusScalarWhereInput",
		id:"StringFilter",
		playerId:"StringFilter",
		cpuSerialNumber:"StringFilter",
		date:"StringFilter",
		uptime:"FloatFilter"
	},
	PlayerUptimeStatusUpdateManyMutationInput:{

	},
	CameraUpdateManyWithoutPlayerNestedInput:{
		create:"CameraCreateWithoutPlayerInput",
		connectOrCreate:"CameraCreateOrConnectWithoutPlayerInput",
		upsert:"CameraUpsertWithWhereUniqueWithoutPlayerInput",
		createMany:"CameraCreateManyPlayerInputEnvelope",
		set:"CameraWhereUniqueInput",
		disconnect:"CameraWhereUniqueInput",
		delete:"CameraWhereUniqueInput",
		connect:"CameraWhereUniqueInput",
		update:"CameraUpdateWithWhereUniqueWithoutPlayerInput",
		updateMany:"CameraUpdateManyWithWhereWithoutPlayerInput",
		deleteMany:"CameraScalarWhereInput"
	},
	CameraUpsertWithWhereUniqueWithoutPlayerInput:{
		where:"CameraWhereUniqueInput",
		update:"CameraUpdateWithoutPlayerInput",
		create:"CameraCreateWithoutPlayerInput"
	},
	CameraUpdateWithoutPlayerInput:{
		createdAt:"DateTime",
		updatedAt:"DateTime",
		workspace:"WorkspaceUpdateOneWithoutCamerasNestedInput"
	},
	WorkspaceUpdateOneWithoutCamerasNestedInput:{
		create:"WorkspaceCreateWithoutCamerasInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutCamerasInput",
		upsert:"WorkspaceUpsertWithoutCamerasInput",
		delete:"WorkspaceWhereInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutCamerasInput"
	},
	WorkspaceUpsertWithoutCamerasInput:{
		update:"WorkspaceUpdateWithoutCamerasInput",
		create:"WorkspaceCreateWithoutCamerasInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutCamerasInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	TransactionUpdateManyWithoutWorkspaceNestedInput:{
		create:"TransactionCreateWithoutWorkspaceInput",
		connectOrCreate:"TransactionCreateOrConnectWithoutWorkspaceInput",
		upsert:"TransactionUpsertWithWhereUniqueWithoutWorkspaceInput",
		createMany:"TransactionCreateManyWorkspaceInputEnvelope",
		set:"TransactionWhereUniqueInput",
		disconnect:"TransactionWhereUniqueInput",
		delete:"TransactionWhereUniqueInput",
		connect:"TransactionWhereUniqueInput",
		update:"TransactionUpdateWithWhereUniqueWithoutWorkspaceInput",
		updateMany:"TransactionUpdateManyWithWhereWithoutWorkspaceInput",
		deleteMany:"TransactionScalarWhereInput"
	},
	TransactionUpsertWithWhereUniqueWithoutWorkspaceInput:{
		where:"TransactionWhereUniqueInput",
		update:"TransactionUpdateWithoutWorkspaceInput",
		create:"TransactionCreateWithoutWorkspaceInput"
	},
	TransactionUpdateWithoutWorkspaceInput:{
		createAt:"DateTime",
		processedAt:"DateTime",
		transactionStatus:"TransactionStatus",
		details:"JSON",
		payouts:"PayoutUpdateManyWithoutTransactionNestedInput"
	},
	PayoutUpdateManyWithoutTransactionNestedInput:{
		create:"PayoutCreateWithoutTransactionInput",
		connectOrCreate:"PayoutCreateOrConnectWithoutTransactionInput",
		upsert:"PayoutUpsertWithWhereUniqueWithoutTransactionInput",
		createMany:"PayoutCreateManyTransactionInputEnvelope",
		set:"PayoutWhereUniqueInput",
		disconnect:"PayoutWhereUniqueInput",
		delete:"PayoutWhereUniqueInput",
		connect:"PayoutWhereUniqueInput",
		update:"PayoutUpdateWithWhereUniqueWithoutTransactionInput",
		updateMany:"PayoutUpdateManyWithWhereWithoutTransactionInput",
		deleteMany:"PayoutScalarWhereInput"
	},
	PayoutUpsertWithWhereUniqueWithoutTransactionInput:{
		where:"PayoutWhereUniqueInput",
		update:"PayoutUpdateWithoutTransactionInput",
		create:"PayoutCreateWithoutTransactionInput"
	},
	PayoutUpdateWithoutTransactionInput:{
		createdAt:"DateTime",
		status:"PayoutStatus",
		booking:"BookingUpdateOneRequiredWithoutPayoutsNestedInput"
	},
	BookingUpdateOneRequiredWithoutPayoutsNestedInput:{
		create:"BookingCreateWithoutPayoutsInput",
		connectOrCreate:"BookingCreateOrConnectWithoutPayoutsInput",
		upsert:"BookingUpsertWithoutPayoutsInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateToOneWithWhereWithoutPayoutsInput"
	},
	BookingUpsertWithoutPayoutsInput:{
		update:"BookingUpdateWithoutPayoutsInput",
		create:"BookingCreateWithoutPayoutsInput",
		where:"BookingWhereInput"
	},
	BookingUpdateWithoutPayoutsInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	CampaignUpdateOneWithoutBookingsNestedInput:{
		create:"CampaignCreateWithoutBookingsInput",
		connectOrCreate:"CampaignCreateOrConnectWithoutBookingsInput",
		upsert:"CampaignUpsertWithoutBookingsInput",
		delete:"CampaignWhereInput",
		connect:"CampaignWhereUniqueInput",
		update:"CampaignUpdateToOneWithWhereWithoutBookingsInput"
	},
	CampaignUpsertWithoutBookingsInput:{
		update:"CampaignUpdateWithoutBookingsInput",
		create:"CampaignCreateWithoutBookingsInput",
		where:"CampaignWhereInput"
	},
	CampaignUpdateWithoutBookingsInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		businessCategory:"BusinessCategoryUpdateOneRequiredWithoutCampaignsNestedInput",
		user:"UserUpdateOneRequiredWithoutCampaignsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutCampaignsNestedInput",
		payments:"PaymentUpdateManyWithoutCampaignNestedInput",
		assets:"FileUpdateManyWithoutCampaignsNestedInput"
	},
	PaymentUpdateManyWithoutCampaignNestedInput:{
		create:"PaymentCreateWithoutCampaignInput",
		connectOrCreate:"PaymentCreateOrConnectWithoutCampaignInput",
		upsert:"PaymentUpsertWithWhereUniqueWithoutCampaignInput",
		createMany:"PaymentCreateManyCampaignInputEnvelope",
		set:"PaymentWhereUniqueInput",
		disconnect:"PaymentWhereUniqueInput",
		delete:"PaymentWhereUniqueInput",
		connect:"PaymentWhereUniqueInput",
		update:"PaymentUpdateWithWhereUniqueWithoutCampaignInput",
		updateMany:"PaymentUpdateManyWithWhereWithoutCampaignInput",
		deleteMany:"PaymentScalarWhereInput"
	},
	PaymentUpsertWithWhereUniqueWithoutCampaignInput:{
		where:"PaymentWhereUniqueInput",
		update:"PaymentUpdateWithoutCampaignInput",
		create:"PaymentCreateWithoutCampaignInput"
	},
	PaymentUpdateWithoutCampaignInput:{
		paymentGateway:"PaymentGatewayName",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutPaymentNestedInput"
	},
	PaymentAllocationUpdateManyWithoutPaymentNestedInput:{
		create:"PaymentAllocationCreateWithoutPaymentInput",
		connectOrCreate:"PaymentAllocationCreateOrConnectWithoutPaymentInput",
		upsert:"PaymentAllocationUpsertWithWhereUniqueWithoutPaymentInput",
		createMany:"PaymentAllocationCreateManyPaymentInputEnvelope",
		set:"PaymentAllocationWhereUniqueInput",
		disconnect:"PaymentAllocationWhereUniqueInput",
		delete:"PaymentAllocationWhereUniqueInput",
		connect:"PaymentAllocationWhereUniqueInput",
		update:"PaymentAllocationUpdateWithWhereUniqueWithoutPaymentInput",
		updateMany:"PaymentAllocationUpdateManyWithWhereWithoutPaymentInput",
		deleteMany:"PaymentAllocationScalarWhereInput"
	},
	PaymentAllocationUpsertWithWhereUniqueWithoutPaymentInput:{
		where:"PaymentAllocationWhereUniqueInput",
		update:"PaymentAllocationUpdateWithoutPaymentInput",
		create:"PaymentAllocationCreateWithoutPaymentInput"
	},
	PaymentAllocationUpdateWithoutPaymentInput:{
		booking:"BookingUpdateOneRequiredWithoutPaymentAllocationsNestedInput"
	},
	BookingUpdateOneRequiredWithoutPaymentAllocationsNestedInput:{
		create:"BookingCreateWithoutPaymentAllocationsInput",
		connectOrCreate:"BookingCreateOrConnectWithoutPaymentAllocationsInput",
		upsert:"BookingUpsertWithoutPaymentAllocationsInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateToOneWithWhereWithoutPaymentAllocationsInput"
	},
	BookingUpsertWithoutPaymentAllocationsInput:{
		update:"BookingUpdateWithoutPaymentAllocationsInput",
		create:"BookingCreateWithoutPaymentAllocationsInput",
		where:"BookingWhereInput"
	},
	BookingUpdateWithoutPaymentAllocationsInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	PayoutUpdateManyWithoutBookingNestedInput:{
		create:"PayoutCreateWithoutBookingInput",
		connectOrCreate:"PayoutCreateOrConnectWithoutBookingInput",
		upsert:"PayoutUpsertWithWhereUniqueWithoutBookingInput",
		createMany:"PayoutCreateManyBookingInputEnvelope",
		set:"PayoutWhereUniqueInput",
		disconnect:"PayoutWhereUniqueInput",
		delete:"PayoutWhereUniqueInput",
		connect:"PayoutWhereUniqueInput",
		update:"PayoutUpdateWithWhereUniqueWithoutBookingInput",
		updateMany:"PayoutUpdateManyWithWhereWithoutBookingInput",
		deleteMany:"PayoutScalarWhereInput"
	},
	PayoutUpsertWithWhereUniqueWithoutBookingInput:{
		where:"PayoutWhereUniqueInput",
		update:"PayoutUpdateWithoutBookingInput",
		create:"PayoutCreateWithoutBookingInput"
	},
	PayoutUpdateWithoutBookingInput:{
		createdAt:"DateTime",
		status:"PayoutStatus",
		transaction:"TransactionUpdateOneWithoutPayoutsNestedInput"
	},
	TransactionUpdateOneWithoutPayoutsNestedInput:{
		create:"TransactionCreateWithoutPayoutsInput",
		connectOrCreate:"TransactionCreateOrConnectWithoutPayoutsInput",
		upsert:"TransactionUpsertWithoutPayoutsInput",
		delete:"TransactionWhereInput",
		connect:"TransactionWhereUniqueInput",
		update:"TransactionUpdateToOneWithWhereWithoutPayoutsInput"
	},
	TransactionUpsertWithoutPayoutsInput:{
		update:"TransactionUpdateWithoutPayoutsInput",
		create:"TransactionCreateWithoutPayoutsInput",
		where:"TransactionWhereInput"
	},
	TransactionUpdateWithoutPayoutsInput:{
		createAt:"DateTime",
		processedAt:"DateTime",
		transactionStatus:"TransactionStatus",
		details:"JSON",
		workspace:"WorkspaceUpdateOneWithoutTransactionsNestedInput"
	},
	WorkspaceUpdateOneWithoutTransactionsNestedInput:{
		create:"WorkspaceCreateWithoutTransactionsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutTransactionsInput",
		upsert:"WorkspaceUpsertWithoutTransactionsInput",
		delete:"WorkspaceWhereInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutTransactionsInput"
	},
	WorkspaceUpsertWithoutTransactionsInput:{
		update:"WorkspaceUpdateWithoutTransactionsInput",
		create:"WorkspaceCreateWithoutTransactionsInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutTransactionsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput:{
		create:"SubscriptionCreateWithoutActiveWorkspaceInput",
		connectOrCreate:"SubscriptionCreateOrConnectWithoutActiveWorkspaceInput",
		upsert:"SubscriptionUpsertWithoutActiveWorkspaceInput",
		disconnect:"SubscriptionWhereInput",
		delete:"SubscriptionWhereInput",
		connect:"SubscriptionWhereUniqueInput",
		update:"SubscriptionUpdateToOneWithWhereWithoutActiveWorkspaceInput"
	},
	SubscriptionUpsertWithoutActiveWorkspaceInput:{
		update:"SubscriptionUpdateWithoutActiveWorkspaceInput",
		create:"SubscriptionCreateWithoutActiveWorkspaceInput",
		where:"SubscriptionWhereInput"
	},
	SubscriptionUpdateWithoutActiveWorkspaceInput:{
		startDate:"DateTime",
		endDate:"DateTime",
		cancellationDetails:"CancellationDetailsCreateInput"
	},
	SubscriptionUpdateToOneWithWhereWithoutActiveWorkspaceInput:{
		where:"SubscriptionWhereInput",
		data:"SubscriptionUpdateWithoutActiveWorkspaceInput"
	},
	WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput:{
		create:"WorkspaceRoleCreateWithoutWorkspaceInput",
		connectOrCreate:"WorkspaceRoleCreateOrConnectWithoutWorkspaceInput",
		upsert:"WorkspaceRoleUpsertWithWhereUniqueWithoutWorkspaceInput",
		createMany:"WorkspaceRoleCreateManyWorkspaceInputEnvelope",
		set:"WorkspaceRoleWhereUniqueInput",
		disconnect:"WorkspaceRoleWhereUniqueInput",
		delete:"WorkspaceRoleWhereUniqueInput",
		connect:"WorkspaceRoleWhereUniqueInput",
		update:"WorkspaceRoleUpdateWithWhereUniqueWithoutWorkspaceInput",
		updateMany:"WorkspaceRoleUpdateManyWithWhereWithoutWorkspaceInput",
		deleteMany:"WorkspaceRoleScalarWhereInput"
	},
	WorkspaceRoleUpsertWithWhereUniqueWithoutWorkspaceInput:{
		where:"WorkspaceRoleWhereUniqueInput",
		update:"WorkspaceRoleUpdateWithoutWorkspaceInput",
		create:"WorkspaceRoleCreateWithoutWorkspaceInput"
	},
	WorkspaceRoleUpdateWithoutWorkspaceInput:{
		permissions:"Permission",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		memberships:"MembershipUpdateManyWithoutRoleNestedInput"
	},
	MembershipUpdateManyWithoutRoleNestedInput:{
		create:"MembershipCreateWithoutRoleInput",
		connectOrCreate:"MembershipCreateOrConnectWithoutRoleInput",
		upsert:"MembershipUpsertWithWhereUniqueWithoutRoleInput",
		createMany:"MembershipCreateManyRoleInputEnvelope",
		set:"MembershipWhereUniqueInput",
		disconnect:"MembershipWhereUniqueInput",
		delete:"MembershipWhereUniqueInput",
		connect:"MembershipWhereUniqueInput",
		update:"MembershipUpdateWithWhereUniqueWithoutRoleInput",
		updateMany:"MembershipUpdateManyWithWhereWithoutRoleInput",
		deleteMany:"MembershipScalarWhereInput"
	},
	MembershipUpsertWithWhereUniqueWithoutRoleInput:{
		where:"MembershipWhereUniqueInput",
		update:"MembershipUpdateWithoutRoleInput",
		create:"MembershipCreateWithoutRoleInput"
	},
	MembershipUpdateWithoutRoleInput:{
		createdAt:"DateTime",
		user:"UserUpdateOneRequiredWithoutMembershipsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutMembershipsNestedInput"
	},
	MembershipUpdateWithWhereUniqueWithoutRoleInput:{
		where:"MembershipWhereUniqueInput",
		data:"MembershipUpdateWithoutRoleInput"
	},
	MembershipUpdateManyWithWhereWithoutRoleInput:{
		where:"MembershipScalarWhereInput",
		data:"MembershipUpdateManyMutationInput"
	},
	MembershipScalarWhereInput:{
		AND:"MembershipScalarWhereInput",
		OR:"MembershipScalarWhereInput",
		NOT:"MembershipScalarWhereInput",
		id:"StringFilter",
		createdAt:"DateTimeFilter",
		userId:"StringFilter",
		workspaceId:"StringFilter",
		roleId:"StringFilter"
	},
	MembershipUpdateManyMutationInput:{
		createdAt:"DateTime"
	},
	WorkspaceRoleUpdateWithWhereUniqueWithoutWorkspaceInput:{
		where:"WorkspaceRoleWhereUniqueInput",
		data:"WorkspaceRoleUpdateWithoutWorkspaceInput"
	},
	WorkspaceRoleUpdateManyWithWhereWithoutWorkspaceInput:{
		where:"WorkspaceRoleScalarWhereInput",
		data:"WorkspaceRoleUpdateManyMutationInput"
	},
	WorkspaceRoleScalarWhereInput:{
		AND:"WorkspaceRoleScalarWhereInput",
		OR:"WorkspaceRoleScalarWhereInput",
		NOT:"WorkspaceRoleScalarWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		permissions:"EnumPermissionNullableListFilter",
		workspaceId:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter"
	},
	WorkspaceRoleUpdateManyMutationInput:{
		permissions:"Permission",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	UserUpdateManyWithoutLeadWorspacesNestedInput:{
		create:"UserCreateWithoutLeadWorspacesInput",
		connectOrCreate:"UserCreateOrConnectWithoutLeadWorspacesInput",
		upsert:"UserUpsertWithWhereUniqueWithoutLeadWorspacesInput",
		set:"UserWhereUniqueInput",
		disconnect:"UserWhereUniqueInput",
		delete:"UserWhereUniqueInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateWithWhereUniqueWithoutLeadWorspacesInput",
		updateMany:"UserUpdateManyWithWhereWithoutLeadWorspacesInput",
		deleteMany:"UserScalarWhereInput"
	},
	UserUpsertWithWhereUniqueWithoutLeadWorspacesInput:{
		where:"UserWhereUniqueInput",
		update:"UserUpdateWithoutLeadWorspacesInput",
		create:"UserCreateWithoutLeadWorspacesInput"
	},
	UserUpdateWithoutLeadWorspacesInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	AdBoardPublicReviewUpdateManyWithoutUserNestedInput:{
		create:"AdBoardPublicReviewCreateWithoutUserInput",
		connectOrCreate:"AdBoardPublicReviewCreateOrConnectWithoutUserInput",
		upsert:"AdBoardPublicReviewUpsertWithWhereUniqueWithoutUserInput",
		createMany:"AdBoardPublicReviewCreateManyUserInputEnvelope",
		set:"AdBoardPublicReviewWhereUniqueInput",
		disconnect:"AdBoardPublicReviewWhereUniqueInput",
		delete:"AdBoardPublicReviewWhereUniqueInput",
		connect:"AdBoardPublicReviewWhereUniqueInput",
		update:"AdBoardPublicReviewUpdateWithWhereUniqueWithoutUserInput",
		updateMany:"AdBoardPublicReviewUpdateManyWithWhereWithoutUserInput",
		deleteMany:"AdBoardPublicReviewScalarWhereInput"
	},
	AdBoardPublicReviewUpsertWithWhereUniqueWithoutUserInput:{
		where:"AdBoardPublicReviewWhereUniqueInput",
		update:"AdBoardPublicReviewUpdateWithoutUserInput",
		create:"AdBoardPublicReviewCreateWithoutUserInput"
	},
	AdBoardPublicReviewUpdateWithoutUserInput:{
		createdAt:"DateTime",
		adBoard:"AdBoardUpdateOneRequiredWithoutPublicReviewsNestedInput",
		booking:"BookingUpdateOneRequiredWithoutReviewNestedInput"
	},
	AdBoardUpdateOneRequiredWithoutPublicReviewsNestedInput:{
		create:"AdBoardCreateWithoutPublicReviewsInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutPublicReviewsInput",
		upsert:"AdBoardUpsertWithoutPublicReviewsInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateToOneWithWhereWithoutPublicReviewsInput"
	},
	AdBoardUpsertWithoutPublicReviewsInput:{
		update:"AdBoardUpdateWithoutPublicReviewsInput",
		create:"AdBoardCreateWithoutPublicReviewsInput",
		where:"AdBoardWhereInput"
	},
	AdBoardUpdateWithoutPublicReviewsInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	UserUpdateOneWithoutArchivedAdboardsNestedInput:{
		create:"UserCreateWithoutArchivedAdboardsInput",
		connectOrCreate:"UserCreateOrConnectWithoutArchivedAdboardsInput",
		upsert:"UserUpsertWithoutArchivedAdboardsInput",
		delete:"UserWhereInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutArchivedAdboardsInput"
	},
	UserUpsertWithoutArchivedAdboardsInput:{
		update:"UserUpdateWithoutArchivedAdboardsInput",
		create:"UserCreateWithoutArchivedAdboardsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutArchivedAdboardsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	WorkspaceUpdateManyWithoutLeadsNestedInput:{
		create:"WorkspaceCreateWithoutLeadsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutLeadsInput",
		upsert:"WorkspaceUpsertWithWhereUniqueWithoutLeadsInput",
		set:"WorkspaceWhereUniqueInput",
		disconnect:"WorkspaceWhereUniqueInput",
		delete:"WorkspaceWhereUniqueInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateWithWhereUniqueWithoutLeadsInput",
		updateMany:"WorkspaceUpdateManyWithWhereWithoutLeadsInput",
		deleteMany:"WorkspaceScalarWhereInput"
	},
	WorkspaceUpsertWithWhereUniqueWithoutLeadsInput:{
		where:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateWithoutLeadsInput",
		create:"WorkspaceCreateWithoutLeadsInput"
	},
	WorkspaceUpdateWithoutLeadsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	CameraUpdateManyWithoutWorkspaceNestedInput:{
		create:"CameraCreateWithoutWorkspaceInput",
		connectOrCreate:"CameraCreateOrConnectWithoutWorkspaceInput",
		upsert:"CameraUpsertWithWhereUniqueWithoutWorkspaceInput",
		createMany:"CameraCreateManyWorkspaceInputEnvelope",
		set:"CameraWhereUniqueInput",
		disconnect:"CameraWhereUniqueInput",
		delete:"CameraWhereUniqueInput",
		connect:"CameraWhereUniqueInput",
		update:"CameraUpdateWithWhereUniqueWithoutWorkspaceInput",
		updateMany:"CameraUpdateManyWithWhereWithoutWorkspaceInput",
		deleteMany:"CameraScalarWhereInput"
	},
	CameraUpsertWithWhereUniqueWithoutWorkspaceInput:{
		where:"CameraWhereUniqueInput",
		update:"CameraUpdateWithoutWorkspaceInput",
		create:"CameraCreateWithoutWorkspaceInput"
	},
	CameraUpdateWithoutWorkspaceInput:{
		createdAt:"DateTime",
		updatedAt:"DateTime",
		player:"PlayerUpdateOneWithoutCamerasNestedInput"
	},
	PlayerUpdateOneWithoutCamerasNestedInput:{
		create:"PlayerCreateWithoutCamerasInput",
		connectOrCreate:"PlayerCreateOrConnectWithoutCamerasInput",
		upsert:"PlayerUpsertWithoutCamerasInput",
		delete:"PlayerWhereInput",
		connect:"PlayerWhereUniqueInput",
		update:"PlayerUpdateToOneWithWhereWithoutCamerasInput"
	},
	PlayerUpsertWithoutCamerasInput:{
		update:"PlayerUpdateWithoutCamerasInput",
		create:"PlayerCreateWithoutCamerasInput",
		where:"PlayerWhereInput"
	},
	PlayerUpdateWithoutCamerasInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutPisignagePlayersNestedInput",
		workspace:"WorkspaceUpdateOneWithoutPlayersNestedInput",
		status:"PlayerUptimeStatusUpdateManyWithoutPlayerNestedInput",
		signageType:"DigitalSignageUpdateOneWithoutPlayersNestedInput",
		audienceType:"AudienceUpdateManyWithoutPlayersNestedInput",
		adBoards:"AdBoardUpdateManyWithoutPlayersNestedInput",
		deletedBy:"UserUpdateOneWithoutDeletedPlayerIdsNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutPlayerNestedInput"
	},
	DigitalSignageUpdateOneWithoutPlayersNestedInput:{
		create:"DigitalSignageCreateWithoutPlayersInput",
		connectOrCreate:"DigitalSignageCreateOrConnectWithoutPlayersInput",
		upsert:"DigitalSignageUpsertWithoutPlayersInput",
		delete:"DigitalSignageWhereInput",
		connect:"DigitalSignageWhereUniqueInput",
		update:"DigitalSignageUpdateToOneWithWhereWithoutPlayersInput"
	},
	DigitalSignageUpsertWithoutPlayersInput:{
		update:"DigitalSignageUpdateWithoutPlayersInput",
		create:"DigitalSignageCreateWithoutPlayersInput",
		where:"DigitalSignageWhereInput"
	},
	DigitalSignageUpdateWithoutPlayersInput:{
		type:"SignageType",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	DigitalSignageUpdateToOneWithWhereWithoutPlayersInput:{
		where:"DigitalSignageWhereInput",
		data:"DigitalSignageUpdateWithoutPlayersInput"
	},
	AudienceUpdateManyWithoutPlayersNestedInput:{
		create:"AudienceCreateWithoutPlayersInput",
		connectOrCreate:"AudienceCreateOrConnectWithoutPlayersInput",
		upsert:"AudienceUpsertWithWhereUniqueWithoutPlayersInput",
		set:"AudienceWhereUniqueInput",
		disconnect:"AudienceWhereUniqueInput",
		delete:"AudienceWhereUniqueInput",
		connect:"AudienceWhereUniqueInput",
		update:"AudienceUpdateWithWhereUniqueWithoutPlayersInput",
		updateMany:"AudienceUpdateManyWithWhereWithoutPlayersInput",
		deleteMany:"AudienceScalarWhereInput"
	},
	AudienceUpsertWithWhereUniqueWithoutPlayersInput:{
		where:"AudienceWhereUniqueInput",
		update:"AudienceUpdateWithoutPlayersInput",
		create:"AudienceCreateWithoutPlayersInput"
	},
	AudienceUpdateWithoutPlayersInput:{
		type:"AudienceType",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	AudienceUpdateWithWhereUniqueWithoutPlayersInput:{
		where:"AudienceWhereUniqueInput",
		data:"AudienceUpdateWithoutPlayersInput"
	},
	AudienceUpdateManyWithWhereWithoutPlayersInput:{
		where:"AudienceScalarWhereInput",
		data:"AudienceUpdateManyMutationInput"
	},
	AudienceScalarWhereInput:{
		AND:"AudienceScalarWhereInput",
		OR:"AudienceScalarWhereInput",
		NOT:"AudienceScalarWhereInput",
		id:"StringFilter",
		type:"EnumAudienceTypeFilter",
		name:"StringFilter",
		description:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		playerIDs:"StringNullableListFilter"
	},
	AudienceUpdateManyMutationInput:{
		type:"AudienceType",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	AdBoardUpdateManyWithoutPlayersNestedInput:{
		create:"AdBoardCreateWithoutPlayersInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutPlayersInput",
		upsert:"AdBoardUpsertWithWhereUniqueWithoutPlayersInput",
		set:"AdBoardWhereUniqueInput",
		disconnect:"AdBoardWhereUniqueInput",
		delete:"AdBoardWhereUniqueInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithWhereUniqueWithoutPlayersInput",
		updateMany:"AdBoardUpdateManyWithWhereWithoutPlayersInput",
		deleteMany:"AdBoardScalarWhereInput"
	},
	AdBoardUpsertWithWhereUniqueWithoutPlayersInput:{
		where:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithoutPlayersInput",
		create:"AdBoardCreateWithoutPlayersInput"
	},
	AdBoardUpdateWithoutPlayersInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	WishlistUpdateManyWithoutAdBoardsNestedInput:{
		create:"WishlistCreateWithoutAdBoardsInput",
		connectOrCreate:"WishlistCreateOrConnectWithoutAdBoardsInput",
		upsert:"WishlistUpsertWithWhereUniqueWithoutAdBoardsInput",
		set:"WishlistWhereUniqueInput",
		disconnect:"WishlistWhereUniqueInput",
		delete:"WishlistWhereUniqueInput",
		connect:"WishlistWhereUniqueInput",
		update:"WishlistUpdateWithWhereUniqueWithoutAdBoardsInput",
		updateMany:"WishlistUpdateManyWithWhereWithoutAdBoardsInput",
		deleteMany:"WishlistScalarWhereInput"
	},
	WishlistUpsertWithWhereUniqueWithoutAdBoardsInput:{
		where:"WishlistWhereUniqueInput",
		update:"WishlistUpdateWithoutAdBoardsInput",
		create:"WishlistCreateWithoutAdBoardsInput"
	},
	WishlistUpdateWithoutAdBoardsInput:{
		createdAt:"DateTime",
		user:"UserUpdateOneRequiredWithoutWishlistsNestedInput"
	},
	UserUpdateOneRequiredWithoutWishlistsNestedInput:{
		create:"UserCreateWithoutWishlistsInput",
		connectOrCreate:"UserCreateOrConnectWithoutWishlistsInput",
		upsert:"UserUpsertWithoutWishlistsInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutWishlistsInput"
	},
	UserUpsertWithoutWishlistsInput:{
		update:"UserUpdateWithoutWishlistsInput",
		create:"UserCreateWithoutWishlistsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutWishlistsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	UserPositionUpdateManyWithoutUserNestedInput:{
		create:"UserPositionCreateWithoutUserInput",
		connectOrCreate:"UserPositionCreateOrConnectWithoutUserInput",
		upsert:"UserPositionUpsertWithWhereUniqueWithoutUserInput",
		createMany:"UserPositionCreateManyUserInputEnvelope",
		set:"UserPositionWhereUniqueInput",
		disconnect:"UserPositionWhereUniqueInput",
		delete:"UserPositionWhereUniqueInput",
		connect:"UserPositionWhereUniqueInput",
		update:"UserPositionUpdateWithWhereUniqueWithoutUserInput",
		updateMany:"UserPositionUpdateManyWithWhereWithoutUserInput",
		deleteMany:"UserPositionScalarWhereInput"
	},
	UserPositionUpsertWithWhereUniqueWithoutUserInput:{
		where:"UserPositionWhereUniqueInput",
		update:"UserPositionUpdateWithoutUserInput",
		create:"UserPositionCreateWithoutUserInput"
	},
	UserPositionUpdateWithoutUserInput:{
		timestamp:"DateTime",
		createdAt:"DateTime",
		coords:"UserPositionCoordsCreateInput",
		location:"UserPositionLocationCreateInput"
	},
	UserPositionUpdateWithWhereUniqueWithoutUserInput:{
		where:"UserPositionWhereUniqueInput",
		data:"UserPositionUpdateWithoutUserInput"
	},
	UserPositionUpdateManyWithWhereWithoutUserInput:{
		where:"UserPositionScalarWhereInput",
		data:"UserPositionUpdateManyMutationInput"
	},
	UserPositionScalarWhereInput:{
		AND:"UserPositionScalarWhereInput",
		OR:"UserPositionScalarWhereInput",
		NOT:"UserPositionScalarWhereInput",
		id:"StringFilter",
		timestamp:"DateTimeFilter",
		createdAt:"DateTimeFilter",
		userId:"StringFilter"
	},
	UserPositionUpdateManyMutationInput:{
		timestamp:"DateTime",
		createdAt:"DateTime",
		coords:"UserPositionCoordsCreateInput",
		location:"UserPositionLocationCreateInput"
	},
	PlayerUpdateManyWithoutDeletedByNestedInput:{
		create:"PlayerCreateWithoutDeletedByInput",
		connectOrCreate:"PlayerCreateOrConnectWithoutDeletedByInput",
		upsert:"PlayerUpsertWithWhereUniqueWithoutDeletedByInput",
		createMany:"PlayerCreateManyDeletedByInputEnvelope",
		set:"PlayerWhereUniqueInput",
		disconnect:"PlayerWhereUniqueInput",
		delete:"PlayerWhereUniqueInput",
		connect:"PlayerWhereUniqueInput",
		update:"PlayerUpdateWithWhereUniqueWithoutDeletedByInput",
		updateMany:"PlayerUpdateManyWithWhereWithoutDeletedByInput",
		deleteMany:"PlayerScalarWhereInput"
	},
	PlayerUpsertWithWhereUniqueWithoutDeletedByInput:{
		where:"PlayerWhereUniqueInput",
		update:"PlayerUpdateWithoutDeletedByInput",
		create:"PlayerCreateWithoutDeletedByInput"
	},
	PlayerUpdateWithoutDeletedByInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutPisignagePlayersNestedInput",
		workspace:"WorkspaceUpdateOneWithoutPlayersNestedInput",
		status:"PlayerUptimeStatusUpdateManyWithoutPlayerNestedInput",
		cameras:"CameraUpdateManyWithoutPlayerNestedInput",
		signageType:"DigitalSignageUpdateOneWithoutPlayersNestedInput",
		audienceType:"AudienceUpdateManyWithoutPlayersNestedInput",
		adBoards:"AdBoardUpdateManyWithoutPlayersNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutPlayerNestedInput"
	},
	StreamingDeviceUpdateManyWithoutPlayerNestedInput:{
		create:"StreamingDeviceCreateWithoutPlayerInput",
		connectOrCreate:"StreamingDeviceCreateOrConnectWithoutPlayerInput",
		upsert:"StreamingDeviceUpsertWithWhereUniqueWithoutPlayerInput",
		createMany:"StreamingDeviceCreateManyPlayerInputEnvelope",
		set:"StreamingDeviceWhereUniqueInput",
		disconnect:"StreamingDeviceWhereUniqueInput",
		delete:"StreamingDeviceWhereUniqueInput",
		connect:"StreamingDeviceWhereUniqueInput",
		update:"StreamingDeviceUpdateWithWhereUniqueWithoutPlayerInput",
		updateMany:"StreamingDeviceUpdateManyWithWhereWithoutPlayerInput",
		deleteMany:"StreamingDeviceScalarWhereInput"
	},
	StreamingDeviceUpsertWithWhereUniqueWithoutPlayerInput:{
		where:"StreamingDeviceWhereUniqueInput",
		update:"StreamingDeviceUpdateWithoutPlayerInput",
		create:"StreamingDeviceCreateWithoutPlayerInput"
	},
	StreamingDeviceUpdateWithoutPlayerInput:{
		connectionLogs:"ConnectionLogCreateInput",
		billboardMonitoring:"BillboardMonitoringCreateInput",
		trafficMonitoring:"TrafficMonitoringCreateInput",
		services:"StreamingServicesCreateInput",
		workspace:"WorkspaceUpdateOneWithoutCameraStreamingDevicesNestedInput",
		billboardMonitoringAlerts:"BillboardMonitoringAlertUpdateManyWithoutStreamingDeviceNestedInput"
	},
	WorkspaceUpdateOneWithoutCameraStreamingDevicesNestedInput:{
		create:"WorkspaceCreateWithoutCameraStreamingDevicesInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutCameraStreamingDevicesInput",
		upsert:"WorkspaceUpsertWithoutCameraStreamingDevicesInput",
		delete:"WorkspaceWhereInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutCameraStreamingDevicesInput"
	},
	WorkspaceUpsertWithoutCameraStreamingDevicesInput:{
		update:"WorkspaceUpdateWithoutCameraStreamingDevicesInput",
		create:"WorkspaceCreateWithoutCameraStreamingDevicesInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutCameraStreamingDevicesInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput"
	},
	WorkspaceUpdateToOneWithWhereWithoutCameraStreamingDevicesInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutCameraStreamingDevicesInput"
	},
	BillboardMonitoringAlertUpdateManyWithoutStreamingDeviceNestedInput:{
		create:"BillboardMonitoringAlertCreateWithoutStreamingDeviceInput",
		connectOrCreate:"BillboardMonitoringAlertCreateOrConnectWithoutStreamingDeviceInput",
		upsert:"BillboardMonitoringAlertUpsertWithWhereUniqueWithoutStreamingDeviceInput",
		createMany:"BillboardMonitoringAlertCreateManyStreamingDeviceInputEnvelope",
		set:"BillboardMonitoringAlertWhereUniqueInput",
		disconnect:"BillboardMonitoringAlertWhereUniqueInput",
		delete:"BillboardMonitoringAlertWhereUniqueInput",
		connect:"BillboardMonitoringAlertWhereUniqueInput",
		update:"BillboardMonitoringAlertUpdateWithWhereUniqueWithoutStreamingDeviceInput",
		updateMany:"BillboardMonitoringAlertUpdateManyWithWhereWithoutStreamingDeviceInput",
		deleteMany:"BillboardMonitoringAlertScalarWhereInput"
	},
	BillboardMonitoringAlertUpsertWithWhereUniqueWithoutStreamingDeviceInput:{
		where:"BillboardMonitoringAlertWhereUniqueInput",
		update:"BillboardMonitoringAlertUpdateWithoutStreamingDeviceInput",
		create:"BillboardMonitoringAlertCreateWithoutStreamingDeviceInput"
	},
	BillboardMonitoringAlertUpdateWithoutStreamingDeviceInput:{
		startTime:"DateTime",
		endTime:"DateTime",
		enabledAlerts:"AlertConfigCreateInput"
	},
	BillboardMonitoringAlertUpdateWithWhereUniqueWithoutStreamingDeviceInput:{
		where:"BillboardMonitoringAlertWhereUniqueInput",
		data:"BillboardMonitoringAlertUpdateWithoutStreamingDeviceInput"
	},
	BillboardMonitoringAlertUpdateManyWithWhereWithoutStreamingDeviceInput:{
		where:"BillboardMonitoringAlertScalarWhereInput",
		data:"BillboardMonitoringAlertUpdateManyMutationInput"
	},
	BillboardMonitoringAlertScalarWhereInput:{
		AND:"BillboardMonitoringAlertScalarWhereInput",
		OR:"BillboardMonitoringAlertScalarWhereInput",
		NOT:"BillboardMonitoringAlertScalarWhereInput",
		id:"StringFilter",
		startTime:"DateTimeFilter",
		endTime:"DateTimeNullableFilter",
		isActive:"BoolFilter",
		isFalsePositive:"BoolFilter",
		streamingDeviceId:"StringFilter"
	},
	BillboardMonitoringAlertUpdateManyMutationInput:{
		startTime:"DateTime",
		endTime:"DateTime",
		enabledAlerts:"AlertConfigCreateInput"
	},
	StreamingDeviceUpdateWithWhereUniqueWithoutPlayerInput:{
		where:"StreamingDeviceWhereUniqueInput",
		data:"StreamingDeviceUpdateWithoutPlayerInput"
	},
	StreamingDeviceUpdateManyWithWhereWithoutPlayerInput:{
		where:"StreamingDeviceScalarWhereInput",
		data:"StreamingDeviceUpdateManyMutationInput"
	},
	StreamingDeviceScalarWhereInput:{
		AND:"StreamingDeviceScalarWhereInput",
		OR:"StreamingDeviceScalarWhereInput",
		NOT:"StreamingDeviceScalarWhereInput",
		id:"StringFilter",
		name:"StringNullableFilter",
		deviceId:"StringFilter",
		socketId:"StringNullableFilter",
		isConnected:"BoolNullableFilter",
		playerId:"StringNullableFilter",
		workspaceId:"StringNullableFilter",
		rtspStreamUrl:"StringNullableFilter",
		publicWebUrl:"StringNullableFilter"
	},
	StreamingDeviceUpdateManyMutationInput:{
		connectionLogs:"ConnectionLogCreateInput",
		billboardMonitoring:"BillboardMonitoringCreateInput",
		trafficMonitoring:"TrafficMonitoringCreateInput",
		services:"StreamingServicesCreateInput"
	},
	PlayerUpdateWithWhereUniqueWithoutDeletedByInput:{
		where:"PlayerWhereUniqueInput",
		data:"PlayerUpdateWithoutDeletedByInput"
	},
	PlayerUpdateManyWithWhereWithoutDeletedByInput:{
		where:"PlayerScalarWhereInput",
		data:"PlayerUpdateManyMutationInput"
	},
	PlayerScalarWhereInput:{
		AND:"PlayerScalarWhereInput",
		OR:"PlayerScalarWhereInput",
		NOT:"PlayerScalarWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		configLocation:"StringNullableFilter",
		pisignagePlayerId:"StringNullableFilter",
		pisignageGroupId:"StringNullableFilter",
		cpuSerialNumber:"StringNullableFilter",
		displayName:"StringNullableFilter",
		adBoardGroupId:"StringNullableFilter",
		playlistIds:"StringNullableListFilter",
		workpaceId:"StringNullableFilter",
		signageTypeId:"StringNullableFilter",
		audienceTypeId:"StringNullableListFilter",
		aspectRatioType:"EnumAspectRatioTypeFilter",
		customAspectRatioWidth:"IntNullableFilter",
		customAspectRatioHeight:"IntNullableFilter",
		isOnline:"BoolFilter",
		adBoardIds:"StringNullableListFilter",
		createdAt:"DateTimeNullableFilter",
		updatedAt:"DateTimeNullableFilter",
		markForDeletion:"BoolFilter",
		deletedAt:"DateTimeNullableFilter",
		deletedByUserId:"StringNullableFilter",
		visible:"BoolFilter"
	},
	PlayerUpdateManyMutationInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime"
	},
	ContentVersionUpdateManyWithoutDeployedByNestedInput:{
		create:"ContentVersionCreateWithoutDeployedByInput",
		connectOrCreate:"ContentVersionCreateOrConnectWithoutDeployedByInput",
		upsert:"ContentVersionUpsertWithWhereUniqueWithoutDeployedByInput",
		createMany:"ContentVersionCreateManyDeployedByInputEnvelope",
		set:"ContentVersionWhereUniqueInput",
		disconnect:"ContentVersionWhereUniqueInput",
		delete:"ContentVersionWhereUniqueInput",
		connect:"ContentVersionWhereUniqueInput",
		update:"ContentVersionUpdateWithWhereUniqueWithoutDeployedByInput",
		updateMany:"ContentVersionUpdateManyWithWhereWithoutDeployedByInput",
		deleteMany:"ContentVersionScalarWhereInput"
	},
	ContentVersionUpsertWithWhereUniqueWithoutDeployedByInput:{
		where:"ContentVersionWhereUniqueInput",
		update:"ContentVersionUpdateWithoutDeployedByInput",
		create:"ContentVersionCreateWithoutDeployedByInput"
	},
	ContentVersionUpdateWithoutDeployedByInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime",
		booking:"BookingUpdateOneRequiredWithoutContentVersionsNestedInput",
		submittedBy:"UserUpdateOneRequiredWithoutSubmittedContentVersionsNestedInput",
		approvedBy:"UserUpdateOneWithoutApprovedContentVersionsNestedInput",
		assets:"FileUpdateManyWithoutContentVersionsNestedInput"
	},
	BookingUpdateOneRequiredWithoutContentVersionsNestedInput:{
		create:"BookingCreateWithoutContentVersionsInput",
		connectOrCreate:"BookingCreateOrConnectWithoutContentVersionsInput",
		upsert:"BookingUpsertWithoutContentVersionsInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateToOneWithWhereWithoutContentVersionsInput"
	},
	BookingUpsertWithoutContentVersionsInput:{
		update:"BookingUpdateWithoutContentVersionsInput",
		create:"BookingCreateWithoutContentVersionsInput",
		where:"BookingWhereInput"
	},
	BookingUpdateWithoutContentVersionsInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	UserUpdateManyWithoutSharedBookingsNestedInput:{
		create:"UserCreateWithoutSharedBookingsInput",
		connectOrCreate:"UserCreateOrConnectWithoutSharedBookingsInput",
		upsert:"UserUpsertWithWhereUniqueWithoutSharedBookingsInput",
		set:"UserWhereUniqueInput",
		disconnect:"UserWhereUniqueInput",
		delete:"UserWhereUniqueInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateWithWhereUniqueWithoutSharedBookingsInput",
		updateMany:"UserUpdateManyWithWhereWithoutSharedBookingsInput",
		deleteMany:"UserScalarWhereInput"
	},
	UserUpsertWithWhereUniqueWithoutSharedBookingsInput:{
		where:"UserWhereUniqueInput",
		update:"UserUpdateWithoutSharedBookingsInput",
		create:"UserCreateWithoutSharedBookingsInput"
	},
	UserUpdateWithoutSharedBookingsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	WishlistUpdateManyWithoutUserNestedInput:{
		create:"WishlistCreateWithoutUserInput",
		connectOrCreate:"WishlistCreateOrConnectWithoutUserInput",
		upsert:"WishlistUpsertWithWhereUniqueWithoutUserInput",
		createMany:"WishlistCreateManyUserInputEnvelope",
		set:"WishlistWhereUniqueInput",
		disconnect:"WishlistWhereUniqueInput",
		delete:"WishlistWhereUniqueInput",
		connect:"WishlistWhereUniqueInput",
		update:"WishlistUpdateWithWhereUniqueWithoutUserInput",
		updateMany:"WishlistUpdateManyWithWhereWithoutUserInput",
		deleteMany:"WishlistScalarWhereInput"
	},
	WishlistUpsertWithWhereUniqueWithoutUserInput:{
		where:"WishlistWhereUniqueInput",
		update:"WishlistUpdateWithoutUserInput",
		create:"WishlistCreateWithoutUserInput"
	},
	WishlistUpdateWithoutUserInput:{
		createdAt:"DateTime",
		adBoards:"AdBoardUpdateManyWithoutWishlistsNestedInput"
	},
	AdBoardUpdateManyWithoutWishlistsNestedInput:{
		create:"AdBoardCreateWithoutWishlistsInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutWishlistsInput",
		upsert:"AdBoardUpsertWithWhereUniqueWithoutWishlistsInput",
		set:"AdBoardWhereUniqueInput",
		disconnect:"AdBoardWhereUniqueInput",
		delete:"AdBoardWhereUniqueInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithWhereUniqueWithoutWishlistsInput",
		updateMany:"AdBoardUpdateManyWithWhereWithoutWishlistsInput",
		deleteMany:"AdBoardScalarWhereInput"
	},
	AdBoardUpsertWithWhereUniqueWithoutWishlistsInput:{
		where:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithoutWishlistsInput",
		create:"AdBoardCreateWithoutWishlistsInput"
	},
	AdBoardUpdateWithoutWishlistsInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput"
	},
	AdBoardUpdateWithWhereUniqueWithoutWishlistsInput:{
		where:"AdBoardWhereUniqueInput",
		data:"AdBoardUpdateWithoutWishlistsInput"
	},
	AdBoardUpdateManyWithWhereWithoutWishlistsInput:{
		where:"AdBoardScalarWhereInput",
		data:"AdBoardUpdateManyMutationInput"
	},
	AdBoardScalarWhereInput:{
		AND:"AdBoardScalarWhereInput",
		OR:"AdBoardScalarWhereInput",
		NOT:"AdBoardScalarWhereInput",
		id:"StringFilter",
		state:"StringFilter",
		city:"StringFilter",
		country:"StringFilter",
		outdoor:"BoolFilter",
		locationCategoryId:"StringNullableFilter",
		locationSubCategoryId:"StringNullableFilter",
		alias:"StringNullableFilter",
		title:"StringFilter",
		pricePerDay:"IntFilter",
		originalPricePerDay:"IntNullableFilter",
		description:"StringNullableFilter",
		adBoardTypeId:"StringNullableFilter",
		tags:"StringNullableListFilter",
		featuredImage:"StringNullableFilter",
		galleryImgs:"StringNullableListFilter",
		notes:"StringNullableListFilter",
		impressionMultiplier:"FloatNullableFilter",
		categoryId:"StringNullableFilter",
		restrictedBusinessIds:"StringNullableListFilter",
		targetAudiences:"StringNullableListFilter",
		acceptedMediaTypes:"StringNullableListFilter",
		status:"EnumAdBoardStatusFilter",
		adboardDraftStatus:"EnumAdboardDraftStatusNullableFilter",
		isLive:"BoolFilter",
		numberOfDisplays:"IntFilter",
		dailyOperationHours:"IntFilter",
		adsPerLoop:"IntFilter",
		adsDuration:"IntFilter",
		monthlyPrice:"FloatNullableFilter",
		offlineBookingsEnabled:"BoolFilter",
		createdAt:"DateTimeNullableFilter",
		createdByUserId:"StringNullableFilter",
		href:"StringNullableFilter",
		workspaceId:"StringFilter",
		playerIds:"StringNullableListFilter",
		publisherScreenId:"StringNullableFilter",
		additionalData:"JsonNullableFilter",
		publishedVersionId:"StringNullableFilter",
		lastPublishedAt:"DateTimeNullableFilter",
		isArchived:"BoolFilter",
		archivedAt:"DateTimeNullableFilter",
		archivedByUserId:"StringNullableFilter",
		updatedAt:"DateTimeNullableFilter",
		wishlistIds:"StringNullableListFilter"
	},
	WishlistUpdateWithWhereUniqueWithoutUserInput:{
		where:"WishlistWhereUniqueInput",
		data:"WishlistUpdateWithoutUserInput"
	},
	WishlistUpdateManyWithWhereWithoutUserInput:{
		where:"WishlistScalarWhereInput",
		data:"WishlistUpdateManyMutationInput"
	},
	WishlistScalarWhereInput:{
		AND:"WishlistScalarWhereInput",
		OR:"WishlistScalarWhereInput",
		NOT:"WishlistScalarWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		userId:"StringFilter",
		adBoardIds:"StringNullableListFilter",
		createdAt:"DateTimeFilter"
	},
	WishlistUpdateManyMutationInput:{
		createdAt:"DateTime"
	},
	ContentVersionUpdateManyWithoutSubmittedByNestedInput:{
		create:"ContentVersionCreateWithoutSubmittedByInput",
		connectOrCreate:"ContentVersionCreateOrConnectWithoutSubmittedByInput",
		upsert:"ContentVersionUpsertWithWhereUniqueWithoutSubmittedByInput",
		createMany:"ContentVersionCreateManySubmittedByInputEnvelope",
		set:"ContentVersionWhereUniqueInput",
		disconnect:"ContentVersionWhereUniqueInput",
		delete:"ContentVersionWhereUniqueInput",
		connect:"ContentVersionWhereUniqueInput",
		update:"ContentVersionUpdateWithWhereUniqueWithoutSubmittedByInput",
		updateMany:"ContentVersionUpdateManyWithWhereWithoutSubmittedByInput",
		deleteMany:"ContentVersionScalarWhereInput"
	},
	ContentVersionUpsertWithWhereUniqueWithoutSubmittedByInput:{
		where:"ContentVersionWhereUniqueInput",
		update:"ContentVersionUpdateWithoutSubmittedByInput",
		create:"ContentVersionCreateWithoutSubmittedByInput"
	},
	ContentVersionUpdateWithoutSubmittedByInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime",
		booking:"BookingUpdateOneRequiredWithoutContentVersionsNestedInput",
		approvedBy:"UserUpdateOneWithoutApprovedContentVersionsNestedInput",
		deployedBy:"UserUpdateOneWithoutDeployedContentVersionsNestedInput",
		assets:"FileUpdateManyWithoutContentVersionsNestedInput"
	},
	UserUpdateOneWithoutApprovedContentVersionsNestedInput:{
		create:"UserCreateWithoutApprovedContentVersionsInput",
		connectOrCreate:"UserCreateOrConnectWithoutApprovedContentVersionsInput",
		upsert:"UserUpsertWithoutApprovedContentVersionsInput",
		delete:"UserWhereInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutApprovedContentVersionsInput"
	},
	UserUpsertWithoutApprovedContentVersionsInput:{
		update:"UserUpdateWithoutApprovedContentVersionsInput",
		create:"UserCreateWithoutApprovedContentVersionsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutApprovedContentVersionsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput"
	},
	UserUpdateToOneWithWhereWithoutApprovedContentVersionsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutApprovedContentVersionsInput"
	},
	UserUpdateOneWithoutDeployedContentVersionsNestedInput:{
		create:"UserCreateWithoutDeployedContentVersionsInput",
		connectOrCreate:"UserCreateOrConnectWithoutDeployedContentVersionsInput",
		upsert:"UserUpsertWithoutDeployedContentVersionsInput",
		delete:"UserWhereInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutDeployedContentVersionsInput"
	},
	UserUpsertWithoutDeployedContentVersionsInput:{
		update:"UserUpdateWithoutDeployedContentVersionsInput",
		create:"UserCreateWithoutDeployedContentVersionsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutDeployedContentVersionsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	ContentVersionUpdateManyWithoutApprovedByNestedInput:{
		create:"ContentVersionCreateWithoutApprovedByInput",
		connectOrCreate:"ContentVersionCreateOrConnectWithoutApprovedByInput",
		upsert:"ContentVersionUpsertWithWhereUniqueWithoutApprovedByInput",
		createMany:"ContentVersionCreateManyApprovedByInputEnvelope",
		set:"ContentVersionWhereUniqueInput",
		disconnect:"ContentVersionWhereUniqueInput",
		delete:"ContentVersionWhereUniqueInput",
		connect:"ContentVersionWhereUniqueInput",
		update:"ContentVersionUpdateWithWhereUniqueWithoutApprovedByInput",
		updateMany:"ContentVersionUpdateManyWithWhereWithoutApprovedByInput",
		deleteMany:"ContentVersionScalarWhereInput"
	},
	ContentVersionUpsertWithWhereUniqueWithoutApprovedByInput:{
		where:"ContentVersionWhereUniqueInput",
		update:"ContentVersionUpdateWithoutApprovedByInput",
		create:"ContentVersionCreateWithoutApprovedByInput"
	},
	ContentVersionUpdateWithoutApprovedByInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime",
		booking:"BookingUpdateOneRequiredWithoutContentVersionsNestedInput",
		submittedBy:"UserUpdateOneRequiredWithoutSubmittedContentVersionsNestedInput",
		deployedBy:"UserUpdateOneWithoutDeployedContentVersionsNestedInput",
		assets:"FileUpdateManyWithoutContentVersionsNestedInput"
	},
	FileUpdateManyWithoutContentVersionsNestedInput:{
		create:"FileCreateWithoutContentVersionsInput",
		connectOrCreate:"FileCreateOrConnectWithoutContentVersionsInput",
		upsert:"FileUpsertWithWhereUniqueWithoutContentVersionsInput",
		set:"FileWhereUniqueInput",
		disconnect:"FileWhereUniqueInput",
		delete:"FileWhereUniqueInput",
		connect:"FileWhereUniqueInput",
		update:"FileUpdateWithWhereUniqueWithoutContentVersionsInput",
		updateMany:"FileUpdateManyWithWhereWithoutContentVersionsInput",
		deleteMany:"FileScalarWhereInput"
	},
	FileUpsertWithWhereUniqueWithoutContentVersionsInput:{
		where:"FileWhereUniqueInput",
		update:"FileUpdateWithoutContentVersionsInput",
		create:"FileCreateWithoutContentVersionsInput"
	},
	FileUpdateWithoutContentVersionsInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserUpdateOneWithoutUpdatedFilesNestedInput",
		createdBy:"UserUpdateOneRequiredWithoutCreatedFilesNestedInput",
		bookings:"BookingUpdateManyWithoutAssetsNestedInput",
		workspace:"WorkspaceUpdateOneWithoutFilesNestedInput",
		proofBooking:"BookingUpdateOneWithoutProofsNestedInput",
		campaigns:"CampaignUpdateManyWithoutAssetsNestedInput"
	},
	CampaignUpdateManyWithoutAssetsNestedInput:{
		create:"CampaignCreateWithoutAssetsInput",
		connectOrCreate:"CampaignCreateOrConnectWithoutAssetsInput",
		upsert:"CampaignUpsertWithWhereUniqueWithoutAssetsInput",
		set:"CampaignWhereUniqueInput",
		disconnect:"CampaignWhereUniqueInput",
		delete:"CampaignWhereUniqueInput",
		connect:"CampaignWhereUniqueInput",
		update:"CampaignUpdateWithWhereUniqueWithoutAssetsInput",
		updateMany:"CampaignUpdateManyWithWhereWithoutAssetsInput",
		deleteMany:"CampaignScalarWhereInput"
	},
	CampaignUpsertWithWhereUniqueWithoutAssetsInput:{
		where:"CampaignWhereUniqueInput",
		update:"CampaignUpdateWithoutAssetsInput",
		create:"CampaignCreateWithoutAssetsInput"
	},
	CampaignUpdateWithoutAssetsInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		businessCategory:"BusinessCategoryUpdateOneRequiredWithoutCampaignsNestedInput",
		user:"UserUpdateOneRequiredWithoutCampaignsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutCampaignsNestedInput",
		bookings:"BookingUpdateManyWithoutCampaignNestedInput",
		payments:"PaymentUpdateManyWithoutCampaignNestedInput"
	},
	CampaignUpdateWithWhereUniqueWithoutAssetsInput:{
		where:"CampaignWhereUniqueInput",
		data:"CampaignUpdateWithoutAssetsInput"
	},
	CampaignUpdateManyWithWhereWithoutAssetsInput:{
		where:"CampaignScalarWhereInput",
		data:"CampaignUpdateManyMutationInput"
	},
	CampaignScalarWhereInput:{
		AND:"CampaignScalarWhereInput",
		OR:"CampaignScalarWhereInput",
		NOT:"CampaignScalarWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		description:"StringNullableFilter",
		businessCategoryId:"StringFilter",
		purpose:"StringFilter",
		userId:"StringFilter",
		adCategoryId:"StringNullableListFilter",
		paymentStatus:"EnumPaymentStatusFilter",
		origin:"StringFilter",
		assetsIDs:"StringNullableListFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter"
	},
	CampaignUpdateManyMutationInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	FileUpdateWithWhereUniqueWithoutContentVersionsInput:{
		where:"FileWhereUniqueInput",
		data:"FileUpdateWithoutContentVersionsInput"
	},
	FileUpdateManyWithWhereWithoutContentVersionsInput:{
		where:"FileScalarWhereInput",
		data:"FileUpdateManyMutationInput"
	},
	FileScalarWhereInput:{
		AND:"FileScalarWhereInput",
		OR:"FileScalarWhereInput",
		NOT:"FileScalarWhereInput",
		id:"StringFilter",
		contentType:"StringFilter",
		ctime:"StringNullableFilter",
		filename:"StringFilter",
		filepath:"StringNullableFilter",
		isDirectory:"BoolFilter",
		mtime:"StringFilter",
		name:"StringFilter",
		size:"IntFilter",
		status:"EnumFileStatusNullableFilter",
		type:"StringFilter",
		updatedAt:"DateTimeFilter",
		createdAt:"DateTimeFilter",
		updatedByUserId:"StringNullableFilter",
		createdByUserId:"StringFilter",
		url:"StringFilter",
		bookingsIDs:"StringNullableListFilter",
		workspaceId:"StringNullableFilter",
		proofBookingId:"StringNullableFilter",
		campaignIds:"StringNullableListFilter",
		contentVersionId:"StringNullableListFilter"
	},
	FileUpdateManyMutationInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime"
	},
	ContentVersionUpdateWithWhereUniqueWithoutApprovedByInput:{
		where:"ContentVersionWhereUniqueInput",
		data:"ContentVersionUpdateWithoutApprovedByInput"
	},
	ContentVersionUpdateManyWithWhereWithoutApprovedByInput:{
		where:"ContentVersionScalarWhereInput",
		data:"ContentVersionUpdateManyMutationInput"
	},
	ContentVersionScalarWhereInput:{
		AND:"ContentVersionScalarWhereInput",
		OR:"ContentVersionScalarWhereInput",
		NOT:"ContentVersionScalarWhereInput",
		id:"StringFilter",
		bookingId:"StringFilter",
		versionNumber:"IntFilter",
		status:"EnumContentApprovalStatusFilter",
		submittedAt:"DateTimeFilter",
		approvedAt:"DateTimeNullableFilter",
		deployedAt:"DateTimeNullableFilter",
		submittedByUserId:"StringFilter",
		approvedByUserId:"StringNullableFilter",
		deployedByUserId:"StringNullableFilter",
		assetIds:"StringNullableListFilter",
		comments:"StringNullableFilter",
		createdAt:"DateTimeFilter"
	},
	ContentVersionUpdateManyMutationInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime"
	},
	UserUpdateToOneWithWhereWithoutDeployedContentVersionsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutDeployedContentVersionsInput"
	},
	ContentVersionUpdateWithWhereUniqueWithoutSubmittedByInput:{
		where:"ContentVersionWhereUniqueInput",
		data:"ContentVersionUpdateWithoutSubmittedByInput"
	},
	ContentVersionUpdateManyWithWhereWithoutSubmittedByInput:{
		where:"ContentVersionScalarWhereInput",
		data:"ContentVersionUpdateManyMutationInput"
	},
	UserUpdateWithWhereUniqueWithoutSharedBookingsInput:{
		where:"UserWhereUniqueInput",
		data:"UserUpdateWithoutSharedBookingsInput"
	},
	UserUpdateManyWithWhereWithoutSharedBookingsInput:{
		where:"UserScalarWhereInput",
		data:"UserUpdateManyMutationInput"
	},
	UserScalarWhereInput:{
		AND:"UserScalarWhereInput",
		OR:"UserScalarWhereInput",
		NOT:"UserScalarWhereInput",
		id:"StringFilter",
		uid:"StringNullableFilter",
		email:"StringFilter",
		image:"StringNullableFilter",
		phoneNumber:"StringNullableFilter",
		displayName:"StringNullableFilter",
		otherDetails:"JsonNullableFilter",
		roles:"EnumRoleNullableListFilter",
		sharedBookingIds:"StringNullableListFilter",
		disclaimerAccepted:"BoolFilter",
		leadWorkspaceIds:"StringNullableListFilter"
	},
	UserUpdateManyMutationInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput"
	},
	SlotUsageUpdateManyWithoutBookingNestedInput:{
		create:"SlotUsageCreateWithoutBookingInput",
		connectOrCreate:"SlotUsageCreateOrConnectWithoutBookingInput",
		upsert:"SlotUsageUpsertWithWhereUniqueWithoutBookingInput",
		createMany:"SlotUsageCreateManyBookingInputEnvelope",
		set:"SlotUsageWhereUniqueInput",
		disconnect:"SlotUsageWhereUniqueInput",
		delete:"SlotUsageWhereUniqueInput",
		connect:"SlotUsageWhereUniqueInput",
		update:"SlotUsageUpdateWithWhereUniqueWithoutBookingInput",
		updateMany:"SlotUsageUpdateManyWithWhereWithoutBookingInput",
		deleteMany:"SlotUsageScalarWhereInput"
	},
	SlotUsageUpsertWithWhereUniqueWithoutBookingInput:{
		where:"SlotUsageWhereUniqueInput",
		update:"SlotUsageUpdateWithoutBookingInput",
		create:"SlotUsageCreateWithoutBookingInput"
	},
	SlotUsageUpdateWithoutBookingInput:{
		date:"DateTime"
	},
	SlotUsageUpdateWithWhereUniqueWithoutBookingInput:{
		where:"SlotUsageWhereUniqueInput",
		data:"SlotUsageUpdateWithoutBookingInput"
	},
	SlotUsageUpdateManyWithWhereWithoutBookingInput:{
		where:"SlotUsageScalarWhereInput",
		data:"SlotUsageUpdateManyMutationInput"
	},
	SlotUsageScalarWhereInput:{
		AND:"SlotUsageScalarWhereInput",
		OR:"SlotUsageScalarWhereInput",
		NOT:"SlotUsageScalarWhereInput",
		id:"StringFilter",
		bookingId:"StringFilter",
		date:"DateTimeFilter",
		slotUsed:"IntFilter"
	},
	SlotUsageUpdateManyMutationInput:{
		date:"DateTime"
	},
	AdBoardPublicReviewUpdateOneWithoutBookingNestedInput:{
		create:"AdBoardPublicReviewCreateWithoutBookingInput",
		connectOrCreate:"AdBoardPublicReviewCreateOrConnectWithoutBookingInput",
		upsert:"AdBoardPublicReviewUpsertWithoutBookingInput",
		disconnect:"AdBoardPublicReviewWhereInput",
		delete:"AdBoardPublicReviewWhereInput",
		connect:"AdBoardPublicReviewWhereUniqueInput",
		update:"AdBoardPublicReviewUpdateToOneWithWhereWithoutBookingInput"
	},
	AdBoardPublicReviewUpsertWithoutBookingInput:{
		update:"AdBoardPublicReviewUpdateWithoutBookingInput",
		create:"AdBoardPublicReviewCreateWithoutBookingInput",
		where:"AdBoardPublicReviewWhereInput"
	},
	AdBoardPublicReviewUpdateWithoutBookingInput:{
		createdAt:"DateTime",
		adBoard:"AdBoardUpdateOneRequiredWithoutPublicReviewsNestedInput",
		user:"UserUpdateOneRequiredWithoutPublicReviewsNestedInput"
	},
	AdBoardPublicReviewUpdateToOneWithWhereWithoutBookingInput:{
		where:"AdBoardPublicReviewWhereInput",
		data:"AdBoardPublicReviewUpdateWithoutBookingInput"
	},
	BookingHistoryUpdateManyWithoutBookingNestedInput:{
		create:"BookingHistoryCreateWithoutBookingInput",
		connectOrCreate:"BookingHistoryCreateOrConnectWithoutBookingInput",
		upsert:"BookingHistoryUpsertWithWhereUniqueWithoutBookingInput",
		createMany:"BookingHistoryCreateManyBookingInputEnvelope",
		set:"BookingHistoryWhereUniqueInput",
		disconnect:"BookingHistoryWhereUniqueInput",
		delete:"BookingHistoryWhereUniqueInput",
		connect:"BookingHistoryWhereUniqueInput",
		update:"BookingHistoryUpdateWithWhereUniqueWithoutBookingInput",
		updateMany:"BookingHistoryUpdateManyWithWhereWithoutBookingInput",
		deleteMany:"BookingHistoryScalarWhereInput"
	},
	BookingHistoryUpsertWithWhereUniqueWithoutBookingInput:{
		where:"BookingHistoryWhereUniqueInput",
		update:"BookingHistoryUpdateWithoutBookingInput",
		create:"BookingHistoryCreateWithoutBookingInput"
	},
	BookingHistoryUpdateWithoutBookingInput:{
		status:"BookingStatus",
		timestamp:"DateTime"
	},
	BookingHistoryUpdateWithWhereUniqueWithoutBookingInput:{
		where:"BookingHistoryWhereUniqueInput",
		data:"BookingHistoryUpdateWithoutBookingInput"
	},
	BookingHistoryUpdateManyWithWhereWithoutBookingInput:{
		where:"BookingHistoryScalarWhereInput",
		data:"BookingHistoryUpdateManyMutationInput"
	},
	BookingHistoryScalarWhereInput:{
		AND:"BookingHistoryScalarWhereInput",
		OR:"BookingHistoryScalarWhereInput",
		NOT:"BookingHistoryScalarWhereInput",
		id:"StringFilter",
		bookingId:"StringFilter",
		status:"EnumBookingStatusFilter",
		createdBy:"StringFilter",
		timestamp:"DateTimeFilter"
	},
	BookingHistoryUpdateManyMutationInput:{
		status:"BookingStatus",
		timestamp:"DateTime"
	},
	RefundRequestUpdateOneWithoutBookingNestedInput:{
		create:"RefundRequestCreateWithoutBookingInput",
		connectOrCreate:"RefundRequestCreateOrConnectWithoutBookingInput",
		upsert:"RefundRequestUpsertWithoutBookingInput",
		disconnect:"RefundRequestWhereInput",
		delete:"RefundRequestWhereInput",
		connect:"RefundRequestWhereUniqueInput",
		update:"RefundRequestUpdateToOneWithWhereWithoutBookingInput"
	},
	RefundRequestUpsertWithoutBookingInput:{
		update:"RefundRequestUpdateWithoutBookingInput",
		create:"RefundRequestCreateWithoutBookingInput",
		where:"RefundRequestWhereInput"
	},
	RefundRequestUpdateWithoutBookingInput:{
		requestedAt:"DateTime"
	},
	RefundRequestUpdateToOneWithWhereWithoutBookingInput:{
		where:"RefundRequestWhereInput",
		data:"RefundRequestUpdateWithoutBookingInput"
	},
	RefundApprovalUpdateOneWithoutBookingNestedInput:{
		create:"RefundApprovalCreateWithoutBookingInput",
		connectOrCreate:"RefundApprovalCreateOrConnectWithoutBookingInput",
		upsert:"RefundApprovalUpsertWithoutBookingInput",
		disconnect:"RefundApprovalWhereInput",
		delete:"RefundApprovalWhereInput",
		connect:"RefundApprovalWhereUniqueInput",
		update:"RefundApprovalUpdateToOneWithWhereWithoutBookingInput"
	},
	RefundApprovalUpsertWithoutBookingInput:{
		update:"RefundApprovalUpdateWithoutBookingInput",
		create:"RefundApprovalCreateWithoutBookingInput",
		where:"RefundApprovalWhereInput"
	},
	RefundApprovalUpdateWithoutBookingInput:{
		approvedAt:"DateTime"
	},
	RefundApprovalUpdateToOneWithWhereWithoutBookingInput:{
		where:"RefundApprovalWhereInput",
		data:"RefundApprovalUpdateWithoutBookingInput"
	},
	RefundProcessedUpdateOneWithoutBookingNestedInput:{
		create:"RefundProcessedCreateWithoutBookingInput",
		connectOrCreate:"RefundProcessedCreateOrConnectWithoutBookingInput",
		upsert:"RefundProcessedUpsertWithoutBookingInput",
		disconnect:"RefundProcessedWhereInput",
		delete:"RefundProcessedWhereInput",
		connect:"RefundProcessedWhereUniqueInput",
		update:"RefundProcessedUpdateToOneWithWhereWithoutBookingInput"
	},
	RefundProcessedUpsertWithoutBookingInput:{
		update:"RefundProcessedUpdateWithoutBookingInput",
		create:"RefundProcessedCreateWithoutBookingInput",
		where:"RefundProcessedWhereInput"
	},
	RefundProcessedUpdateWithoutBookingInput:{
		processedAt:"DateTime",
		paymentMethod:"PaymentGatewayName"
	},
	RefundProcessedUpdateToOneWithWhereWithoutBookingInput:{
		where:"RefundProcessedWhereInput",
		data:"RefundProcessedUpdateWithoutBookingInput"
	},
	BookingUpdateToOneWithWhereWithoutContentVersionsInput:{
		where:"BookingWhereInput",
		data:"BookingUpdateWithoutContentVersionsInput"
	},
	ContentVersionUpdateWithWhereUniqueWithoutDeployedByInput:{
		where:"ContentVersionWhereUniqueInput",
		data:"ContentVersionUpdateWithoutDeployedByInput"
	},
	ContentVersionUpdateManyWithWhereWithoutDeployedByInput:{
		where:"ContentVersionScalarWhereInput",
		data:"ContentVersionUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutWishlistsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutWishlistsInput"
	},
	WishlistUpdateWithWhereUniqueWithoutAdBoardsInput:{
		where:"WishlistWhereUniqueInput",
		data:"WishlistUpdateWithoutAdBoardsInput"
	},
	WishlistUpdateManyWithWhereWithoutAdBoardsInput:{
		where:"WishlistScalarWhereInput",
		data:"WishlistUpdateManyMutationInput"
	},
	AdBoardUpdateWithWhereUniqueWithoutPlayersInput:{
		where:"AdBoardWhereUniqueInput",
		data:"AdBoardUpdateWithoutPlayersInput"
	},
	AdBoardUpdateManyWithWhereWithoutPlayersInput:{
		where:"AdBoardScalarWhereInput",
		data:"AdBoardUpdateManyMutationInput"
	},
	UserUpdateOneWithoutDeletedPlayerIdsNestedInput:{
		create:"UserCreateWithoutDeletedPlayerIdsInput",
		connectOrCreate:"UserCreateOrConnectWithoutDeletedPlayerIdsInput",
		upsert:"UserUpsertWithoutDeletedPlayerIdsInput",
		delete:"UserWhereInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutDeletedPlayerIdsInput"
	},
	UserUpsertWithoutDeletedPlayerIdsInput:{
		update:"UserUpdateWithoutDeletedPlayerIdsInput",
		create:"UserCreateWithoutDeletedPlayerIdsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutDeletedPlayerIdsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	UserUpdateToOneWithWhereWithoutDeletedPlayerIdsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutDeletedPlayerIdsInput"
	},
	PlayerUpdateToOneWithWhereWithoutCamerasInput:{
		where:"PlayerWhereInput",
		data:"PlayerUpdateWithoutCamerasInput"
	},
	CameraUpdateWithWhereUniqueWithoutWorkspaceInput:{
		where:"CameraWhereUniqueInput",
		data:"CameraUpdateWithoutWorkspaceInput"
	},
	CameraUpdateManyWithWhereWithoutWorkspaceInput:{
		where:"CameraScalarWhereInput",
		data:"CameraUpdateManyMutationInput"
	},
	CameraScalarWhereInput:{
		AND:"CameraScalarWhereInput",
		OR:"CameraScalarWhereInput",
		NOT:"CameraScalarWhereInput",
		id:"StringFilter",
		name:"StringNullableFilter",
		isOnline:"BoolFilter",
		playerId:"StringNullableFilter",
		workspaceId:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		isPublic:"BoolFilter"
	},
	CameraUpdateManyMutationInput:{
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	StreamingDeviceUpdateManyWithoutWorkspaceNestedInput:{
		create:"StreamingDeviceCreateWithoutWorkspaceInput",
		connectOrCreate:"StreamingDeviceCreateOrConnectWithoutWorkspaceInput",
		upsert:"StreamingDeviceUpsertWithWhereUniqueWithoutWorkspaceInput",
		createMany:"StreamingDeviceCreateManyWorkspaceInputEnvelope",
		set:"StreamingDeviceWhereUniqueInput",
		disconnect:"StreamingDeviceWhereUniqueInput",
		delete:"StreamingDeviceWhereUniqueInput",
		connect:"StreamingDeviceWhereUniqueInput",
		update:"StreamingDeviceUpdateWithWhereUniqueWithoutWorkspaceInput",
		updateMany:"StreamingDeviceUpdateManyWithWhereWithoutWorkspaceInput",
		deleteMany:"StreamingDeviceScalarWhereInput"
	},
	StreamingDeviceUpsertWithWhereUniqueWithoutWorkspaceInput:{
		where:"StreamingDeviceWhereUniqueInput",
		update:"StreamingDeviceUpdateWithoutWorkspaceInput",
		create:"StreamingDeviceCreateWithoutWorkspaceInput"
	},
	StreamingDeviceUpdateWithoutWorkspaceInput:{
		connectionLogs:"ConnectionLogCreateInput",
		billboardMonitoring:"BillboardMonitoringCreateInput",
		trafficMonitoring:"TrafficMonitoringCreateInput",
		services:"StreamingServicesCreateInput",
		player:"PlayerUpdateOneWithoutCameraStreamingDevicesNestedInput",
		billboardMonitoringAlerts:"BillboardMonitoringAlertUpdateManyWithoutStreamingDeviceNestedInput"
	},
	PlayerUpdateOneWithoutCameraStreamingDevicesNestedInput:{
		create:"PlayerCreateWithoutCameraStreamingDevicesInput",
		connectOrCreate:"PlayerCreateOrConnectWithoutCameraStreamingDevicesInput",
		upsert:"PlayerUpsertWithoutCameraStreamingDevicesInput",
		delete:"PlayerWhereInput",
		connect:"PlayerWhereUniqueInput",
		update:"PlayerUpdateToOneWithWhereWithoutCameraStreamingDevicesInput"
	},
	PlayerUpsertWithoutCameraStreamingDevicesInput:{
		update:"PlayerUpdateWithoutCameraStreamingDevicesInput",
		create:"PlayerCreateWithoutCameraStreamingDevicesInput",
		where:"PlayerWhereInput"
	},
	PlayerUpdateWithoutCameraStreamingDevicesInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutPisignagePlayersNestedInput",
		workspace:"WorkspaceUpdateOneWithoutPlayersNestedInput",
		status:"PlayerUptimeStatusUpdateManyWithoutPlayerNestedInput",
		cameras:"CameraUpdateManyWithoutPlayerNestedInput",
		signageType:"DigitalSignageUpdateOneWithoutPlayersNestedInput",
		audienceType:"AudienceUpdateManyWithoutPlayersNestedInput",
		adBoards:"AdBoardUpdateManyWithoutPlayersNestedInput",
		deletedBy:"UserUpdateOneWithoutDeletedPlayerIdsNestedInput"
	},
	PlayerUpdateToOneWithWhereWithoutCameraStreamingDevicesInput:{
		where:"PlayerWhereInput",
		data:"PlayerUpdateWithoutCameraStreamingDevicesInput"
	},
	StreamingDeviceUpdateWithWhereUniqueWithoutWorkspaceInput:{
		where:"StreamingDeviceWhereUniqueInput",
		data:"StreamingDeviceUpdateWithoutWorkspaceInput"
	},
	StreamingDeviceUpdateManyWithWhereWithoutWorkspaceInput:{
		where:"StreamingDeviceScalarWhereInput",
		data:"StreamingDeviceUpdateManyMutationInput"
	},
	WorkspaceUpdateWithWhereUniqueWithoutLeadsInput:{
		where:"WorkspaceWhereUniqueInput",
		data:"WorkspaceUpdateWithoutLeadsInput"
	},
	WorkspaceUpdateManyWithWhereWithoutLeadsInput:{
		where:"WorkspaceScalarWhereInput",
		data:"WorkspaceUpdateManyMutationInput"
	},
	WorkspaceScalarWhereInput:{
		AND:"WorkspaceScalarWhereInput",
		OR:"WorkspaceScalarWhereInput",
		NOT:"WorkspaceScalarWhereInput",
		id:"StringFilter",
		type:"EnumWorkspaceTypeFilter",
		name:"StringFilter",
		key:"StringFilter",
		userIds:"StringNullableListFilter",
		ownerId:"StringNullableFilter",
		avatar:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		stripeSubscriptionId:"StringNullableFilter",
		leadIds:"StringNullableListFilter",
		webhookAppId:"StringNullableFilter",
		stackAuthTeamId:"StringNullableFilter"
	},
	WorkspaceUpdateManyMutationInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	UserUpdateToOneWithWhereWithoutArchivedAdboardsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutArchivedAdboardsInput"
	},
	AdBoardUpdateToOneWithWhereWithoutPublicReviewsInput:{
		where:"AdBoardWhereInput",
		data:"AdBoardUpdateWithoutPublicReviewsInput"
	},
	BookingUpdateOneRequiredWithoutReviewNestedInput:{
		create:"BookingCreateWithoutReviewInput",
		connectOrCreate:"BookingCreateOrConnectWithoutReviewInput",
		upsert:"BookingUpsertWithoutReviewInput",
		connect:"BookingWhereUniqueInput",
		update:"BookingUpdateToOneWithWhereWithoutReviewInput"
	},
	BookingUpsertWithoutReviewInput:{
		update:"BookingUpdateWithoutReviewInput",
		create:"BookingCreateWithoutReviewInput",
		where:"BookingWhereInput"
	},
	BookingUpdateWithoutReviewInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	BookingUpdateToOneWithWhereWithoutReviewInput:{
		where:"BookingWhereInput",
		data:"BookingUpdateWithoutReviewInput"
	},
	AdBoardPublicReviewUpdateWithWhereUniqueWithoutUserInput:{
		where:"AdBoardPublicReviewWhereUniqueInput",
		data:"AdBoardPublicReviewUpdateWithoutUserInput"
	},
	AdBoardPublicReviewUpdateManyWithWhereWithoutUserInput:{
		where:"AdBoardPublicReviewScalarWhereInput",
		data:"AdBoardPublicReviewUpdateManyMutationInput"
	},
	AdBoardPublicReviewScalarWhereInput:{
		AND:"AdBoardPublicReviewScalarWhereInput",
		OR:"AdBoardPublicReviewScalarWhereInput",
		NOT:"AdBoardPublicReviewScalarWhereInput",
		id:"StringFilter",
		rating:"FloatFilter",
		title:"StringFilter",
		description:"StringFilter",
		isVerified:"BoolFilter",
		helpfulYes:"IntFilter",
		helpfulNo:"IntFilter",
		imageUrls:"StringNullableListFilter",
		adBoardId:"StringFilter",
		userId:"StringFilter",
		createdAt:"DateTimeFilter",
		bookingId:"StringFilter"
	},
	AdBoardPublicReviewUpdateManyMutationInput:{
		createdAt:"DateTime"
	},
	UserUpdateWithWhereUniqueWithoutLeadWorspacesInput:{
		where:"UserWhereUniqueInput",
		data:"UserUpdateWithoutLeadWorspacesInput"
	},
	UserUpdateManyWithWhereWithoutLeadWorspacesInput:{
		where:"UserScalarWhereInput",
		data:"UserUpdateManyMutationInput"
	},
	WorkspaceUpdateToOneWithWhereWithoutTransactionsInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutTransactionsInput"
	},
	TransactionUpdateToOneWithWhereWithoutPayoutsInput:{
		where:"TransactionWhereInput",
		data:"TransactionUpdateWithoutPayoutsInput"
	},
	PayoutUpdateWithWhereUniqueWithoutBookingInput:{
		where:"PayoutWhereUniqueInput",
		data:"PayoutUpdateWithoutBookingInput"
	},
	PayoutUpdateManyWithWhereWithoutBookingInput:{
		where:"PayoutScalarWhereInput",
		data:"PayoutUpdateManyMutationInput"
	},
	PayoutScalarWhereInput:{
		AND:"PayoutScalarWhereInput",
		OR:"PayoutScalarWhereInput",
		NOT:"PayoutScalarWhereInput",
		id:"StringFilter",
		totalAmount:"FloatFilter",
		commissionRate:"FloatFilter",
		commissionAmount:"FloatFilter",
		netAmount:"FloatFilter",
		createdAt:"DateTimeFilter",
		bookingId:"StringFilter",
		status:"EnumPayoutStatusFilter",
		transactionId:"StringNullableFilter"
	},
	PayoutUpdateManyMutationInput:{
		createdAt:"DateTime",
		status:"PayoutStatus"
	},
	BookingUpdateToOneWithWhereWithoutPaymentAllocationsInput:{
		where:"BookingWhereInput",
		data:"BookingUpdateWithoutPaymentAllocationsInput"
	},
	PaymentAllocationUpdateWithWhereUniqueWithoutPaymentInput:{
		where:"PaymentAllocationWhereUniqueInput",
		data:"PaymentAllocationUpdateWithoutPaymentInput"
	},
	PaymentAllocationUpdateManyWithWhereWithoutPaymentInput:{
		where:"PaymentAllocationScalarWhereInput",
		data:"PaymentAllocationUpdateManyMutationInput"
	},
	PaymentAllocationScalarWhereInput:{
		AND:"PaymentAllocationScalarWhereInput",
		OR:"PaymentAllocationScalarWhereInput",
		NOT:"PaymentAllocationScalarWhereInput",
		id:"StringFilter",
		paymentId:"StringFilter",
		bookingId:"StringFilter",
		subtotal:"FloatFilter",
		tax:"FloatFilter",
		discount:"FloatFilter",
		total:"FloatFilter"
	},
	PaymentAllocationUpdateManyMutationInput:{

	},
	PaymentUpdateWithWhereUniqueWithoutCampaignInput:{
		where:"PaymentWhereUniqueInput",
		data:"PaymentUpdateWithoutCampaignInput"
	},
	PaymentUpdateManyWithWhereWithoutCampaignInput:{
		where:"PaymentScalarWhereInput",
		data:"PaymentUpdateManyMutationInput"
	},
	PaymentScalarWhereInput:{
		AND:"PaymentScalarWhereInput",
		OR:"PaymentScalarWhereInput",
		NOT:"PaymentScalarWhereInput",
		id:"StringFilter",
		paymentIntentId:"StringFilter",
		checkoutSessionId:"StringFilter",
		eventId:"StringFilter",
		liveMode:"BoolFilter",
		paymentGateway:"EnumPaymentGatewayNameFilter",
		subtotal:"FloatFilter",
		total:"FloatFilter",
		tax:"FloatFilter",
		discount:"FloatFilter",
		campaignId:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter"
	},
	PaymentUpdateManyMutationInput:{
		paymentGateway:"PaymentGatewayName",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	FileUpdateManyWithoutCampaignsNestedInput:{
		create:"FileCreateWithoutCampaignsInput",
		connectOrCreate:"FileCreateOrConnectWithoutCampaignsInput",
		upsert:"FileUpsertWithWhereUniqueWithoutCampaignsInput",
		set:"FileWhereUniqueInput",
		disconnect:"FileWhereUniqueInput",
		delete:"FileWhereUniqueInput",
		connect:"FileWhereUniqueInput",
		update:"FileUpdateWithWhereUniqueWithoutCampaignsInput",
		updateMany:"FileUpdateManyWithWhereWithoutCampaignsInput",
		deleteMany:"FileScalarWhereInput"
	},
	FileUpsertWithWhereUniqueWithoutCampaignsInput:{
		where:"FileWhereUniqueInput",
		update:"FileUpdateWithoutCampaignsInput",
		create:"FileCreateWithoutCampaignsInput"
	},
	FileUpdateWithoutCampaignsInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserUpdateOneWithoutUpdatedFilesNestedInput",
		createdBy:"UserUpdateOneRequiredWithoutCreatedFilesNestedInput",
		bookings:"BookingUpdateManyWithoutAssetsNestedInput",
		workspace:"WorkspaceUpdateOneWithoutFilesNestedInput",
		proofBooking:"BookingUpdateOneWithoutProofsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutAssetsNestedInput"
	},
	ContentVersionUpdateManyWithoutAssetsNestedInput:{
		create:"ContentVersionCreateWithoutAssetsInput",
		connectOrCreate:"ContentVersionCreateOrConnectWithoutAssetsInput",
		upsert:"ContentVersionUpsertWithWhereUniqueWithoutAssetsInput",
		set:"ContentVersionWhereUniqueInput",
		disconnect:"ContentVersionWhereUniqueInput",
		delete:"ContentVersionWhereUniqueInput",
		connect:"ContentVersionWhereUniqueInput",
		update:"ContentVersionUpdateWithWhereUniqueWithoutAssetsInput",
		updateMany:"ContentVersionUpdateManyWithWhereWithoutAssetsInput",
		deleteMany:"ContentVersionScalarWhereInput"
	},
	ContentVersionUpsertWithWhereUniqueWithoutAssetsInput:{
		where:"ContentVersionWhereUniqueInput",
		update:"ContentVersionUpdateWithoutAssetsInput",
		create:"ContentVersionCreateWithoutAssetsInput"
	},
	ContentVersionUpdateWithoutAssetsInput:{
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		createdAt:"DateTime",
		booking:"BookingUpdateOneRequiredWithoutContentVersionsNestedInput",
		submittedBy:"UserUpdateOneRequiredWithoutSubmittedContentVersionsNestedInput",
		approvedBy:"UserUpdateOneWithoutApprovedContentVersionsNestedInput",
		deployedBy:"UserUpdateOneWithoutDeployedContentVersionsNestedInput"
	},
	ContentVersionUpdateWithWhereUniqueWithoutAssetsInput:{
		where:"ContentVersionWhereUniqueInput",
		data:"ContentVersionUpdateWithoutAssetsInput"
	},
	ContentVersionUpdateManyWithWhereWithoutAssetsInput:{
		where:"ContentVersionScalarWhereInput",
		data:"ContentVersionUpdateManyMutationInput"
	},
	FileUpdateWithWhereUniqueWithoutCampaignsInput:{
		where:"FileWhereUniqueInput",
		data:"FileUpdateWithoutCampaignsInput"
	},
	FileUpdateManyWithWhereWithoutCampaignsInput:{
		where:"FileScalarWhereInput",
		data:"FileUpdateManyMutationInput"
	},
	CampaignUpdateToOneWithWhereWithoutBookingsInput:{
		where:"CampaignWhereInput",
		data:"CampaignUpdateWithoutBookingsInput"
	},
	BookingUpdateToOneWithWhereWithoutPayoutsInput:{
		where:"BookingWhereInput",
		data:"BookingUpdateWithoutPayoutsInput"
	},
	PayoutUpdateWithWhereUniqueWithoutTransactionInput:{
		where:"PayoutWhereUniqueInput",
		data:"PayoutUpdateWithoutTransactionInput"
	},
	PayoutUpdateManyWithWhereWithoutTransactionInput:{
		where:"PayoutScalarWhereInput",
		data:"PayoutUpdateManyMutationInput"
	},
	TransactionUpdateWithWhereUniqueWithoutWorkspaceInput:{
		where:"TransactionWhereUniqueInput",
		data:"TransactionUpdateWithoutWorkspaceInput"
	},
	TransactionUpdateManyWithWhereWithoutWorkspaceInput:{
		where:"TransactionScalarWhereInput",
		data:"TransactionUpdateManyMutationInput"
	},
	TransactionScalarWhereInput:{
		AND:"TransactionScalarWhereInput",
		OR:"TransactionScalarWhereInput",
		NOT:"TransactionScalarWhereInput",
		workspaceId:"StringNullableFilter",
		id:"StringFilter",
		amount:"FloatFilter",
		createAt:"DateTimeFilter",
		processedAt:"DateTimeNullableFilter",
		relatedEntityId:"StringFilter",
		transactionStatus:"EnumTransactionStatusFilter",
		details:"JsonNullableFilter"
	},
	TransactionUpdateManyMutationInput:{
		createAt:"DateTime",
		processedAt:"DateTime",
		transactionStatus:"TransactionStatus",
		details:"JSON"
	},
	WorkspaceUpdateToOneWithWhereWithoutCamerasInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutCamerasInput"
	},
	CameraUpdateWithWhereUniqueWithoutPlayerInput:{
		where:"CameraWhereUniqueInput",
		data:"CameraUpdateWithoutPlayerInput"
	},
	CameraUpdateManyWithWhereWithoutPlayerInput:{
		where:"CameraScalarWhereInput",
		data:"CameraUpdateManyMutationInput"
	},
	PlayerUpdateWithWhereUniqueWithoutWorkspaceInput:{
		where:"PlayerWhereUniqueInput",
		data:"PlayerUpdateWithoutWorkspaceInput"
	},
	PlayerUpdateManyWithWhereWithoutWorkspaceInput:{
		where:"PlayerScalarWhereInput",
		data:"PlayerUpdateManyMutationInput"
	},
	WorkspaceUpdateToOneWithWhereWithoutBookingsInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutBookingsInput"
	},
	BookingUpdateToOneWithWhereWithoutProofsInput:{
		where:"BookingWhereInput",
		data:"BookingUpdateWithoutProofsInput"
	},
	FileUpdateWithWhereUniqueWithoutWorkspaceInput:{
		where:"FileWhereUniqueInput",
		data:"FileUpdateWithoutWorkspaceInput"
	},
	FileUpdateManyWithWhereWithoutWorkspaceInput:{
		where:"FileScalarWhereInput",
		data:"FileUpdateManyMutationInput"
	},
	WorkspaceUpdateWithWhereUniqueWithoutOwnerInput:{
		where:"WorkspaceWhereUniqueInput",
		data:"WorkspaceUpdateWithoutOwnerInput"
	},
	WorkspaceUpdateManyWithWhereWithoutOwnerInput:{
		where:"WorkspaceScalarWhereInput",
		data:"WorkspaceUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutPublicReviewsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutPublicReviewsInput"
	},
	AdBoardPublicReviewUpdateWithWhereUniqueWithoutAdBoardInput:{
		where:"AdBoardPublicReviewWhereUniqueInput",
		data:"AdBoardPublicReviewUpdateWithoutAdBoardInput"
	},
	AdBoardPublicReviewUpdateManyWithWhereWithoutAdBoardInput:{
		where:"AdBoardPublicReviewScalarWhereInput",
		data:"AdBoardPublicReviewUpdateManyMutationInput"
	},
	AdBoardUpdateWithWhereUniqueWithoutArchivedByInput:{
		where:"AdBoardWhereUniqueInput",
		data:"AdBoardUpdateWithoutArchivedByInput"
	},
	AdBoardUpdateManyWithWhereWithoutArchivedByInput:{
		where:"AdBoardScalarWhereInput",
		data:"AdBoardUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutReviewCommentsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutReviewCommentsInput"
	},
	AdBoardReviewCommentUpdateWithWhereUniqueWithoutAdBoardInput:{
		where:"AdBoardReviewCommentWhereUniqueInput",
		data:"AdBoardReviewCommentUpdateWithoutAdBoardInput"
	},
	AdBoardReviewCommentUpdateManyWithWhereWithoutAdBoardInput:{
		where:"AdBoardReviewCommentScalarWhereInput",
		data:"AdBoardReviewCommentUpdateManyMutationInput"
	},
	AdBoardReviewCommentScalarWhereInput:{
		AND:"AdBoardReviewCommentScalarWhereInput",
		OR:"AdBoardReviewCommentScalarWhereInput",
		NOT:"AdBoardReviewCommentScalarWhereInput",
		id:"StringFilter",
		adBoardId:"StringFilter",
		userId:"StringFilter",
		comment:"StringFilter",
		action:"EnumReviewActionFilter",
		createdAt:"DateTimeFilter"
	},
	AdBoardReviewCommentUpdateManyMutationInput:{
		action:"ReviewAction",
		createdAt:"DateTime"
	},
	AdBoardUpdateToOneWithWhereWithoutPublishedVersionInput:{
		where:"AdBoardWhereInput",
		data:"AdBoardUpdateWithoutPublishedVersionInput"
	},
	AdBoardUpdateToOneWithWhereWithoutReviewCommentsInput:{
		where:"AdBoardWhereInput",
		data:"AdBoardUpdateWithoutReviewCommentsInput"
	},
	AdBoardReviewCommentUpdateWithWhereUniqueWithoutUserInput:{
		where:"AdBoardReviewCommentWhereUniqueInput",
		data:"AdBoardReviewCommentUpdateWithoutUserInput"
	},
	AdBoardReviewCommentUpdateManyWithWhereWithoutUserInput:{
		where:"AdBoardReviewCommentScalarWhereInput",
		data:"AdBoardReviewCommentUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutPublishAdboardVersionInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutPublishAdboardVersionInput"
	},
	AdBoardPublishHistoryUpdateWithWhereUniqueWithoutAdBoardInput:{
		where:"AdBoardPublishHistoryWhereUniqueInput",
		data:"AdBoardPublishHistoryUpdateWithoutAdBoardInput"
	},
	AdBoardPublishHistoryUpdateManyWithWhereWithoutAdBoardInput:{
		where:"AdBoardPublishHistoryScalarWhereInput",
		data:"AdBoardPublishHistoryUpdateManyMutationInput"
	},
	AdBoardPublishHistoryScalarWhereInput:{
		AND:"AdBoardPublishHistoryScalarWhereInput",
		OR:"AdBoardPublishHistoryScalarWhereInput",
		NOT:"AdBoardPublishHistoryScalarWhereInput",
		id:"StringFilter",
		adBoardId:"StringFilter",
		publishedAt:"DateTimeFilter",
		publishedByUserId:"StringFilter",
		changesSnapshot:"JsonFilter"
	},
	AdBoardPublishHistoryUpdateManyMutationInput:{
		publishedAt:"DateTime",
		changesSnapshot:"JSON"
	},
	AdBoardUpdateToOneWithWhereWithoutDraftAdboardInput:{
		where:"AdBoardWhereInput",
		data:"AdBoardUpdateWithoutDraftAdboardInput"
	},
	AdBoardUpdateToOneWithWhereWithoutHistoryInput:{
		where:"AdBoardWhereInput",
		data:"AdBoardUpdateWithoutHistoryInput"
	},
	AdBoardPublishHistoryUpdateWithWhereUniqueWithoutPublishedByInput:{
		where:"AdBoardPublishHistoryWhereUniqueInput",
		data:"AdBoardPublishHistoryUpdateWithoutPublishedByInput"
	},
	AdBoardPublishHistoryUpdateManyWithWhereWithoutPublishedByInput:{
		where:"AdBoardPublishHistoryScalarWhereInput",
		data:"AdBoardPublishHistoryUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutChangelogsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutChangelogsInput"
	},
	ChangelogUpdateWithWhereUniqueWithoutBookingInput:{
		where:"ChangelogWhereUniqueInput",
		data:"ChangelogUpdateWithoutBookingInput"
	},
	ChangelogUpdateManyWithWhereWithoutBookingInput:{
		where:"ChangelogScalarWhereInput",
		data:"ChangelogUpdateManyMutationInput"
	},
	ChangelogScalarWhereInput:{
		AND:"ChangelogScalarWhereInput",
		OR:"ChangelogScalarWhereInput",
		NOT:"ChangelogScalarWhereInput",
		id:"StringFilter",
		createdAt:"DateTimeFilter",
		message:"StringFilter",
		action:"StringFilter",
		bookingId:"StringNullableFilter",
		userId:"StringFilter",
		updates:"JsonNullableFilter"
	},
	ChangelogUpdateManyMutationInput:{
		createdAt:"DateTime",
		updates:"JSON"
	},
	BookingUpdateWithWhereUniqueWithoutWorkspaceInput:{
		where:"BookingWhereUniqueInput",
		data:"BookingUpdateWithoutWorkspaceInput"
	},
	BookingUpdateManyWithWhereWithoutWorkspaceInput:{
		where:"BookingScalarWhereInput",
		data:"BookingUpdateManyMutationInput"
	},
	BookingScalarWhereInput:{
		AND:"BookingScalarWhereInput",
		OR:"BookingScalarWhereInput",
		NOT:"BookingScalarWhereInput",
		id:"StringFilter",
		additionalInformation:"StringNullableFilter",
		origin:"StringNullableFilter",
		bookingCode:"StringFilter",
		bookingDate:"DateTimeFilter",
		bookingFor:"StringFilter",
		purpose:"StringFilter",
		adBoardId:"StringFilter",
		workspaceId:"StringNullableFilter",
		campaignId:"StringNullableFilter",
		businessCategoryId:"StringNullableFilter",
		adCategoryId:"StringNullableListFilter",
		bookingStatus:"EnumBookingStatusFilter",
		paymentStatus:"EnumPaymentStatusNullableFilter",
		deploymentStatus:"EnumDeploymentStatusFilter",
		assetsIDs:"StringNullableListFilter",
		currentDeployedVersionId:"StringNullableFilter",
		userId:"StringFilter",
		sharedUserIds:"StringNullableListFilter",
		isOffline:"BoolFilter",
		isEnquiry:"BoolFilter",
		isPaid:"BoolFilter",
		enquiryDate:"DateTimeNullableFilter",
		approvalDate:"DateTimeNullableFilter",
		paymentDate:"DateTimeNullableFilter",
		confirmationDate:"DateTimeNullableFilter",
		contentScheduledDate:"DateTimeNullableFilter",
		contentLiveDate:"DateTimeNullableFilter",
		completionDate:"DateTimeNullableFilter",
		refundStatus:"EnumRefundStatusFilter"
	},
	BookingUpdateManyMutationInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus"
	},
	WorkspaceUpdateToOneWithWhereWithoutMembershipsInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutMembershipsInput"
	},
	WorkspaceRoleUpdateOneRequiredWithoutMembershipsNestedInput:{
		create:"WorkspaceRoleCreateWithoutMembershipsInput",
		connectOrCreate:"WorkspaceRoleCreateOrConnectWithoutMembershipsInput",
		upsert:"WorkspaceRoleUpsertWithoutMembershipsInput",
		connect:"WorkspaceRoleWhereUniqueInput",
		update:"WorkspaceRoleUpdateToOneWithWhereWithoutMembershipsInput"
	},
	WorkspaceRoleUpsertWithoutMembershipsInput:{
		update:"WorkspaceRoleUpdateWithoutMembershipsInput",
		create:"WorkspaceRoleCreateWithoutMembershipsInput",
		where:"WorkspaceRoleWhereInput"
	},
	WorkspaceRoleUpdateWithoutMembershipsInput:{
		permissions:"Permission",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		workspace:"WorkspaceUpdateOneWithoutWorkspaceRolesNestedInput"
	},
	WorkspaceUpdateOneWithoutWorkspaceRolesNestedInput:{
		create:"WorkspaceCreateWithoutWorkspaceRolesInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutWorkspaceRolesInput",
		upsert:"WorkspaceUpsertWithoutWorkspaceRolesInput",
		delete:"WorkspaceWhereInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutWorkspaceRolesInput"
	},
	WorkspaceUpsertWithoutWorkspaceRolesInput:{
		update:"WorkspaceUpdateWithoutWorkspaceRolesInput",
		create:"WorkspaceCreateWithoutWorkspaceRolesInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutWorkspaceRolesInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	WorkspaceUpdateToOneWithWhereWithoutWorkspaceRolesInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutWorkspaceRolesInput"
	},
	WorkspaceRoleUpdateToOneWithWhereWithoutMembershipsInput:{
		where:"WorkspaceRoleWhereInput",
		data:"WorkspaceRoleUpdateWithoutMembershipsInput"
	},
	MembershipUpdateWithWhereUniqueWithoutUserInput:{
		where:"MembershipWhereUniqueInput",
		data:"MembershipUpdateWithoutUserInput"
	},
	MembershipUpdateManyWithWhereWithoutUserInput:{
		where:"MembershipScalarWhereInput",
		data:"MembershipUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutAuditsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutAuditsInput"
	},
	AuditUpdateWithWhereUniqueWithoutWorkspaceInput:{
		where:"AuditWhereUniqueInput",
		data:"AuditUpdateWithoutWorkspaceInput"
	},
	AuditUpdateManyWithWhereWithoutWorkspaceInput:{
		where:"AuditScalarWhereInput",
		data:"AuditUpdateManyMutationInput"
	},
	AuditScalarWhereInput:{
		AND:"AuditScalarWhereInput",
		OR:"AuditScalarWhereInput",
		NOT:"AuditScalarWhereInput",
		id:"StringFilter",
		createdAt:"DateTimeFilter",
		message:"StringFilter",
		action:"StringFilter",
		userId:"StringFilter",
		workspaceId:"StringNullableFilter",
		updates:"JsonNullableFilter"
	},
	AuditUpdateManyMutationInput:{
		createdAt:"DateTime",
		entity:"EntityCreateInput",
		updates:"JSON"
	},
	WorkspaceUpdateToOneWithWhereWithoutPlayersInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutPlayersInput"
	},
	PlayerUpdateWithWhereUniqueWithoutAdBoardGroupInput:{
		where:"PlayerWhereUniqueInput",
		data:"PlayerUpdateWithoutAdBoardGroupInput"
	},
	PlayerUpdateManyWithWhereWithoutAdBoardGroupInput:{
		where:"PlayerScalarWhereInput",
		data:"PlayerUpdateManyMutationInput"
	},
	WorkspaceUpdateOneRequiredWithoutAdBoardGroupsNestedInput:{
		create:"WorkspaceCreateWithoutAdBoardGroupsInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutAdBoardGroupsInput",
		upsert:"WorkspaceUpsertWithoutAdBoardGroupsInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutAdBoardGroupsInput"
	},
	WorkspaceUpsertWithoutAdBoardGroupsInput:{
		update:"WorkspaceUpdateWithoutAdBoardGroupsInput",
		create:"WorkspaceCreateWithoutAdBoardGroupsInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutAdBoardGroupsInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	WorkspaceUpdateToOneWithWhereWithoutAdBoardGroupsInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutAdBoardGroupsInput"
	},
	AdBoardGroupUpdateWithWhereUniqueWithoutScheduledPlaylistsInput:{
		where:"AdBoardGroupWhereUniqueInput",
		data:"AdBoardGroupUpdateWithoutScheduledPlaylistsInput"
	},
	AdBoardGroupUpdateManyWithWhereWithoutScheduledPlaylistsInput:{
		where:"AdBoardGroupScalarWhereInput",
		data:"AdBoardGroupUpdateManyMutationInput"
	},
	PlaylistUpdateManyWithoutFooterPlaylistNestedInput:{
		create:"PlaylistCreateWithoutFooterPlaylistInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutFooterPlaylistInput",
		upsert:"PlaylistUpsertWithWhereUniqueWithoutFooterPlaylistInput",
		createMany:"PlaylistCreateManyFooterPlaylistInputEnvelope",
		set:"PlaylistWhereUniqueInput",
		disconnect:"PlaylistWhereUniqueInput",
		delete:"PlaylistWhereUniqueInput",
		connect:"PlaylistWhereUniqueInput",
		update:"PlaylistUpdateWithWhereUniqueWithoutFooterPlaylistInput",
		updateMany:"PlaylistUpdateManyWithWhereWithoutFooterPlaylistInput",
		deleteMany:"PlaylistScalarWhereInput"
	},
	PlaylistUpsertWithWhereUniqueWithoutFooterPlaylistInput:{
		where:"PlaylistWhereUniqueInput",
		update:"PlaylistUpdateWithoutFooterPlaylistInput",
		create:"PlaylistCreateWithoutFooterPlaylistInput"
	},
	PlaylistUpdateWithoutFooterPlaylistInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		sidebarPlaylist:"PlaylistUpdateOneWithoutSidebarParentPlaylistsNestedInput",
		adBoardGroupsForAds:"AdBoardGroupUpdateManyWithoutAdsPlaylistNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutScheduledPlaylistsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutPlaylistsNestedInput",
		footerParentPlaylists:"PlaylistUpdateManyWithoutFooterPlaylistNestedInput",
		sidebarParentPlaylists:"PlaylistUpdateManyWithoutSidebarPlaylistNestedInput"
	},
	PlaylistUpdateManyWithoutSidebarPlaylistNestedInput:{
		create:"PlaylistCreateWithoutSidebarPlaylistInput",
		connectOrCreate:"PlaylistCreateOrConnectWithoutSidebarPlaylistInput",
		upsert:"PlaylistUpsertWithWhereUniqueWithoutSidebarPlaylistInput",
		createMany:"PlaylistCreateManySidebarPlaylistInputEnvelope",
		set:"PlaylistWhereUniqueInput",
		disconnect:"PlaylistWhereUniqueInput",
		delete:"PlaylistWhereUniqueInput",
		connect:"PlaylistWhereUniqueInput",
		update:"PlaylistUpdateWithWhereUniqueWithoutSidebarPlaylistInput",
		updateMany:"PlaylistUpdateManyWithWhereWithoutSidebarPlaylistInput",
		deleteMany:"PlaylistScalarWhereInput"
	},
	PlaylistUpsertWithWhereUniqueWithoutSidebarPlaylistInput:{
		where:"PlaylistWhereUniqueInput",
		update:"PlaylistUpdateWithoutSidebarPlaylistInput",
		create:"PlaylistCreateWithoutSidebarPlaylistInput"
	},
	PlaylistUpdateWithoutSidebarPlaylistInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistUpdateOneWithoutFooterParentPlaylistsNestedInput",
		adBoardGroupsForAds:"AdBoardGroupUpdateManyWithoutAdsPlaylistNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutScheduledPlaylistsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutPlaylistsNestedInput",
		footerParentPlaylists:"PlaylistUpdateManyWithoutFooterPlaylistNestedInput",
		sidebarParentPlaylists:"PlaylistUpdateManyWithoutSidebarPlaylistNestedInput"
	},
	PlaylistUpdateWithWhereUniqueWithoutSidebarPlaylistInput:{
		where:"PlaylistWhereUniqueInput",
		data:"PlaylistUpdateWithoutSidebarPlaylistInput"
	},
	PlaylistUpdateManyWithWhereWithoutSidebarPlaylistInput:{
		where:"PlaylistScalarWhereInput",
		data:"PlaylistUpdateManyMutationInput"
	},
	PlaylistScalarWhereInput:{
		AND:"PlaylistScalarWhereInput",
		OR:"PlaylistScalarWhereInput",
		NOT:"PlaylistScalarWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		displayName:"StringNullableFilter",
		isAdsPlaylist:"BoolNullableFilter",
		footerPlaylistId:"StringNullableFilter",
		sidebarPlaylistId:"StringNullableFilter",
		layout:"EnumScreenLayoutFilter",
		isDeployed:"BoolNullableFilter",
		adBoardGroupIds:"StringNullableListFilter",
		workspaceId:"StringFilter"
	},
	PlaylistUpdateManyMutationInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout"
	},
	PlaylistUpdateWithWhereUniqueWithoutFooterPlaylistInput:{
		where:"PlaylistWhereUniqueInput",
		data:"PlaylistUpdateWithoutFooterPlaylistInput"
	},
	PlaylistUpdateManyWithWhereWithoutFooterPlaylistInput:{
		where:"PlaylistScalarWhereInput",
		data:"PlaylistUpdateManyMutationInput"
	},
	PlaylistUpdateToOneWithWhereWithoutAdBoardGroupsForAdsInput:{
		where:"PlaylistWhereInput",
		data:"PlaylistUpdateWithoutAdBoardGroupsForAdsInput"
	},
	AdBoardGroupUpdateToOneWithWhereWithoutAdBoardInput:{
		where:"AdBoardGroupWhereInput",
		data:"AdBoardGroupUpdateWithoutAdBoardInput"
	},
	AdBoardUpdateWithWhereUniqueWithoutWorkspaceInput:{
		where:"AdBoardWhereUniqueInput",
		data:"AdBoardUpdateWithoutWorkspaceInput"
	},
	AdBoardUpdateManyWithWhereWithoutWorkspaceInput:{
		where:"AdBoardScalarWhereInput",
		data:"AdBoardUpdateManyMutationInput"
	},
	WorkspaceUpdateToOneWithWhereWithoutPlaylistsInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutPlaylistsInput"
	},
	PlaylistUpdateWithWhereUniqueWithoutAdBoardGroupsInput:{
		where:"PlaylistWhereUniqueInput",
		data:"PlaylistUpdateWithoutAdBoardGroupsInput"
	},
	PlaylistUpdateManyWithWhereWithoutAdBoardGroupsInput:{
		where:"PlaylistScalarWhereInput",
		data:"PlaylistUpdateManyMutationInput"
	},
	AdBoardGroupUpdateToOneWithWhereWithoutPisignagePlayersInput:{
		where:"AdBoardGroupWhereInput",
		data:"AdBoardGroupUpdateWithoutPisignagePlayersInput"
	},
	PlayerUpdateWithWhereUniqueWithoutAdBoardsInput:{
		where:"PlayerWhereUniqueInput",
		data:"PlayerUpdateWithoutAdBoardsInput"
	},
	PlayerUpdateManyWithWhereWithoutAdBoardsInput:{
		where:"PlayerScalarWhereInput",
		data:"PlayerUpdateManyMutationInput"
	},
	AdBoardUpdateToOneWithWhereWithoutAdBoardGroupInput:{
		where:"AdBoardWhereInput",
		data:"AdBoardUpdateWithoutAdBoardGroupInput"
	},
	AdBoardGroupUpdateWithWhereUniqueWithoutAdsPlaylistInput:{
		where:"AdBoardGroupWhereUniqueInput",
		data:"AdBoardGroupUpdateWithoutAdsPlaylistInput"
	},
	AdBoardGroupUpdateManyWithWhereWithoutAdsPlaylistInput:{
		where:"AdBoardGroupScalarWhereInput",
		data:"AdBoardGroupUpdateManyMutationInput"
	},
	PlaylistUpdateToOneWithWhereWithoutSidebarParentPlaylistsInput:{
		where:"PlaylistWhereInput",
		data:"PlaylistUpdateWithoutSidebarParentPlaylistsInput"
	},
	PlaylistUpdateToOneWithWhereWithoutFooterParentPlaylistsInput:{
		where:"PlaylistWhereInput",
		data:"PlaylistUpdateWithoutFooterParentPlaylistsInput"
	},
	PlaylistUpdateWithWhereUniqueWithoutWorkspaceInput:{
		where:"PlaylistWhereUniqueInput",
		data:"PlaylistUpdateWithoutWorkspaceInput"
	},
	PlaylistUpdateManyWithWhereWithoutWorkspaceInput:{
		where:"PlaylistScalarWhereInput",
		data:"PlaylistUpdateManyMutationInput"
	},
	WorkspaceUpdateToOneWithWhereWithoutAdBoardsInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutAdBoardsInput"
	},
	AdBoardUpdateToOneWithWhereWithoutBookingsInput:{
		where:"AdBoardWhereInput",
		data:"AdBoardUpdateWithoutBookingsInput"
	},
	BookingUpdateWithWhereUniqueWithoutSharedUsersInput:{
		where:"BookingWhereUniqueInput",
		data:"BookingUpdateWithoutSharedUsersInput"
	},
	BookingUpdateManyWithWhereWithoutSharedUsersInput:{
		where:"BookingScalarWhereInput",
		data:"BookingUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutBookingsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutBookingsInput"
	},
	BookingUpdateWithWhereUniqueWithoutCampaignInput:{
		where:"BookingWhereUniqueInput",
		data:"BookingUpdateWithoutCampaignInput"
	},
	BookingUpdateManyWithWhereWithoutCampaignInput:{
		where:"BookingScalarWhereInput",
		data:"BookingUpdateManyMutationInput"
	},
	CampaignUpdateWithWhereUniqueWithoutUserInput:{
		where:"CampaignWhereUniqueInput",
		data:"CampaignUpdateWithoutUserInput"
	},
	CampaignUpdateManyWithWhereWithoutUserInput:{
		where:"CampaignScalarWhereInput",
		data:"CampaignUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutMembershipsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutMembershipsInput"
	},
	MembershipUpdateWithWhereUniqueWithoutWorkspaceInput:{
		where:"MembershipWhereUniqueInput",
		data:"MembershipUpdateWithoutWorkspaceInput"
	},
	MembershipUpdateManyWithWhereWithoutWorkspaceInput:{
		where:"MembershipScalarWhereInput",
		data:"MembershipUpdateManyMutationInput"
	},
	WorkspaceUpdateToOneWithWhereWithoutAuditsInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutAuditsInput"
	},
	AuditUpdateWithWhereUniqueWithoutUserInput:{
		where:"AuditWhereUniqueInput",
		data:"AuditUpdateWithoutUserInput"
	},
	AuditUpdateManyWithWhereWithoutUserInput:{
		where:"AuditScalarWhereInput",
		data:"AuditUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutOrdersInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutOrdersInput"
	},
	OrderUpdateWithWhereUniqueWithoutAdBoardInput:{
		where:"OrderWhereUniqueInput",
		data:"OrderUpdateWithoutAdBoardInput"
	},
	OrderUpdateManyWithWhereWithoutAdBoardInput:{
		where:"OrderScalarWhereInput",
		data:"OrderUpdateManyMutationInput"
	},
	OrderScalarWhereInput:{
		AND:"OrderScalarWhereInput",
		OR:"OrderScalarWhereInput",
		NOT:"OrderScalarWhereInput",
		id:"StringFilter",
		adBoardId:"StringFilter",
		createdDate:"DateTimeFilter",
		createdByUserId:"StringNullableFilter",
		origin:"StringFilter",
		paymentId:"StringNullableFilter"
	},
	OrderUpdateManyMutationInput:{
		createdDate:"DateTime",
		priceSummary:"PriceSummaryCreateInput",
		selectedDate:"OrderSelectedDateCreateInput"
	},
	AdBoardUpdateWithWhereUniqueWithoutCreatedByInput:{
		where:"AdBoardWhereUniqueInput",
		data:"AdBoardUpdateWithoutCreatedByInput"
	},
	AdBoardUpdateManyWithWhereWithoutCreatedByInput:{
		where:"AdBoardScalarWhereInput",
		data:"AdBoardUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutOwnedWorkspacesInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutOwnedWorkspacesInput"
	},
	WorkspaceUpdateToOneWithWhereWithoutFilesInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutFilesInput"
	},
	FileUpdateWithWhereUniqueWithoutProofBookingInput:{
		where:"FileWhereUniqueInput",
		data:"FileUpdateWithoutProofBookingInput"
	},
	FileUpdateManyWithWhereWithoutProofBookingInput:{
		where:"FileScalarWhereInput",
		data:"FileUpdateManyMutationInput"
	},
	BookingUpdateWithWhereUniqueWithoutAdCategoryInput:{
		where:"BookingWhereUniqueInput",
		data:"BookingUpdateWithoutAdCategoryInput"
	},
	BookingUpdateManyWithWhereWithoutAdCategoryInput:{
		where:"BookingScalarWhereInput",
		data:"BookingUpdateManyMutationInput"
	},
	AdvertisementCategoryUpdateWithWhereUniqueWithoutCampaignsInput:{
		where:"AdvertisementCategoryWhereUniqueInput",
		data:"AdvertisementCategoryUpdateWithoutCampaignsInput"
	},
	AdvertisementCategoryUpdateManyWithWhereWithoutCampaignsInput:{
		where:"AdvertisementCategoryScalarWhereInput",
		data:"AdvertisementCategoryUpdateManyMutationInput"
	},
	AdvertisementCategoryScalarWhereInput:{
		AND:"AdvertisementCategoryScalarWhereInput",
		OR:"AdvertisementCategoryScalarWhereInput",
		NOT:"AdvertisementCategoryScalarWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		type:"EnumAdvertisementCategoryEnumFilter",
		description:"StringNullableFilter",
		createdAt:"DateTimeFilter",
		updatedAt:"DateTimeFilter",
		campaignIds:"StringNullableListFilter",
		bookingIds:"StringNullableListFilter"
	},
	AdvertisementCategoryUpdateManyMutationInput:{
		type:"AdvertisementCategoryEnum",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	CampaignUpdateToOneWithWhereWithoutPaymentsInput:{
		where:"CampaignWhereInput",
		data:"CampaignUpdateWithoutPaymentsInput"
	},
	PaymentUpdateToOneWithWhereWithoutPaymentAllocationsInput:{
		where:"PaymentWhereInput",
		data:"PaymentUpdateWithoutPaymentAllocationsInput"
	},
	PaymentAllocationUpdateWithWhereUniqueWithoutBookingInput:{
		where:"PaymentAllocationWhereUniqueInput",
		data:"PaymentAllocationUpdateWithoutBookingInput"
	},
	PaymentAllocationUpdateManyWithWhereWithoutBookingInput:{
		where:"PaymentAllocationScalarWhereInput",
		data:"PaymentAllocationUpdateManyMutationInput"
	},
	BookingUpdateToOneWithWhereWithoutChangelogsInput:{
		where:"BookingWhereInput",
		data:"BookingUpdateWithoutChangelogsInput"
	},
	ChangelogUpdateWithWhereUniqueWithoutUserInput:{
		where:"ChangelogWhereUniqueInput",
		data:"ChangelogUpdateWithoutUserInput"
	},
	ChangelogUpdateManyWithWhereWithoutUserInput:{
		where:"ChangelogScalarWhereInput",
		data:"ChangelogUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutAdBoardsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutAdBoardsInput"
	},
	AdBoardUpdateToOneWithWhereWithoutOrdersInput:{
		where:"AdBoardWhereInput",
		data:"AdBoardUpdateWithoutOrdersInput"
	},
	OrderUpdateWithWhereUniqueWithoutCreatedByInput:{
		where:"OrderWhereUniqueInput",
		data:"OrderUpdateWithoutCreatedByInput"
	},
	OrderUpdateManyWithWhereWithoutCreatedByInput:{
		where:"OrderScalarWhereInput",
		data:"OrderUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutCreatedFilesInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutCreatedFilesInput"
	},
	FileUpdateWithWhereUniqueWithoutUpdatedByInput:{
		where:"FileWhereUniqueInput",
		data:"FileUpdateWithoutUpdatedByInput"
	},
	FileUpdateManyWithWhereWithoutUpdatedByInput:{
		where:"FileScalarWhereInput",
		data:"FileUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutSubmittedContentVersionsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutSubmittedContentVersionsInput"
	},
	ContentVersionUpdateWithWhereUniqueWithoutBookingInput:{
		where:"ContentVersionWhereUniqueInput",
		data:"ContentVersionUpdateWithoutBookingInput"
	},
	ContentVersionUpdateManyWithWhereWithoutBookingInput:{
		where:"ContentVersionScalarWhereInput",
		data:"ContentVersionUpdateManyMutationInput"
	},
	BookingUpdateWithWhereUniqueWithoutAssetsInput:{
		where:"BookingWhereUniqueInput",
		data:"BookingUpdateWithoutAssetsInput"
	},
	BookingUpdateManyWithWhereWithoutAssetsInput:{
		where:"BookingScalarWhereInput",
		data:"BookingUpdateManyMutationInput"
	},
	FileUpdateWithWhereUniqueWithoutCreatedByInput:{
		where:"FileWhereUniqueInput",
		data:"FileUpdateWithoutCreatedByInput"
	},
	FileUpdateManyWithWhereWithoutCreatedByInput:{
		where:"FileScalarWhereInput",
		data:"FileUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutUpdatedFilesInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutUpdatedFilesInput"
	},
	FileUpdateWithWhereUniqueWithoutBookingsInput:{
		where:"FileWhereUniqueInput",
		data:"FileUpdateWithoutBookingsInput"
	},
	FileUpdateManyWithWhereWithoutBookingsInput:{
		where:"FileScalarWhereInput",
		data:"FileUpdateManyMutationInput"
	},
	BookingUpdateWithWhereUniqueWithoutBusinessCategoryInput:{
		where:"BookingWhereUniqueInput",
		data:"BookingUpdateWithoutBusinessCategoryInput"
	},
	BookingUpdateManyWithWhereWithoutBusinessCategoryInput:{
		where:"BookingScalarWhereInput",
		data:"BookingUpdateManyMutationInput"
	},
	BusinessCategoryUpdateToOneWithWhereWithoutCampaignsInput:{
		where:"BusinessCategoryWhereInput",
		data:"BusinessCategoryUpdateWithoutCampaignsInput"
	},
	CampaignUpdateWithWhereUniqueWithoutAdCategoryInput:{
		where:"CampaignWhereUniqueInput",
		data:"CampaignUpdateWithoutAdCategoryInput"
	},
	CampaignUpdateManyWithWhereWithoutAdCategoryInput:{
		where:"CampaignScalarWhereInput",
		data:"CampaignUpdateManyMutationInput"
	},
	AdvertisementCategoryUpdateWithWhereUniqueWithoutBookingsInput:{
		where:"AdvertisementCategoryWhereUniqueInput",
		data:"AdvertisementCategoryUpdateWithoutBookingsInput"
	},
	AdvertisementCategoryUpdateManyWithWhereWithoutBookingsInput:{
		where:"AdvertisementCategoryScalarWhereInput",
		data:"AdvertisementCategoryUpdateManyMutationInput"
	},
	BookingUpdateWithWhereUniqueWithoutUserInput:{
		where:"BookingWhereUniqueInput",
		data:"BookingUpdateWithoutUserInput"
	},
	BookingUpdateManyWithWhereWithoutUserInput:{
		where:"BookingScalarWhereInput",
		data:"BookingUpdateManyMutationInput"
	},
	UserUpdateToOneWithWhereWithoutCampaignsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutCampaignsInput"
	},
	CampaignUpdateWithWhereUniqueWithoutBusinessCategoryInput:{
		where:"CampaignWhereUniqueInput",
		data:"CampaignUpdateWithoutBusinessCategoryInput"
	},
	CampaignUpdateManyWithWhereWithoutBusinessCategoryInput:{
		where:"CampaignScalarWhereInput",
		data:"CampaignUpdateManyMutationInput"
	},
	BusinessCategoryUpdateToOneWithWhereWithoutBookingsInput:{
		where:"BusinessCategoryWhereInput",
		data:"BusinessCategoryUpdateWithoutBookingsInput"
	},
	BookingUpdateWithWhereUniqueWithoutAdBoardInput:{
		where:"BookingWhereUniqueInput",
		data:"BookingUpdateWithoutAdBoardInput"
	},
	BookingUpdateManyWithWhereWithoutAdBoardInput:{
		where:"BookingScalarWhereInput",
		data:"BookingUpdateManyMutationInput"
	},
	AdBoardUpdateWithWhereUniqueWithoutCategoryInput:{
		where:"AdBoardWhereUniqueInput",
		data:"AdBoardUpdateWithoutCategoryInput"
	},
	AdBoardUpdateManyWithWhereWithoutCategoryInput:{
		where:"AdBoardScalarWhereInput",
		data:"AdBoardUpdateManyMutationInput"
	},
	BusinessCategoryUpdateWithWhereUniqueWithoutRestrictedByAdBoardsInput:{
		where:"BusinessCategoryWhereUniqueInput",
		data:"BusinessCategoryUpdateWithoutRestrictedByAdBoardsInput"
	},
	BusinessCategoryUpdateManyWithWhereWithoutRestrictedByAdBoardsInput:{
		where:"BusinessCategoryScalarWhereInput",
		data:"BusinessCategoryUpdateManyMutationInput"
	},
	BusinessCategoryScalarWhereInput:{
		AND:"BusinessCategoryScalarWhereInput",
		OR:"BusinessCategoryScalarWhereInput",
		NOT:"BusinessCategoryScalarWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		description:"StringNullableFilter",
		restrictedByAdBoardIds:"StringNullableListFilter"
	},
	BusinessCategoryUpdateManyMutationInput:{

	},
	AdBoardUpdateWithWhereUniqueWithoutLocationCategoryInput:{
		where:"AdBoardWhereUniqueInput",
		data:"AdBoardUpdateWithoutLocationCategoryInput"
	},
	AdBoardUpdateManyWithWhereWithoutLocationCategoryInput:{
		where:"AdBoardScalarWhereInput",
		data:"AdBoardUpdateManyMutationInput"
	},
	LocationCategoryUpdateToOneWithWhereWithoutLocationSubCategoryInput:{
		where:"LocationCategoryWhereInput",
		data:"LocationCategoryUpdateWithoutLocationSubCategoryInput"
	},
	LocationSubCategoryUpdateToOneWithWhereWithoutAdBoardsInput:{
		where:"LocationSubCategoryWhereInput",
		data:"LocationSubCategoryUpdateWithoutAdBoardsInput"
	},
	AdBoardUpdateWithWhereUniqueWithoutRestrictedBusinesInput:{
		where:"AdBoardWhereUniqueInput",
		data:"AdBoardUpdateWithoutRestrictedBusinesInput"
	},
	AdBoardUpdateManyWithWhereWithoutRestrictedBusinesInput:{
		where:"AdBoardScalarWhereInput",
		data:"AdBoardUpdateManyMutationInput"
	},
	BusinessCategoryUpdateToOneWithWhereWithoutAdBoardsInput:{
		where:"BusinessCategoryWhereInput",
		data:"BusinessCategoryUpdateWithoutAdBoardsInput"
	},
	AdBoardUpdateWithWhereUniqueWithoutLocationSubCategoryInput:{
		where:"AdBoardWhereUniqueInput",
		data:"AdBoardUpdateWithoutLocationSubCategoryInput"
	},
	AdBoardUpdateManyWithWhereWithoutLocationSubCategoryInput:{
		where:"AdBoardScalarWhereInput",
		data:"AdBoardUpdateManyMutationInput"
	},
	LocationSubCategoryUpdateWithWhereUniqueWithoutLocationCategoryInput:{
		where:"LocationSubCategoryWhereUniqueInput",
		data:"LocationSubCategoryUpdateWithoutLocationCategoryInput"
	},
	LocationSubCategoryUpdateManyWithWhereWithoutLocationCategoryInput:{
		where:"LocationSubCategoryScalarWhereInput",
		data:"LocationSubCategoryUpdateManyMutationInput"
	},
	LocationSubCategoryScalarWhereInput:{
		AND:"LocationSubCategoryScalarWhereInput",
		OR:"LocationSubCategoryScalarWhereInput",
		NOT:"LocationSubCategoryScalarWhereInput",
		id:"StringFilter",
		name:"StringFilter",
		locationCategoryId:"StringNullableFilter"
	},
	LocationSubCategoryUpdateManyMutationInput:{

	},
	LocationCategoryUpdateToOneWithWhereWithoutAdBoardsInput:{
		where:"LocationCategoryWhereInput",
		data:"LocationCategoryUpdateWithoutAdBoardsInput"
	},
	AdBoardGroupCreateManyInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType"
	},
	AdBoardGroupCreateInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType",
		adBoard:"AdBoardCreateNestedOneWithoutAdBoardGroupInput",
		scheduledPlaylists:"PlaylistCreateNestedManyWithoutAdBoardGroupsInput",
		adsPlaylist:"PlaylistCreateNestedOneWithoutAdBoardGroupsForAdsInput",
		pisignagePlayers:"PlayerCreateNestedManyWithoutAdBoardGroupInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardGroupsInput"
	},
	AdBoardGroupUpdateInput:{
		schedules:"ScheduleCreateInput",
		fitImage:"FitType",
		fitVideo:"FitType",
		adBoard:"AdBoardUpdateOneWithoutAdBoardGroupNestedInput",
		scheduledPlaylists:"PlaylistUpdateManyWithoutAdBoardGroupsNestedInput",
		adsPlaylist:"PlaylistUpdateOneWithoutAdBoardGroupsForAdsNestedInput",
		pisignagePlayers:"PlayerUpdateManyWithoutAdBoardGroupNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardGroupsNestedInput"
	},
	AdBoardTypeCreateManyInput:{

	},
	AdBoardTypeCreateInput:{
		adBoards:"AdBoardCreateNestedManyWithoutTypeInput"
	},
	AdBoardCreateNestedManyWithoutTypeInput:{
		create:"AdBoardCreateWithoutTypeInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutTypeInput",
		createMany:"AdBoardCreateManyTypeInputEnvelope",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutTypeInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		slotConfigurations:"SlotConfigurationCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	AdBoardCreateOrConnectWithoutTypeInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutTypeInput"
	},
	AdBoardCreateManyTypeInputEnvelope:{
		data:"AdBoardCreateManyTypeInput"
	},
	AdBoardCreateManyTypeInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime"
	},
	AdBoardTypeUpdateManyMutationInput:{

	},
	AdBoardTypeUpdateInput:{
		adBoards:"AdBoardUpdateManyWithoutTypeNestedInput"
	},
	AdBoardUpdateManyWithoutTypeNestedInput:{
		create:"AdBoardCreateWithoutTypeInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutTypeInput",
		upsert:"AdBoardUpsertWithWhereUniqueWithoutTypeInput",
		createMany:"AdBoardCreateManyTypeInputEnvelope",
		set:"AdBoardWhereUniqueInput",
		disconnect:"AdBoardWhereUniqueInput",
		delete:"AdBoardWhereUniqueInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithWhereUniqueWithoutTypeInput",
		updateMany:"AdBoardUpdateManyWithWhereWithoutTypeInput",
		deleteMany:"AdBoardScalarWhereInput"
	},
	AdBoardUpsertWithWhereUniqueWithoutTypeInput:{
		where:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateWithoutTypeInput",
		create:"AdBoardCreateWithoutTypeInput"
	},
	AdBoardUpdateWithoutTypeInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		slotConfigurations:"SlotConfigurationUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	AdBoardUpdateWithWhereUniqueWithoutTypeInput:{
		where:"AdBoardWhereUniqueInput",
		data:"AdBoardUpdateWithoutTypeInput"
	},
	AdBoardUpdateManyWithWhereWithoutTypeInput:{
		where:"AdBoardScalarWhereInput",
		data:"AdBoardUpdateManyMutationInput"
	},
	AdvertisementCategoryCreateManyInput:{
		type:"AdvertisementCategoryEnum",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	AdvertisementCategoryCreateInput:{
		type:"AdvertisementCategoryEnum",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		campaigns:"CampaignCreateNestedManyWithoutAdCategoryInput",
		bookings:"BookingCreateNestedManyWithoutAdCategoryInput"
	},
	AdvertisementCategoryUpdateInput:{
		type:"AdvertisementCategoryEnum",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		campaigns:"CampaignUpdateManyWithoutAdCategoryNestedInput",
		bookings:"BookingUpdateManyWithoutAdCategoryNestedInput"
	},
	AuditCreateManyInput:{
		createdAt:"DateTime",
		entity:"EntityCreateInput",
		updates:"JSON"
	},
	AuditCreateInput:{
		createdAt:"DateTime",
		entity:"EntityCreateInput",
		updates:"JSON",
		user:"UserCreateNestedOneWithoutAuditsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAuditsInput"
	},
	AuditUpdateInput:{
		createdAt:"DateTime",
		entity:"EntityCreateInput",
		updates:"JSON",
		user:"UserUpdateOneRequiredWithoutAuditsNestedInput",
		workspace:"WorkspaceUpdateOneWithoutAuditsNestedInput"
	},
	BookingCreateManyInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus"
	},
	BookingCreateInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutBookingsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutBookingsInput",
		assets:"FileCreateNestedManyWithoutBookingsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutBookingInput",
		paymentAllocations:"PaymentAllocationCreateNestedManyWithoutBookingInput",
		proofs:"FileCreateNestedManyWithoutProofBookingInput",
		user:"UserCreateNestedOneWithoutBookingsInput",
		adBoard:"AdBoardCreateNestedOneWithoutBookingsInput",
		changelogs:"ChangelogCreateNestedManyWithoutBookingInput",
		workspace:"WorkspaceCreateNestedOneWithoutBookingsInput",
		campaign:"CampaignCreateNestedOneWithoutBookingsInput",
		payouts:"PayoutCreateNestedManyWithoutBookingInput",
		sharedUsers:"UserCreateNestedManyWithoutSharedBookingsInput",
		slotUsage:"SlotUsageCreateNestedManyWithoutBookingInput",
		review:"AdBoardPublicReviewCreateNestedOneWithoutBookingInput",
		history:"BookingHistoryCreateNestedManyWithoutBookingInput",
		refundRequest:"RefundRequestCreateNestedOneWithoutBookingInput",
		refundApproval:"RefundApprovalCreateNestedOneWithoutBookingInput",
		refundProcessed:"RefundProcessedCreateNestedOneWithoutBookingInput"
	},
	BookingUpdateInput:{
		bookingDate:"DateTime",
		bookingDetails:"BookingUserDetailsCreateInput",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		selectedDates:"OrderSelectedDateCreateInput",
		payment:"BookingPaymentCreateInput",
		priceSummary:"PriceSummaryCreateInput",
		pisignage:"BookingPisignageDataCreateInput",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		businessCategory:"BusinessCategoryUpdateOneWithoutBookingsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutBookingsNestedInput",
		assets:"FileUpdateManyWithoutBookingsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutBookingNestedInput",
		paymentAllocations:"PaymentAllocationUpdateManyWithoutBookingNestedInput",
		proofs:"FileUpdateManyWithoutProofBookingNestedInput",
		user:"UserUpdateOneRequiredWithoutBookingsNestedInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutBookingsNestedInput",
		changelogs:"ChangelogUpdateManyWithoutBookingNestedInput",
		workspace:"WorkspaceUpdateOneWithoutBookingsNestedInput",
		campaign:"CampaignUpdateOneWithoutBookingsNestedInput",
		payouts:"PayoutUpdateManyWithoutBookingNestedInput",
		sharedUsers:"UserUpdateManyWithoutSharedBookingsNestedInput",
		slotUsage:"SlotUsageUpdateManyWithoutBookingNestedInput",
		review:"AdBoardPublicReviewUpdateOneWithoutBookingNestedInput",
		history:"BookingHistoryUpdateManyWithoutBookingNestedInput",
		refundRequest:"RefundRequestUpdateOneWithoutBookingNestedInput",
		refundApproval:"RefundApprovalUpdateOneWithoutBookingNestedInput",
		refundProcessed:"RefundProcessedUpdateOneWithoutBookingNestedInput"
	},
	BusinessCategoryCreateManyInput:{

	},
	BusinessCategoryCreateInput:{
		adBoards:"AdBoardCreateNestedManyWithoutCategoryInput",
		restrictedByAdBoards:"AdBoardCreateNestedManyWithoutRestrictedBusinesInput",
		campaigns:"CampaignCreateNestedManyWithoutBusinessCategoryInput",
		bookings:"BookingCreateNestedManyWithoutBusinessCategoryInput"
	},
	BusinessCategoryUpdateInput:{
		adBoards:"AdBoardUpdateManyWithoutCategoryNestedInput",
		restrictedByAdBoards:"AdBoardUpdateManyWithoutRestrictedBusinesNestedInput",
		campaigns:"CampaignUpdateManyWithoutBusinessCategoryNestedInput",
		bookings:"BookingUpdateManyWithoutBusinessCategoryNestedInput"
	},
	CameraCreateManyInput:{
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	CameraCreateInput:{
		createdAt:"DateTime",
		updatedAt:"DateTime",
		player:"PlayerCreateNestedOneWithoutCamerasInput",
		workspace:"WorkspaceCreateNestedOneWithoutCamerasInput"
	},
	CameraUpdateInput:{
		createdAt:"DateTime",
		updatedAt:"DateTime",
		player:"PlayerUpdateOneWithoutCamerasNestedInput",
		workspace:"WorkspaceUpdateOneWithoutCamerasNestedInput"
	},
	CampaignCreateManyInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	CampaignCreateInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		businessCategory:"BusinessCategoryCreateNestedOneWithoutCampaignsInput",
		user:"UserCreateNestedOneWithoutCampaignsInput",
		adCategory:"AdvertisementCategoryCreateNestedManyWithoutCampaignsInput",
		bookings:"BookingCreateNestedManyWithoutCampaignInput",
		payments:"PaymentCreateNestedManyWithoutCampaignInput",
		assets:"FileCreateNestedManyWithoutCampaignsInput"
	},
	CampaignUpdateInput:{
		payment:"BookingPaymentCreateInput",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummaryCreateInput",
		selectedDates:"OrderSelectedDateCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		businessCategory:"BusinessCategoryUpdateOneRequiredWithoutCampaignsNestedInput",
		user:"UserUpdateOneRequiredWithoutCampaignsNestedInput",
		adCategory:"AdvertisementCategoryUpdateManyWithoutCampaignsNestedInput",
		bookings:"BookingUpdateManyWithoutCampaignNestedInput",
		payments:"PaymentUpdateManyWithoutCampaignNestedInput",
		assets:"FileUpdateManyWithoutCampaignsNestedInput"
	},
	FileCreateManyInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime"
	},
	FileCreateInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserCreateNestedOneWithoutUpdatedFilesInput",
		createdBy:"UserCreateNestedOneWithoutCreatedFilesInput",
		bookings:"BookingCreateNestedManyWithoutAssetsInput",
		workspace:"WorkspaceCreateNestedOneWithoutFilesInput",
		proofBooking:"BookingCreateNestedOneWithoutProofsInput",
		campaigns:"CampaignCreateNestedManyWithoutAssetsInput",
		contentVersions:"ContentVersionCreateNestedManyWithoutAssetsInput"
	},
	FileUpdateInput:{
		meta:"FileMetaCreateInput",
		status:"FileStatus",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedBy:"UserUpdateOneWithoutUpdatedFilesNestedInput",
		createdBy:"UserUpdateOneRequiredWithoutCreatedFilesNestedInput",
		bookings:"BookingUpdateManyWithoutAssetsNestedInput",
		workspace:"WorkspaceUpdateOneWithoutFilesNestedInput",
		proofBooking:"BookingUpdateOneWithoutProofsNestedInput",
		campaigns:"CampaignUpdateManyWithoutAssetsNestedInput",
		contentVersions:"ContentVersionUpdateManyWithoutAssetsNestedInput"
	},
	MembershipCreateManyInput:{
		createdAt:"DateTime"
	},
	MembershipCreateInput:{
		createdAt:"DateTime",
		user:"UserCreateNestedOneWithoutMembershipsInput",
		workspace:"WorkspaceCreateNestedOneWithoutMembershipsInput",
		role:"WorkspaceRoleCreateNestedOneWithoutMembershipsInput"
	},
	MembershipUpdateInput:{
		createdAt:"DateTime",
		user:"UserUpdateOneRequiredWithoutMembershipsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutMembershipsNestedInput",
		role:"WorkspaceRoleUpdateOneRequiredWithoutMembershipsNestedInput"
	},
	NotificationCreateManyInput:{
		type:"NotificationType",
		metadata:"JSON",
		createdAt:"DateTime",
		readAt:"DateTime",
		channels:"NotificationChannel"
	},
	NotificationCreateInput:{
		type:"NotificationType",
		metadata:"JSON",
		createdAt:"DateTime",
		readAt:"DateTime",
		channels:"NotificationChannel",
		recipient:"UserCreateNestedOneWithoutNotificationsInput"
	},
	UserCreateNestedOneWithoutNotificationsInput:{
		create:"UserCreateWithoutNotificationsInput",
		connectOrCreate:"UserCreateOrConnectWithoutNotificationsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutNotificationsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	UserCreateOrConnectWithoutNotificationsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutNotificationsInput"
	},
	NotificationUpdateInput:{
		type:"NotificationType",
		metadata:"JSON",
		createdAt:"DateTime",
		readAt:"DateTime",
		channels:"NotificationChannel",
		recipient:"UserUpdateOneRequiredWithoutNotificationsNestedInput"
	},
	UserUpdateOneRequiredWithoutNotificationsNestedInput:{
		create:"UserCreateWithoutNotificationsInput",
		connectOrCreate:"UserCreateOrConnectWithoutNotificationsInput",
		upsert:"UserUpsertWithoutNotificationsInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutNotificationsInput"
	},
	UserUpsertWithoutNotificationsInput:{
		update:"UserUpdateWithoutNotificationsInput",
		create:"UserCreateWithoutNotificationsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutNotificationsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	UserUpdateToOneWithWhereWithoutNotificationsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutNotificationsInput"
	},
	OrderCreateManyInput:{
		createdDate:"DateTime",
		priceSummary:"PriceSummaryCreateInput",
		selectedDate:"OrderSelectedDateCreateInput"
	},
	OrderCreateInput:{
		createdDate:"DateTime",
		priceSummary:"PriceSummaryCreateInput",
		selectedDate:"OrderSelectedDateCreateInput",
		adBoard:"AdBoardCreateNestedOneWithoutOrdersInput",
		createdBy:"UserCreateNestedOneWithoutOrdersInput"
	},
	OrderUpdateInput:{
		createdDate:"DateTime",
		priceSummary:"PriceSummaryCreateInput",
		selectedDate:"OrderSelectedDateCreateInput",
		adBoard:"AdBoardUpdateOneRequiredWithoutOrdersNestedInput",
		createdBy:"UserUpdateOneWithoutOrdersNestedInput"
	},
	PlayerCreateManyInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime"
	},
	PlayerCreateInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutPisignagePlayersInput",
		workspace:"WorkspaceCreateNestedOneWithoutPlayersInput",
		status:"PlayerUptimeStatusCreateNestedManyWithoutPlayerInput",
		cameras:"CameraCreateNestedManyWithoutPlayerInput",
		signageType:"DigitalSignageCreateNestedOneWithoutPlayersInput",
		audienceType:"AudienceCreateNestedManyWithoutPlayersInput",
		adBoards:"AdBoardCreateNestedManyWithoutPlayersInput",
		deletedBy:"UserCreateNestedOneWithoutDeletedPlayerIdsInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutPlayerInput"
	},
	PlayerUpdateInput:{
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackDetails:"PlaybackTimeCreateInput",
		aspectRatioType:"AspectRatioType",
		map:"MapCreateInput",
		galleryFiles:"GalleryFileCreateInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		deletedAt:"DateTime",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutPisignagePlayersNestedInput",
		workspace:"WorkspaceUpdateOneWithoutPlayersNestedInput",
		status:"PlayerUptimeStatusUpdateManyWithoutPlayerNestedInput",
		cameras:"CameraUpdateManyWithoutPlayerNestedInput",
		signageType:"DigitalSignageUpdateOneWithoutPlayersNestedInput",
		audienceType:"AudienceUpdateManyWithoutPlayersNestedInput",
		adBoards:"AdBoardUpdateManyWithoutPlayersNestedInput",
		deletedBy:"UserUpdateOneWithoutDeletedPlayerIdsNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutPlayerNestedInput"
	},
	PlaylistCreateManyInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout"
	},
	PlaylistCreateInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistCreateNestedOneWithoutFooterParentPlaylistsInput",
		sidebarPlaylist:"PlaylistCreateNestedOneWithoutSidebarParentPlaylistsInput",
		adBoardGroupsForAds:"AdBoardGroupCreateNestedManyWithoutAdsPlaylistInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutScheduledPlaylistsInput",
		workspace:"WorkspaceCreateNestedOneWithoutPlaylistsInput",
		footerParentPlaylists:"PlaylistCreateNestedManyWithoutFooterPlaylistInput",
		sidebarParentPlaylists:"PlaylistCreateNestedManyWithoutSidebarPlaylistInput"
	},
	PlaylistUpdateInput:{
		assets:"PisignageFileCreateInput",
		layout:"ScreenLayout",
		footerPlaylist:"PlaylistUpdateOneWithoutFooterParentPlaylistsNestedInput",
		sidebarPlaylist:"PlaylistUpdateOneWithoutSidebarParentPlaylistsNestedInput",
		adBoardGroupsForAds:"AdBoardGroupUpdateManyWithoutAdsPlaylistNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutScheduledPlaylistsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutPlaylistsNestedInput",
		footerParentPlaylists:"PlaylistUpdateManyWithoutFooterPlaylistNestedInput",
		sidebarParentPlaylists:"PlaylistUpdateManyWithoutSidebarPlaylistNestedInput"
	},
	SlotConfigurationCreateManyInput:{
		date:"DateTime"
	},
	SlotConfigurationCreateInput:{
		date:"DateTime",
		adBoard:"AdBoardCreateNestedOneWithoutSlotConfigurationsInput"
	},
	AdBoardCreateNestedOneWithoutSlotConfigurationsInput:{
		create:"AdBoardCreateWithoutSlotConfigurationsInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutSlotConfigurationsInput",
		connect:"AdBoardWhereUniqueInput"
	},
	AdBoardCreateWithoutSlotConfigurationsInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryCreateNestedOneWithoutAdBoardsInput",
		locationSubCategory:"LocationSubCategoryCreateNestedOneWithoutAdBoardsInput",
		type:"AdBoardTypeCreateNestedOneWithoutAdBoardsInput",
		category:"BusinessCategoryCreateNestedOneWithoutAdBoardsInput",
		restrictedBusines:"BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput",
		bookings:"BookingCreateNestedManyWithoutAdBoardInput",
		orders:"OrderCreateNestedManyWithoutAdBoardInput",
		createdBy:"UserCreateNestedOneWithoutAdBoardsInput",
		workspace:"WorkspaceCreateNestedOneWithoutAdBoardsInput",
		players:"PlayerCreateNestedManyWithoutAdBoardsInput",
		adBoardGroup:"AdBoardGroupCreateNestedOneWithoutAdBoardInput",
		publishedVersion:"AdBoardCreateNestedOneWithoutDraftAdboardInput",
		draftAdboard:"AdBoardCreateNestedOneWithoutPublishedVersionInput",
		history:"AdBoardPublishHistoryCreateNestedManyWithoutAdBoardInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutAdBoardInput",
		archivedBy:"UserCreateNestedOneWithoutArchivedAdboardsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutAdBoardInput",
		wishlists:"WishlistCreateNestedManyWithoutAdBoardsInput"
	},
	AdBoardCreateOrConnectWithoutSlotConfigurationsInput:{
		where:"AdBoardWhereUniqueInput",
		create:"AdBoardCreateWithoutSlotConfigurationsInput"
	},
	SlotConfigurationUpdateInput:{
		date:"DateTime",
		adBoard:"AdBoardUpdateOneRequiredWithoutSlotConfigurationsNestedInput"
	},
	AdBoardUpdateOneRequiredWithoutSlotConfigurationsNestedInput:{
		create:"AdBoardCreateWithoutSlotConfigurationsInput",
		connectOrCreate:"AdBoardCreateOrConnectWithoutSlotConfigurationsInput",
		upsert:"AdBoardUpsertWithoutSlotConfigurationsInput",
		connect:"AdBoardWhereUniqueInput",
		update:"AdBoardUpdateToOneWithWhereWithoutSlotConfigurationsInput"
	},
	AdBoardUpsertWithoutSlotConfigurationsInput:{
		update:"AdBoardUpdateWithoutSlotConfigurationsInput",
		create:"AdBoardCreateWithoutSlotConfigurationsInput",
		where:"AdBoardWhereInput"
	},
	AdBoardUpdateWithoutSlotConfigurationsInput:{
		pricingTiers:"PricingTierCreateInput",
		aboutSpecifications:"SpecificationCreateInput",
		specifications:"SpecificationCreateInput",
		resolution:"ResolutionCreateInput",
		screenSize:"ScreenSizeCreateInput",
		playbackTimes:"PlaybackTimeCreateInput",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		createdAt:"DateTime",
		additionalData:"JSON",
		lastPublishedAt:"DateTime",
		archivedAt:"DateTime",
		updatedAt:"DateTime",
		locationCategory:"LocationCategoryUpdateOneWithoutAdBoardsNestedInput",
		locationSubCategory:"LocationSubCategoryUpdateOneWithoutAdBoardsNestedInput",
		type:"AdBoardTypeUpdateOneWithoutAdBoardsNestedInput",
		category:"BusinessCategoryUpdateOneWithoutAdBoardsNestedInput",
		restrictedBusines:"BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput",
		bookings:"BookingUpdateManyWithoutAdBoardNestedInput",
		orders:"OrderUpdateManyWithoutAdBoardNestedInput",
		createdBy:"UserUpdateOneWithoutAdBoardsNestedInput",
		workspace:"WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput",
		players:"PlayerUpdateManyWithoutAdBoardsNestedInput",
		adBoardGroup:"AdBoardGroupUpdateOneWithoutAdBoardNestedInput",
		publishedVersion:"AdBoardUpdateOneWithoutDraftAdboardNestedInput",
		draftAdboard:"AdBoardUpdateOneWithoutPublishedVersionNestedInput",
		history:"AdBoardPublishHistoryUpdateManyWithoutAdBoardNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutAdBoardNestedInput",
		archivedBy:"UserUpdateOneWithoutArchivedAdboardsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutAdBoardNestedInput",
		wishlists:"WishlistUpdateManyWithoutAdBoardsNestedInput"
	},
	AdBoardUpdateToOneWithWhereWithoutSlotConfigurationsInput:{
		where:"AdBoardWhereInput",
		data:"AdBoardUpdateWithoutSlotConfigurationsInput"
	},
	SubscriptionCreateManyInput:{
		startDate:"DateTime",
		endDate:"DateTime",
		cancellationDetails:"CancellationDetailsCreateInput"
	},
	SubscriptionCreateInput:{
		startDate:"DateTime",
		endDate:"DateTime",
		cancellationDetails:"CancellationDetailsCreateInput",
		activeWorkspace:"WorkspaceCreateNestedOneWithoutActiveSubscriptionInput"
	},
	WorkspaceCreateNestedOneWithoutActiveSubscriptionInput:{
		create:"WorkspaceCreateWithoutActiveSubscriptionInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutActiveSubscriptionInput",
		connect:"WorkspaceWhereUniqueInput"
	},
	WorkspaceCreateWithoutActiveSubscriptionInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	WorkspaceCreateOrConnectWithoutActiveSubscriptionInput:{
		where:"WorkspaceWhereUniqueInput",
		create:"WorkspaceCreateWithoutActiveSubscriptionInput"
	},
	SubscriptionUpdateManyMutationInput:{
		startDate:"DateTime",
		endDate:"DateTime",
		cancellationDetails:"CancellationDetailsCreateInput"
	},
	SubscriptionUpdateInput:{
		startDate:"DateTime",
		endDate:"DateTime",
		cancellationDetails:"CancellationDetailsCreateInput",
		activeWorkspace:"WorkspaceUpdateOneRequiredWithoutActiveSubscriptionNestedInput"
	},
	WorkspaceUpdateOneRequiredWithoutActiveSubscriptionNestedInput:{
		create:"WorkspaceCreateWithoutActiveSubscriptionInput",
		connectOrCreate:"WorkspaceCreateOrConnectWithoutActiveSubscriptionInput",
		upsert:"WorkspaceUpsertWithoutActiveSubscriptionInput",
		connect:"WorkspaceWhereUniqueInput",
		update:"WorkspaceUpdateToOneWithWhereWithoutActiveSubscriptionInput"
	},
	WorkspaceUpsertWithoutActiveSubscriptionInput:{
		update:"WorkspaceUpdateWithoutActiveSubscriptionInput",
		create:"WorkspaceCreateWithoutActiveSubscriptionInput",
		where:"WorkspaceWhereInput"
	},
	WorkspaceUpdateWithoutActiveSubscriptionInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	WorkspaceUpdateToOneWithWhereWithoutActiveSubscriptionInput:{
		where:"WorkspaceWhereInput",
		data:"WorkspaceUpdateWithoutActiveSubscriptionInput"
	},
	UserCreateManyInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput"
	},
	UserCreateInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		userPositions:"UserPositionCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	UserUpdateInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		userPositions:"UserPositionUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	UserPositionCreateManyInput:{
		timestamp:"DateTime",
		createdAt:"DateTime",
		coords:"UserPositionCoordsCreateInput",
		location:"UserPositionLocationCreateInput"
	},
	UserPositionCreateInput:{
		timestamp:"DateTime",
		createdAt:"DateTime",
		coords:"UserPositionCoordsCreateInput",
		location:"UserPositionLocationCreateInput",
		user:"UserCreateNestedOneWithoutUserPositionsInput"
	},
	UserCreateNestedOneWithoutUserPositionsInput:{
		create:"UserCreateWithoutUserPositionsInput",
		connectOrCreate:"UserCreateOrConnectWithoutUserPositionsInput",
		connect:"UserWhereUniqueInput"
	},
	UserCreateWithoutUserPositionsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingCreateNestedManyWithoutUserInput",
		createdFiles:"FileCreateNestedManyWithoutCreatedByInput",
		updatedFiles:"FileCreateNestedManyWithoutUpdatedByInput",
		orders:"OrderCreateNestedManyWithoutCreatedByInput",
		changelogs:"ChangelogCreateNestedManyWithoutUserInput",
		adBoards:"AdBoardCreateNestedManyWithoutCreatedByInput",
		audits:"AuditCreateNestedManyWithoutUserInput",
		campaigns:"CampaignCreateNestedManyWithoutUserInput",
		sharedBookings:"BookingCreateNestedManyWithoutSharedUsersInput",
		memberships:"MembershipCreateNestedManyWithoutUserInput",
		notifications:"NotificationCreateNestedManyWithoutRecipientInput",
		publishAdboardVersion:"AdBoardPublishHistoryCreateNestedManyWithoutPublishedByInput",
		reviewComments:"AdBoardReviewCommentCreateNestedManyWithoutUserInput",
		archivedAdboards:"AdBoardCreateNestedManyWithoutArchivedByInput",
		ownedWorkspaces:"WorkspaceCreateNestedManyWithoutOwnerInput",
		leadWorspaces:"WorkspaceCreateNestedManyWithoutLeadsInput",
		publicReviews:"AdBoardPublicReviewCreateNestedManyWithoutUserInput",
		wishlists:"WishlistCreateNestedManyWithoutUserInput",
		deletedPlayerIds:"PlayerCreateNestedManyWithoutDeletedByInput",
		deployedContentVersions:"ContentVersionCreateNestedManyWithoutDeployedByInput",
		submittedContentVersions:"ContentVersionCreateNestedManyWithoutSubmittedByInput",
		approvedContentVersions:"ContentVersionCreateNestedManyWithoutApprovedByInput"
	},
	UserCreateOrConnectWithoutUserPositionsInput:{
		where:"UserWhereUniqueInput",
		create:"UserCreateWithoutUserPositionsInput"
	},
	UserPositionUpdateInput:{
		timestamp:"DateTime",
		createdAt:"DateTime",
		coords:"UserPositionCoordsCreateInput",
		location:"UserPositionLocationCreateInput",
		user:"UserUpdateOneRequiredWithoutUserPositionsNestedInput"
	},
	UserUpdateOneRequiredWithoutUserPositionsNestedInput:{
		create:"UserCreateWithoutUserPositionsInput",
		connectOrCreate:"UserCreateOrConnectWithoutUserPositionsInput",
		upsert:"UserUpsertWithoutUserPositionsInput",
		connect:"UserWhereUniqueInput",
		update:"UserUpdateToOneWithWhereWithoutUserPositionsInput"
	},
	UserUpsertWithoutUserPositionsInput:{
		update:"UserUpdateWithoutUserPositionsInput",
		create:"UserCreateWithoutUserPositionsInput",
		where:"UserWhereInput"
	},
	UserUpdateWithoutUserPositionsInput:{
		otherDetails:"JSON",
		stripe:"UserStripeCreateInput",
		roles:"Role",
		refunds:"BookingRefundCreateInput",
		notificationPreference:"NotificationPreferenceCreateInput",
		bookings:"BookingUpdateManyWithoutUserNestedInput",
		createdFiles:"FileUpdateManyWithoutCreatedByNestedInput",
		updatedFiles:"FileUpdateManyWithoutUpdatedByNestedInput",
		orders:"OrderUpdateManyWithoutCreatedByNestedInput",
		changelogs:"ChangelogUpdateManyWithoutUserNestedInput",
		adBoards:"AdBoardUpdateManyWithoutCreatedByNestedInput",
		audits:"AuditUpdateManyWithoutUserNestedInput",
		campaigns:"CampaignUpdateManyWithoutUserNestedInput",
		sharedBookings:"BookingUpdateManyWithoutSharedUsersNestedInput",
		memberships:"MembershipUpdateManyWithoutUserNestedInput",
		notifications:"NotificationUpdateManyWithoutRecipientNestedInput",
		publishAdboardVersion:"AdBoardPublishHistoryUpdateManyWithoutPublishedByNestedInput",
		reviewComments:"AdBoardReviewCommentUpdateManyWithoutUserNestedInput",
		archivedAdboards:"AdBoardUpdateManyWithoutArchivedByNestedInput",
		ownedWorkspaces:"WorkspaceUpdateManyWithoutOwnerNestedInput",
		leadWorspaces:"WorkspaceUpdateManyWithoutLeadsNestedInput",
		publicReviews:"AdBoardPublicReviewUpdateManyWithoutUserNestedInput",
		wishlists:"WishlistUpdateManyWithoutUserNestedInput",
		deletedPlayerIds:"PlayerUpdateManyWithoutDeletedByNestedInput",
		deployedContentVersions:"ContentVersionUpdateManyWithoutDeployedByNestedInput",
		submittedContentVersions:"ContentVersionUpdateManyWithoutSubmittedByNestedInput",
		approvedContentVersions:"ContentVersionUpdateManyWithoutApprovedByNestedInput"
	},
	UserUpdateToOneWithWhereWithoutUserPositionsInput:{
		where:"UserWhereInput",
		data:"UserUpdateWithoutUserPositionsInput"
	},
	WishlistCreateManyInput:{
		createdAt:"DateTime"
	},
	WishlistCreateInput:{
		createdAt:"DateTime",
		user:"UserCreateNestedOneWithoutWishlistsInput",
		adBoards:"AdBoardCreateNestedManyWithoutWishlistsInput"
	},
	WishlistUpdateInput:{
		createdAt:"DateTime",
		user:"UserUpdateOneRequiredWithoutWishlistsNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWishlistsNestedInput"
	},
	WorkspaceCreateManyInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	WorkspaceCreateInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserCreateNestedOneWithoutOwnedWorkspacesInput",
		memberships:"MembershipCreateNestedManyWithoutWorkspaceInput",
		adBoards:"AdBoardCreateNestedManyWithoutWorkspaceInput",
		playlists:"PlaylistCreateNestedManyWithoutWorkspaceInput",
		adBoardGroups:"AdBoardGroupCreateNestedManyWithoutWorkspaceInput",
		audits:"AuditCreateNestedManyWithoutWorkspaceInput",
		bookings:"BookingCreateNestedManyWithoutWorkspaceInput",
		files:"FileCreateNestedManyWithoutWorkspaceInput",
		players:"PlayerCreateNestedManyWithoutWorkspaceInput",
		transactions:"TransactionCreateNestedManyWithoutWorkspaceInput",
		activeSubscription:"SubscriptionCreateNestedOneWithoutActiveWorkspaceInput",
		workspaceRoles:"WorkspaceRoleCreateNestedManyWithoutWorkspaceInput",
		leads:"UserCreateNestedManyWithoutLeadWorspacesInput",
		cameras:"CameraCreateNestedManyWithoutWorkspaceInput",
		cameraStreamingDevices:"StreamingDeviceCreateNestedManyWithoutWorkspaceInput"
	},
	WorkspaceUpdateInput:{
		type:"WorkspaceType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		owner:"UserUpdateOneWithoutOwnedWorkspacesNestedInput",
		memberships:"MembershipUpdateManyWithoutWorkspaceNestedInput",
		adBoards:"AdBoardUpdateManyWithoutWorkspaceNestedInput",
		playlists:"PlaylistUpdateManyWithoutWorkspaceNestedInput",
		adBoardGroups:"AdBoardGroupUpdateManyWithoutWorkspaceNestedInput",
		audits:"AuditUpdateManyWithoutWorkspaceNestedInput",
		bookings:"BookingUpdateManyWithoutWorkspaceNestedInput",
		files:"FileUpdateManyWithoutWorkspaceNestedInput",
		players:"PlayerUpdateManyWithoutWorkspaceNestedInput",
		transactions:"TransactionUpdateManyWithoutWorkspaceNestedInput",
		activeSubscription:"SubscriptionUpdateOneWithoutActiveWorkspaceNestedInput",
		workspaceRoles:"WorkspaceRoleUpdateManyWithoutWorkspaceNestedInput",
		leads:"UserUpdateManyWithoutLeadWorspacesNestedInput",
		cameras:"CameraUpdateManyWithoutWorkspaceNestedInput",
		cameraStreamingDevices:"StreamingDeviceUpdateManyWithoutWorkspaceNestedInput"
	},
	WorkspaceRoleCreateManyInput:{
		permissions:"Permission",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	WorkspaceRoleCreateInput:{
		permissions:"Permission",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		workspace:"WorkspaceCreateNestedOneWithoutWorkspaceRolesInput",
		memberships:"MembershipCreateNestedManyWithoutRoleInput"
	},
	WorkspaceRoleUpdateInput:{
		permissions:"Permission",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		workspace:"WorkspaceUpdateOneWithoutWorkspaceRolesNestedInput",
		memberships:"MembershipUpdateManyWithoutRoleNestedInput"
	},
	AccountDetails:{

	},
	UserInput:{

	},
	TemplateIds: "enum" as const,
	AdBoardPublicReviewCreateInput:{
		createdAt:"DateTime",
		adBoard:"AdBoardCreateNestedOneWithoutPublicReviewsInput",
		user:"UserCreateNestedOneWithoutPublicReviewsInput",
		booking:"BookingCreateNestedOneWithoutReviewInput"
	},
	StreamingDeviceCreateInput:{
		connectionLogs:"ConnectionLogCreateInput",
		billboardMonitoring:"BillboardMonitoringCreateInput",
		trafficMonitoring:"TrafficMonitoringCreateInput",
		services:"StreamingServicesCreateInput",
		player:"PlayerCreateNestedOneWithoutCameraStreamingDevicesInput",
		workspace:"WorkspaceCreateNestedOneWithoutCameraStreamingDevicesInput",
		billboardMonitoringAlerts:"BillboardMonitoringAlertCreateNestedManyWithoutStreamingDeviceInput"
	},
	StreamingDeviceUpdateInput:{
		connectionLogs:"ConnectionLogCreateInput",
		billboardMonitoring:"BillboardMonitoringCreateInput",
		trafficMonitoring:"TrafficMonitoringCreateInput",
		services:"StreamingServicesCreateInput",
		player:"PlayerUpdateOneWithoutCameraStreamingDevicesNestedInput",
		workspace:"WorkspaceUpdateOneWithoutCameraStreamingDevicesNestedInput",
		billboardMonitoringAlerts:"BillboardMonitoringAlertUpdateManyWithoutStreamingDeviceNestedInput"
	},
	AssetRow:{

	},
	PlayerPlaySettingInput:{

	}
}

export const ReturnTypes: Record<string,any> = {
	Query:{
		aggregateAdBoard:"AggregateAdBoard",
		findFirstAdBoard:"AdBoard",
		findFirstAdBoardOrThrow:"AdBoard",
		adBoards:"AdBoard",
		adBoard:"AdBoard",
		getAdBoard:"AdBoard",
		groupByAdBoard:"AdBoardGroupBy",
		aggregateAdBoardGroup:"AggregateAdBoardGroup",
		findFirstAdBoardGroup:"AdBoardGroup",
		findFirstAdBoardGroupOrThrow:"AdBoardGroup",
		adBoardGroups:"AdBoardGroup",
		adBoardGroup:"AdBoardGroup",
		getAdBoardGroup:"AdBoardGroup",
		groupByAdBoardGroup:"AdBoardGroupGroupBy",
		aggregateAdBoardType:"AggregateAdBoardType",
		findFirstAdBoardType:"AdBoardType",
		findFirstAdBoardTypeOrThrow:"AdBoardType",
		adBoardTypes:"AdBoardType",
		adBoardType:"AdBoardType",
		getAdBoardType:"AdBoardType",
		groupByAdBoardType:"AdBoardTypeGroupBy",
		aggregateAdvertisementCategory:"AggregateAdvertisementCategory",
		findFirstAdvertisementCategory:"AdvertisementCategory",
		findFirstAdvertisementCategoryOrThrow:"AdvertisementCategory",
		advertisementCategories:"AdvertisementCategory",
		advertisementCategory:"AdvertisementCategory",
		getAdvertisementCategory:"AdvertisementCategory",
		groupByAdvertisementCategory:"AdvertisementCategoryGroupBy",
		aggregateAudit:"AggregateAudit",
		findFirstAudit:"Audit",
		findFirstAuditOrThrow:"Audit",
		audits:"Audit",
		audit:"Audit",
		getAudit:"Audit",
		groupByAudit:"AuditGroupBy",
		aggregateBooking:"AggregateBooking",
		findFirstBooking:"Booking",
		findFirstBookingOrThrow:"Booking",
		bookings:"Booking",
		booking:"Booking",
		getBooking:"Booking",
		groupByBooking:"BookingGroupBy",
		aggregateBusinessCategory:"AggregateBusinessCategory",
		findFirstBusinessCategory:"BusinessCategory",
		findFirstBusinessCategoryOrThrow:"BusinessCategory",
		businessCategories:"BusinessCategory",
		businessCategory:"BusinessCategory",
		getBusinessCategory:"BusinessCategory",
		groupByBusinessCategory:"BusinessCategoryGroupBy",
		aggregateCamera:"AggregateCamera",
		findFirstCamera:"Camera",
		findFirstCameraOrThrow:"Camera",
		cameras:"Camera",
		camera:"Camera",
		getCamera:"Camera",
		groupByCamera:"CameraGroupBy",
		aggregateCampaign:"AggregateCampaign",
		findFirstCampaign:"Campaign",
		findFirstCampaignOrThrow:"Campaign",
		campaigns:"Campaign",
		campaign:"Campaign",
		getCampaign:"Campaign",
		groupByCampaign:"CampaignGroupBy",
		aggregateFile:"AggregateFile",
		findFirstFile:"File",
		findFirstFileOrThrow:"File",
		files:"File",
		file:"File",
		getFile:"File",
		groupByFile:"FileGroupBy",
		aggregateMembership:"AggregateMembership",
		findFirstMembership:"Membership",
		findFirstMembershipOrThrow:"Membership",
		memberships:"Membership",
		membership:"Membership",
		getMembership:"Membership",
		groupByMembership:"MembershipGroupBy",
		aggregateNotification:"AggregateNotification",
		findFirstNotification:"Notification",
		findFirstNotificationOrThrow:"Notification",
		notifications:"Notification",
		notification:"Notification",
		getNotification:"Notification",
		groupByNotification:"NotificationGroupBy",
		aggregateOrder:"AggregateOrder",
		findFirstOrder:"Order",
		findFirstOrderOrThrow:"Order",
		orders:"Order",
		order:"Order",
		getOrder:"Order",
		groupByOrder:"OrderGroupBy",
		aggregatePlayer:"AggregatePlayer",
		findFirstPlayer:"Player",
		findFirstPlayerOrThrow:"Player",
		players:"Player",
		player:"Player",
		getPlayer:"Player",
		groupByPlayer:"PlayerGroupBy",
		aggregatePlaylist:"AggregatePlaylist",
		findFirstPlaylist:"Playlist",
		findFirstPlaylistOrThrow:"Playlist",
		playlists:"PisignagePlaylist",
		playlist:"Playlist",
		getPlaylist:"Playlist",
		groupByPlaylist:"PlaylistGroupBy",
		aggregateSlotConfiguration:"AggregateSlotConfiguration",
		findFirstSlotConfiguration:"SlotConfiguration",
		findFirstSlotConfigurationOrThrow:"SlotConfiguration",
		slotConfigurations:"SlotConfiguration",
		slotConfiguration:"SlotConfiguration",
		getSlotConfiguration:"SlotConfiguration",
		groupBySlotConfiguration:"SlotConfigurationGroupBy",
		aggregateSubscription:"AggregateSubscription",
		findFirstSubscription:"Subscription",
		findFirstSubscriptionOrThrow:"Subscription",
		subscriptions:"Subscription",
		subscription:"Subscription",
		getSubscription:"Subscription",
		groupBySubscription:"SubscriptionGroupBy",
		aggregateUser:"AggregateUser",
		findFirstUser:"User",
		findFirstUserOrThrow:"User",
		users:"User",
		user:"User",
		getUser:"User",
		groupByUser:"UserGroupBy",
		aggregateUserPosition:"AggregateUserPosition",
		findFirstUserPosition:"UserPosition",
		findFirstUserPositionOrThrow:"UserPosition",
		userPositions:"UserPosition",
		userPosition:"UserPosition",
		getUserPosition:"UserPosition",
		groupByUserPosition:"UserPositionGroupBy",
		aggregateWishlist:"AggregateWishlist",
		findFirstWishlist:"Wishlist",
		findFirstWishlistOrThrow:"Wishlist",
		wishlists:"Wishlist",
		wishlist:"Wishlist",
		getWishlist:"Wishlist",
		groupByWishlist:"WishlistGroupBy",
		aggregateWorkspace:"AggregateWorkspace",
		findFirstWorkspace:"Workspace",
		findFirstWorkspaceOrThrow:"Workspace",
		workspaces:"Workspace",
		workspace:"Workspace",
		getWorkspace:"Workspace",
		groupByWorkspace:"WorkspaceGroupBy",
		aggregateWorkspaceRole:"AggregateWorkspaceRole",
		findFirstWorkspaceRole:"WorkspaceRole",
		findFirstWorkspaceRoleOrThrow:"WorkspaceRole",
		workspaceRoles:"WorkspaceRole",
		workspaceRole:"WorkspaceRole",
		getWorkspaceRole:"WorkspaceRole",
		groupByWorkspaceRole:"WorkspaceRoleGroupBy",
		adBoardPublicReviews:"AdBoardPublicReview",
		billboardAiCameraStats:"BillboardAiCameraStat",
		bookingHistories:"BookingHistory",
		contentVersions:"ContentVersion",
		findFirstStreamingDevice:"StreamingDevice",
		streamingDevices:"StreamingDevice",
		aggregateTrafficStat:"TrafficStatAggregate",
		trafficStats:"TrafficStat",
		loggedInUser:"User",
		getAdBoardAvailability:"Slot",
		playlogs:"PlayEvent"
	},
	AggregateAdBoard:{
		_count:"AdBoardCountAggregate",
		_avg:"AdBoardAvgAggregate",
		_sum:"AdBoardSumAggregate",
		_min:"AdBoardMinAggregate",
		_max:"AdBoardMaxAggregate"
	},
	AdBoardCountAggregate:{
		id:"Int",
		state:"Int",
		city:"Int",
		country:"Int",
		outdoor:"Int",
		locationCategoryId:"Int",
		locationSubCategoryId:"Int",
		alias:"Int",
		title:"Int",
		pricePerDay:"Int",
		originalPricePerDay:"Int",
		description:"Int",
		adBoardTypeId:"Int",
		tags:"Int",
		featuredImage:"Int",
		galleryImgs:"Int",
		notes:"Int",
		impressionMultiplier:"Int",
		categoryId:"Int",
		restrictedBusinessIds:"Int",
		targetAudiences:"Int",
		acceptedMediaTypes:"Int",
		status:"Int",
		adboardDraftStatus:"Int",
		isLive:"Int",
		numberOfDisplays:"Int",
		dailyOperationHours:"Int",
		adsPerLoop:"Int",
		adsDuration:"Int",
		monthlyPrice:"Int",
		offlineBookingsEnabled:"Int",
		createdAt:"Int",
		createdByUserId:"Int",
		href:"Int",
		workspaceId:"Int",
		playerIds:"Int",
		publisherScreenId:"Int",
		additionalData:"Int",
		publishedVersionId:"Int",
		lastPublishedAt:"Int",
		isArchived:"Int",
		archivedAt:"Int",
		archivedByUserId:"Int",
		updatedAt:"Int",
		wishlistIds:"Int",
		_all:"Int"
	},
	AdBoardAvgAggregate:{
		pricePerDay:"Float",
		originalPricePerDay:"Float",
		impressionMultiplier:"Float",
		numberOfDisplays:"Float",
		dailyOperationHours:"Float",
		adsPerLoop:"Float",
		adsDuration:"Float",
		monthlyPrice:"Float"
	},
	AdBoardSumAggregate:{
		pricePerDay:"Int",
		originalPricePerDay:"Int",
		impressionMultiplier:"Float",
		numberOfDisplays:"Int",
		dailyOperationHours:"Int",
		adsPerLoop:"Int",
		adsDuration:"Int",
		monthlyPrice:"Float"
	},
	AdBoardMinAggregate:{
		id:"String",
		state:"String",
		city:"String",
		country:"String",
		outdoor:"Boolean",
		locationCategoryId:"String",
		locationSubCategoryId:"String",
		alias:"String",
		title:"String",
		pricePerDay:"Int",
		originalPricePerDay:"Int",
		description:"String",
		adBoardTypeId:"String",
		featuredImage:"String",
		impressionMultiplier:"Float",
		categoryId:"String",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		isLive:"Boolean",
		numberOfDisplays:"Int",
		dailyOperationHours:"Int",
		adsPerLoop:"Int",
		adsDuration:"Int",
		monthlyPrice:"Float",
		offlineBookingsEnabled:"Boolean",
		createdAt:"DateTime",
		createdByUserId:"String",
		href:"String",
		workspaceId:"String",
		publisherScreenId:"String",
		publishedVersionId:"String",
		lastPublishedAt:"DateTime",
		isArchived:"Boolean",
		archivedAt:"DateTime",
		archivedByUserId:"String",
		updatedAt:"DateTime"
	},
	DateTime: `scalar.DateTime` as const,
	AdBoardMaxAggregate:{
		id:"String",
		state:"String",
		city:"String",
		country:"String",
		outdoor:"Boolean",
		locationCategoryId:"String",
		locationSubCategoryId:"String",
		alias:"String",
		title:"String",
		pricePerDay:"Int",
		originalPricePerDay:"Int",
		description:"String",
		adBoardTypeId:"String",
		featuredImage:"String",
		impressionMultiplier:"Float",
		categoryId:"String",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		isLive:"Boolean",
		numberOfDisplays:"Int",
		dailyOperationHours:"Int",
		adsPerLoop:"Int",
		adsDuration:"Int",
		monthlyPrice:"Float",
		offlineBookingsEnabled:"Boolean",
		createdAt:"DateTime",
		createdByUserId:"String",
		href:"String",
		workspaceId:"String",
		publisherScreenId:"String",
		publishedVersionId:"String",
		lastPublishedAt:"DateTime",
		isArchived:"Boolean",
		archivedAt:"DateTime",
		archivedByUserId:"String",
		updatedAt:"DateTime"
	},
	JSON: `scalar.JSON` as const,
	AdBoard:{
		id:"String",
		state:"String",
		city:"String",
		country:"String",
		outdoor:"Boolean",
		locationCategoryId:"String",
		locationSubCategoryId:"String",
		alias:"String",
		title:"String",
		pricePerDay:"Int",
		pricingTiers:"PricingTier",
		originalPricePerDay:"Int",
		description:"String",
		aboutSpecifications:"Specification",
		adBoardTypeId:"String",
		tags:"String",
		featuredImage:"String",
		galleryImgs:"String",
		specifications:"Specification",
		notes:"String",
		impressionMultiplier:"Float",
		resolution:"Resolution",
		screenSize:"ScreenSize",
		categoryId:"String",
		restrictedBusinessIds:"String",
		targetAudiences:"String",
		playbackTimes:"PlaybackTime",
		acceptedMediaTypes:"String",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		isLive:"Boolean",
		numberOfDisplays:"Int",
		dailyOperationHours:"Int",
		adsPerLoop:"Int",
		adsDuration:"Int",
		monthlyPrice:"Float",
		offlineBookingsEnabled:"Boolean",
		createdAt:"DateTime",
		createdByUserId:"String",
		href:"String",
		workspaceId:"String",
		playerIds:"String",
		publisherScreenId:"String",
		additionalData:"JSON",
		publishedVersionId:"String",
		lastPublishedAt:"DateTime",
		isArchived:"Boolean",
		archivedAt:"DateTime",
		archivedByUserId:"String",
		updatedAt:"DateTime",
		wishlistIds:"String",
		_count:"AdBoardCount",
		locationCategory:"LocationCategory",
		locationSubCategory:"LocationSubCategory",
		type:"AdBoardType",
		category:"BusinessCategory",
		restrictedBusines:"BusinessCategory",
		bookings:"Booking",
		orders:"Order",
		slotConfigurations:"SlotConfiguration",
		createdBy:"User",
		workspace:"Workspace",
		players:"Player",
		adBoardGroup:"AdBoardGroup",
		publishedVersion:"AdBoard",
		draftAdboard:"AdBoard",
		history:"AdBoardPublishHistory",
		reviewComments:"AdBoardReviewComment",
		archivedBy:"User",
		publicReviews:"AdBoardPublicReview",
		wishlists:"Wishlist"
	},
	PricingTier:{
		minDays:"Int",
		maxDays:"Int",
		pricePerDay:"Float"
	},
	Specification:{
		name:"String",
		value:"String"
	},
	Resolution:{
		height:"Int",
		width:"Int"
	},
	ScreenSize:{
		height:"Float",
		unit:"MeasurementUnit",
		width:"Float"
	},
	PlaybackTime:{
		name:"String",
		startTime:"String",
		endTime:"String"
	},
	AdBoardCount:{
		restrictedBusines:"Int",
		bookings:"Int",
		orders:"Int",
		slotConfigurations:"Int",
		players:"Int",
		history:"Int",
		reviewComments:"Int",
		publicReviews:"Int",
		wishlists:"Int"
	},
	LocationCategory:{
		id:"String",
		name:"String",
		_count:"LocationCategoryCount",
		adBoards:"AdBoard",
		locationSubCategory:"LocationSubCategory"
	},
	LocationCategoryCount:{
		adBoards:"Int",
		locationSubCategory:"Int"
	},
	LocationSubCategory:{
		id:"String",
		name:"String",
		locationCategoryId:"String",
		_count:"LocationSubCategoryCount",
		locationCategory:"LocationCategory",
		adBoards:"AdBoard"
	},
	LocationSubCategoryCount:{
		adBoards:"Int"
	},
	AdBoardType:{
		id:"String",
		name:"String",
		description:"String",
		_count:"AdBoardTypeCount",
		adBoards:"AdBoard"
	},
	AdBoardTypeCount:{
		adBoards:"Int"
	},
	BusinessCategory:{
		id:"String",
		name:"String",
		description:"String",
		restrictedByAdBoardIds:"String",
		_count:"BusinessCategoryCount",
		adBoards:"AdBoard",
		restrictedByAdBoards:"AdBoard",
		campaigns:"Campaign",
		bookings:"Booking"
	},
	BusinessCategoryCount:{
		adBoards:"Int",
		restrictedByAdBoards:"Int",
		campaigns:"Int",
		bookings:"Int"
	},
	Campaign:{
		id:"String",
		name:"String",
		description:"String",
		businessCategoryId:"String",
		purpose:"String",
		userId:"String",
		adCategoryId:"String",
		payment:"BookingPayment",
		paymentStatus:"PaymentStatus",
		priceSummary:"PriceSummary",
		selectedDates:"OrderSelectedDate",
		origin:"String",
		assetsIDs:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		_count:"CampaignCount",
		businessCategory:"BusinessCategory",
		user:"User",
		adCategory:"AdvertisementCategory",
		bookings:"Booking",
		payments:"Payment",
		assets:"File"
	},
	BookingPayment:{
		liveMode:"Boolean",
		checkoutSessionId:"String",
		customer:"BookingCustomer",
		paymentGateway:"PaymentGatewayName",
		paymentId:"String",
		sessionId:"String",
		totalDetails:"PaymentTotalDetails",
		razorpay:"JSON",
		stripe:"JSON"
	},
	BookingCustomer:{
		customerId:"String",
		customerDetails:"PaymentCustomerDetails"
	},
	PaymentCustomerDetails:{
		email:"String",
		name:"String",
		phone:"String"
	},
	PaymentTotalDetails:{
		discount:"Float",
		shipping:"Float",
		subtotal:"Float",
		tax:"Float",
		total:"Float"
	},
	PriceSummary:{
		days:"Int",
		discount:"Float",
		payableRent:"Float",
		subtotal:"Float",
		rentPerDay:"Int",
		serviceCharge:"Float",
		totalRent:"Int"
	},
	OrderSelectedDate:{
		endDate:"DateTime",
		startDate:"DateTime"
	},
	CampaignCount:{
		adCategory:"Int",
		bookings:"Int",
		payments:"Int",
		assets:"Int"
	},
	User:{
		id:"String",
		uid:"String",
		email:"String",
		image:"String",
		phoneNumber:"String",
		displayName:"String",
		otherDetails:"JSON",
		stripe:"UserStripe",
		roles:"Role",
		refunds:"BookingRefund",
		sharedBookingIds:"String",
		disclaimerAccepted:"Boolean",
		notificationPreference:"NotificationPreference",
		leadWorkspaceIds:"String",
		_count:"UserCount",
		bookings:"Booking",
		createdFiles:"File",
		updatedFiles:"File",
		orders:"Order",
		changelogs:"Changelog",
		adBoards:"AdBoard",
		audits:"Audit",
		campaigns:"Campaign",
		sharedBookings:"Booking",
		memberships:"Membership",
		notifications:"Notification",
		publishAdboardVersion:"AdBoardPublishHistory",
		reviewComments:"AdBoardReviewComment",
		archivedAdboards:"AdBoard",
		ownedWorkspaces:"Workspace",
		leadWorspaces:"Workspace",
		publicReviews:"AdBoardPublicReview",
		userPositions:"UserPosition",
		wishlists:"Wishlist",
		deletedPlayerIds:"Player",
		deployedContentVersions:"ContentVersion",
		submittedContentVersions:"ContentVersion",
		approvedContentVersions:"ContentVersion"
	},
	UserStripe:{
		customerId:"String"
	},
	BookingRefund:{
		id:"String",
		razorpay:"JSON",
		stripe:"JSON",
		createdByUserId:"String"
	},
	NotificationPreference:{
		type:"NotificationType",
		channels:"NotificationChannel",
		pushSetting:"PushSetting",
		enabled:"Boolean"
	},
	PushSetting:{
		fcmTokens:"String"
	},
	UserCount:{
		bookings:"Int",
		createdFiles:"Int",
		updatedFiles:"Int",
		orders:"Int",
		changelogs:"Int",
		adBoards:"Int",
		audits:"Int",
		campaigns:"Int",
		sharedBookings:"Int",
		memberships:"Int",
		notifications:"Int",
		publishAdboardVersion:"Int",
		reviewComments:"Int",
		archivedAdboards:"Int",
		ownedWorkspaces:"Int",
		leadWorspaces:"Int",
		publicReviews:"Int",
		userPositions:"Int",
		wishlists:"Int",
		deletedPlayerIds:"Int",
		deployedContentVersions:"Int",
		submittedContentVersions:"Int",
		approvedContentVersions:"Int"
	},
	Booking:{
		id:"String",
		additionalInformation:"String",
		origin:"String",
		bookingCode:"String",
		bookingDate:"DateTime",
		bookingFor:"String",
		purpose:"String",
		adBoardId:"String",
		workspaceId:"String",
		campaignId:"String",
		businessCategoryId:"String",
		adCategoryId:"String",
		bookingDetails:"BookingUserDetails",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		assetsIDs:"String",
		currentDeployedVersionId:"String",
		selectedDates:"OrderSelectedDate",
		payment:"BookingPayment",
		priceSummary:"PriceSummary",
		pisignage:"BookingPisignageData",
		userId:"String",
		sharedUserIds:"String",
		isOffline:"Boolean",
		isEnquiry:"Boolean",
		isPaid:"Boolean",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		_count:"BookingCount",
		businessCategory:"BusinessCategory",
		adCategory:"AdvertisementCategory",
		assets:"File",
		contentVersions:"ContentVersion",
		paymentAllocations:"PaymentAllocation",
		proofs:"File",
		user:"User",
		adBoard:"AdBoard",
		changelogs:"Changelog",
		workspace:"Workspace",
		campaign:"Campaign",
		payouts:"Payout",
		sharedUsers:"User",
		slotUsage:"SlotUsage",
		review:"AdBoardPublicReview",
		history:"BookingHistory",
		refundRequest:"RefundRequest",
		refundApproval:"RefundApproval",
		refundProcessed:"RefundProcessed"
	},
	BookingUserDetails:{
		email:"String",
		name:"String",
		phone:"String"
	},
	BookingPisignageData:{
		deployedFileName:"String",
		playlistId:"String"
	},
	BookingCount:{
		adCategory:"Int",
		assets:"Int",
		contentVersions:"Int",
		paymentAllocations:"Int",
		proofs:"Int",
		changelogs:"Int",
		payouts:"Int",
		sharedUsers:"Int",
		slotUsage:"Int",
		history:"Int"
	},
	AdvertisementCategory:{
		id:"String",
		name:"String",
		type:"AdvertisementCategoryEnum",
		description:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		campaignIds:"String",
		bookingIds:"String",
		_count:"AdvertisementCategoryCount",
		campaigns:"Campaign",
		bookings:"Booking"
	},
	AdvertisementCategoryCount:{
		campaigns:"Int",
		bookings:"Int"
	},
	File:{
		id:"String",
		contentType:"String",
		ctime:"String",
		filename:"String",
		filepath:"String",
		isDirectory:"Boolean",
		meta:"FileMeta",
		mtime:"String",
		name:"String",
		size:"Int",
		status:"FileStatus",
		type:"String",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedByUserId:"String",
		createdByUserId:"String",
		url:"String",
		bookingsIDs:"String",
		workspaceId:"String",
		proofBookingId:"String",
		campaignIds:"String",
		contentVersionId:"String",
		_count:"FileCount",
		updatedBy:"User",
		createdBy:"User",
		bookings:"Booking",
		workspace:"Workspace",
		proofBooking:"Booking",
		campaigns:"Campaign",
		contentVersions:"ContentVersion"
	},
	FileMeta:{
		duration:"Float",
		height:"Int",
		width:"Int"
	},
	FileCount:{
		bookings:"Int",
		campaigns:"Int",
		contentVersions:"Int"
	},
	Workspace:{
		id:"String",
		type:"WorkspaceType",
		name:"String",
		key:"String",
		userIds:"String",
		ownerId:"String",
		avatar:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		stripeSubscriptionId:"String",
		leadIds:"String",
		webhookAppId:"String",
		stackAuthTeamId:"String",
		_count:"WorkspaceCount",
		owner:"User",
		memberships:"Membership",
		adBoards:"AdBoard",
		playlists:"Playlist",
		adBoardGroups:"AdBoardGroup",
		audits:"Audit",
		bookings:"Booking",
		files:"File",
		players:"Player",
		transactions:"Transaction",
		activeSubscription:"Subscription",
		workspaceRoles:"WorkspaceRole",
		leads:"User",
		cameras:"Camera",
		cameraStreamingDevices:"StreamingDevice",
		webhookDashboardUrl:"String"
	},
	WorkspaceCount:{
		memberships:"Int",
		adBoards:"Int",
		playlists:"Int",
		adBoardGroups:"Int",
		audits:"Int",
		bookings:"Int",
		files:"Int",
		players:"Int",
		transactions:"Int",
		workspaceRoles:"Int",
		leads:"Int",
		cameras:"Int",
		cameraStreamingDevices:"Int"
	},
	Membership:{
		id:"String",
		createdAt:"DateTime",
		userId:"String",
		workspaceId:"String",
		roleId:"String",
		user:"User",
		workspace:"Workspace",
		role:"WorkspaceRole"
	},
	WorkspaceRole:{
		id:"String",
		name:"String",
		permissions:"Permission",
		workspaceId:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		_count:"WorkspaceRoleCount",
		workspace:"Workspace",
		memberships:"Membership"
	},
	WorkspaceRoleCount:{
		memberships:"Int"
	},
	Playlist:{
		id:"String",
		name:"String",
		displayName:"String",
		assets:"PisignageFile",
		isAdsPlaylist:"Boolean",
		footerPlaylistId:"String",
		sidebarPlaylistId:"String",
		layout:"ScreenLayout",
		isDeployed:"Boolean",
		adBoardGroupIds:"String",
		workspaceId:"String",
		_count:"PlaylistCount",
		footerPlaylist:"Playlist",
		sidebarPlaylist:"Playlist",
		adBoardGroupsForAds:"AdBoardGroup",
		adBoardGroups:"AdBoardGroup",
		workspace:"Workspace",
		footerParentPlaylists:"Playlist",
		sidebarParentPlaylists:"Playlist"
	},
	PisignageFile:{
		name:"String",
		duration:"Int",
		muteAudio:"Boolean",
		isVideo:"Boolean"
	},
	PlaylistCount:{
		adBoardGroupsForAds:"Int",
		adBoardGroups:"Int",
		footerParentPlaylists:"Int",
		sidebarParentPlaylists:"Int"
	},
	AdBoardGroup:{
		id:"String",
		name:"String",
		adBoardId:"String",
		schedules:"Schedule",
		scheduledPlaylistsIDs:"String",
		adsPlaylistID:"String",
		pisignageGroupId:"String",
		fitImage:"FitType",
		fitVideo:"FitType",
		workspaceId:"String",
		_count:"AdBoardGroupCount",
		adBoard:"AdBoard",
		scheduledPlaylists:"Playlist",
		adsPlaylist:"Playlist",
		pisignagePlayers:"Player",
		workspace:"Workspace"
	},
	Schedule:{
		playlistId:"String",
		playlistType:"String",
		skipForSchedule:"Boolean",
		startTime:"String",
		endTime:"String"
	},
	AdBoardGroupCount:{
		scheduledPlaylists:"Int",
		pisignagePlayers:"Int"
	},
	Player:{
		id:"String",
		name:"String",
		configLocation:"String",
		pisignagePlayerId:"String",
		pisignageGroupId:"String",
		cpuSerialNumber:"String",
		displayName:"String",
		adBoardGroupId:"String",
		playlistIds:"String",
		workpaceId:"String",
		resolution:"Resolution",
		screenSize:"ScreenSize",
		signageTypeId:"String",
		audienceTypeId:"String",
		playbackDetails:"PlaybackTime",
		aspectRatioType:"AspectRatioType",
		customAspectRatioWidth:"Int",
		customAspectRatioHeight:"Int",
		map:"Map",
		isOnline:"Boolean",
		adBoardIds:"String",
		galleryFiles:"GalleryFile",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		markForDeletion:"Boolean",
		deletedAt:"DateTime",
		deletedByUserId:"String",
		visible:"Boolean",
		_count:"PlayerCount",
		adBoardGroup:"AdBoardGroup",
		workspace:"Workspace",
		status:"PlayerUptimeStatus",
		cameras:"Camera",
		signageType:"DigitalSignage",
		audienceType:"Audience",
		adBoards:"AdBoard",
		deletedBy:"User",
		cameraStreamingDevices:"StreamingDevice",
		pisignagePlayer:"PlayerInfo",
		pisignageGroup:"GroupInfo"
	},
	Map:{
		lat:"Float",
		lng:"Float",
		address:"String",
		city:"String",
		state:"String",
		country:"String"
	},
	GalleryFile:{
		name:"String",
		url:"String",
		contentType:"String",
		width:"Int",
		height:"Int",
		duration:"Float",
		visible:"Boolean"
	},
	PlayerCount:{
		status:"Int",
		cameras:"Int",
		audienceType:"Int",
		adBoards:"Int",
		cameraStreamingDevices:"Int"
	},
	PlayerUptimeStatus:{
		id:"String",
		playerId:"String",
		cpuSerialNumber:"String",
		date:"String",
		uptime:"Float",
		player:"Player"
	},
	Camera:{
		id:"String",
		name:"String",
		isOnline:"Boolean",
		playerId:"String",
		workspaceId:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		isPublic:"Boolean",
		player:"Player",
		workspace:"Workspace"
	},
	DigitalSignage:{
		id:"String",
		type:"SignageType",
		name:"String",
		description:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		_count:"DigitalSignageCount",
		players:"Player"
	},
	DigitalSignageCount:{
		players:"Int"
	},
	Audience:{
		id:"String",
		type:"AudienceType",
		name:"String",
		description:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		playerIDs:"String",
		_count:"AudienceCount",
		players:"Player"
	},
	AudienceCount:{
		players:"Int"
	},
	StreamingDevice:{
		id:"String",
		name:"String",
		deviceId:"String",
		socketId:"String",
		isConnected:"Boolean",
		playerId:"String",
		connectionLogs:"ConnectionLog",
		workspaceId:"String",
		billboardMonitoring:"BillboardMonitoring",
		trafficMonitoring:"TrafficMonitoring",
		rtspStreamUrl:"String",
		publicWebUrl:"String",
		services:"StreamingServices",
		_count:"StreamingDeviceCount",
		player:"Player",
		workspace:"Workspace",
		billboardMonitoringAlerts:"BillboardMonitoringAlert"
	},
	ConnectionLog:{
		timestamp:"DateTime",
		log:"String",
		data:"JSON"
	},
	BillboardMonitoring:{
		customInstructions:"String",
		rtspStreamUrl:"String",
		aiApiKey:"String",
		apiCallInterval:"Float",
		publicWebUrl:"String",
		alertsEnabled:"Boolean",
		alertConfigs:"AlertConfig"
	},
	AlertConfig:{
		enabled:"Boolean",
		recipients:"String",
		channel:"AlertChannel"
	},
	TrafficMonitoring:{
		enabled:"Boolean",
		rtspStreamUrl:"String",
		metadata:"JSON",
		inferenceInterval:"Float",
		longStayThreshold:"Int",
		apiEndpoint:"String",
		batchSize:"Int",
		apiCallInterval:"Int"
	},
	StreamingServices:{
		billboardMonitoring:"BillboardMonitoring",
		trafficMonitoring:"TrafficMonitoring",
		rtspStreamUrl:"String",
		publicWebUrl:"String"
	},
	StreamingDeviceCount:{
		billboardMonitoringAlerts:"Int"
	},
	BillboardMonitoringAlert:{
		id:"String",
		startTime:"DateTime",
		endTime:"DateTime",
		isActive:"Boolean",
		isFalsePositive:"Boolean",
		enabledAlerts:"AlertConfig",
		streamingDeviceId:"String",
		streamingDevice:"StreamingDevice"
	},
	PlayerInfo:{
		_id:"String",
		selfGroupId:"String",
		name:"String",
		TZ:"String",
		cpuSerialNumber:"String",
		managed:"Boolean",
		configLocation:"String",
		labels:"String",
		group:"Group",
		version:"String",
		platform_version:"String",
		myIpAddress:"String",
		ip:"String",
		location:"String",
		playlistOn:"Boolean",
		isConnected:"Boolean",
		cecTvStatus:"Boolean",
		tvStatus:"Boolean",
		syncInProgress:"Boolean",
		currentPlaylist:"String",
		licensed:"Boolean",
		installation:"String",
		lastUpload:"String",
		lastReported:"String"
	},
	Group:{
		_id:"String",
		name:"String"
	},
	GroupInfo:{
		_id:"String",
		name:"String",
		playlistToSchedule:"String",
		combineDefaultPlaylist:"Boolean",
		playAllEligiblePlaylists:"Boolean",
		shuffleContent:"Boolean",
		alternateContent:"Boolean",
		assetsValidity:"AssetValidity",
		assets:"String",
		deployedAssets:"String",
		playlists:"GroupPlaylist",
		deployedPlaylists:"GroupPlaylist",
		labels:"String",
		installation:"String",
		lastDeployed:"Int",
		resolution:"String",
		orientation:"String",
		monitorArrangement:"MonitorArrangement",
		animationEnable:"Boolean",
		animationType:"String",
		signageBackgroundColor:"String",
		logo:"String",
		logox:"Int",
		logoy:"Int",
		emergencyMessage:"EmergencyMessage",
		sleep:"Sleep",
		reboot:"Reboot",
		deployTime:"String",
		deployEveryday:"Boolean",
		everydayDeployTime:"String",
		enableMpv:"Boolean",
		mpvAudioDelay:"String",
		selectedVideoPlayer:"String",
		disableWebUi:"Boolean",
		disableHwWidgets:"Boolean",
		disableWarnings:"Boolean",
		enablePio:"Boolean",
		disableAp:"Boolean",
		imageLetterboxed:"Boolean",
		showClock:"ShowClock",
		videoKeepAspect:"Boolean",
		urlReloadDisable:"Boolean",
		keepWeblinksInMemory:"Boolean",
		loadPlaylistOnCompletion:"Boolean",
		omxVolume:"Int",
		timeToStopVideo:"Int"
	},
	AssetValidity:{
		enable:"Boolean",
		startdate:"String",
		enddate:"String",
		starthour:"Int",
		endhour:"Int"
	},
	GroupPlaylist:{
		skipForSchedule:"Boolean",
		name:"String"
	},
	MonitorArrangement:{
		mode:"String",
		reverse:"Boolean"
	},
	EmergencyMessage:{
		enable:"Boolean",
		vPos:"String",
		hPos:"String",
		msg:"String"
	},
	Sleep:{
		enable:"Boolean",
		ontime:"String",
		offtime:"String"
	},
	Reboot:{
		enable:"Boolean",
		time:"String"
	},
	ShowClock:{
		enable:"Boolean",
		position:"String",
		format:"String"
	},
	Audit:{
		id:"String",
		createdAt:"DateTime",
		message:"String",
		action:"String",
		entity:"Entity",
		userId:"String",
		workspaceId:"String",
		updates:"JSON",
		user:"User",
		workspace:"Workspace"
	},
	Entity:{
		type:"String",
		id:"String",
		name:"String"
	},
	Transaction:{
		workspaceId:"String",
		id:"String",
		amount:"Float",
		createAt:"DateTime",
		processedAt:"DateTime",
		relatedEntityId:"String",
		transactionStatus:"TransactionStatus",
		details:"JSON",
		_count:"TransactionCount",
		workspace:"Workspace",
		payouts:"Payout"
	},
	TransactionCount:{
		payouts:"Int"
	},
	Payout:{
		id:"String",
		totalAmount:"Float",
		commissionRate:"Float",
		commissionAmount:"Float",
		netAmount:"Float",
		createdAt:"DateTime",
		bookingId:"String",
		status:"PayoutStatus",
		transactionId:"String",
		booking:"Booking",
		transaction:"Transaction"
	},
	Subscription:{
		id:"String",
		packageId:"String",
		packageName:"String",
		priceLookupKey:"String",
		startDate:"DateTime",
		endDate:"DateTime",
		status:"String",
		stripePaymentIntentId:"String",
		stripeSubscriptionId:"String",
		stripeCheckoutSessionId:"String",
		cancellationDetails:"CancellationDetails",
		activeWorkspaceId:"String",
		activeWorkspace:"Workspace"
	},
	CancellationDetails:{
		canceledAt:"DateTime",
		cancelAt:"DateTime",
		cancelAtPeriodEnd:"Boolean",
		reason:"String"
	},
	ContentVersion:{
		id:"String",
		bookingId:"String",
		versionNumber:"Int",
		status:"ContentApprovalStatus",
		submittedAt:"DateTime",
		approvedAt:"DateTime",
		deployedAt:"DateTime",
		submittedByUserId:"String",
		approvedByUserId:"String",
		deployedByUserId:"String",
		assetIds:"String",
		comments:"String",
		createdAt:"DateTime",
		_count:"ContentVersionCount",
		booking:"Booking",
		submittedBy:"User",
		approvedBy:"User",
		deployedBy:"User",
		assets:"File"
	},
	ContentVersionCount:{
		assets:"Int"
	},
	PaymentAllocation:{
		id:"String",
		paymentId:"String",
		bookingId:"String",
		subtotal:"Float",
		tax:"Float",
		discount:"Float",
		total:"Float",
		payment:"Payment",
		booking:"Booking"
	},
	Payment:{
		id:"String",
		paymentIntentId:"String",
		checkoutSessionId:"String",
		eventId:"String",
		liveMode:"Boolean",
		paymentGateway:"PaymentGatewayName",
		subtotal:"Float",
		total:"Float",
		tax:"Float",
		discount:"Float",
		campaignId:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		_count:"PaymentCount",
		campaign:"Campaign",
		paymentAllocations:"PaymentAllocation"
	},
	PaymentCount:{
		paymentAllocations:"Int"
	},
	Changelog:{
		id:"String",
		createdAt:"DateTime",
		message:"String",
		action:"String",
		bookingId:"String",
		userId:"String",
		updates:"JSON",
		booking:"Booking",
		user:"User"
	},
	SlotUsage:{
		id:"String",
		bookingId:"String",
		date:"DateTime",
		slotUsed:"Int",
		booking:"Booking"
	},
	AdBoardPublicReview:{
		id:"String",
		rating:"Float",
		title:"String",
		description:"String",
		isVerified:"Boolean",
		helpfulYes:"Int",
		helpfulNo:"Int",
		imageUrls:"String",
		adBoardId:"String",
		userId:"String",
		createdAt:"DateTime",
		bookingId:"String",
		adBoard:"AdBoard",
		user:"User",
		booking:"Booking"
	},
	BookingHistory:{
		id:"String",
		bookingId:"String",
		status:"BookingStatus",
		createdBy:"String",
		timestamp:"DateTime",
		booking:"Booking"
	},
	RefundRequest:{
		id:"String",
		bookingId:"String",
		requestedAt:"DateTime",
		requestedBy:"String",
		reason:"String",
		amountRequested:"Float",
		booking:"Booking"
	},
	RefundApproval:{
		id:"String",
		bookingId:"String",
		approvedAt:"DateTime",
		approvedBy:"String",
		amountApproved:"Float",
		notes:"String",
		booking:"Booking"
	},
	RefundProcessed:{
		id:"String",
		bookingId:"String",
		processedAt:"DateTime",
		paymentMethod:"PaymentGatewayName",
		transactionId:"String",
		booking:"Booking"
	},
	Order:{
		id:"String",
		adBoardId:"String",
		createdDate:"DateTime",
		createdByUserId:"String",
		origin:"String",
		paymentId:"String",
		priceSummary:"PriceSummary",
		selectedDate:"OrderSelectedDate",
		adBoard:"AdBoard",
		createdBy:"User"
	},
	Notification:{
		id:"String",
		type:"NotificationType",
		title:"String",
		content:"String",
		metadata:"JSON",
		createdAt:"DateTime",
		readAt:"DateTime",
		recipientId:"String",
		channels:"NotificationChannel",
		recipient:"User"
	},
	AdBoardPublishHistory:{
		id:"String",
		adBoardId:"String",
		publishedAt:"DateTime",
		publishedByUserId:"String",
		changesSnapshot:"JSON",
		adBoard:"AdBoard",
		publishedBy:"User"
	},
	AdBoardReviewComment:{
		id:"String",
		adBoardId:"String",
		userId:"String",
		comment:"String",
		action:"ReviewAction",
		createdAt:"DateTime",
		adBoard:"AdBoard",
		user:"User"
	},
	UserPosition:{
		id:"String",
		timestamp:"DateTime",
		createdAt:"DateTime",
		userId:"String",
		coords:"UserPositionCoords",
		location:"UserPositionLocation",
		user:"User"
	},
	UserPositionCoords:{
		accuracy:"Float",
		altitude:"Float",
		altitudeAccuracy:"Float",
		heading:"Float",
		latitude:"Float",
		longitude:"Float",
		speed:"Float"
	},
	UserPositionLocation:{
		address:"String",
		city:"String",
		state:"String",
		country:"String"
	},
	Wishlist:{
		id:"String",
		name:"String",
		userId:"String",
		adBoardIds:"String",
		createdAt:"DateTime",
		_count:"WishlistCount",
		user:"User",
		adBoards:"AdBoard"
	},
	WishlistCount:{
		adBoards:"Int"
	},
	SlotConfiguration:{
		id:"String",
		adBoardId:"String",
		date:"DateTime",
		availableSlots:"Int",
		adBoard:"AdBoard"
	},
	AdBoardGroupBy:{
		id:"String",
		state:"String",
		city:"String",
		country:"String",
		outdoor:"Boolean",
		locationCategoryId:"String",
		locationSubCategoryId:"String",
		alias:"String",
		title:"String",
		pricePerDay:"Int",
		originalPricePerDay:"Int",
		description:"String",
		adBoardTypeId:"String",
		tags:"String",
		featuredImage:"String",
		galleryImgs:"String",
		notes:"String",
		impressionMultiplier:"Float",
		categoryId:"String",
		restrictedBusinessIds:"String",
		targetAudiences:"String",
		acceptedMediaTypes:"String",
		status:"AdBoardStatus",
		adboardDraftStatus:"AdboardDraftStatus",
		isLive:"Boolean",
		numberOfDisplays:"Int",
		dailyOperationHours:"Int",
		adsPerLoop:"Int",
		adsDuration:"Int",
		monthlyPrice:"Float",
		offlineBookingsEnabled:"Boolean",
		createdAt:"DateTime",
		createdByUserId:"String",
		href:"String",
		workspaceId:"String",
		playerIds:"String",
		publisherScreenId:"String",
		additionalData:"JSON",
		publishedVersionId:"String",
		lastPublishedAt:"DateTime",
		isArchived:"Boolean",
		archivedAt:"DateTime",
		archivedByUserId:"String",
		updatedAt:"DateTime",
		wishlistIds:"String",
		_count:"AdBoardCountAggregate",
		_avg:"AdBoardAvgAggregate",
		_sum:"AdBoardSumAggregate",
		_min:"AdBoardMinAggregate",
		_max:"AdBoardMaxAggregate"
	},
	AggregateAdBoardGroup:{
		_count:"AdBoardGroupCountAggregate",
		_min:"AdBoardGroupMinAggregate",
		_max:"AdBoardGroupMaxAggregate"
	},
	AdBoardGroupCountAggregate:{
		id:"Int",
		name:"Int",
		adBoardId:"Int",
		scheduledPlaylistsIDs:"Int",
		adsPlaylistID:"Int",
		pisignageGroupId:"Int",
		fitImage:"Int",
		fitVideo:"Int",
		workspaceId:"Int",
		_all:"Int"
	},
	AdBoardGroupMinAggregate:{
		id:"String",
		name:"String",
		adBoardId:"String",
		adsPlaylistID:"String",
		pisignageGroupId:"String",
		fitImage:"FitType",
		fitVideo:"FitType",
		workspaceId:"String"
	},
	AdBoardGroupMaxAggregate:{
		id:"String",
		name:"String",
		adBoardId:"String",
		adsPlaylistID:"String",
		pisignageGroupId:"String",
		fitImage:"FitType",
		fitVideo:"FitType",
		workspaceId:"String"
	},
	AdBoardGroupGroupBy:{
		id:"String",
		name:"String",
		adBoardId:"String",
		scheduledPlaylistsIDs:"String",
		adsPlaylistID:"String",
		pisignageGroupId:"String",
		fitImage:"FitType",
		fitVideo:"FitType",
		workspaceId:"String",
		_count:"AdBoardGroupCountAggregate",
		_min:"AdBoardGroupMinAggregate",
		_max:"AdBoardGroupMaxAggregate"
	},
	AggregateAdBoardType:{
		_count:"AdBoardTypeCountAggregate",
		_min:"AdBoardTypeMinAggregate",
		_max:"AdBoardTypeMaxAggregate"
	},
	AdBoardTypeCountAggregate:{
		id:"Int",
		name:"Int",
		description:"Int",
		_all:"Int"
	},
	AdBoardTypeMinAggregate:{
		id:"String",
		name:"String",
		description:"String"
	},
	AdBoardTypeMaxAggregate:{
		id:"String",
		name:"String",
		description:"String"
	},
	AdBoardTypeGroupBy:{
		id:"String",
		name:"String",
		description:"String",
		_count:"AdBoardTypeCountAggregate",
		_min:"AdBoardTypeMinAggregate",
		_max:"AdBoardTypeMaxAggregate"
	},
	AggregateAdvertisementCategory:{
		_count:"AdvertisementCategoryCountAggregate",
		_min:"AdvertisementCategoryMinAggregate",
		_max:"AdvertisementCategoryMaxAggregate"
	},
	AdvertisementCategoryCountAggregate:{
		id:"Int",
		name:"Int",
		type:"Int",
		description:"Int",
		createdAt:"Int",
		updatedAt:"Int",
		campaignIds:"Int",
		bookingIds:"Int",
		_all:"Int"
	},
	AdvertisementCategoryMinAggregate:{
		id:"String",
		name:"String",
		type:"AdvertisementCategoryEnum",
		description:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	AdvertisementCategoryMaxAggregate:{
		id:"String",
		name:"String",
		type:"AdvertisementCategoryEnum",
		description:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	AdvertisementCategoryGroupBy:{
		id:"String",
		name:"String",
		type:"AdvertisementCategoryEnum",
		description:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		campaignIds:"String",
		bookingIds:"String",
		_count:"AdvertisementCategoryCountAggregate",
		_min:"AdvertisementCategoryMinAggregate",
		_max:"AdvertisementCategoryMaxAggregate"
	},
	AggregateAudit:{
		_count:"AuditCountAggregate",
		_min:"AuditMinAggregate",
		_max:"AuditMaxAggregate"
	},
	AuditCountAggregate:{
		id:"Int",
		createdAt:"Int",
		message:"Int",
		action:"Int",
		userId:"Int",
		workspaceId:"Int",
		updates:"Int",
		_all:"Int"
	},
	AuditMinAggregate:{
		id:"String",
		createdAt:"DateTime",
		message:"String",
		action:"String",
		userId:"String",
		workspaceId:"String"
	},
	AuditMaxAggregate:{
		id:"String",
		createdAt:"DateTime",
		message:"String",
		action:"String",
		userId:"String",
		workspaceId:"String"
	},
	AuditGroupBy:{
		id:"String",
		createdAt:"DateTime",
		message:"String",
		action:"String",
		userId:"String",
		workspaceId:"String",
		updates:"JSON",
		_count:"AuditCountAggregate",
		_min:"AuditMinAggregate",
		_max:"AuditMaxAggregate"
	},
	AggregateBooking:{
		_count:"BookingCountAggregate",
		_min:"BookingMinAggregate",
		_max:"BookingMaxAggregate"
	},
	BookingCountAggregate:{
		id:"Int",
		additionalInformation:"Int",
		origin:"Int",
		bookingCode:"Int",
		bookingDate:"Int",
		bookingFor:"Int",
		purpose:"Int",
		adBoardId:"Int",
		workspaceId:"Int",
		campaignId:"Int",
		businessCategoryId:"Int",
		adCategoryId:"Int",
		bookingStatus:"Int",
		paymentStatus:"Int",
		deploymentStatus:"Int",
		assetsIDs:"Int",
		currentDeployedVersionId:"Int",
		userId:"Int",
		sharedUserIds:"Int",
		isOffline:"Int",
		isEnquiry:"Int",
		isPaid:"Int",
		enquiryDate:"Int",
		approvalDate:"Int",
		paymentDate:"Int",
		confirmationDate:"Int",
		contentScheduledDate:"Int",
		contentLiveDate:"Int",
		completionDate:"Int",
		refundStatus:"Int",
		_all:"Int"
	},
	BookingMinAggregate:{
		id:"String",
		additionalInformation:"String",
		origin:"String",
		bookingCode:"String",
		bookingDate:"DateTime",
		bookingFor:"String",
		purpose:"String",
		adBoardId:"String",
		workspaceId:"String",
		campaignId:"String",
		businessCategoryId:"String",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		currentDeployedVersionId:"String",
		userId:"String",
		isOffline:"Boolean",
		isEnquiry:"Boolean",
		isPaid:"Boolean",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus"
	},
	BookingMaxAggregate:{
		id:"String",
		additionalInformation:"String",
		origin:"String",
		bookingCode:"String",
		bookingDate:"DateTime",
		bookingFor:"String",
		purpose:"String",
		adBoardId:"String",
		workspaceId:"String",
		campaignId:"String",
		businessCategoryId:"String",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		currentDeployedVersionId:"String",
		userId:"String",
		isOffline:"Boolean",
		isEnquiry:"Boolean",
		isPaid:"Boolean",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus"
	},
	BookingGroupBy:{
		id:"String",
		additionalInformation:"String",
		origin:"String",
		bookingCode:"String",
		bookingDate:"DateTime",
		bookingFor:"String",
		purpose:"String",
		adBoardId:"String",
		workspaceId:"String",
		campaignId:"String",
		businessCategoryId:"String",
		adCategoryId:"String",
		bookingStatus:"BookingStatus",
		paymentStatus:"PaymentStatus",
		deploymentStatus:"DeploymentStatus",
		assetsIDs:"String",
		currentDeployedVersionId:"String",
		userId:"String",
		sharedUserIds:"String",
		isOffline:"Boolean",
		isEnquiry:"Boolean",
		isPaid:"Boolean",
		enquiryDate:"DateTime",
		approvalDate:"DateTime",
		paymentDate:"DateTime",
		confirmationDate:"DateTime",
		contentScheduledDate:"DateTime",
		contentLiveDate:"DateTime",
		completionDate:"DateTime",
		refundStatus:"RefundStatus",
		_count:"BookingCountAggregate",
		_min:"BookingMinAggregate",
		_max:"BookingMaxAggregate"
	},
	AggregateBusinessCategory:{
		_count:"BusinessCategoryCountAggregate",
		_min:"BusinessCategoryMinAggregate",
		_max:"BusinessCategoryMaxAggregate"
	},
	BusinessCategoryCountAggregate:{
		id:"Int",
		name:"Int",
		description:"Int",
		restrictedByAdBoardIds:"Int",
		_all:"Int"
	},
	BusinessCategoryMinAggregate:{
		id:"String",
		name:"String",
		description:"String"
	},
	BusinessCategoryMaxAggregate:{
		id:"String",
		name:"String",
		description:"String"
	},
	BusinessCategoryGroupBy:{
		id:"String",
		name:"String",
		description:"String",
		restrictedByAdBoardIds:"String",
		_count:"BusinessCategoryCountAggregate",
		_min:"BusinessCategoryMinAggregate",
		_max:"BusinessCategoryMaxAggregate"
	},
	AggregateCamera:{
		_count:"CameraCountAggregate",
		_min:"CameraMinAggregate",
		_max:"CameraMaxAggregate"
	},
	CameraCountAggregate:{
		id:"Int",
		name:"Int",
		isOnline:"Int",
		playerId:"Int",
		workspaceId:"Int",
		createdAt:"Int",
		updatedAt:"Int",
		isPublic:"Int",
		_all:"Int"
	},
	CameraMinAggregate:{
		id:"String",
		name:"String",
		isOnline:"Boolean",
		playerId:"String",
		workspaceId:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		isPublic:"Boolean"
	},
	CameraMaxAggregate:{
		id:"String",
		name:"String",
		isOnline:"Boolean",
		playerId:"String",
		workspaceId:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		isPublic:"Boolean"
	},
	CameraGroupBy:{
		id:"String",
		name:"String",
		isOnline:"Boolean",
		playerId:"String",
		workspaceId:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		isPublic:"Boolean",
		_count:"CameraCountAggregate",
		_min:"CameraMinAggregate",
		_max:"CameraMaxAggregate"
	},
	AggregateCampaign:{
		_count:"CampaignCountAggregate",
		_min:"CampaignMinAggregate",
		_max:"CampaignMaxAggregate"
	},
	CampaignCountAggregate:{
		id:"Int",
		name:"Int",
		description:"Int",
		businessCategoryId:"Int",
		purpose:"Int",
		userId:"Int",
		adCategoryId:"Int",
		paymentStatus:"Int",
		origin:"Int",
		assetsIDs:"Int",
		createdAt:"Int",
		updatedAt:"Int",
		_all:"Int"
	},
	CampaignMinAggregate:{
		id:"String",
		name:"String",
		description:"String",
		businessCategoryId:"String",
		purpose:"String",
		userId:"String",
		paymentStatus:"PaymentStatus",
		origin:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	CampaignMaxAggregate:{
		id:"String",
		name:"String",
		description:"String",
		businessCategoryId:"String",
		purpose:"String",
		userId:"String",
		paymentStatus:"PaymentStatus",
		origin:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	CampaignGroupBy:{
		id:"String",
		name:"String",
		description:"String",
		businessCategoryId:"String",
		purpose:"String",
		userId:"String",
		adCategoryId:"String",
		paymentStatus:"PaymentStatus",
		origin:"String",
		assetsIDs:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		_count:"CampaignCountAggregate",
		_min:"CampaignMinAggregate",
		_max:"CampaignMaxAggregate"
	},
	AggregateFile:{
		_count:"FileCountAggregate",
		_avg:"FileAvgAggregate",
		_sum:"FileSumAggregate",
		_min:"FileMinAggregate",
		_max:"FileMaxAggregate"
	},
	FileCountAggregate:{
		id:"Int",
		contentType:"Int",
		ctime:"Int",
		filename:"Int",
		filepath:"Int",
		isDirectory:"Int",
		mtime:"Int",
		name:"Int",
		size:"Int",
		status:"Int",
		type:"Int",
		updatedAt:"Int",
		createdAt:"Int",
		updatedByUserId:"Int",
		createdByUserId:"Int",
		url:"Int",
		bookingsIDs:"Int",
		workspaceId:"Int",
		proofBookingId:"Int",
		campaignIds:"Int",
		contentVersionId:"Int",
		_all:"Int"
	},
	FileAvgAggregate:{
		size:"Float"
	},
	FileSumAggregate:{
		size:"Int"
	},
	FileMinAggregate:{
		id:"String",
		contentType:"String",
		ctime:"String",
		filename:"String",
		filepath:"String",
		isDirectory:"Boolean",
		mtime:"String",
		name:"String",
		size:"Int",
		status:"FileStatus",
		type:"String",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedByUserId:"String",
		createdByUserId:"String",
		url:"String",
		workspaceId:"String",
		proofBookingId:"String"
	},
	FileMaxAggregate:{
		id:"String",
		contentType:"String",
		ctime:"String",
		filename:"String",
		filepath:"String",
		isDirectory:"Boolean",
		mtime:"String",
		name:"String",
		size:"Int",
		status:"FileStatus",
		type:"String",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedByUserId:"String",
		createdByUserId:"String",
		url:"String",
		workspaceId:"String",
		proofBookingId:"String"
	},
	FileGroupBy:{
		id:"String",
		contentType:"String",
		ctime:"String",
		filename:"String",
		filepath:"String",
		isDirectory:"Boolean",
		mtime:"String",
		name:"String",
		size:"Int",
		status:"FileStatus",
		type:"String",
		updatedAt:"DateTime",
		createdAt:"DateTime",
		updatedByUserId:"String",
		createdByUserId:"String",
		url:"String",
		bookingsIDs:"String",
		workspaceId:"String",
		proofBookingId:"String",
		campaignIds:"String",
		contentVersionId:"String",
		_count:"FileCountAggregate",
		_avg:"FileAvgAggregate",
		_sum:"FileSumAggregate",
		_min:"FileMinAggregate",
		_max:"FileMaxAggregate"
	},
	AggregateMembership:{
		_count:"MembershipCountAggregate",
		_min:"MembershipMinAggregate",
		_max:"MembershipMaxAggregate"
	},
	MembershipCountAggregate:{
		id:"Int",
		createdAt:"Int",
		userId:"Int",
		workspaceId:"Int",
		roleId:"Int",
		_all:"Int"
	},
	MembershipMinAggregate:{
		id:"String",
		createdAt:"DateTime",
		userId:"String",
		workspaceId:"String",
		roleId:"String"
	},
	MembershipMaxAggregate:{
		id:"String",
		createdAt:"DateTime",
		userId:"String",
		workspaceId:"String",
		roleId:"String"
	},
	MembershipGroupBy:{
		id:"String",
		createdAt:"DateTime",
		userId:"String",
		workspaceId:"String",
		roleId:"String",
		_count:"MembershipCountAggregate",
		_min:"MembershipMinAggregate",
		_max:"MembershipMaxAggregate"
	},
	AggregateNotification:{
		_count:"NotificationCountAggregate",
		_min:"NotificationMinAggregate",
		_max:"NotificationMaxAggregate"
	},
	NotificationCountAggregate:{
		id:"Int",
		type:"Int",
		title:"Int",
		content:"Int",
		metadata:"Int",
		createdAt:"Int",
		readAt:"Int",
		recipientId:"Int",
		channels:"Int",
		_all:"Int"
	},
	NotificationMinAggregate:{
		id:"String",
		type:"NotificationType",
		title:"String",
		content:"String",
		createdAt:"DateTime",
		readAt:"DateTime",
		recipientId:"String"
	},
	NotificationMaxAggregate:{
		id:"String",
		type:"NotificationType",
		title:"String",
		content:"String",
		createdAt:"DateTime",
		readAt:"DateTime",
		recipientId:"String"
	},
	NotificationGroupBy:{
		id:"String",
		type:"NotificationType",
		title:"String",
		content:"String",
		metadata:"JSON",
		createdAt:"DateTime",
		readAt:"DateTime",
		recipientId:"String",
		channels:"NotificationChannel",
		_count:"NotificationCountAggregate",
		_min:"NotificationMinAggregate",
		_max:"NotificationMaxAggregate"
	},
	AggregateOrder:{
		_count:"OrderCountAggregate",
		_min:"OrderMinAggregate",
		_max:"OrderMaxAggregate"
	},
	OrderCountAggregate:{
		id:"Int",
		adBoardId:"Int",
		createdDate:"Int",
		createdByUserId:"Int",
		origin:"Int",
		paymentId:"Int",
		_all:"Int"
	},
	OrderMinAggregate:{
		id:"String",
		adBoardId:"String",
		createdDate:"DateTime",
		createdByUserId:"String",
		origin:"String",
		paymentId:"String"
	},
	OrderMaxAggregate:{
		id:"String",
		adBoardId:"String",
		createdDate:"DateTime",
		createdByUserId:"String",
		origin:"String",
		paymentId:"String"
	},
	OrderGroupBy:{
		id:"String",
		adBoardId:"String",
		createdDate:"DateTime",
		createdByUserId:"String",
		origin:"String",
		paymentId:"String",
		_count:"OrderCountAggregate",
		_min:"OrderMinAggregate",
		_max:"OrderMaxAggregate"
	},
	AggregatePlayer:{
		_count:"PlayerCountAggregate",
		_avg:"PlayerAvgAggregate",
		_sum:"PlayerSumAggregate",
		_min:"PlayerMinAggregate",
		_max:"PlayerMaxAggregate"
	},
	PlayerCountAggregate:{
		id:"Int",
		name:"Int",
		configLocation:"Int",
		pisignagePlayerId:"Int",
		pisignageGroupId:"Int",
		cpuSerialNumber:"Int",
		displayName:"Int",
		adBoardGroupId:"Int",
		playlistIds:"Int",
		workpaceId:"Int",
		signageTypeId:"Int",
		audienceTypeId:"Int",
		aspectRatioType:"Int",
		customAspectRatioWidth:"Int",
		customAspectRatioHeight:"Int",
		isOnline:"Int",
		adBoardIds:"Int",
		createdAt:"Int",
		updatedAt:"Int",
		markForDeletion:"Int",
		deletedAt:"Int",
		deletedByUserId:"Int",
		visible:"Int",
		_all:"Int"
	},
	PlayerAvgAggregate:{
		customAspectRatioWidth:"Float",
		customAspectRatioHeight:"Float"
	},
	PlayerSumAggregate:{
		customAspectRatioWidth:"Int",
		customAspectRatioHeight:"Int"
	},
	PlayerMinAggregate:{
		id:"String",
		name:"String",
		configLocation:"String",
		pisignagePlayerId:"String",
		pisignageGroupId:"String",
		cpuSerialNumber:"String",
		displayName:"String",
		adBoardGroupId:"String",
		workpaceId:"String",
		signageTypeId:"String",
		aspectRatioType:"AspectRatioType",
		customAspectRatioWidth:"Int",
		customAspectRatioHeight:"Int",
		isOnline:"Boolean",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		markForDeletion:"Boolean",
		deletedAt:"DateTime",
		deletedByUserId:"String",
		visible:"Boolean"
	},
	PlayerMaxAggregate:{
		id:"String",
		name:"String",
		configLocation:"String",
		pisignagePlayerId:"String",
		pisignageGroupId:"String",
		cpuSerialNumber:"String",
		displayName:"String",
		adBoardGroupId:"String",
		workpaceId:"String",
		signageTypeId:"String",
		aspectRatioType:"AspectRatioType",
		customAspectRatioWidth:"Int",
		customAspectRatioHeight:"Int",
		isOnline:"Boolean",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		markForDeletion:"Boolean",
		deletedAt:"DateTime",
		deletedByUserId:"String",
		visible:"Boolean"
	},
	PlayerGroupBy:{
		id:"String",
		name:"String",
		configLocation:"String",
		pisignagePlayerId:"String",
		pisignageGroupId:"String",
		cpuSerialNumber:"String",
		displayName:"String",
		adBoardGroupId:"String",
		playlistIds:"String",
		workpaceId:"String",
		signageTypeId:"String",
		audienceTypeId:"String",
		aspectRatioType:"AspectRatioType",
		customAspectRatioWidth:"Int",
		customAspectRatioHeight:"Int",
		isOnline:"Boolean",
		adBoardIds:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		markForDeletion:"Boolean",
		deletedAt:"DateTime",
		deletedByUserId:"String",
		visible:"Boolean",
		_count:"PlayerCountAggregate",
		_avg:"PlayerAvgAggregate",
		_sum:"PlayerSumAggregate",
		_min:"PlayerMinAggregate",
		_max:"PlayerMaxAggregate"
	},
	AggregatePlaylist:{
		_count:"PlaylistCountAggregate",
		_min:"PlaylistMinAggregate",
		_max:"PlaylistMaxAggregate"
	},
	PlaylistCountAggregate:{
		id:"Int",
		name:"Int",
		displayName:"Int",
		isAdsPlaylist:"Int",
		footerPlaylistId:"Int",
		sidebarPlaylistId:"Int",
		layout:"Int",
		isDeployed:"Int",
		adBoardGroupIds:"Int",
		workspaceId:"Int",
		_all:"Int"
	},
	PlaylistMinAggregate:{
		id:"String",
		name:"String",
		displayName:"String",
		isAdsPlaylist:"Boolean",
		footerPlaylistId:"String",
		sidebarPlaylistId:"String",
		layout:"ScreenLayout",
		isDeployed:"Boolean",
		workspaceId:"String"
	},
	PlaylistMaxAggregate:{
		id:"String",
		name:"String",
		displayName:"String",
		isAdsPlaylist:"Boolean",
		footerPlaylistId:"String",
		sidebarPlaylistId:"String",
		layout:"ScreenLayout",
		isDeployed:"Boolean",
		workspaceId:"String"
	},
	PisignagePlaylist:{
		name:"String",
		version:"Int",
		layout:"Layout",
		templateName:"String",
		videoWindow:"VideoWindowProperties",
		zoneVideoWindow:"ZoneVideoWindow",
		assets:"PlaylistAssetRow"
	},
	VideoWindowProperties:{
		length:"Int",
		width:"Int",
		xoffset:"Int",
		yoffset:"Int"
	},
	ZoneVideoWindow:{
		side:"VideoWindowProperties",
		bottom:"VideoWindowProperties",
		zone4:"VideoWindowProperties"
	},
	PlaylistAssetRow:{
		filename:"String",
		duration:"Int",
		isVideo:"Boolean",
		selected:"Boolean",
		option:"String",
		fullscreen:"Boolean",
		side:"String",
		bottom:"String",
		zone4:"String",
		zone5:"String",
		zone6:"String"
	},
	PlaylistGroupBy:{
		id:"String",
		name:"String",
		displayName:"String",
		isAdsPlaylist:"Boolean",
		footerPlaylistId:"String",
		sidebarPlaylistId:"String",
		layout:"ScreenLayout",
		isDeployed:"Boolean",
		adBoardGroupIds:"String",
		workspaceId:"String",
		_count:"PlaylistCountAggregate",
		_min:"PlaylistMinAggregate",
		_max:"PlaylistMaxAggregate"
	},
	AggregateSlotConfiguration:{
		_count:"SlotConfigurationCountAggregate",
		_avg:"SlotConfigurationAvgAggregate",
		_sum:"SlotConfigurationSumAggregate",
		_min:"SlotConfigurationMinAggregate",
		_max:"SlotConfigurationMaxAggregate"
	},
	SlotConfigurationCountAggregate:{
		id:"Int",
		adBoardId:"Int",
		date:"Int",
		availableSlots:"Int",
		_all:"Int"
	},
	SlotConfigurationAvgAggregate:{
		availableSlots:"Float"
	},
	SlotConfigurationSumAggregate:{
		availableSlots:"Int"
	},
	SlotConfigurationMinAggregate:{
		id:"String",
		adBoardId:"String",
		date:"DateTime",
		availableSlots:"Int"
	},
	SlotConfigurationMaxAggregate:{
		id:"String",
		adBoardId:"String",
		date:"DateTime",
		availableSlots:"Int"
	},
	SlotConfigurationGroupBy:{
		id:"String",
		adBoardId:"String",
		date:"DateTime",
		availableSlots:"Int",
		_count:"SlotConfigurationCountAggregate",
		_avg:"SlotConfigurationAvgAggregate",
		_sum:"SlotConfigurationSumAggregate",
		_min:"SlotConfigurationMinAggregate",
		_max:"SlotConfigurationMaxAggregate"
	},
	AggregateSubscription:{
		_count:"SubscriptionCountAggregate",
		_min:"SubscriptionMinAggregate",
		_max:"SubscriptionMaxAggregate"
	},
	SubscriptionCountAggregate:{
		id:"Int",
		packageId:"Int",
		packageName:"Int",
		priceLookupKey:"Int",
		startDate:"Int",
		endDate:"Int",
		status:"Int",
		stripePaymentIntentId:"Int",
		stripeSubscriptionId:"Int",
		stripeCheckoutSessionId:"Int",
		activeWorkspaceId:"Int",
		_all:"Int"
	},
	SubscriptionMinAggregate:{
		id:"String",
		packageId:"String",
		packageName:"String",
		priceLookupKey:"String",
		startDate:"DateTime",
		endDate:"DateTime",
		status:"String",
		stripePaymentIntentId:"String",
		stripeSubscriptionId:"String",
		stripeCheckoutSessionId:"String",
		activeWorkspaceId:"String"
	},
	SubscriptionMaxAggregate:{
		id:"String",
		packageId:"String",
		packageName:"String",
		priceLookupKey:"String",
		startDate:"DateTime",
		endDate:"DateTime",
		status:"String",
		stripePaymentIntentId:"String",
		stripeSubscriptionId:"String",
		stripeCheckoutSessionId:"String",
		activeWorkspaceId:"String"
	},
	SubscriptionGroupBy:{
		id:"String",
		packageId:"String",
		packageName:"String",
		priceLookupKey:"String",
		startDate:"DateTime",
		endDate:"DateTime",
		status:"String",
		stripePaymentIntentId:"String",
		stripeSubscriptionId:"String",
		stripeCheckoutSessionId:"String",
		activeWorkspaceId:"String",
		_count:"SubscriptionCountAggregate",
		_min:"SubscriptionMinAggregate",
		_max:"SubscriptionMaxAggregate"
	},
	AggregateUser:{
		_count:"UserCountAggregate",
		_min:"UserMinAggregate",
		_max:"UserMaxAggregate"
	},
	UserCountAggregate:{
		id:"Int",
		uid:"Int",
		email:"Int",
		image:"Int",
		phoneNumber:"Int",
		displayName:"Int",
		otherDetails:"Int",
		roles:"Int",
		sharedBookingIds:"Int",
		disclaimerAccepted:"Int",
		leadWorkspaceIds:"Int",
		_all:"Int"
	},
	UserMinAggregate:{
		id:"String",
		uid:"String",
		email:"String",
		image:"String",
		phoneNumber:"String",
		displayName:"String",
		disclaimerAccepted:"Boolean"
	},
	UserMaxAggregate:{
		id:"String",
		uid:"String",
		email:"String",
		image:"String",
		phoneNumber:"String",
		displayName:"String",
		disclaimerAccepted:"Boolean"
	},
	UserGroupBy:{
		id:"String",
		uid:"String",
		email:"String",
		image:"String",
		phoneNumber:"String",
		displayName:"String",
		otherDetails:"JSON",
		roles:"Role",
		sharedBookingIds:"String",
		disclaimerAccepted:"Boolean",
		leadWorkspaceIds:"String",
		_count:"UserCountAggregate",
		_min:"UserMinAggregate",
		_max:"UserMaxAggregate"
	},
	AggregateUserPosition:{
		_count:"UserPositionCountAggregate",
		_min:"UserPositionMinAggregate",
		_max:"UserPositionMaxAggregate"
	},
	UserPositionCountAggregate:{
		id:"Int",
		timestamp:"Int",
		createdAt:"Int",
		userId:"Int",
		_all:"Int"
	},
	UserPositionMinAggregate:{
		id:"String",
		timestamp:"DateTime",
		createdAt:"DateTime",
		userId:"String"
	},
	UserPositionMaxAggregate:{
		id:"String",
		timestamp:"DateTime",
		createdAt:"DateTime",
		userId:"String"
	},
	UserPositionGroupBy:{
		id:"String",
		timestamp:"DateTime",
		createdAt:"DateTime",
		userId:"String",
		_count:"UserPositionCountAggregate",
		_min:"UserPositionMinAggregate",
		_max:"UserPositionMaxAggregate"
	},
	AggregateWishlist:{
		_count:"WishlistCountAggregate",
		_min:"WishlistMinAggregate",
		_max:"WishlistMaxAggregate"
	},
	WishlistCountAggregate:{
		id:"Int",
		name:"Int",
		userId:"Int",
		adBoardIds:"Int",
		createdAt:"Int",
		_all:"Int"
	},
	WishlistMinAggregate:{
		id:"String",
		name:"String",
		userId:"String",
		createdAt:"DateTime"
	},
	WishlistMaxAggregate:{
		id:"String",
		name:"String",
		userId:"String",
		createdAt:"DateTime"
	},
	WishlistGroupBy:{
		id:"String",
		name:"String",
		userId:"String",
		adBoardIds:"String",
		createdAt:"DateTime",
		_count:"WishlistCountAggregate",
		_min:"WishlistMinAggregate",
		_max:"WishlistMaxAggregate"
	},
	AggregateWorkspace:{
		_count:"WorkspaceCountAggregate",
		_min:"WorkspaceMinAggregate",
		_max:"WorkspaceMaxAggregate"
	},
	WorkspaceCountAggregate:{
		id:"Int",
		type:"Int",
		name:"Int",
		key:"Int",
		userIds:"Int",
		ownerId:"Int",
		avatar:"Int",
		createdAt:"Int",
		updatedAt:"Int",
		stripeSubscriptionId:"Int",
		leadIds:"Int",
		webhookAppId:"Int",
		stackAuthTeamId:"Int",
		_all:"Int"
	},
	WorkspaceMinAggregate:{
		id:"String",
		type:"WorkspaceType",
		name:"String",
		key:"String",
		ownerId:"String",
		avatar:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		stripeSubscriptionId:"String",
		webhookAppId:"String",
		stackAuthTeamId:"String"
	},
	WorkspaceMaxAggregate:{
		id:"String",
		type:"WorkspaceType",
		name:"String",
		key:"String",
		ownerId:"String",
		avatar:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		stripeSubscriptionId:"String",
		webhookAppId:"String",
		stackAuthTeamId:"String"
	},
	WorkspaceGroupBy:{
		id:"String",
		type:"WorkspaceType",
		name:"String",
		key:"String",
		userIds:"String",
		ownerId:"String",
		avatar:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		stripeSubscriptionId:"String",
		leadIds:"String",
		webhookAppId:"String",
		stackAuthTeamId:"String",
		_count:"WorkspaceCountAggregate",
		_min:"WorkspaceMinAggregate",
		_max:"WorkspaceMaxAggregate"
	},
	AggregateWorkspaceRole:{
		_count:"WorkspaceRoleCountAggregate",
		_min:"WorkspaceRoleMinAggregate",
		_max:"WorkspaceRoleMaxAggregate"
	},
	WorkspaceRoleCountAggregate:{
		id:"Int",
		name:"Int",
		permissions:"Int",
		workspaceId:"Int",
		createdAt:"Int",
		updatedAt:"Int",
		_all:"Int"
	},
	WorkspaceRoleMinAggregate:{
		id:"String",
		name:"String",
		workspaceId:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	WorkspaceRoleMaxAggregate:{
		id:"String",
		name:"String",
		workspaceId:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	WorkspaceRoleGroupBy:{
		id:"String",
		name:"String",
		permissions:"Permission",
		workspaceId:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		_count:"WorkspaceRoleCountAggregate",
		_min:"WorkspaceRoleMinAggregate",
		_max:"WorkspaceRoleMaxAggregate"
	},
	BillboardAiCameraStat:{
		id:"String",
		deviceId:"String",
		timestamp:"DateTime",
		hasScreenDefects:"Boolean",
		hasPatches:"Boolean",
		isOnline:"Boolean",
		details:"String"
	},
	TrafficStatAggregate:{
		_id:"TrafficAggregateId",
		personCount:"Float",
		carCount:"Float"
	},
	TrafficAggregateId:{
		year:"String",
		month:"String",
		day:"String",
		hour:"String"
	},
	TrafficStat:{
		id:"String",
		deviceId:"String",
		timestamp:"DateTime",
		newCount:"JSON",
		stableCount:"JSON",
		passedCount:"JSON",
		newPeopleInfo:"PeopleInfo"
	},
	PeopleInfo:{
		gender:"String",
		age:"String"
	},
	Slot:{
		date:"String",
		slots:"Float"
	},
	PlayEvent:{
		_id:"ID",
		category:"String",
		ts:"String",
		type:"String",
		description:"String",
		fileName:"String",
		duration:"Int",
		startTimestamp:"String",
		endTimestamp:"String",
		playerId:"String"
	},
	Mutation:{
		createManyAdBoard:"AffectedRowsOutput",
		createOneAdBoard:"AdBoard",
		deleteManyAdBoard:"AffectedRowsOutput",
		deleteOneAdBoard:"AdBoard",
		updateManyAdBoard:"AffectedRowsOutput",
		updateOneAdBoard:"AdBoard",
		upsertOneAdBoard:"AdBoard",
		createManyAdBoardGroup:"AffectedRowsOutput",
		createOneAdBoardGroup:"AdBoardGroup",
		deleteManyAdBoardGroup:"AffectedRowsOutput",
		deleteOneAdBoardGroup:"AdBoardGroup",
		updateManyAdBoardGroup:"AffectedRowsOutput",
		updateOneAdBoardGroup:"AdBoardGroup",
		upsertOneAdBoardGroup:"AdBoardGroup",
		createManyAdBoardType:"AffectedRowsOutput",
		createOneAdBoardType:"AdBoardType",
		deleteManyAdBoardType:"AffectedRowsOutput",
		deleteOneAdBoardType:"AdBoardType",
		updateManyAdBoardType:"AffectedRowsOutput",
		updateOneAdBoardType:"AdBoardType",
		upsertOneAdBoardType:"AdBoardType",
		createManyAdvertisementCategory:"AffectedRowsOutput",
		createOneAdvertisementCategory:"AdvertisementCategory",
		deleteManyAdvertisementCategory:"AffectedRowsOutput",
		deleteOneAdvertisementCategory:"AdvertisementCategory",
		updateManyAdvertisementCategory:"AffectedRowsOutput",
		updateOneAdvertisementCategory:"AdvertisementCategory",
		upsertOneAdvertisementCategory:"AdvertisementCategory",
		createManyAudit:"AffectedRowsOutput",
		createOneAudit:"Audit",
		deleteManyAudit:"AffectedRowsOutput",
		deleteOneAudit:"Audit",
		updateManyAudit:"AffectedRowsOutput",
		updateOneAudit:"Audit",
		upsertOneAudit:"Audit",
		createManyBooking:"AffectedRowsOutput",
		createOneBooking:"Booking",
		deleteManyBooking:"AffectedRowsOutput",
		deleteOneBooking:"Booking",
		updateManyBooking:"AffectedRowsOutput",
		updateOneBooking:"Booking",
		upsertOneBooking:"Booking",
		createManyBusinessCategory:"AffectedRowsOutput",
		createOneBusinessCategory:"BusinessCategory",
		deleteManyBusinessCategory:"AffectedRowsOutput",
		deleteOneBusinessCategory:"BusinessCategory",
		updateManyBusinessCategory:"AffectedRowsOutput",
		updateOneBusinessCategory:"BusinessCategory",
		upsertOneBusinessCategory:"BusinessCategory",
		createManyCamera:"AffectedRowsOutput",
		createOneCamera:"Camera",
		deleteManyCamera:"AffectedRowsOutput",
		deleteOneCamera:"Camera",
		updateManyCamera:"AffectedRowsOutput",
		updateOneCamera:"Camera",
		upsertOneCamera:"Camera",
		createManyCampaign:"AffectedRowsOutput",
		createOneCampaign:"Campaign",
		deleteManyCampaign:"AffectedRowsOutput",
		deleteOneCampaign:"Campaign",
		updateManyCampaign:"AffectedRowsOutput",
		updateOneCampaign:"Campaign",
		upsertOneCampaign:"Campaign",
		createManyFile:"AffectedRowsOutput",
		createOneFile:"File",
		deleteManyFile:"AffectedRowsOutput",
		deleteOneFile:"File",
		updateManyFile:"AffectedRowsOutput",
		updateOneFile:"File",
		upsertOneFile:"File",
		createManyMembership:"AffectedRowsOutput",
		createOneMembership:"Membership",
		deleteManyMembership:"AffectedRowsOutput",
		deleteOneMembership:"Membership",
		updateManyMembership:"AffectedRowsOutput",
		updateOneMembership:"Membership",
		upsertOneMembership:"Membership",
		createManyNotification:"AffectedRowsOutput",
		createOneNotification:"Notification",
		deleteManyNotification:"AffectedRowsOutput",
		deleteOneNotification:"Notification",
		updateManyNotification:"AffectedRowsOutput",
		updateOneNotification:"Notification",
		upsertOneNotification:"Notification",
		createManyOrder:"AffectedRowsOutput",
		createOneOrder:"Order",
		deleteManyOrder:"AffectedRowsOutput",
		deleteOneOrder:"Order",
		updateManyOrder:"AffectedRowsOutput",
		updateOneOrder:"Order",
		upsertOneOrder:"Order",
		createManyPlayer:"AffectedRowsOutput",
		createOnePlayer:"Player",
		deleteManyPlayer:"AffectedRowsOutput",
		deleteOnePlayer:"Player",
		updateManyPlayer:"AffectedRowsOutput",
		updateOnePlayer:"Player",
		upsertOnePlayer:"Player",
		createManyPlaylist:"AffectedRowsOutput",
		createOnePlaylist:"Playlist",
		deleteManyPlaylist:"AffectedRowsOutput",
		deleteOnePlaylist:"Playlist",
		updateManyPlaylist:"AffectedRowsOutput",
		updateOnePlaylist:"Playlist",
		upsertOnePlaylist:"Playlist",
		createManySlotConfiguration:"AffectedRowsOutput",
		createOneSlotConfiguration:"SlotConfiguration",
		deleteManySlotConfiguration:"AffectedRowsOutput",
		deleteOneSlotConfiguration:"SlotConfiguration",
		updateManySlotConfiguration:"AffectedRowsOutput",
		updateOneSlotConfiguration:"SlotConfiguration",
		upsertOneSlotConfiguration:"SlotConfiguration",
		createManySubscription:"AffectedRowsOutput",
		createOneSubscription:"Subscription",
		deleteManySubscription:"AffectedRowsOutput",
		deleteOneSubscription:"Subscription",
		updateManySubscription:"AffectedRowsOutput",
		updateOneSubscription:"Subscription",
		upsertOneSubscription:"Subscription",
		createManyUser:"AffectedRowsOutput",
		createOneUser:"User",
		deleteManyUser:"AffectedRowsOutput",
		deleteOneUser:"User",
		updateManyUser:"AffectedRowsOutput",
		updateOneUser:"User",
		upsertOneUser:"User",
		createManyUserPosition:"AffectedRowsOutput",
		createOneUserPosition:"UserPosition",
		deleteManyUserPosition:"AffectedRowsOutput",
		deleteOneUserPosition:"UserPosition",
		updateManyUserPosition:"AffectedRowsOutput",
		updateOneUserPosition:"UserPosition",
		upsertOneUserPosition:"UserPosition",
		createManyWishlist:"AffectedRowsOutput",
		createOneWishlist:"Wishlist",
		deleteManyWishlist:"AffectedRowsOutput",
		deleteOneWishlist:"Wishlist",
		updateManyWishlist:"AffectedRowsOutput",
		updateOneWishlist:"Wishlist",
		upsertOneWishlist:"Wishlist",
		createManyWorkspace:"AffectedRowsOutput",
		createOneWorkspace:"Workspace",
		deleteManyWorkspace:"AffectedRowsOutput",
		deleteOneWorkspace:"Workspace",
		updateManyWorkspace:"AffectedRowsOutput",
		updateOneWorkspace:"Workspace",
		upsertOneWorkspace:"Workspace",
		createManyWorkspaceRole:"AffectedRowsOutput",
		createOneWorkspaceRole:"WorkspaceRole",
		deleteManyWorkspaceRole:"AffectedRowsOutput",
		deleteOneWorkspaceRole:"WorkspaceRole",
		updateManyWorkspaceRole:"AffectedRowsOutput",
		updateOneWorkspaceRole:"WorkspaceRole",
		upsertOneWorkspaceRole:"WorkspaceRole",
		updateUser:"User",
		createCustomUser:"User",
		deleteUserCustom:"GenericResponse",
		sendMail:"EmailOutput",
		createOneCampaignBooking:"Campaign",
		createOneAdboardPublicReview:"AdBoardPublicReview",
		createOneCameraStreamingDevice:"StreamingDevice",
		updateOneCameraStreamingDevice:"StreamingDevice",
		refreshSubscription:"TypedGenericResponse",
		cancelSubscription:"TypedGenericResponse",
		updateBookingStatus:"Booking",
		cancelBooking:"Booking",
		updateBookingAssets:"Booking",
		approveBookingAsset:"Booking",
		deployBookingAsset:"Booking",
		updateAdboard:"AdBoard",
		addReviewComment:"AdBoardReviewComment",
		updateAdBoardStatus:"AdBoard",
		publishApprovedDraft:"AdBoard",
		addPlayersToAdboard:"AdBoard",
		createOneAdboardWithGroup:"AdBoard",
		deleteOneAdboardWithGroup:"AdBoard",
		updateOneScheduler:"AdBoardGroup",
		deployPlaylist:"StatusOutput",
		setupOnePlayer:"Player",
		updatePlayerCode:"Player",
		updatePlayerPlaySettings:"Player",
		addPlaylistToPlayer:"Player",
		setPlaylistToPlayer:"Player",
		resetTvCode:"Player"
	},
	AffectedRowsOutput:{
		count:"Int"
	},
	GenericResponse:{
		success:"Boolean"
	},
	EmailOutput:{
		success:"Boolean"
	},
	TypedGenericResponse:{
		success:"Boolean"
	},
	StatusOutput:{
		success:"Boolean"
	}
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const
}